/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const QuoteWSProtos = $root.QuoteWSProtos = (() => {

    /**
     * Namespace QuoteWSProtos.
     * @exports QuoteWSProtos
     * @namespace
     */
    const QuoteWSProtos = {};

    QuoteWSProtos.AddUpdateQuoteSubscriptionRequest = (function() {

        /**
         * Properties of an AddUpdateQuoteSubscriptionRequest.
         * @memberof QuoteWSProtos
         * @interface IAddUpdateQuoteSubscriptionRequest
         * @property {string|null} [symbol] AddUpdateQuoteSubscriptionRequest symbol
         * @property {Array.<string>|null} [subscribeFields] AddUpdateQuoteSubscriptionRequest subscribeFields
         * @property {Array.<string>|null} [unsubscribeFields] AddUpdateQuoteSubscriptionRequest unsubscribeFields
         */

        /**
         * Constructs a new AddUpdateQuoteSubscriptionRequest.
         * @memberof QuoteWSProtos
         * @classdesc Represents an AddUpdateQuoteSubscriptionRequest.
         * @implements IAddUpdateQuoteSubscriptionRequest
         * @constructor
         * @param {QuoteWSProtos.IAddUpdateQuoteSubscriptionRequest=} [properties] Properties to set
         */
        function AddUpdateQuoteSubscriptionRequest(properties) {
            this.subscribeFields = [];
            this.unsubscribeFields = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUpdateQuoteSubscriptionRequest symbol.
         * @member {string} symbol
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @instance
         */
        AddUpdateQuoteSubscriptionRequest.prototype.symbol = "";

        /**
         * AddUpdateQuoteSubscriptionRequest subscribeFields.
         * @member {Array.<string>} subscribeFields
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @instance
         */
        AddUpdateQuoteSubscriptionRequest.prototype.subscribeFields = $util.emptyArray;

        /**
         * AddUpdateQuoteSubscriptionRequest unsubscribeFields.
         * @member {Array.<string>} unsubscribeFields
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @instance
         */
        AddUpdateQuoteSubscriptionRequest.prototype.unsubscribeFields = $util.emptyArray;

        /**
         * Creates a new AddUpdateQuoteSubscriptionRequest instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @static
         * @param {QuoteWSProtos.IAddUpdateQuoteSubscriptionRequest=} [properties] Properties to set
         * @returns {QuoteWSProtos.AddUpdateQuoteSubscriptionRequest} AddUpdateQuoteSubscriptionRequest instance
         */
        AddUpdateQuoteSubscriptionRequest.create = function create(properties) {
            return new AddUpdateQuoteSubscriptionRequest(properties);
        };

        /**
         * Encodes the specified AddUpdateQuoteSubscriptionRequest message. Does not implicitly {@link QuoteWSProtos.AddUpdateQuoteSubscriptionRequest.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @static
         * @param {QuoteWSProtos.IAddUpdateQuoteSubscriptionRequest} message AddUpdateQuoteSubscriptionRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUpdateQuoteSubscriptionRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
            if (message.subscribeFields != null && message.subscribeFields.length)
                for (let i = 0; i < message.subscribeFields.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.subscribeFields[i]);
            if (message.unsubscribeFields != null && message.unsubscribeFields.length)
                for (let i = 0; i < message.unsubscribeFields.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.unsubscribeFields[i]);
            return writer;
        };

        /**
         * Encodes the specified AddUpdateQuoteSubscriptionRequest message, length delimited. Does not implicitly {@link QuoteWSProtos.AddUpdateQuoteSubscriptionRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @static
         * @param {QuoteWSProtos.IAddUpdateQuoteSubscriptionRequest} message AddUpdateQuoteSubscriptionRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUpdateQuoteSubscriptionRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddUpdateQuoteSubscriptionRequest message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.AddUpdateQuoteSubscriptionRequest} AddUpdateQuoteSubscriptionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUpdateQuoteSubscriptionRequest.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.AddUpdateQuoteSubscriptionRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.symbol = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.subscribeFields && message.subscribeFields.length))
                            message.subscribeFields = [];
                        message.subscribeFields.push(reader.string());
                        break;
                    }
                case 3: {
                        if (!(message.unsubscribeFields && message.unsubscribeFields.length))
                            message.unsubscribeFields = [];
                        message.unsubscribeFields.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddUpdateQuoteSubscriptionRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.AddUpdateQuoteSubscriptionRequest} AddUpdateQuoteSubscriptionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUpdateQuoteSubscriptionRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddUpdateQuoteSubscriptionRequest message.
         * @function verify
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddUpdateQuoteSubscriptionRequest.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.subscribeFields != null && message.hasOwnProperty("subscribeFields")) {
                if (!Array.isArray(message.subscribeFields))
                    return "subscribeFields: array expected";
                for (let i = 0; i < message.subscribeFields.length; ++i)
                    if (!$util.isString(message.subscribeFields[i]))
                        return "subscribeFields: string[] expected";
            }
            if (message.unsubscribeFields != null && message.hasOwnProperty("unsubscribeFields")) {
                if (!Array.isArray(message.unsubscribeFields))
                    return "unsubscribeFields: array expected";
                for (let i = 0; i < message.unsubscribeFields.length; ++i)
                    if (!$util.isString(message.unsubscribeFields[i]))
                        return "unsubscribeFields: string[] expected";
            }
            return null;
        };

        /**
         * Creates an AddUpdateQuoteSubscriptionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.AddUpdateQuoteSubscriptionRequest} AddUpdateQuoteSubscriptionRequest
         */
        AddUpdateQuoteSubscriptionRequest.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.AddUpdateQuoteSubscriptionRequest)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteWSProtos.AddUpdateQuoteSubscriptionRequest();
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            if (object.subscribeFields) {
                if (!Array.isArray(object.subscribeFields))
                    throw TypeError(".QuoteWSProtos.AddUpdateQuoteSubscriptionRequest.subscribeFields: array expected");
                message.subscribeFields = [];
                for (let i = 0; i < object.subscribeFields.length; ++i)
                    message.subscribeFields[i] = String(object.subscribeFields[i]);
            }
            if (object.unsubscribeFields) {
                if (!Array.isArray(object.unsubscribeFields))
                    throw TypeError(".QuoteWSProtos.AddUpdateQuoteSubscriptionRequest.unsubscribeFields: array expected");
                message.unsubscribeFields = [];
                for (let i = 0; i < object.unsubscribeFields.length; ++i)
                    message.unsubscribeFields[i] = String(object.unsubscribeFields[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddUpdateQuoteSubscriptionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @static
         * @param {QuoteWSProtos.AddUpdateQuoteSubscriptionRequest} message AddUpdateQuoteSubscriptionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUpdateQuoteSubscriptionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.subscribeFields = [];
                object.unsubscribeFields = [];
            }
            if (options.defaults)
                object.symbol = "";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.subscribeFields && message.subscribeFields.length) {
                object.subscribeFields = [];
                for (let j = 0; j < message.subscribeFields.length; ++j)
                    object.subscribeFields[j] = message.subscribeFields[j];
            }
            if (message.unsubscribeFields && message.unsubscribeFields.length) {
                object.unsubscribeFields = [];
                for (let j = 0; j < message.unsubscribeFields.length; ++j)
                    object.unsubscribeFields[j] = message.unsubscribeFields[j];
            }
            return object;
        };

        /**
         * Converts this AddUpdateQuoteSubscriptionRequest to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.AddUpdateQuoteSubscriptionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUpdateQuoteSubscriptionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddUpdateQuoteSubscriptionRequest;
    })();

    QuoteWSProtos.RemoveQuoteSubscriptionRequest = (function() {

        /**
         * Properties of a RemoveQuoteSubscriptionRequest.
         * @memberof QuoteWSProtos
         * @interface IRemoveQuoteSubscriptionRequest
         * @property {string|null} [symbol] RemoveQuoteSubscriptionRequest symbol
         */

        /**
         * Constructs a new RemoveQuoteSubscriptionRequest.
         * @memberof QuoteWSProtos
         * @classdesc Represents a RemoveQuoteSubscriptionRequest.
         * @implements IRemoveQuoteSubscriptionRequest
         * @constructor
         * @param {QuoteWSProtos.IRemoveQuoteSubscriptionRequest=} [properties] Properties to set
         */
        function RemoveQuoteSubscriptionRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveQuoteSubscriptionRequest symbol.
         * @member {string} symbol
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @instance
         */
        RemoveQuoteSubscriptionRequest.prototype.symbol = "";

        /**
         * Creates a new RemoveQuoteSubscriptionRequest instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @static
         * @param {QuoteWSProtos.IRemoveQuoteSubscriptionRequest=} [properties] Properties to set
         * @returns {QuoteWSProtos.RemoveQuoteSubscriptionRequest} RemoveQuoteSubscriptionRequest instance
         */
        RemoveQuoteSubscriptionRequest.create = function create(properties) {
            return new RemoveQuoteSubscriptionRequest(properties);
        };

        /**
         * Encodes the specified RemoveQuoteSubscriptionRequest message. Does not implicitly {@link QuoteWSProtos.RemoveQuoteSubscriptionRequest.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @static
         * @param {QuoteWSProtos.IRemoveQuoteSubscriptionRequest} message RemoveQuoteSubscriptionRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveQuoteSubscriptionRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
            return writer;
        };

        /**
         * Encodes the specified RemoveQuoteSubscriptionRequest message, length delimited. Does not implicitly {@link QuoteWSProtos.RemoveQuoteSubscriptionRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @static
         * @param {QuoteWSProtos.IRemoveQuoteSubscriptionRequest} message RemoveQuoteSubscriptionRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveQuoteSubscriptionRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveQuoteSubscriptionRequest message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.RemoveQuoteSubscriptionRequest} RemoveQuoteSubscriptionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveQuoteSubscriptionRequest.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.RemoveQuoteSubscriptionRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.symbol = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveQuoteSubscriptionRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.RemoveQuoteSubscriptionRequest} RemoveQuoteSubscriptionRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveQuoteSubscriptionRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveQuoteSubscriptionRequest message.
         * @function verify
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveQuoteSubscriptionRequest.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            return null;
        };

        /**
         * Creates a RemoveQuoteSubscriptionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.RemoveQuoteSubscriptionRequest} RemoveQuoteSubscriptionRequest
         */
        RemoveQuoteSubscriptionRequest.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.RemoveQuoteSubscriptionRequest)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteWSProtos.RemoveQuoteSubscriptionRequest();
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            return message;
        };

        /**
         * Creates a plain object from a RemoveQuoteSubscriptionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @static
         * @param {QuoteWSProtos.RemoveQuoteSubscriptionRequest} message RemoveQuoteSubscriptionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveQuoteSubscriptionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.symbol = "";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            return object;
        };

        /**
         * Converts this RemoveQuoteSubscriptionRequest to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.RemoveQuoteSubscriptionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveQuoteSubscriptionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveQuoteSubscriptionRequest;
    })();

    QuoteWSProtos.QuoteSocketRequest = (function() {

        /**
         * Properties of a QuoteSocketRequest.
         * @memberof QuoteWSProtos
         * @interface IQuoteSocketRequest
         * @property {QuoteWSProtos.IAddUpdateQuoteSubscriptionRequest|null} [addUpdateQuoteSubscriptionRequest] QuoteSocketRequest addUpdateQuoteSubscriptionRequest
         * @property {QuoteWSProtos.IRemoveQuoteSubscriptionRequest|null} [removeQuoteSubscriptionRequest] QuoteSocketRequest removeQuoteSubscriptionRequest
         * @property {QuoteWSProtos.IPong|null} [PONG] QuoteSocketRequest PONG
         */

        /**
         * Constructs a new QuoteSocketRequest.
         * @memberof QuoteWSProtos
         * @classdesc Represents a QuoteSocketRequest.
         * @implements IQuoteSocketRequest
         * @constructor
         * @param {QuoteWSProtos.IQuoteSocketRequest=} [properties] Properties to set
         */
        function QuoteSocketRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuoteSocketRequest addUpdateQuoteSubscriptionRequest.
         * @member {QuoteWSProtos.IAddUpdateQuoteSubscriptionRequest|null|undefined} addUpdateQuoteSubscriptionRequest
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @instance
         */
        QuoteSocketRequest.prototype.addUpdateQuoteSubscriptionRequest = null;

        /**
         * QuoteSocketRequest removeQuoteSubscriptionRequest.
         * @member {QuoteWSProtos.IRemoveQuoteSubscriptionRequest|null|undefined} removeQuoteSubscriptionRequest
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @instance
         */
        QuoteSocketRequest.prototype.removeQuoteSubscriptionRequest = null;

        /**
         * QuoteSocketRequest PONG.
         * @member {QuoteWSProtos.IPong|null|undefined} PONG
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @instance
         */
        QuoteSocketRequest.prototype.PONG = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * QuoteSocketRequest data.
         * @member {"addUpdateQuoteSubscriptionRequest"|"removeQuoteSubscriptionRequest"|"PONG"|undefined} data
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @instance
         */
        Object.defineProperty(QuoteSocketRequest.prototype, "data", {
            get: $util.oneOfGetter($oneOfFields = ["addUpdateQuoteSubscriptionRequest", "removeQuoteSubscriptionRequest", "PONG"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new QuoteSocketRequest instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @static
         * @param {QuoteWSProtos.IQuoteSocketRequest=} [properties] Properties to set
         * @returns {QuoteWSProtos.QuoteSocketRequest} QuoteSocketRequest instance
         */
        QuoteSocketRequest.create = function create(properties) {
            return new QuoteSocketRequest(properties);
        };

        /**
         * Encodes the specified QuoteSocketRequest message. Does not implicitly {@link QuoteWSProtos.QuoteSocketRequest.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @static
         * @param {QuoteWSProtos.IQuoteSocketRequest} message QuoteSocketRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteSocketRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.addUpdateQuoteSubscriptionRequest != null && Object.hasOwnProperty.call(message, "addUpdateQuoteSubscriptionRequest"))
                $root.QuoteWSProtos.AddUpdateQuoteSubscriptionRequest.encode(message.addUpdateQuoteSubscriptionRequest, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.removeQuoteSubscriptionRequest != null && Object.hasOwnProperty.call(message, "removeQuoteSubscriptionRequest"))
                $root.QuoteWSProtos.RemoveQuoteSubscriptionRequest.encode(message.removeQuoteSubscriptionRequest, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.PONG != null && Object.hasOwnProperty.call(message, "PONG"))
                $root.QuoteWSProtos.Pong.encode(message.PONG, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified QuoteSocketRequest message, length delimited. Does not implicitly {@link QuoteWSProtos.QuoteSocketRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @static
         * @param {QuoteWSProtos.IQuoteSocketRequest} message QuoteSocketRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteSocketRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteSocketRequest message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.QuoteSocketRequest} QuoteSocketRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteSocketRequest.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.QuoteSocketRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.addUpdateQuoteSubscriptionRequest = $root.QuoteWSProtos.AddUpdateQuoteSubscriptionRequest.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 2: {
                        message.removeQuoteSubscriptionRequest = $root.QuoteWSProtos.RemoveQuoteSubscriptionRequest.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 3: {
                        message.PONG = $root.QuoteWSProtos.Pong.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuoteSocketRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.QuoteSocketRequest} QuoteSocketRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteSocketRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuoteSocketRequest message.
         * @function verify
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuoteSocketRequest.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            let properties = {};
            if (message.addUpdateQuoteSubscriptionRequest != null && message.hasOwnProperty("addUpdateQuoteSubscriptionRequest")) {
                properties.data = 1;
                {
                    let error = $root.QuoteWSProtos.AddUpdateQuoteSubscriptionRequest.verify(message.addUpdateQuoteSubscriptionRequest, long + 1);
                    if (error)
                        return "addUpdateQuoteSubscriptionRequest." + error;
                }
            }
            if (message.removeQuoteSubscriptionRequest != null && message.hasOwnProperty("removeQuoteSubscriptionRequest")) {
                if (properties.data === 1)
                    return "data: multiple values";
                properties.data = 1;
                {
                    let error = $root.QuoteWSProtos.RemoveQuoteSubscriptionRequest.verify(message.removeQuoteSubscriptionRequest, long + 1);
                    if (error)
                        return "removeQuoteSubscriptionRequest." + error;
                }
            }
            if (message.PONG != null && message.hasOwnProperty("PONG")) {
                if (properties.data === 1)
                    return "data: multiple values";
                properties.data = 1;
                {
                    let error = $root.QuoteWSProtos.Pong.verify(message.PONG, long + 1);
                    if (error)
                        return "PONG." + error;
                }
            }
            return null;
        };

        /**
         * Creates a QuoteSocketRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.QuoteSocketRequest} QuoteSocketRequest
         */
        QuoteSocketRequest.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.QuoteSocketRequest)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteWSProtos.QuoteSocketRequest();
            if (object.addUpdateQuoteSubscriptionRequest != null) {
                if (typeof object.addUpdateQuoteSubscriptionRequest !== "object")
                    throw TypeError(".QuoteWSProtos.QuoteSocketRequest.addUpdateQuoteSubscriptionRequest: object expected");
                message.addUpdateQuoteSubscriptionRequest = $root.QuoteWSProtos.AddUpdateQuoteSubscriptionRequest.fromObject(object.addUpdateQuoteSubscriptionRequest, long + 1);
            }
            if (object.removeQuoteSubscriptionRequest != null) {
                if (typeof object.removeQuoteSubscriptionRequest !== "object")
                    throw TypeError(".QuoteWSProtos.QuoteSocketRequest.removeQuoteSubscriptionRequest: object expected");
                message.removeQuoteSubscriptionRequest = $root.QuoteWSProtos.RemoveQuoteSubscriptionRequest.fromObject(object.removeQuoteSubscriptionRequest, long + 1);
            }
            if (object.PONG != null) {
                if (typeof object.PONG !== "object")
                    throw TypeError(".QuoteWSProtos.QuoteSocketRequest.PONG: object expected");
                message.PONG = $root.QuoteWSProtos.Pong.fromObject(object.PONG, long + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a QuoteSocketRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @static
         * @param {QuoteWSProtos.QuoteSocketRequest} message QuoteSocketRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuoteSocketRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.addUpdateQuoteSubscriptionRequest != null && message.hasOwnProperty("addUpdateQuoteSubscriptionRequest")) {
                object.addUpdateQuoteSubscriptionRequest = $root.QuoteWSProtos.AddUpdateQuoteSubscriptionRequest.toObject(message.addUpdateQuoteSubscriptionRequest, options);
                if (options.oneofs)
                    object.data = "addUpdateQuoteSubscriptionRequest";
            }
            if (message.removeQuoteSubscriptionRequest != null && message.hasOwnProperty("removeQuoteSubscriptionRequest")) {
                object.removeQuoteSubscriptionRequest = $root.QuoteWSProtos.RemoveQuoteSubscriptionRequest.toObject(message.removeQuoteSubscriptionRequest, options);
                if (options.oneofs)
                    object.data = "removeQuoteSubscriptionRequest";
            }
            if (message.PONG != null && message.hasOwnProperty("PONG")) {
                object.PONG = $root.QuoteWSProtos.Pong.toObject(message.PONG, options);
                if (options.oneofs)
                    object.data = "PONG";
            }
            return object;
        };

        /**
         * Converts this QuoteSocketRequest to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.QuoteSocketRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuoteSocketRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return QuoteSocketRequest;
    })();

    QuoteWSProtos.QuoteSocketResponse = (function() {

        /**
         * Properties of a QuoteSocketResponse.
         * @memberof QuoteWSProtos
         * @interface IQuoteSocketResponse
         * @property {QuoteWSProtos.IQuoteResponse|null} [Quote] QuoteSocketResponse Quote
         * @property {QuoteWSProtos.ISubscribeConfResponse|null} [SubscribeQuotesResponse] QuoteSocketResponse SubscribeQuotesResponse
         * @property {QuoteWSProtos.ISubscribeConfResponse|null} [UnsubscribeQuotesResponse] QuoteSocketResponse UnsubscribeQuotesResponse
         * @property {QuoteWSProtos.IPing|null} [PING] QuoteSocketResponse PING
         * @property {QuoteWSProtos.IErrorResponse|null} [Error] QuoteSocketResponse Error
         */

        /**
         * Constructs a new QuoteSocketResponse.
         * @memberof QuoteWSProtos
         * @classdesc Represents a QuoteSocketResponse.
         * @implements IQuoteSocketResponse
         * @constructor
         * @param {QuoteWSProtos.IQuoteSocketResponse=} [properties] Properties to set
         */
        function QuoteSocketResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuoteSocketResponse Quote.
         * @member {QuoteWSProtos.IQuoteResponse|null|undefined} Quote
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @instance
         */
        QuoteSocketResponse.prototype.Quote = null;

        /**
         * QuoteSocketResponse SubscribeQuotesResponse.
         * @member {QuoteWSProtos.ISubscribeConfResponse|null|undefined} SubscribeQuotesResponse
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @instance
         */
        QuoteSocketResponse.prototype.SubscribeQuotesResponse = null;

        /**
         * QuoteSocketResponse UnsubscribeQuotesResponse.
         * @member {QuoteWSProtos.ISubscribeConfResponse|null|undefined} UnsubscribeQuotesResponse
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @instance
         */
        QuoteSocketResponse.prototype.UnsubscribeQuotesResponse = null;

        /**
         * QuoteSocketResponse PING.
         * @member {QuoteWSProtos.IPing|null|undefined} PING
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @instance
         */
        QuoteSocketResponse.prototype.PING = null;

        /**
         * QuoteSocketResponse Error.
         * @member {QuoteWSProtos.IErrorResponse|null|undefined} Error
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @instance
         */
        QuoteSocketResponse.prototype.Error = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * QuoteSocketResponse messageType.
         * @member {"Quote"|"SubscribeQuotesResponse"|"UnsubscribeQuotesResponse"|"PING"|"Error"|undefined} messageType
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @instance
         */
        Object.defineProperty(QuoteSocketResponse.prototype, "messageType", {
            get: $util.oneOfGetter($oneOfFields = ["Quote", "SubscribeQuotesResponse", "UnsubscribeQuotesResponse", "PING", "Error"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new QuoteSocketResponse instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @static
         * @param {QuoteWSProtos.IQuoteSocketResponse=} [properties] Properties to set
         * @returns {QuoteWSProtos.QuoteSocketResponse} QuoteSocketResponse instance
         */
        QuoteSocketResponse.create = function create(properties) {
            return new QuoteSocketResponse(properties);
        };

        /**
         * Encodes the specified QuoteSocketResponse message. Does not implicitly {@link QuoteWSProtos.QuoteSocketResponse.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @static
         * @param {QuoteWSProtos.IQuoteSocketResponse} message QuoteSocketResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteSocketResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Quote != null && Object.hasOwnProperty.call(message, "Quote"))
                $root.QuoteWSProtos.QuoteResponse.encode(message.Quote, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.SubscribeQuotesResponse != null && Object.hasOwnProperty.call(message, "SubscribeQuotesResponse"))
                $root.QuoteWSProtos.SubscribeConfResponse.encode(message.SubscribeQuotesResponse, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.UnsubscribeQuotesResponse != null && Object.hasOwnProperty.call(message, "UnsubscribeQuotesResponse"))
                $root.QuoteWSProtos.SubscribeConfResponse.encode(message.UnsubscribeQuotesResponse, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.PING != null && Object.hasOwnProperty.call(message, "PING"))
                $root.QuoteWSProtos.Ping.encode(message.PING, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.Error != null && Object.hasOwnProperty.call(message, "Error"))
                $root.QuoteWSProtos.ErrorResponse.encode(message.Error, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified QuoteSocketResponse message, length delimited. Does not implicitly {@link QuoteWSProtos.QuoteSocketResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @static
         * @param {QuoteWSProtos.IQuoteSocketResponse} message QuoteSocketResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteSocketResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteSocketResponse message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.QuoteSocketResponse} QuoteSocketResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteSocketResponse.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.QuoteSocketResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.Quote = $root.QuoteWSProtos.QuoteResponse.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 2: {
                        message.SubscribeQuotesResponse = $root.QuoteWSProtos.SubscribeConfResponse.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 3: {
                        message.UnsubscribeQuotesResponse = $root.QuoteWSProtos.SubscribeConfResponse.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 4: {
                        message.PING = $root.QuoteWSProtos.Ping.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 5: {
                        message.Error = $root.QuoteWSProtos.ErrorResponse.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuoteSocketResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.QuoteSocketResponse} QuoteSocketResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteSocketResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuoteSocketResponse message.
         * @function verify
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuoteSocketResponse.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            let properties = {};
            if (message.Quote != null && message.hasOwnProperty("Quote")) {
                properties.messageType = 1;
                {
                    let error = $root.QuoteWSProtos.QuoteResponse.verify(message.Quote, long + 1);
                    if (error)
                        return "Quote." + error;
                }
            }
            if (message.SubscribeQuotesResponse != null && message.hasOwnProperty("SubscribeQuotesResponse")) {
                if (properties.messageType === 1)
                    return "messageType: multiple values";
                properties.messageType = 1;
                {
                    let error = $root.QuoteWSProtos.SubscribeConfResponse.verify(message.SubscribeQuotesResponse, long + 1);
                    if (error)
                        return "SubscribeQuotesResponse." + error;
                }
            }
            if (message.UnsubscribeQuotesResponse != null && message.hasOwnProperty("UnsubscribeQuotesResponse")) {
                if (properties.messageType === 1)
                    return "messageType: multiple values";
                properties.messageType = 1;
                {
                    let error = $root.QuoteWSProtos.SubscribeConfResponse.verify(message.UnsubscribeQuotesResponse, long + 1);
                    if (error)
                        return "UnsubscribeQuotesResponse." + error;
                }
            }
            if (message.PING != null && message.hasOwnProperty("PING")) {
                if (properties.messageType === 1)
                    return "messageType: multiple values";
                properties.messageType = 1;
                {
                    let error = $root.QuoteWSProtos.Ping.verify(message.PING, long + 1);
                    if (error)
                        return "PING." + error;
                }
            }
            if (message.Error != null && message.hasOwnProperty("Error")) {
                if (properties.messageType === 1)
                    return "messageType: multiple values";
                properties.messageType = 1;
                {
                    let error = $root.QuoteWSProtos.ErrorResponse.verify(message.Error, long + 1);
                    if (error)
                        return "Error." + error;
                }
            }
            return null;
        };

        /**
         * Creates a QuoteSocketResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.QuoteSocketResponse} QuoteSocketResponse
         */
        QuoteSocketResponse.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.QuoteSocketResponse)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteWSProtos.QuoteSocketResponse();
            if (object.Quote != null) {
                if (typeof object.Quote !== "object")
                    throw TypeError(".QuoteWSProtos.QuoteSocketResponse.Quote: object expected");
                message.Quote = $root.QuoteWSProtos.QuoteResponse.fromObject(object.Quote, long + 1);
            }
            if (object.SubscribeQuotesResponse != null) {
                if (typeof object.SubscribeQuotesResponse !== "object")
                    throw TypeError(".QuoteWSProtos.QuoteSocketResponse.SubscribeQuotesResponse: object expected");
                message.SubscribeQuotesResponse = $root.QuoteWSProtos.SubscribeConfResponse.fromObject(object.SubscribeQuotesResponse, long + 1);
            }
            if (object.UnsubscribeQuotesResponse != null) {
                if (typeof object.UnsubscribeQuotesResponse !== "object")
                    throw TypeError(".QuoteWSProtos.QuoteSocketResponse.UnsubscribeQuotesResponse: object expected");
                message.UnsubscribeQuotesResponse = $root.QuoteWSProtos.SubscribeConfResponse.fromObject(object.UnsubscribeQuotesResponse, long + 1);
            }
            if (object.PING != null) {
                if (typeof object.PING !== "object")
                    throw TypeError(".QuoteWSProtos.QuoteSocketResponse.PING: object expected");
                message.PING = $root.QuoteWSProtos.Ping.fromObject(object.PING, long + 1);
            }
            if (object.Error != null) {
                if (typeof object.Error !== "object")
                    throw TypeError(".QuoteWSProtos.QuoteSocketResponse.Error: object expected");
                message.Error = $root.QuoteWSProtos.ErrorResponse.fromObject(object.Error, long + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a QuoteSocketResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @static
         * @param {QuoteWSProtos.QuoteSocketResponse} message QuoteSocketResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuoteSocketResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.Quote != null && message.hasOwnProperty("Quote")) {
                object.Quote = $root.QuoteWSProtos.QuoteResponse.toObject(message.Quote, options);
                if (options.oneofs)
                    object.messageType = "Quote";
            }
            if (message.SubscribeQuotesResponse != null && message.hasOwnProperty("SubscribeQuotesResponse")) {
                object.SubscribeQuotesResponse = $root.QuoteWSProtos.SubscribeConfResponse.toObject(message.SubscribeQuotesResponse, options);
                if (options.oneofs)
                    object.messageType = "SubscribeQuotesResponse";
            }
            if (message.UnsubscribeQuotesResponse != null && message.hasOwnProperty("UnsubscribeQuotesResponse")) {
                object.UnsubscribeQuotesResponse = $root.QuoteWSProtos.SubscribeConfResponse.toObject(message.UnsubscribeQuotesResponse, options);
                if (options.oneofs)
                    object.messageType = "UnsubscribeQuotesResponse";
            }
            if (message.PING != null && message.hasOwnProperty("PING")) {
                object.PING = $root.QuoteWSProtos.Ping.toObject(message.PING, options);
                if (options.oneofs)
                    object.messageType = "PING";
            }
            if (message.Error != null && message.hasOwnProperty("Error")) {
                object.Error = $root.QuoteWSProtos.ErrorResponse.toObject(message.Error, options);
                if (options.oneofs)
                    object.messageType = "Error";
            }
            return object;
        };

        /**
         * Converts this QuoteSocketResponse to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.QuoteSocketResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuoteSocketResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return QuoteSocketResponse;
    })();

    QuoteWSProtos.SubscribeConfResponse = (function() {

        /**
         * Properties of a SubscribeConfResponse.
         * @memberof QuoteWSProtos
         * @interface ISubscribeConfResponse
         * @property {string|null} [symbol] SubscribeConfResponse symbol
         * @property {number|null} [SUCCESS] SubscribeConfResponse SUCCESS
         * @property {number|null} [NO_CONTENT] SubscribeConfResponse NO_CONTENT
         * @property {QuoteWSProtos.IErrorResponse|null} [BAD_REQUEST] SubscribeConfResponse BAD_REQUEST
         * @property {QuoteWSProtos.IErrorResponse|null} [UNAUTHORISED] SubscribeConfResponse UNAUTHORISED
         * @property {QuoteWSProtos.IErrorResponse|null} [FORBIDDEN] SubscribeConfResponse FORBIDDEN
         * @property {QuoteWSProtos.IErrorResponse|null} [INTERNAL_SERVER_ERROR] SubscribeConfResponse INTERNAL_SERVER_ERROR
         */

        /**
         * Constructs a new SubscribeConfResponse.
         * @memberof QuoteWSProtos
         * @classdesc Represents a SubscribeConfResponse.
         * @implements ISubscribeConfResponse
         * @constructor
         * @param {QuoteWSProtos.ISubscribeConfResponse=} [properties] Properties to set
         */
        function SubscribeConfResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SubscribeConfResponse symbol.
         * @member {string} symbol
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @instance
         */
        SubscribeConfResponse.prototype.symbol = "";

        /**
         * SubscribeConfResponse SUCCESS.
         * @member {number} SUCCESS
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @instance
         */
        SubscribeConfResponse.prototype.SUCCESS = 0;

        /**
         * SubscribeConfResponse NO_CONTENT.
         * @member {number} NO_CONTENT
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @instance
         */
        SubscribeConfResponse.prototype.NO_CONTENT = 0;

        /**
         * SubscribeConfResponse BAD_REQUEST.
         * @member {QuoteWSProtos.IErrorResponse|null|undefined} BAD_REQUEST
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @instance
         */
        SubscribeConfResponse.prototype.BAD_REQUEST = null;

        /**
         * SubscribeConfResponse UNAUTHORISED.
         * @member {QuoteWSProtos.IErrorResponse|null|undefined} UNAUTHORISED
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @instance
         */
        SubscribeConfResponse.prototype.UNAUTHORISED = null;

        /**
         * SubscribeConfResponse FORBIDDEN.
         * @member {QuoteWSProtos.IErrorResponse|null|undefined} FORBIDDEN
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @instance
         */
        SubscribeConfResponse.prototype.FORBIDDEN = null;

        /**
         * SubscribeConfResponse INTERNAL_SERVER_ERROR.
         * @member {QuoteWSProtos.IErrorResponse|null|undefined} INTERNAL_SERVER_ERROR
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @instance
         */
        SubscribeConfResponse.prototype.INTERNAL_SERVER_ERROR = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * SubscribeConfResponse statusCode.
         * @member {"SUCCESS"|"NO_CONTENT"|"BAD_REQUEST"|"UNAUTHORISED"|"FORBIDDEN"|"INTERNAL_SERVER_ERROR"|undefined} statusCode
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @instance
         */
        Object.defineProperty(SubscribeConfResponse.prototype, "statusCode", {
            get: $util.oneOfGetter($oneOfFields = ["SUCCESS", "NO_CONTENT", "BAD_REQUEST", "UNAUTHORISED", "FORBIDDEN", "INTERNAL_SERVER_ERROR"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SubscribeConfResponse instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @static
         * @param {QuoteWSProtos.ISubscribeConfResponse=} [properties] Properties to set
         * @returns {QuoteWSProtos.SubscribeConfResponse} SubscribeConfResponse instance
         */
        SubscribeConfResponse.create = function create(properties) {
            return new SubscribeConfResponse(properties);
        };

        /**
         * Encodes the specified SubscribeConfResponse message. Does not implicitly {@link QuoteWSProtos.SubscribeConfResponse.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @static
         * @param {QuoteWSProtos.ISubscribeConfResponse} message SubscribeConfResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SubscribeConfResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
            if (message.SUCCESS != null && Object.hasOwnProperty.call(message, "SUCCESS"))
                writer.uint32(/* id 200, wireType 0 =*/1600).int32(message.SUCCESS);
            if (message.NO_CONTENT != null && Object.hasOwnProperty.call(message, "NO_CONTENT"))
                writer.uint32(/* id 204, wireType 0 =*/1632).int32(message.NO_CONTENT);
            if (message.BAD_REQUEST != null && Object.hasOwnProperty.call(message, "BAD_REQUEST"))
                $root.QuoteWSProtos.ErrorResponse.encode(message.BAD_REQUEST, writer.uint32(/* id 400, wireType 2 =*/3202).fork()).ldelim();
            if (message.UNAUTHORISED != null && Object.hasOwnProperty.call(message, "UNAUTHORISED"))
                $root.QuoteWSProtos.ErrorResponse.encode(message.UNAUTHORISED, writer.uint32(/* id 401, wireType 2 =*/3210).fork()).ldelim();
            if (message.FORBIDDEN != null && Object.hasOwnProperty.call(message, "FORBIDDEN"))
                $root.QuoteWSProtos.ErrorResponse.encode(message.FORBIDDEN, writer.uint32(/* id 403, wireType 2 =*/3226).fork()).ldelim();
            if (message.INTERNAL_SERVER_ERROR != null && Object.hasOwnProperty.call(message, "INTERNAL_SERVER_ERROR"))
                $root.QuoteWSProtos.ErrorResponse.encode(message.INTERNAL_SERVER_ERROR, writer.uint32(/* id 500, wireType 2 =*/4002).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SubscribeConfResponse message, length delimited. Does not implicitly {@link QuoteWSProtos.SubscribeConfResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @static
         * @param {QuoteWSProtos.ISubscribeConfResponse} message SubscribeConfResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SubscribeConfResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SubscribeConfResponse message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.SubscribeConfResponse} SubscribeConfResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SubscribeConfResponse.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.SubscribeConfResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.symbol = reader.string();
                        break;
                    }
                case 200: {
                        message.SUCCESS = reader.int32();
                        break;
                    }
                case 204: {
                        message.NO_CONTENT = reader.int32();
                        break;
                    }
                case 400: {
                        message.BAD_REQUEST = $root.QuoteWSProtos.ErrorResponse.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 401: {
                        message.UNAUTHORISED = $root.QuoteWSProtos.ErrorResponse.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 403: {
                        message.FORBIDDEN = $root.QuoteWSProtos.ErrorResponse.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 500: {
                        message.INTERNAL_SERVER_ERROR = $root.QuoteWSProtos.ErrorResponse.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SubscribeConfResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.SubscribeConfResponse} SubscribeConfResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SubscribeConfResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SubscribeConfResponse message.
         * @function verify
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SubscribeConfResponse.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            let properties = {};
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.SUCCESS != null && message.hasOwnProperty("SUCCESS")) {
                properties.statusCode = 1;
                if (!$util.isInteger(message.SUCCESS))
                    return "SUCCESS: integer expected";
            }
            if (message.NO_CONTENT != null && message.hasOwnProperty("NO_CONTENT")) {
                if (properties.statusCode === 1)
                    return "statusCode: multiple values";
                properties.statusCode = 1;
                if (!$util.isInteger(message.NO_CONTENT))
                    return "NO_CONTENT: integer expected";
            }
            if (message.BAD_REQUEST != null && message.hasOwnProperty("BAD_REQUEST")) {
                if (properties.statusCode === 1)
                    return "statusCode: multiple values";
                properties.statusCode = 1;
                {
                    let error = $root.QuoteWSProtos.ErrorResponse.verify(message.BAD_REQUEST, long + 1);
                    if (error)
                        return "BAD_REQUEST." + error;
                }
            }
            if (message.UNAUTHORISED != null && message.hasOwnProperty("UNAUTHORISED")) {
                if (properties.statusCode === 1)
                    return "statusCode: multiple values";
                properties.statusCode = 1;
                {
                    let error = $root.QuoteWSProtos.ErrorResponse.verify(message.UNAUTHORISED, long + 1);
                    if (error)
                        return "UNAUTHORISED." + error;
                }
            }
            if (message.FORBIDDEN != null && message.hasOwnProperty("FORBIDDEN")) {
                if (properties.statusCode === 1)
                    return "statusCode: multiple values";
                properties.statusCode = 1;
                {
                    let error = $root.QuoteWSProtos.ErrorResponse.verify(message.FORBIDDEN, long + 1);
                    if (error)
                        return "FORBIDDEN." + error;
                }
            }
            if (message.INTERNAL_SERVER_ERROR != null && message.hasOwnProperty("INTERNAL_SERVER_ERROR")) {
                if (properties.statusCode === 1)
                    return "statusCode: multiple values";
                properties.statusCode = 1;
                {
                    let error = $root.QuoteWSProtos.ErrorResponse.verify(message.INTERNAL_SERVER_ERROR, long + 1);
                    if (error)
                        return "INTERNAL_SERVER_ERROR." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SubscribeConfResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.SubscribeConfResponse} SubscribeConfResponse
         */
        SubscribeConfResponse.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.SubscribeConfResponse)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteWSProtos.SubscribeConfResponse();
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            if (object.SUCCESS != null)
                message.SUCCESS = object.SUCCESS | 0;
            if (object.NO_CONTENT != null)
                message.NO_CONTENT = object.NO_CONTENT | 0;
            if (object.BAD_REQUEST != null) {
                if (typeof object.BAD_REQUEST !== "object")
                    throw TypeError(".QuoteWSProtos.SubscribeConfResponse.BAD_REQUEST: object expected");
                message.BAD_REQUEST = $root.QuoteWSProtos.ErrorResponse.fromObject(object.BAD_REQUEST, long + 1);
            }
            if (object.UNAUTHORISED != null) {
                if (typeof object.UNAUTHORISED !== "object")
                    throw TypeError(".QuoteWSProtos.SubscribeConfResponse.UNAUTHORISED: object expected");
                message.UNAUTHORISED = $root.QuoteWSProtos.ErrorResponse.fromObject(object.UNAUTHORISED, long + 1);
            }
            if (object.FORBIDDEN != null) {
                if (typeof object.FORBIDDEN !== "object")
                    throw TypeError(".QuoteWSProtos.SubscribeConfResponse.FORBIDDEN: object expected");
                message.FORBIDDEN = $root.QuoteWSProtos.ErrorResponse.fromObject(object.FORBIDDEN, long + 1);
            }
            if (object.INTERNAL_SERVER_ERROR != null) {
                if (typeof object.INTERNAL_SERVER_ERROR !== "object")
                    throw TypeError(".QuoteWSProtos.SubscribeConfResponse.INTERNAL_SERVER_ERROR: object expected");
                message.INTERNAL_SERVER_ERROR = $root.QuoteWSProtos.ErrorResponse.fromObject(object.INTERNAL_SERVER_ERROR, long + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a SubscribeConfResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @static
         * @param {QuoteWSProtos.SubscribeConfResponse} message SubscribeConfResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SubscribeConfResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.symbol = "";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.SUCCESS != null && message.hasOwnProperty("SUCCESS")) {
                object.SUCCESS = message.SUCCESS;
                if (options.oneofs)
                    object.statusCode = "SUCCESS";
            }
            if (message.NO_CONTENT != null && message.hasOwnProperty("NO_CONTENT")) {
                object.NO_CONTENT = message.NO_CONTENT;
                if (options.oneofs)
                    object.statusCode = "NO_CONTENT";
            }
            if (message.BAD_REQUEST != null && message.hasOwnProperty("BAD_REQUEST")) {
                object.BAD_REQUEST = $root.QuoteWSProtos.ErrorResponse.toObject(message.BAD_REQUEST, options);
                if (options.oneofs)
                    object.statusCode = "BAD_REQUEST";
            }
            if (message.UNAUTHORISED != null && message.hasOwnProperty("UNAUTHORISED")) {
                object.UNAUTHORISED = $root.QuoteWSProtos.ErrorResponse.toObject(message.UNAUTHORISED, options);
                if (options.oneofs)
                    object.statusCode = "UNAUTHORISED";
            }
            if (message.FORBIDDEN != null && message.hasOwnProperty("FORBIDDEN")) {
                object.FORBIDDEN = $root.QuoteWSProtos.ErrorResponse.toObject(message.FORBIDDEN, options);
                if (options.oneofs)
                    object.statusCode = "FORBIDDEN";
            }
            if (message.INTERNAL_SERVER_ERROR != null && message.hasOwnProperty("INTERNAL_SERVER_ERROR")) {
                object.INTERNAL_SERVER_ERROR = $root.QuoteWSProtos.ErrorResponse.toObject(message.INTERNAL_SERVER_ERROR, options);
                if (options.oneofs)
                    object.statusCode = "INTERNAL_SERVER_ERROR";
            }
            return object;
        };

        /**
         * Converts this SubscribeConfResponse to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.SubscribeConfResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SubscribeConfResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SubscribeConfResponse;
    })();

    QuoteWSProtos.Result = (function() {

        /**
         * Properties of a Result.
         * @memberof QuoteWSProtos
         * @interface IResult
         * @property {string|null} [code] Result code
         * @property {string|null} [message] Result message
         */

        /**
         * Constructs a new Result.
         * @memberof QuoteWSProtos
         * @classdesc Represents a Result.
         * @implements IResult
         * @constructor
         * @param {QuoteWSProtos.IResult=} [properties] Properties to set
         */
        function Result(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Result code.
         * @member {string} code
         * @memberof QuoteWSProtos.Result
         * @instance
         */
        Result.prototype.code = "";

        /**
         * Result message.
         * @member {string} message
         * @memberof QuoteWSProtos.Result
         * @instance
         */
        Result.prototype.message = "";

        /**
         * Creates a new Result instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.Result
         * @static
         * @param {QuoteWSProtos.IResult=} [properties] Properties to set
         * @returns {QuoteWSProtos.Result} Result instance
         */
        Result.create = function create(properties) {
            return new Result(properties);
        };

        /**
         * Encodes the specified Result message. Does not implicitly {@link QuoteWSProtos.Result.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.Result
         * @static
         * @param {QuoteWSProtos.IResult} message Result message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Result.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.code);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified Result message, length delimited. Does not implicitly {@link QuoteWSProtos.Result.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.Result
         * @static
         * @param {QuoteWSProtos.IResult} message Result message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Result.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Result message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.Result
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.Result} Result
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Result.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.Result();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.string();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Result message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.Result
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.Result} Result
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Result.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Result message.
         * @function verify
         * @memberof QuoteWSProtos.Result
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Result.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isString(message.code))
                    return "code: string expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a Result message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.Result
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.Result} Result
         */
        Result.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.Result)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteWSProtos.Result();
            if (object.code != null)
                message.code = String(object.code);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a Result message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.Result
         * @static
         * @param {QuoteWSProtos.Result} message Result
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Result.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.code = "";
                object.message = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this Result to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.Result
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Result.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Result;
    })();

    QuoteWSProtos.ErrorResponse = (function() {

        /**
         * Properties of an ErrorResponse.
         * @memberof QuoteWSProtos
         * @interface IErrorResponse
         * @property {QuoteWSProtos.IResult|null} [result] ErrorResponse result
         * @property {Array.<string>|null} [errors] ErrorResponse errors
         */

        /**
         * Constructs a new ErrorResponse.
         * @memberof QuoteWSProtos
         * @classdesc Represents an ErrorResponse.
         * @implements IErrorResponse
         * @constructor
         * @param {QuoteWSProtos.IErrorResponse=} [properties] Properties to set
         */
        function ErrorResponse(properties) {
            this.errors = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ErrorResponse result.
         * @member {QuoteWSProtos.IResult|null|undefined} result
         * @memberof QuoteWSProtos.ErrorResponse
         * @instance
         */
        ErrorResponse.prototype.result = null;

        /**
         * ErrorResponse errors.
         * @member {Array.<string>} errors
         * @memberof QuoteWSProtos.ErrorResponse
         * @instance
         */
        ErrorResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new ErrorResponse instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.ErrorResponse
         * @static
         * @param {QuoteWSProtos.IErrorResponse=} [properties] Properties to set
         * @returns {QuoteWSProtos.ErrorResponse} ErrorResponse instance
         */
        ErrorResponse.create = function create(properties) {
            return new ErrorResponse(properties);
        };

        /**
         * Encodes the specified ErrorResponse message. Does not implicitly {@link QuoteWSProtos.ErrorResponse.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.ErrorResponse
         * @static
         * @param {QuoteWSProtos.IErrorResponse} message ErrorResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ErrorResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                $root.QuoteWSProtos.Result.encode(message.result, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.errors != null && message.errors.length)
                for (let i = 0; i < message.errors.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.errors[i]);
            return writer;
        };

        /**
         * Encodes the specified ErrorResponse message, length delimited. Does not implicitly {@link QuoteWSProtos.ErrorResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.ErrorResponse
         * @static
         * @param {QuoteWSProtos.IErrorResponse} message ErrorResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ErrorResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ErrorResponse message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.ErrorResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.ErrorResponse} ErrorResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ErrorResponse.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.ErrorResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.result = $root.QuoteWSProtos.Result.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                case 2: {
                        if (!(message.errors && message.errors.length))
                            message.errors = [];
                        message.errors.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ErrorResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.ErrorResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.ErrorResponse} ErrorResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ErrorResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ErrorResponse message.
         * @function verify
         * @memberof QuoteWSProtos.ErrorResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ErrorResponse.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.result != null && message.hasOwnProperty("result")) {
                let error = $root.QuoteWSProtos.Result.verify(message.result, long + 1);
                if (error)
                    return "result." + error;
            }
            if (message.errors != null && message.hasOwnProperty("errors")) {
                if (!Array.isArray(message.errors))
                    return "errors: array expected";
                for (let i = 0; i < message.errors.length; ++i)
                    if (!$util.isString(message.errors[i]))
                        return "errors: string[] expected";
            }
            return null;
        };

        /**
         * Creates an ErrorResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.ErrorResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.ErrorResponse} ErrorResponse
         */
        ErrorResponse.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.ErrorResponse)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteWSProtos.ErrorResponse();
            if (object.result != null) {
                if (typeof object.result !== "object")
                    throw TypeError(".QuoteWSProtos.ErrorResponse.result: object expected");
                message.result = $root.QuoteWSProtos.Result.fromObject(object.result, long + 1);
            }
            if (object.errors) {
                if (!Array.isArray(object.errors))
                    throw TypeError(".QuoteWSProtos.ErrorResponse.errors: array expected");
                message.errors = [];
                for (let i = 0; i < object.errors.length; ++i)
                    message.errors[i] = String(object.errors[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an ErrorResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.ErrorResponse
         * @static
         * @param {QuoteWSProtos.ErrorResponse} message ErrorResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ErrorResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.errors = [];
            if (options.defaults)
                object.result = null;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = $root.QuoteWSProtos.Result.toObject(message.result, options);
            if (message.errors && message.errors.length) {
                object.errors = [];
                for (let j = 0; j < message.errors.length; ++j)
                    object.errors[j] = message.errors[j];
            }
            return object;
        };

        /**
         * Converts this ErrorResponse to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.ErrorResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ErrorResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ErrorResponse;
    })();

    QuoteWSProtos.QuoteResponse = (function() {

        /**
         * Properties of a QuoteResponse.
         * @memberof QuoteWSProtos
         * @interface IQuoteResponse
         * @property {QuoteProtos.IQuote|null} [quote] QuoteResponse quote
         */

        /**
         * Constructs a new QuoteResponse.
         * @memberof QuoteWSProtos
         * @classdesc Represents a QuoteResponse.
         * @implements IQuoteResponse
         * @constructor
         * @param {QuoteWSProtos.IQuoteResponse=} [properties] Properties to set
         */
        function QuoteResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuoteResponse quote.
         * @member {QuoteProtos.IQuote|null|undefined} quote
         * @memberof QuoteWSProtos.QuoteResponse
         * @instance
         */
        QuoteResponse.prototype.quote = null;

        /**
         * Creates a new QuoteResponse instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.QuoteResponse
         * @static
         * @param {QuoteWSProtos.IQuoteResponse=} [properties] Properties to set
         * @returns {QuoteWSProtos.QuoteResponse} QuoteResponse instance
         */
        QuoteResponse.create = function create(properties) {
            return new QuoteResponse(properties);
        };

        /**
         * Encodes the specified QuoteResponse message. Does not implicitly {@link QuoteWSProtos.QuoteResponse.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.QuoteResponse
         * @static
         * @param {QuoteWSProtos.IQuoteResponse} message QuoteResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.quote != null && Object.hasOwnProperty.call(message, "quote"))
                $root.QuoteProtos.Quote.encode(message.quote, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified QuoteResponse message, length delimited. Does not implicitly {@link QuoteWSProtos.QuoteResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.QuoteResponse
         * @static
         * @param {QuoteWSProtos.IQuoteResponse} message QuoteResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteResponse message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.QuoteResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.QuoteResponse} QuoteResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteResponse.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.QuoteResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.quote = $root.QuoteProtos.Quote.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuoteResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.QuoteResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.QuoteResponse} QuoteResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuoteResponse message.
         * @function verify
         * @memberof QuoteWSProtos.QuoteResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuoteResponse.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.quote != null && message.hasOwnProperty("quote")) {
                let error = $root.QuoteProtos.Quote.verify(message.quote, long + 1);
                if (error)
                    return "quote." + error;
            }
            return null;
        };

        /**
         * Creates a QuoteResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.QuoteResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.QuoteResponse} QuoteResponse
         */
        QuoteResponse.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.QuoteResponse)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteWSProtos.QuoteResponse();
            if (object.quote != null) {
                if (typeof object.quote !== "object")
                    throw TypeError(".QuoteWSProtos.QuoteResponse.quote: object expected");
                message.quote = $root.QuoteProtos.Quote.fromObject(object.quote, long + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a QuoteResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.QuoteResponse
         * @static
         * @param {QuoteWSProtos.QuoteResponse} message QuoteResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuoteResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.quote = null;
            if (message.quote != null && message.hasOwnProperty("quote"))
                object.quote = $root.QuoteProtos.Quote.toObject(message.quote, options);
            return object;
        };

        /**
         * Converts this QuoteResponse to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.QuoteResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuoteResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return QuoteResponse;
    })();

    QuoteWSProtos.Ping = (function() {

        /**
         * Properties of a Ping.
         * @memberof QuoteWSProtos
         * @interface IPing
         */

        /**
         * Constructs a new Ping.
         * @memberof QuoteWSProtos
         * @classdesc Represents a Ping.
         * @implements IPing
         * @constructor
         * @param {QuoteWSProtos.IPing=} [properties] Properties to set
         */
        function Ping(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Ping instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.Ping
         * @static
         * @param {QuoteWSProtos.IPing=} [properties] Properties to set
         * @returns {QuoteWSProtos.Ping} Ping instance
         */
        Ping.create = function create(properties) {
            return new Ping(properties);
        };

        /**
         * Encodes the specified Ping message. Does not implicitly {@link QuoteWSProtos.Ping.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.Ping
         * @static
         * @param {QuoteWSProtos.IPing} message Ping message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ping.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Ping message, length delimited. Does not implicitly {@link QuoteWSProtos.Ping.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.Ping
         * @static
         * @param {QuoteWSProtos.IPing} message Ping message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ping.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Ping message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.Ping
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.Ping} Ping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ping.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.Ping();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Ping message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.Ping
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.Ping} Ping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ping.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Ping message.
         * @function verify
         * @memberof QuoteWSProtos.Ping
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Ping.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            return null;
        };

        /**
         * Creates a Ping message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.Ping
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.Ping} Ping
         */
        Ping.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.Ping)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            return new $root.QuoteWSProtos.Ping();
        };

        /**
         * Creates a plain object from a Ping message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.Ping
         * @static
         * @param {QuoteWSProtos.Ping} message Ping
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Ping.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Ping to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.Ping
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Ping.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Ping;
    })();

    QuoteWSProtos.Pong = (function() {

        /**
         * Properties of a Pong.
         * @memberof QuoteWSProtos
         * @interface IPong
         */

        /**
         * Constructs a new Pong.
         * @memberof QuoteWSProtos
         * @classdesc Represents a Pong.
         * @implements IPong
         * @constructor
         * @param {QuoteWSProtos.IPong=} [properties] Properties to set
         */
        function Pong(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Pong instance using the specified properties.
         * @function create
         * @memberof QuoteWSProtos.Pong
         * @static
         * @param {QuoteWSProtos.IPong=} [properties] Properties to set
         * @returns {QuoteWSProtos.Pong} Pong instance
         */
        Pong.create = function create(properties) {
            return new Pong(properties);
        };

        /**
         * Encodes the specified Pong message. Does not implicitly {@link QuoteWSProtos.Pong.verify|verify} messages.
         * @function encode
         * @memberof QuoteWSProtos.Pong
         * @static
         * @param {QuoteWSProtos.IPong} message Pong message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pong.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Pong message, length delimited. Does not implicitly {@link QuoteWSProtos.Pong.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteWSProtos.Pong
         * @static
         * @param {QuoteWSProtos.IPong} message Pong message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pong.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Pong message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteWSProtos.Pong
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteWSProtos.Pong} Pong
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pong.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteWSProtos.Pong();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Pong message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteWSProtos.Pong
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteWSProtos.Pong} Pong
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pong.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Pong message.
         * @function verify
         * @memberof QuoteWSProtos.Pong
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Pong.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            return null;
        };

        /**
         * Creates a Pong message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteWSProtos.Pong
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteWSProtos.Pong} Pong
         */
        Pong.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteWSProtos.Pong)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            return new $root.QuoteWSProtos.Pong();
        };

        /**
         * Creates a plain object from a Pong message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteWSProtos.Pong
         * @static
         * @param {QuoteWSProtos.Pong} message Pong
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Pong.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Pong to JSON.
         * @function toJSON
         * @memberof QuoteWSProtos.Pong
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Pong.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Pong;
    })();

    return QuoteWSProtos;
})();

export const QuoteProtos = $root.QuoteProtos = (() => {

    /**
     * Namespace QuoteProtos.
     * @exports QuoteProtos
     * @namespace
     */
    const QuoteProtos = {};

    /**
     * SessionType enum.
     * @name QuoteProtos.SessionType
     * @enum {number}
     * @property {number} NA=0 NA value
     * @property {number} PRE_MARKET=1 PRE_MARKET value
     * @property {number} REGULAR=2 REGULAR value
     * @property {number} AFTER_MARKET=3 AFTER_MARKET value
     */
    QuoteProtos.SessionType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NA"] = 0;
        values[valuesById[1] = "PRE_MARKET"] = 1;
        values[valuesById[2] = "REGULAR"] = 2;
        values[valuesById[3] = "AFTER_MARKET"] = 3;
        return values;
    })();

    /**
     * TickType enum.
     * @name QuoteProtos.TickType
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} VALID=1 VALID value
     * @property {number} IN_VALID=2 IN_VALID value
     */
    QuoteProtos.TickType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "VALID"] = 1;
        values[valuesById[2] = "IN_VALID"] = 2;
        return values;
    })();

    /**
     * QuoteSource enum.
     * @name QuoteProtos.QuoteSource
     * @enum {number}
     * @property {number} UNKNOWN_SOURCE=0 UNKNOWN_SOURCE value
     * @property {number} QUOTE_STORE=1 QUOTE_STORE value
     * @property {number} QUOTE_CALCULATOR=2 QUOTE_CALCULATOR value
     * @property {number} POLLED_DATA=3 POLLED_DATA value
     * @property {number} ROLLING_FIELDS=4 ROLLING_FIELDS value
     * @property {number} RSI_FIELDS=5 RSI_FIELDS value
     * @property {number} CONTENT_EVENT_PUBLISHER=6 CONTENT_EVENT_PUBLISHER value
     * @property {number} SWAP=7 SWAP value
     * @property {number} VWAP_CALCULATOR=8 VWAP_CALCULATOR value
     */
    QuoteProtos.QuoteSource = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_SOURCE"] = 0;
        values[valuesById[1] = "QUOTE_STORE"] = 1;
        values[valuesById[2] = "QUOTE_CALCULATOR"] = 2;
        values[valuesById[3] = "POLLED_DATA"] = 3;
        values[valuesById[4] = "ROLLING_FIELDS"] = 4;
        values[valuesById[5] = "RSI_FIELDS"] = 5;
        values[valuesById[6] = "CONTENT_EVENT_PUBLISHER"] = 6;
        values[valuesById[7] = "SWAP"] = 7;
        values[valuesById[8] = "VWAP_CALCULATOR"] = 8;
        return values;
    })();

    QuoteProtos.QuoteSeedRequest = (function() {

        /**
         * Properties of a QuoteSeedRequest.
         * @memberof QuoteProtos
         * @interface IQuoteSeedRequest
         * @property {string|null} [reqId] QuoteSeedRequest reqId
         * @property {Array.<string>|null} [symbols] QuoteSeedRequest symbols
         * @property {boolean|null} [seedAll] QuoteSeedRequest seedAll
         */

        /**
         * Constructs a new QuoteSeedRequest.
         * @memberof QuoteProtos
         * @classdesc Represents a QuoteSeedRequest.
         * @implements IQuoteSeedRequest
         * @constructor
         * @param {QuoteProtos.IQuoteSeedRequest=} [properties] Properties to set
         */
        function QuoteSeedRequest(properties) {
            this.symbols = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuoteSeedRequest reqId.
         * @member {string} reqId
         * @memberof QuoteProtos.QuoteSeedRequest
         * @instance
         */
        QuoteSeedRequest.prototype.reqId = "";

        /**
         * QuoteSeedRequest symbols.
         * @member {Array.<string>} symbols
         * @memberof QuoteProtos.QuoteSeedRequest
         * @instance
         */
        QuoteSeedRequest.prototype.symbols = $util.emptyArray;

        /**
         * QuoteSeedRequest seedAll.
         * @member {boolean} seedAll
         * @memberof QuoteProtos.QuoteSeedRequest
         * @instance
         */
        QuoteSeedRequest.prototype.seedAll = false;

        /**
         * Creates a new QuoteSeedRequest instance using the specified properties.
         * @function create
         * @memberof QuoteProtos.QuoteSeedRequest
         * @static
         * @param {QuoteProtos.IQuoteSeedRequest=} [properties] Properties to set
         * @returns {QuoteProtos.QuoteSeedRequest} QuoteSeedRequest instance
         */
        QuoteSeedRequest.create = function create(properties) {
            return new QuoteSeedRequest(properties);
        };

        /**
         * Encodes the specified QuoteSeedRequest message. Does not implicitly {@link QuoteProtos.QuoteSeedRequest.verify|verify} messages.
         * @function encode
         * @memberof QuoteProtos.QuoteSeedRequest
         * @static
         * @param {QuoteProtos.IQuoteSeedRequest} message QuoteSeedRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteSeedRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.reqId != null && Object.hasOwnProperty.call(message, "reqId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.reqId);
            if (message.symbols != null && message.symbols.length)
                for (let i = 0; i < message.symbols.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.symbols[i]);
            if (message.seedAll != null && Object.hasOwnProperty.call(message, "seedAll"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.seedAll);
            return writer;
        };

        /**
         * Encodes the specified QuoteSeedRequest message, length delimited. Does not implicitly {@link QuoteProtos.QuoteSeedRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteProtos.QuoteSeedRequest
         * @static
         * @param {QuoteProtos.IQuoteSeedRequest} message QuoteSeedRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteSeedRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteSeedRequest message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteProtos.QuoteSeedRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteProtos.QuoteSeedRequest} QuoteSeedRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteSeedRequest.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteProtos.QuoteSeedRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.reqId = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.symbols && message.symbols.length))
                            message.symbols = [];
                        message.symbols.push(reader.string());
                        break;
                    }
                case 3: {
                        message.seedAll = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuoteSeedRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteProtos.QuoteSeedRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteProtos.QuoteSeedRequest} QuoteSeedRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteSeedRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuoteSeedRequest message.
         * @function verify
         * @memberof QuoteProtos.QuoteSeedRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuoteSeedRequest.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.reqId != null && message.hasOwnProperty("reqId"))
                if (!$util.isString(message.reqId))
                    return "reqId: string expected";
            if (message.symbols != null && message.hasOwnProperty("symbols")) {
                if (!Array.isArray(message.symbols))
                    return "symbols: array expected";
                for (let i = 0; i < message.symbols.length; ++i)
                    if (!$util.isString(message.symbols[i]))
                        return "symbols: string[] expected";
            }
            if (message.seedAll != null && message.hasOwnProperty("seedAll"))
                if (typeof message.seedAll !== "boolean")
                    return "seedAll: boolean expected";
            return null;
        };

        /**
         * Creates a QuoteSeedRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteProtos.QuoteSeedRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteProtos.QuoteSeedRequest} QuoteSeedRequest
         */
        QuoteSeedRequest.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteProtos.QuoteSeedRequest)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteProtos.QuoteSeedRequest();
            if (object.reqId != null)
                message.reqId = String(object.reqId);
            if (object.symbols) {
                if (!Array.isArray(object.symbols))
                    throw TypeError(".QuoteProtos.QuoteSeedRequest.symbols: array expected");
                message.symbols = [];
                for (let i = 0; i < object.symbols.length; ++i)
                    message.symbols[i] = String(object.symbols[i]);
            }
            if (object.seedAll != null)
                message.seedAll = Boolean(object.seedAll);
            return message;
        };

        /**
         * Creates a plain object from a QuoteSeedRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteProtos.QuoteSeedRequest
         * @static
         * @param {QuoteProtos.QuoteSeedRequest} message QuoteSeedRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuoteSeedRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.symbols = [];
            if (options.defaults) {
                object.reqId = "";
                object.seedAll = false;
            }
            if (message.reqId != null && message.hasOwnProperty("reqId"))
                object.reqId = message.reqId;
            if (message.symbols && message.symbols.length) {
                object.symbols = [];
                for (let j = 0; j < message.symbols.length; ++j)
                    object.symbols[j] = message.symbols[j];
            }
            if (message.seedAll != null && message.hasOwnProperty("seedAll"))
                object.seedAll = message.seedAll;
            return object;
        };

        /**
         * Converts this QuoteSeedRequest to JSON.
         * @function toJSON
         * @memberof QuoteProtos.QuoteSeedRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuoteSeedRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return QuoteSeedRequest;
    })();

    QuoteProtos.QuoteSeedResponse = (function() {

        /**
         * Properties of a QuoteSeedResponse.
         * @memberof QuoteProtos
         * @interface IQuoteSeedResponse
         * @property {string|null} [reqId] QuoteSeedResponse reqId
         * @property {QuoteProtos.IQuote|null} [quote] QuoteSeedResponse quote
         */

        /**
         * Constructs a new QuoteSeedResponse.
         * @memberof QuoteProtos
         * @classdesc Represents a QuoteSeedResponse.
         * @implements IQuoteSeedResponse
         * @constructor
         * @param {QuoteProtos.IQuoteSeedResponse=} [properties] Properties to set
         */
        function QuoteSeedResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuoteSeedResponse reqId.
         * @member {string} reqId
         * @memberof QuoteProtos.QuoteSeedResponse
         * @instance
         */
        QuoteSeedResponse.prototype.reqId = "";

        /**
         * QuoteSeedResponse quote.
         * @member {QuoteProtos.IQuote|null|undefined} quote
         * @memberof QuoteProtos.QuoteSeedResponse
         * @instance
         */
        QuoteSeedResponse.prototype.quote = null;

        /**
         * Creates a new QuoteSeedResponse instance using the specified properties.
         * @function create
         * @memberof QuoteProtos.QuoteSeedResponse
         * @static
         * @param {QuoteProtos.IQuoteSeedResponse=} [properties] Properties to set
         * @returns {QuoteProtos.QuoteSeedResponse} QuoteSeedResponse instance
         */
        QuoteSeedResponse.create = function create(properties) {
            return new QuoteSeedResponse(properties);
        };

        /**
         * Encodes the specified QuoteSeedResponse message. Does not implicitly {@link QuoteProtos.QuoteSeedResponse.verify|verify} messages.
         * @function encode
         * @memberof QuoteProtos.QuoteSeedResponse
         * @static
         * @param {QuoteProtos.IQuoteSeedResponse} message QuoteSeedResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteSeedResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.reqId != null && Object.hasOwnProperty.call(message, "reqId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.reqId);
            if (message.quote != null && Object.hasOwnProperty.call(message, "quote"))
                $root.QuoteProtos.Quote.encode(message.quote, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified QuoteSeedResponse message, length delimited. Does not implicitly {@link QuoteProtos.QuoteSeedResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteProtos.QuoteSeedResponse
         * @static
         * @param {QuoteProtos.IQuoteSeedResponse} message QuoteSeedResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteSeedResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteSeedResponse message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteProtos.QuoteSeedResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteProtos.QuoteSeedResponse} QuoteSeedResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteSeedResponse.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteProtos.QuoteSeedResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.reqId = reader.string();
                        break;
                    }
                case 2: {
                        message.quote = $root.QuoteProtos.Quote.decode(reader, reader.uint32(), undefined, long + 1);
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuoteSeedResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteProtos.QuoteSeedResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteProtos.QuoteSeedResponse} QuoteSeedResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteSeedResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuoteSeedResponse message.
         * @function verify
         * @memberof QuoteProtos.QuoteSeedResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuoteSeedResponse.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.reqId != null && message.hasOwnProperty("reqId"))
                if (!$util.isString(message.reqId))
                    return "reqId: string expected";
            if (message.quote != null && message.hasOwnProperty("quote")) {
                let error = $root.QuoteProtos.Quote.verify(message.quote, long + 1);
                if (error)
                    return "quote." + error;
            }
            return null;
        };

        /**
         * Creates a QuoteSeedResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteProtos.QuoteSeedResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteProtos.QuoteSeedResponse} QuoteSeedResponse
         */
        QuoteSeedResponse.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteProtos.QuoteSeedResponse)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteProtos.QuoteSeedResponse();
            if (object.reqId != null)
                message.reqId = String(object.reqId);
            if (object.quote != null) {
                if (typeof object.quote !== "object")
                    throw TypeError(".QuoteProtos.QuoteSeedResponse.quote: object expected");
                message.quote = $root.QuoteProtos.Quote.fromObject(object.quote, long + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a QuoteSeedResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteProtos.QuoteSeedResponse
         * @static
         * @param {QuoteProtos.QuoteSeedResponse} message QuoteSeedResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuoteSeedResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.reqId = "";
                object.quote = null;
            }
            if (message.reqId != null && message.hasOwnProperty("reqId"))
                object.reqId = message.reqId;
            if (message.quote != null && message.hasOwnProperty("quote"))
                object.quote = $root.QuoteProtos.Quote.toObject(message.quote, options);
            return object;
        };

        /**
         * Converts this QuoteSeedResponse to JSON.
         * @function toJSON
         * @memberof QuoteProtos.QuoteSeedResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuoteSeedResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return QuoteSeedResponse;
    })();

    QuoteProtos.Quote = (function() {

        /**
         * Properties of a Quote.
         * @memberof QuoteProtos
         * @interface IQuote
         * @property {string|null} [symbol] Quote symbol
         * @property {string|null} [opol] Quote opol
         * @property {number|null} [previousClose] Quote previousClose
         * @property {number|null} [close] Quote close
         * @property {number|null} [change] Quote change
         * @property {number|null} [changePercent] Quote changePercent
         * @property {string|null} [name] Quote name
         * @property {string|null} [ipoDate] Quote ipoDate
         * @property {string|null} [exchange] Quote exchange
         * @property {string|null} [tradeExchange] Quote tradeExchange
         * @property {number|null} [preMarketOpen] Quote preMarketOpen
         * @property {number|Long|null} [preMarketOpenTime] Quote preMarketOpenTime
         * @property {number|Long|null} [preMarketVolume] Quote preMarketVolume
         * @property {number|Long|null} [afterMarketVolume] Quote afterMarketVolume
         * @property {number|null} [preMarketPrice] Quote preMarketPrice
         * @property {number|null} [afterMarketPrice] Quote afterMarketPrice
         * @property {number|null} [preMarketOpenChange] Quote preMarketOpenChange
         * @property {number|null} [preMarketOpenChangePercent] Quote preMarketOpenChangePercent
         * @property {QuoteProtos.QuoteSource|null} [source] Quote source
         * @property {Array.<number>|null} [clearFieldNumbers] Quote clearFieldNumbers
         * @property {number|Long|null} [marketCap] Quote marketCap
         * @property {number|null} [rsi] Quote rsi
         * @property {number|null} [atr] Quote atr
         * @property {number|null} [priceToEarnings] Quote priceToEarnings
         * @property {number|Long|null} [averageVolume] Quote averageVolume
         * @property {number|Long|null} [sharesOutstanding] Quote sharesOutstanding
         * @property {string|null} [sector] Quote sector
         * @property {number|null} [sectorCode] Quote sectorCode
         * @property {string|null} [industry] Quote industry
         * @property {number|null} [industryCode] Quote industryCode
         * @property {number|null} [forwardPERatio] Quote forwardPERatio
         * @property {number|null} [pricetoEBITDA] Quote pricetoEBITDA
         * @property {number|null} [trailingDividendYield] Quote trailingDividendYield
         * @property {number|null} [PBRatio] Quote PBRatio
         * @property {number|null} [priceToSales] Quote priceToSales
         * @property {number|null} [FCFPerShare] Quote FCFPerShare
         * @property {number|null} [buyBackYield] Quote buyBackYield
         * @property {number|null} [open] Quote open
         * @property {number|null} [price] Quote price
         * @property {number|null} [high] Quote high
         * @property {number|null} [low] Quote low
         * @property {number|Long|null} [time] Quote time
         * @property {number|null} [size] Quote size
         * @property {string|null} [type] Quote type
         * @property {number|Long|null} [dayVolume] Quote dayVolume
         * @property {number|null} [askPrice] Quote askPrice
         * @property {number|null} [bidPrice] Quote bidPrice
         * @property {string|null} [shareFloatDate] Quote shareFloatDate
         * @property {string|null} [sharesOutstandingDate] Quote sharesOutstandingDate
         * @property {number|Long|null} [shareFloat] Quote shareFloat
         * @property {QuoteProtos.TickType|null} [updateType] Quote updateType
         * @property {string|null} [subtype] Quote subtype
         * @property {QuoteProtos.SessionType|null} [sessionType] Quote sessionType
         * @property {number|Long|null} [volume] Quote volume
         * @property {number|null} [changePercent1Minute] Quote changePercent1Minute
         * @property {number|null} [changePercentClose] Quote changePercentClose
         * @property {number|null} [change5Minute] Quote change5Minute
         * @property {number|null} [changePercent5Minute] Quote changePercent5Minute
         * @property {number|Long|null} [volume1Minute] Quote volume1Minute
         * @property {number|null} [relativeVolume1Minute] Quote relativeVolume1Minute
         * @property {number|null} [change15Minute] Quote change15Minute
         * @property {number|null} [changePercent15Minute] Quote changePercent15Minute
         * @property {number|null} [change30Minute] Quote change30Minute
         * @property {number|null} [changePercent30Minute] Quote changePercent30Minute
         * @property {number|null} [change60Minute] Quote change60Minute
         * @property {number|null} [changePercent60Minute] Quote changePercent60Minute
         * @property {number|null} [changePercentOpen] Quote changePercentOpen
         * @property {number|null} [changeOpen] Quote changeOpen
         * @property {number|null} [customChange] Quote customChange
         * @property {number|null} [customChangePercent] Quote customChangePercent
         * @property {number|Long|null} [customDate] Quote customDate
         * @property {number|null} [preMarketChange] Quote preMarketChange
         * @property {number|null} [preMarketChangePercent] Quote preMarketChangePercent
         * @property {number|null} [afterMarketChange] Quote afterMarketChange
         * @property {number|null} [afterMarketChangePercent] Quote afterMarketChangePercent
         * @property {number|null} [change1Month] Quote change1Month
         * @property {number|null} [price3Month] Quote price3Month
         * @property {number|null} [change3Month] Quote change3Month
         * @property {number|null} [changePercent3Month] Quote changePercent3Month
         * @property {number|null} [price6Month] Quote price6Month
         * @property {number|null} [change6Month] Quote change6Month
         * @property {number|null} [changePercent6Month] Quote changePercent6Month
         * @property {number|null} [change1Year] Quote change1Year
         * @property {number|null} [preMarketChange5Minute] Quote preMarketChange5Minute
         * @property {number|null} [preMarketChangePercent5Minute] Quote preMarketChangePercent5Minute
         * @property {number|null} [preMarketChange15Minute] Quote preMarketChange15Minute
         * @property {number|null} [preMarketChangePercent15Minute] Quote preMarketChangePercent15Minute
         * @property {number|null} [preMarketChange30Minute] Quote preMarketChange30Minute
         * @property {number|null} [preMarketChangePercent30Minute] Quote preMarketChangePercent30Minute
         * @property {number|null} [preMarketChange60Minute] Quote preMarketChange60Minute
         * @property {number|null} [preMarketChangePercent60Minute] Quote preMarketChangePercent60Minute
         * @property {number|null} [regularChange5Minute] Quote regularChange5Minute
         * @property {number|null} [regularChangePercent5Minute] Quote regularChangePercent5Minute
         * @property {number|null} [regularChange15Minute] Quote regularChange15Minute
         * @property {number|null} [regularChangePercent15Minute] Quote regularChangePercent15Minute
         * @property {number|null} [regularChange30Minute] Quote regularChange30Minute
         * @property {number|null} [regularChangePercent30Minute] Quote regularChangePercent30Minute
         * @property {number|null} [regularChange60Minute] Quote regularChange60Minute
         * @property {number|null} [regularChangePercent60Minute] Quote regularChangePercent60Minute
         * @property {number|null} [afterMarketChange5Minute] Quote afterMarketChange5Minute
         * @property {number|null} [afterMarketChangePercent5Minute] Quote afterMarketChangePercent5Minute
         * @property {number|null} [afterMarketChange15Minute] Quote afterMarketChange15Minute
         * @property {number|null} [afterMarketChangePercent15Minute] Quote afterMarketChangePercent15Minute
         * @property {number|null} [afterMarketChange30Minute] Quote afterMarketChange30Minute
         * @property {number|null} [afterMarketChangePercent30Minute] Quote afterMarketChangePercent30Minute
         * @property {number|null} [afterMarketChange60Minute] Quote afterMarketChange60Minute
         * @property {number|null} [afterMarketChangePercent60Minute] Quote afterMarketChangePercent60Minute
         * @property {number|null} [gics] Quote gics
         * @property {number|null} [gicsSector] Quote gicsSector
         * @property {string|null} [gicsSectorName] Quote gicsSectorName
         * @property {number|null} [gicsIndustryGroup] Quote gicsIndustryGroup
         * @property {string|null} [gicsIndustryGroupName] Quote gicsIndustryGroupName
         * @property {number|null} [gicsIndustry] Quote gicsIndustry
         * @property {string|null} [gicsIndustryName] Quote gicsIndustryName
         * @property {number|null} [gicsSubIndustry] Quote gicsSubIndustry
         * @property {string|null} [gicsSubIndustryName] Quote gicsSubIndustryName
         * @property {number|null} [optionable] Quote optionable
         * @property {number|null} [cik] Quote cik
         * @property {string|null} [signalName] Quote signalName
         * @property {number|Long|null} [lastTradeTime] Quote lastTradeTime
         * @property {string|null} [country] Quote country
         * @property {number|Long|null} [sharesShort] Quote sharesShort
         * @property {number|null} [sharesShortPercentOfFloat] Quote sharesShortPercentOfFloat
         * @property {number|null} [sharesShortChangePercent] Quote sharesShortChangePercent
         * @property {number|Long|null} [sharesShortReceiptDate] Quote sharesShortReceiptDate
         * @property {number|Long|null} [sharesShortSettlementDate] Quote sharesShortSettlementDate
         * @property {number|null} [shortInterestRatio] Quote shortInterestRatio
         * @property {number|null} [sharesShortValue] Quote sharesShortValue
         * @property {number|Long|null} [sharesShortPrevious] Quote sharesShortPrevious
         * @property {number|null} [sharesShortPreviousValue] Quote sharesShortPreviousValue
         * @property {number|null} [sharesShortPreviousPercentOfFloat] Quote sharesShortPreviousPercentOfFloat
         * @property {number|Long|null} [sharesShortChange] Quote sharesShortChange
         * @property {number|Long|null} [sentTime] Quote sentTime
         * @property {number|Long|null} [closeTime] Quote closeTime
         * @property {number|Long|null} [volume5Minute] Quote volume5Minute
         * @property {number|Long|null} [volume15Minute] Quote volume15Minute
         * @property {number|Long|null} [volume30Minute] Quote volume30Minute
         * @property {number|Long|null} [volume60Minute] Quote volume60Minute
         * @property {number|null} [relativeVolume5Minute] Quote relativeVolume5Minute
         * @property {number|null} [relativeVolume90Day] Quote relativeVolume90Day
         * @property {number|null} [rvol1m10d] Quote rvol1m10d
         * @property {number|null} [rvol5m10d] Quote rvol5m10d
         * @property {number|null} [rvol5m30d] Quote rvol5m30d
         * @property {number|null} [rvol5m90d] Quote rvol5m90d
         * @property {number|Long|null} [averageVolume10Day] Quote averageVolume10Day
         * @property {number|null} [averageVolumeChangePercent10Day] Quote averageVolumeChangePercent10Day
         * @property {number|null} [high10Day] Quote high10Day
         * @property {number|null} [highChangePercent10Day] Quote highChangePercent10Day
         * @property {number|null} [low10Day] Quote low10Day
         * @property {number|null} [lowChangePercent10Day] Quote lowChangePercent10Day
         * @property {number|null} [movingAverage10Day] Quote movingAverage10Day
         * @property {number|null} [movingAverageChangePercent10Day] Quote movingAverageChangePercent10Day
         * @property {number|Long|null} [averageVolume20Day] Quote averageVolume20Day
         * @property {number|null} [averageVolumeChangePercent20Day] Quote averageVolumeChangePercent20Day
         * @property {number|null} [high20Day] Quote high20Day
         * @property {number|null} [highChangePercent20Day] Quote highChangePercent20Day
         * @property {number|null} [low20Day] Quote low20Day
         * @property {number|null} [lowChangePercent20Day] Quote lowChangePercent20Day
         * @property {number|null} [movingAverage20Day] Quote movingAverage20Day
         * @property {number|null} [movingAverageChangePercent20Day] Quote movingAverageChangePercent20Day
         * @property {number|Long|null} [averageVolume50Day] Quote averageVolume50Day
         * @property {number|null} [averageVolumeChangePercent50Day] Quote averageVolumeChangePercent50Day
         * @property {number|null} [high50Day] Quote high50Day
         * @property {number|null} [highChangePercent50Day] Quote highChangePercent50Day
         * @property {number|null} [low50Day] Quote low50Day
         * @property {number|null} [lowChangePercent50Day] Quote lowChangePercent50Day
         * @property {number|null} [movingAverage50Day] Quote movingAverage50Day
         * @property {number|null} [movingAverageChangePercent50Day] Quote movingAverageChangePercent50Day
         * @property {number|Long|null} [averageVolume100Day] Quote averageVolume100Day
         * @property {number|null} [averageVolumeChangePercent100Day] Quote averageVolumeChangePercent100Day
         * @property {number|null} [high100Day] Quote high100Day
         * @property {number|null} [highChangePercent100Day] Quote highChangePercent100Day
         * @property {number|null} [low100Day] Quote low100Day
         * @property {number|null} [lowChangePercent100Day] Quote lowChangePercent100Day
         * @property {number|null} [movingAverage100Day] Quote movingAverage100Day
         * @property {number|null} [movingAverageChangePercent100Day] Quote movingAverageChangePercent100Day
         * @property {number|Long|null} [averageVolume200Day] Quote averageVolume200Day
         * @property {number|null} [averageVolumeChangePercent200Day] Quote averageVolumeChangePercent200Day
         * @property {number|null} [high200Day] Quote high200Day
         * @property {number|null} [highChangePercent200Day] Quote highChangePercent200Day
         * @property {number|null} [low200Day] Quote low200Day
         * @property {number|null} [lowChangePercent200Day] Quote lowChangePercent200Day
         * @property {number|null} [movingAverage200Day] Quote movingAverage200Day
         * @property {number|null} [movingAverageChangePercent200Day] Quote movingAverageChangePercent200Day
         * @property {number|null} [movingAverage250Day] Quote movingAverage250Day
         * @property {number|null} [movingAverageChangePercent250Day] Quote movingAverageChangePercent250Day
         * @property {number|Long|null} [averageVolume90Day] Quote averageVolume90Day
         * @property {number|null} [nextEarningsDate] Quote nextEarningsDate
         * @property {number|null} [dividend] Quote dividend
         * @property {number|null} [dividendYield] Quote dividendYield
         * @property {number|null} [dividendExDate] Quote dividendExDate
         * @property {number|Long|null} [dividendFrequency] Quote dividendFrequency
         * @property {number|null} [forwardDividendYield] Quote forwardDividendYield
         * @property {number|null} [roe] Quote roe
         * @property {number|null} [roa] Quote roa
         * @property {number|null} [roic] Quote roic
         * @property {number|null} [currentRatio] Quote currentRatio
         * @property {number|null} [grossMargin] Quote grossMargin
         * @property {number|null} [netMargin] Quote netMargin
         * @property {number|null} [operationMargin] Quote operationMargin
         * @property {number|null} [epsMrq] Quote epsMrq
         * @property {number|null} [epsTtm] Quote epsTtm
         * @property {number|null} [dilutedEpsMrq] Quote dilutedEpsMrq
         * @property {number|null} [dilutedEpsTtm] Quote dilutedEpsTtm
         * @property {number|null} [low52Week] Quote low52Week
         * @property {number|null} [high52Week] Quote high52Week
         * @property {number|null} [revenueTtm] Quote revenueTtm
         * @property {number|null} [earningsAsOf] Quote earningsAsOf
         * @property {number|null} [netProfitMargin] Quote netProfitMargin
         * @property {number|null} [change1Week] Quote change1Week
         * @property {number|null} [price1Week] Quote price1Week
         * @property {number|null} [priceChangePercent1Week] Quote priceChangePercent1Week
         * @property {number|null} [price1Month] Quote price1Month
         * @property {number|null} [priceChangePercent1Month] Quote priceChangePercent1Month
         * @property {number|null} [priceHalfYear] Quote priceHalfYear
         * @property {number|null} [priceChangePercentHalfYear] Quote priceChangePercentHalfYear
         * @property {number|null} [priceQuarter] Quote priceQuarter
         * @property {number|null} [priceChangePercentQuarter] Quote priceChangePercentQuarter
         * @property {number|null} [price1Year] Quote price1Year
         * @property {number|null} [priceChangePercent1Year] Quote priceChangePercent1Year
         * @property {number|null} [priceYearToDate] Quote priceYearToDate
         * @property {number|null} [priceChangePercentYearToDate] Quote priceChangePercentYearToDate
         * @property {number|null} [roeMrq] Quote roeMrq
         * @property {number|null} [roaMrq] Quote roaMrq
         * @property {number|null} [roicMrq] Quote roicMrq
         * @property {number|null} [currentRatioMrq] Quote currentRatioMrq
         * @property {number|null} [grossMarginMrq] Quote grossMarginMrq
         * @property {number|null} [netMarginMrq] Quote netMarginMrq
         * @property {number|null} [operationMarginMrq] Quote operationMarginMrq
         * @property {number|Long|null} [previousDayVolume] Quote previousDayVolume
         * @property {number|null} [previousDayAtr] Quote previousDayAtr
         * @property {number|null} [previousDayAdx] Quote previousDayAdx
         * @property {number|null} [previousDayPlusDMSmoothed] Quote previousDayPlusDMSmoothed
         * @property {number|null} [previousDayMinusDMSmoothed] Quote previousDayMinusDMSmoothed
         * @property {number|null} [previousDayHigh] Quote previousDayHigh
         * @property {number|null} [previousDayLow] Quote previousDayLow
         * @property {number|null} [adx] Quote adx
         * @property {number|null} [percentInstitutionalOwnership] Quote percentInstitutionalOwnership
         * @property {number|null} [percentInstitutionalTransactions] Quote percentInstitutionalTransactions
         * @property {string|null} [wiim] Quote wiim
         * @property {number|Long|null} [wiimAsOf] Quote wiimAsOf
         * @property {number|null} [vwap] Quote vwap
         * @property {number|null} [vwapChangePercent] Quote vwapChangePercent
         * @property {number|null} [vwapChange] Quote vwapChange
         * @property {number|null} [rsiAvgGain] Quote rsiAvgGain
         * @property {number|null} [rsiAvgLoss] Quote rsiAvgLoss
         * @property {string|null} [halted] Quote halted
         * @property {number|Long|null} [tradeCount] Quote tradeCount
         * @property {number|Long|null} [regularHighCount] Quote regularHighCount
         * @property {number|Long|null} [regularLowCount] Quote regularLowCount
         * @property {number|Long|null} [preMarketHighCount] Quote preMarketHighCount
         * @property {number|Long|null} [preMarketLowCount] Quote preMarketLowCount
         * @property {number|Long|null} [afterMarketHighCount] Quote afterMarketHighCount
         * @property {number|Long|null} [afterMarketLowCount] Quote afterMarketLowCount
         * @property {number|Long|null} [dayHighCount] Quote dayHighCount
         * @property {number|Long|null} [dayLowCount] Quote dayLowCount
         * @property {number|null} [dayHigh] Quote dayHigh
         * @property {number|null} [dayLow] Quote dayLow
         * @property {number|null} [preMarketHigh] Quote preMarketHigh
         * @property {number|null} [preMarketLow] Quote preMarketLow
         * @property {number|null} [afterMarketHigh] Quote afterMarketHigh
         * @property {number|null} [afterMarketLow] Quote afterMarketLow
         * @property {number|null} [regularHigh] Quote regularHigh
         * @property {number|null} [regularLow] Quote regularLow
         * @property {number|Long|null} [priceSpikeUpCount] Quote priceSpikeUpCount
         * @property {number|Long|null} [priceSpikeDownCount] Quote priceSpikeDownCount
         * @property {number|Long|null} [haltedCount] Quote haltedCount
         * @property {number|null} [usCongressTotal] Quote usCongressTotal
         * @property {number|null} [usCongressRepublicansTotal] Quote usCongressRepublicansTotal
         * @property {number|null} [usCongressDemocratsTotal] Quote usCongressDemocratsTotal
         * @property {number|null} [usCongressOtherTotal] Quote usCongressOtherTotal
         * @property {number|null} [volumeFloatRatio] Quote volumeFloatRatio
         * @property {number|null} [atrp] Quote atrp
         * @property {number|null} [ytdGainLoss] Quote ytdGainLoss
         * @property {number|null} [mtdGainLoss] Quote mtdGainLoss
         * @property {number|null} [ytdChange] Quote ytdChange
         * @property {number|null} [mtdChange] Quote mtdChange
         * @property {number|null} [yearOpen] Quote yearOpen
         * @property {number|null} [monthOpen] Quote monthOpen
         * @property {number|null} [volumeFloatPercent] Quote volumeFloatPercent
         * @property {number|null} [rsi1m] Quote rsi1m
         * @property {number|null} [rsi2m] Quote rsi2m
         * @property {number|null} [rsi5m] Quote rsi5m
         * @property {number|null} [rsi15m] Quote rsi15m
         * @property {number|null} [rsi30m] Quote rsi30m
         * @property {number|null} [rsi60m] Quote rsi60m
         * @property {number|null} [rsiEth1m] Quote rsiEth1m
         * @property {number|null} [rsiEth2m] Quote rsiEth2m
         * @property {number|null} [rsiEth5m] Quote rsiEth5m
         * @property {number|null} [rsiEth15m] Quote rsiEth15m
         * @property {number|null} [rsiEth30m] Quote rsiEth30m
         * @property {number|null} [rsiEth60m] Quote rsiEth60m
         * @property {number|null} [averageDollarVolume10Day] Quote averageDollarVolume10Day
         * @property {number|Long|null} [averageVolume60Day] Quote averageVolume60Day
         * @property {number|null} [relativeVolumePercent60Day] Quote relativeVolumePercent60Day
         * @property {number|null} [rsi1mLowest] Quote rsi1mLowest
         * @property {number|null} [rsi2mLowest] Quote rsi2mLowest
         * @property {number|null} [rsi5mLowest] Quote rsi5mLowest
         * @property {number|null} [rsi15mLowest] Quote rsi15mLowest
         * @property {number|null} [rsi30mLowest] Quote rsi30mLowest
         * @property {number|null} [rsi60mLowest] Quote rsi60mLowest
         * @property {number|null} [rsiEth1mLowest] Quote rsiEth1mLowest
         * @property {number|null} [rsiEth2mLowest] Quote rsiEth2mLowest
         * @property {number|null} [rsiEth5mLowest] Quote rsiEth5mLowest
         * @property {number|null} [rsiEth15mLowest] Quote rsiEth15mLowest
         * @property {number|null} [rsiEth30mLowest] Quote rsiEth30mLowest
         * @property {number|null} [rsiEth60mLowest] Quote rsiEth60mLowest
         * @property {number|null} [rsi1mGreatest] Quote rsi1mGreatest
         * @property {number|null} [rsi2mGreatest] Quote rsi2mGreatest
         * @property {number|null} [rsi5mGreatest] Quote rsi5mGreatest
         * @property {number|null} [rsi15mGreatest] Quote rsi15mGreatest
         * @property {number|null} [rsi30mGreatest] Quote rsi30mGreatest
         * @property {number|null} [rsi60mGreatest] Quote rsi60mGreatest
         * @property {number|null} [rsiEth1mGreatest] Quote rsiEth1mGreatest
         * @property {number|null} [rsiEth2mGreatest] Quote rsiEth2mGreatest
         * @property {number|null} [rsiEth5mGreatest] Quote rsiEth5mGreatest
         * @property {number|null} [rsiEth15mGreatest] Quote rsiEth15mGreatest
         * @property {number|null} [rsiEth30mGreatest] Quote rsiEth30mGreatest
         * @property {number|null} [rsiEth60mGreatest] Quote rsiEth60mGreatest
         * @property {number|null} [rsiCrossOver] Quote rsiCrossOver
         * @property {number|null} [ema12d] Quote ema12d
         * @property {number|null} [ema26d] Quote ema26d
         * @property {number|null} [macd] Quote macd
         * @property {number|null} [macdSignalLine] Quote macdSignalLine
         * @property {number|null} [macdHistogram] Quote macdHistogram
         * @property {number|null} [macdSignalLineBase] Quote macdSignalLineBase
         * @property {number|null} [dividendGrowthRate1Year] Quote dividendGrowthRate1Year
         * @property {number|null} [dividendGrowthRate3Year] Quote dividendGrowthRate3Year
         * @property {number|null} [dividendGrowthRate5Year] Quote dividendGrowthRate5Year
         * @property {number|null} [totalDividendTtm] Quote totalDividendTtm
         * @property {number|null} [dividendIncreasing] Quote dividendIncreasing
         * @property {string|null} [newsBzWireTitle] Quote newsBzWireTitle
         * @property {string|null} [newsBzWireNodeId] Quote newsBzWireNodeId
         * @property {number|Long|null} [newsBzWireTimestamp] Quote newsBzWireTimestamp
         * @property {string|null} [newsPRTitle] Quote newsPRTitle
         * @property {string|null} [newsPRNodeId] Quote newsPRNodeId
         * @property {number|Long|null} [newsPRTimestamp] Quote newsPRTimestamp
         * @property {string|null} [newsSecTitle] Quote newsSecTitle
         * @property {string|null} [newsSecNodeId] Quote newsSecNodeId
         * @property {number|Long|null} [newsSecTimestamp] Quote newsSecTimestamp
         * @property {string|null} [newsBzWireTitleWithNodeId] Quote newsBzWireTitleWithNodeId
         * @property {string|null} [newsPRTitleWithNodeId] Quote newsPRTitleWithNodeId
         * @property {string|null} [newsSecTitleWithNodeId] Quote newsSecTitleWithNodeId
         * @property {number|null} [movingAverage500Day] Quote movingAverage500Day
         * @property {number|null} [gapChange] Quote gapChange
         * @property {number|null} [gapChangePercent] Quote gapChangePercent
         * @property {number|null} [adr14d] Quote adr14d
         * @property {number|null} [dilutedEpsMrqSurprisePercent] Quote dilutedEpsMrqSurprisePercent
         * @property {number|null} [dilutedEpsTtmSurprisePercent] Quote dilutedEpsTtmSurprisePercent
         * @property {number|null} [dilutedRevenueMrqSurprisePercent] Quote dilutedRevenueMrqSurprisePercent
         * @property {number|null} [dilutedRevenueTtmSurprisePercent] Quote dilutedRevenueTtmSurprisePercent
         * @property {number|null} [epsGrowthTtm] Quote epsGrowthTtm
         * @property {number|null} [epsGrowthY2Y] Quote epsGrowthY2Y
         * @property {number|null} [epsGrowthQ2Q] Quote epsGrowthQ2Q
         * @property {number|null} [epsGrowth5Year] Quote epsGrowth5Year
         * @property {number|null} [epsGrowthYearAgoQ] Quote epsGrowthYearAgoQ
         * @property {number|null} [revenueGrowthTtm] Quote revenueGrowthTtm
         * @property {number|null} [revenueGrowthY2Y] Quote revenueGrowthY2Y
         * @property {number|null} [revenueGrowthQ2Q] Quote revenueGrowthQ2Q
         * @property {number|null} [revenueGrowth5Year] Quote revenueGrowth5Year
         * @property {number|null} [revenueGrowthYearAgoQ] Quote revenueGrowthYearAgoQ
         * @property {number|null} [ltDebtEquity] Quote ltDebtEquity
         * @property {string|null} [bullsSay] Quote bullsSay
         * @property {string|null} [bearsSay] Quote bearsSay
         * @property {number|Long|null} [ipoDateNumber] Quote ipoDateNumber
         * @property {number|null} [ffoPerShare] Quote ffoPerShare
         * @property {number|null} [quickRatioMrq] Quote quickRatioMrq
         * @property {number|null} [highAllTime] Quote highAllTime
         * @property {number|null} [lowAllTime] Quote lowAllTime
         * @property {number|null} [evToEbitda] Quote evToEbitda
         * @property {number|null} [totalDebtEquityRatio] Quote totalDebtEquityRatio
         * @property {number|null} [dividendPayoutRatio] Quote dividendPayoutRatio
         * @property {number|null} [operatingCashFlow] Quote operatingCashFlow
         * @property {number|null} [insiderPercentage] Quote insiderPercentage
         * @property {number|null} [priceToCashFlowRatio] Quote priceToCashFlowRatio
         * @property {number|null} [regularHoursChange] Quote regularHoursChange
         * @property {number|null} [regularHoursPercentChange] Quote regularHoursPercentChange
         * @property {number|null} [postToPreHoursChange] Quote postToPreHoursChange
         * @property {number|null} [postToPreHoursPercentChange] Quote postToPreHoursPercentChange
         * @property {number|null} [scannerClose] Quote scannerClose
         * @property {number|null} [scannerChange] Quote scannerChange
         * @property {number|null} [scannerChangePercent] Quote scannerChangePercent
         * @property {number|null} [scannerChangePercentClose] Quote scannerChangePercentClose
         * @property {number|null} [scannerPreviousClose] Quote scannerPreviousClose
         * @property {number|null} [freeCashFlow] Quote freeCashFlow
         * @property {number|null} [minPriceTarget] Quote minPriceTarget
         * @property {number|null} [maxPriceTarget] Quote maxPriceTarget
         * @property {number|null} [meanPriceTarget] Quote meanPriceTarget
         * @property {number|null} [totalNumberOfAnalyst] Quote totalNumberOfAnalyst
         * @property {string|null} [averageAnalystRecommendation] Quote averageAnalystRecommendation
         * @property {number|null} [pegRatio] Quote pegRatio
         * @property {number|null} [priceToFreeCashFlowRatio] Quote priceToFreeCashFlowRatio
         * @property {number|null} [distanceToMaxPriceTarget] Quote distanceToMaxPriceTarget
         * @property {number|null} [distanceToMinPriceTarget] Quote distanceToMinPriceTarget
         * @property {number|null} [distanceToMeanPriceTarget] Quote distanceToMeanPriceTarget
         * @property {string|null} [shortTermTrend] Quote shortTermTrend
         * @property {string|null} [mediumTermTrend] Quote mediumTermTrend
         * @property {string|null} [longTermTrend] Quote longTermTrend
         * @property {number|null} [twentySixWeekChange] Quote twentySixWeekChange
         * @property {number|null} [fiftyTwoWeekChange] Quote fiftyTwoWeekChange
         * @property {number|null} [annualizedStandardDeviation] Quote annualizedStandardDeviation
         * @property {number|null} [momentum] Quote momentum
         * @property {number|null} [value] Quote value
         * @property {number|Long|null} [piotroskiFScore] Quote piotroskiFScore
         * @property {number|null} [netIncomeTtm] Quote netIncomeTtm
         * @property {number|null} [currentRatioYearAgo] Quote currentRatioYearAgo
         * @property {number|null} [roaYearAgo] Quote roaYearAgo
         * @property {number|null} [grossMarginYearAgo] Quote grossMarginYearAgo
         * @property {number|null} [longTermDebt] Quote longTermDebt
         * @property {number|null} [longTermDebtYearAgo] Quote longTermDebtYearAgo
         * @property {number|null} [shareIssued] Quote shareIssued
         * @property {number|null} [shareIssuedYearAgo] Quote shareIssuedYearAgo
         * @property {number|null} [totalAssets] Quote totalAssets
         * @property {number|null} [totalAssetsYearAgo] Quote totalAssetsYearAgo
         * @property {number|null} [totalAssets2YearAgo] Quote totalAssets2YearAgo
         * @property {number|null} [revenueTtmYearAgo] Quote revenueTtmYearAgo
         * @property {number|null} [longTermDebtAndCapitalLeaseObligation] Quote longTermDebtAndCapitalLeaseObligation
         * @property {number|null} [averageTotalAssets] Quote averageTotalAssets
         * @property {number|null} [averageTotalAssetsYearAgo] Quote averageTotalAssetsYearAgo
         * @property {number|null} [growth] Quote growth
         * @property {number|null} [quality] Quote quality
         * @property {number|null} [momentumPercentile] Quote momentumPercentile
         * @property {number|null} [valuePercentile] Quote valuePercentile
         * @property {number|null} [growthPercentile] Quote growthPercentile
         * @property {number|null} [qualityPercentile] Quote qualityPercentile
         * @property {number|null} [rateOfReturnDay] Quote rateOfReturnDay
         * @property {number|null} [rateOfReturnWeek] Quote rateOfReturnWeek
         * @property {number|null} [rateOfReturnMonth] Quote rateOfReturnMonth
         * @property {number|null} [dividendOneDay] Quote dividendOneDay
         * @property {number|null} [dividendOneWeek] Quote dividendOneWeek
         * @property {number|null} [dividendOneMonth] Quote dividendOneMonth
         * @property {number|null} [totalLiabilities] Quote totalLiabilities
         * @property {number|null} [retainedEarnings] Quote retainedEarnings
         * @property {number|null} [ebit] Quote ebit
         * @property {number|null} [altmanZScore] Quote altmanZScore
         * @property {boolean|null} [powerEarningGap] Quote powerEarningGap
         * @property {boolean|null} [monsterPowerEarningGap] Quote monsterPowerEarningGap
         * @property {boolean|null} [monsterGap] Quote monsterGap
         * @property {boolean|null} [oelGap] Quote oelGap
         * @property {number|null} [evToEbit] Quote evToEbit
         * @property {number|null} [priceToTangibleBookValue] Quote priceToTangibleBookValue
         * @property {number|null} [tangibleBookValuePerShare] Quote tangibleBookValuePerShare
         * @property {number|null} [dailyDollarVolume] Quote dailyDollarVolume
         * @property {number|null} [bookValuePerShare] Quote bookValuePerShare
         * @property {number|null} [movingAverage350Day] Quote movingAverage350Day
         * @property {number|null} [priceToAdjEarningsTtm] Quote priceToAdjEarningsTtm
         * @property {number|null} [salesGrowthYoY] Quote salesGrowthYoY
         * @property {number|null} [salesGrowth3Year] Quote salesGrowth3Year
         * @property {number|null} [salesGrowth5Year] Quote salesGrowth5Year
         * @property {number|null} [debtQoQ] Quote debtQoQ
         * @property {number|null} [debtYoY] Quote debtYoY
         * @property {number|null} [debt5Year] Quote debt5Year
         * @property {number|null} [epsGrowth3Year] Quote epsGrowth3Year
         * @property {number|null} [epsGrowth3NormalizedYear] Quote epsGrowth3NormalizedYear
         * @property {number|null} [roe5YrAvg] Quote roe5YrAvg
         * @property {number|null} [stockholdersEquity] Quote stockholdersEquity
         * @property {number|null} [stockholdersEquityYearAgo] Quote stockholdersEquityYearAgo
         * @property {number|null} [stockholdersEquityGrowthYoY] Quote stockholdersEquityGrowthYoY
         * @property {number|null} [vwap1Day] Quote vwap1Day
         * @property {number|null} [vwap5Day] Quote vwap5Day
         * @property {number|null} [vwap10Day] Quote vwap10Day
         * @property {number|null} [vwap50Day] Quote vwap50Day
         * @property {number|null} [vwap100Day] Quote vwap100Day
         * @property {number|null} [vwap200Day] Quote vwap200Day
         * @property {number|null} [roic1YearAvg] Quote roic1YearAvg
         * @property {number|null} [roic5YearAvg] Quote roic5YearAvg
         * @property {number|null} [vwap1m] Quote vwap1m
         * @property {number|null} [vwap5m] Quote vwap5m
         * @property {number|null} [vwap15m] Quote vwap15m
         * @property {number|null} [vwap30m] Quote vwap30m
         * @property {number|null} [vwap60m] Quote vwap60m
         * @property {string|null} [candleStick] Quote candleStick
         * @property {string|null} [patterns] Quote patterns
         * @property {number|null} [earningsForwardGrowth3Year] Quote earningsForwardGrowth3Year
         * @property {number|null} [earningsForwardGrowth5Year] Quote earningsForwardGrowth5Year
         * @property {number|null} [revenueForwardGrowth3Year] Quote revenueForwardGrowth3Year
         * @property {number|null} [revenueForwardGrowth5Year] Quote revenueForwardGrowth5Year
         * @property {number|null} [bidAskSpread] Quote bidAskSpread
         * @property {number|null} [bidAskSpreadPercent] Quote bidAskSpreadPercent
         * @property {number|null} [change1Minute] Quote change1Minute
         * @property {number|null} [preMarketChange1Minute] Quote preMarketChange1Minute
         * @property {number|null} [preMarketChangePercent1Minute] Quote preMarketChangePercent1Minute
         * @property {number|null} [regularChange1Minute] Quote regularChange1Minute
         * @property {number|null} [regularChangePercent1Minute] Quote regularChangePercent1Minute
         * @property {number|null} [afterMarketChange1Minute] Quote afterMarketChange1Minute
         * @property {number|null} [afterMarketChangePercent1Minute] Quote afterMarketChangePercent1Minute
         * @property {string|null} [previousCloseDate] Quote previousCloseDate
         * @property {number|null} [distanceToMaxPriceTargetPercent] Quote distanceToMaxPriceTargetPercent
         * @property {number|null} [distanceToMinPriceTargetPercent] Quote distanceToMinPriceTargetPercent
         * @property {number|null} [distanceToMeanPriceTargetPercent] Quote distanceToMeanPriceTargetPercent
         */

        /**
         * Constructs a new Quote.
         * @memberof QuoteProtos
         * @classdesc Represents a Quote.
         * @implements IQuote
         * @constructor
         * @param {QuoteProtos.IQuote=} [properties] Properties to set
         */
        function Quote(properties) {
            this.clearFieldNumbers = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Quote symbol.
         * @member {string} symbol
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.symbol = "";

        /**
         * Quote opol.
         * @member {string} opol
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.opol = "";

        /**
         * Quote previousClose.
         * @member {number} previousClose
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.previousClose = 0;

        /**
         * Quote close.
         * @member {number} close
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.close = 0;

        /**
         * Quote change.
         * @member {number} change
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change = 0;

        /**
         * Quote changePercent.
         * @member {number} changePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercent = 0;

        /**
         * Quote name.
         * @member {string} name
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.name = "";

        /**
         * Quote ipoDate.
         * @member {string} ipoDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.ipoDate = "";

        /**
         * Quote exchange.
         * @member {string} exchange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.exchange = "";

        /**
         * Quote tradeExchange.
         * @member {string} tradeExchange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.tradeExchange = "";

        /**
         * Quote preMarketOpen.
         * @member {number} preMarketOpen
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketOpen = 0;

        /**
         * Quote preMarketOpenTime.
         * @member {number|Long} preMarketOpenTime
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketOpenTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote preMarketVolume.
         * @member {number|Long} preMarketVolume
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketVolume = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote afterMarketVolume.
         * @member {number|Long} afterMarketVolume
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketVolume = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote preMarketPrice.
         * @member {number} preMarketPrice
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketPrice = 0;

        /**
         * Quote afterMarketPrice.
         * @member {number} afterMarketPrice
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketPrice = 0;

        /**
         * Quote preMarketOpenChange.
         * @member {number} preMarketOpenChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketOpenChange = 0;

        /**
         * Quote preMarketOpenChangePercent.
         * @member {number} preMarketOpenChangePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketOpenChangePercent = 0;

        /**
         * Quote source.
         * @member {QuoteProtos.QuoteSource} source
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.source = 0;

        /**
         * Quote clearFieldNumbers.
         * @member {Array.<number>} clearFieldNumbers
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.clearFieldNumbers = $util.emptyArray;

        /**
         * Quote marketCap.
         * @member {number|Long} marketCap
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.marketCap = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote rsi.
         * @member {number} rsi
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi = 0;

        /**
         * Quote atr.
         * @member {number} atr
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.atr = 0;

        /**
         * Quote priceToEarnings.
         * @member {number} priceToEarnings
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceToEarnings = 0;

        /**
         * Quote averageVolume.
         * @member {number|Long} averageVolume
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolume = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote sharesOutstanding.
         * @member {number|Long} sharesOutstanding
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesOutstanding = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote sector.
         * @member {string} sector
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sector = "";

        /**
         * Quote sectorCode.
         * @member {number} sectorCode
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sectorCode = 0;

        /**
         * Quote industry.
         * @member {string} industry
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.industry = "";

        /**
         * Quote industryCode.
         * @member {number} industryCode
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.industryCode = 0;

        /**
         * Quote forwardPERatio.
         * @member {number} forwardPERatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.forwardPERatio = 0;

        /**
         * Quote pricetoEBITDA.
         * @member {number} pricetoEBITDA
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.pricetoEBITDA = 0;

        /**
         * Quote trailingDividendYield.
         * @member {number} trailingDividendYield
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.trailingDividendYield = 0;

        /**
         * Quote PBRatio.
         * @member {number} PBRatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.PBRatio = 0;

        /**
         * Quote priceToSales.
         * @member {number} priceToSales
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceToSales = 0;

        /**
         * Quote FCFPerShare.
         * @member {number} FCFPerShare
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.FCFPerShare = 0;

        /**
         * Quote buyBackYield.
         * @member {number} buyBackYield
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.buyBackYield = 0;

        /**
         * Quote open.
         * @member {number} open
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.open = 0;

        /**
         * Quote price.
         * @member {number} price
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.price = 0;

        /**
         * Quote high.
         * @member {number} high
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.high = 0;

        /**
         * Quote low.
         * @member {number} low
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.low = 0;

        /**
         * Quote time.
         * @member {number|Long} time
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote size.
         * @member {number} size
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.size = 0;

        /**
         * Quote type.
         * @member {string} type
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.type = "";

        /**
         * Quote dayVolume.
         * @member {number|Long} dayVolume
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dayVolume = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote askPrice.
         * @member {number} askPrice
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.askPrice = 0;

        /**
         * Quote bidPrice.
         * @member {number} bidPrice
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.bidPrice = 0;

        /**
         * Quote shareFloatDate.
         * @member {string} shareFloatDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.shareFloatDate = "";

        /**
         * Quote sharesOutstandingDate.
         * @member {string} sharesOutstandingDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesOutstandingDate = "";

        /**
         * Quote shareFloat.
         * @member {number|Long} shareFloat
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.shareFloat = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote updateType.
         * @member {QuoteProtos.TickType} updateType
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.updateType = 0;

        /**
         * Quote subtype.
         * @member {string} subtype
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.subtype = "";

        /**
         * Quote sessionType.
         * @member {QuoteProtos.SessionType} sessionType
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sessionType = 0;

        /**
         * Quote volume.
         * @member {number|Long} volume
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.volume = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote changePercent1Minute.
         * @member {number} changePercent1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercent1Minute = 0;

        /**
         * Quote changePercentClose.
         * @member {number} changePercentClose
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercentClose = 0;

        /**
         * Quote change5Minute.
         * @member {number} change5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change5Minute = 0;

        /**
         * Quote changePercent5Minute.
         * @member {number} changePercent5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercent5Minute = 0;

        /**
         * Quote volume1Minute.
         * @member {number|Long} volume1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.volume1Minute = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote relativeVolume1Minute.
         * @member {number} relativeVolume1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.relativeVolume1Minute = 0;

        /**
         * Quote change15Minute.
         * @member {number} change15Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change15Minute = 0;

        /**
         * Quote changePercent15Minute.
         * @member {number} changePercent15Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercent15Minute = 0;

        /**
         * Quote change30Minute.
         * @member {number} change30Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change30Minute = 0;

        /**
         * Quote changePercent30Minute.
         * @member {number} changePercent30Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercent30Minute = 0;

        /**
         * Quote change60Minute.
         * @member {number} change60Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change60Minute = 0;

        /**
         * Quote changePercent60Minute.
         * @member {number} changePercent60Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercent60Minute = 0;

        /**
         * Quote changePercentOpen.
         * @member {number} changePercentOpen
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercentOpen = 0;

        /**
         * Quote changeOpen.
         * @member {number} changeOpen
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changeOpen = 0;

        /**
         * Quote customChange.
         * @member {number} customChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.customChange = 0;

        /**
         * Quote customChangePercent.
         * @member {number} customChangePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.customChangePercent = 0;

        /**
         * Quote customDate.
         * @member {number|Long} customDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.customDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote preMarketChange.
         * @member {number} preMarketChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChange = 0;

        /**
         * Quote preMarketChangePercent.
         * @member {number} preMarketChangePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChangePercent = 0;

        /**
         * Quote afterMarketChange.
         * @member {number} afterMarketChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChange = 0;

        /**
         * Quote afterMarketChangePercent.
         * @member {number} afterMarketChangePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChangePercent = 0;

        /**
         * Quote change1Month.
         * @member {number} change1Month
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change1Month = 0;

        /**
         * Quote price3Month.
         * @member {number} price3Month
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.price3Month = 0;

        /**
         * Quote change3Month.
         * @member {number} change3Month
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change3Month = 0;

        /**
         * Quote changePercent3Month.
         * @member {number} changePercent3Month
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercent3Month = 0;

        /**
         * Quote price6Month.
         * @member {number} price6Month
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.price6Month = 0;

        /**
         * Quote change6Month.
         * @member {number} change6Month
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change6Month = 0;

        /**
         * Quote changePercent6Month.
         * @member {number} changePercent6Month
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.changePercent6Month = 0;

        /**
         * Quote change1Year.
         * @member {number} change1Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change1Year = 0;

        /**
         * Quote preMarketChange5Minute.
         * @member {number} preMarketChange5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChange5Minute = 0;

        /**
         * Quote preMarketChangePercent5Minute.
         * @member {number} preMarketChangePercent5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChangePercent5Minute = 0;

        /**
         * Quote preMarketChange15Minute.
         * @member {number} preMarketChange15Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChange15Minute = 0;

        /**
         * Quote preMarketChangePercent15Minute.
         * @member {number} preMarketChangePercent15Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChangePercent15Minute = 0;

        /**
         * Quote preMarketChange30Minute.
         * @member {number} preMarketChange30Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChange30Minute = 0;

        /**
         * Quote preMarketChangePercent30Minute.
         * @member {number} preMarketChangePercent30Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChangePercent30Minute = 0;

        /**
         * Quote preMarketChange60Minute.
         * @member {number} preMarketChange60Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChange60Minute = 0;

        /**
         * Quote preMarketChangePercent60Minute.
         * @member {number} preMarketChangePercent60Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChangePercent60Minute = 0;

        /**
         * Quote regularChange5Minute.
         * @member {number} regularChange5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChange5Minute = 0;

        /**
         * Quote regularChangePercent5Minute.
         * @member {number} regularChangePercent5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChangePercent5Minute = 0;

        /**
         * Quote regularChange15Minute.
         * @member {number} regularChange15Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChange15Minute = 0;

        /**
         * Quote regularChangePercent15Minute.
         * @member {number} regularChangePercent15Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChangePercent15Minute = 0;

        /**
         * Quote regularChange30Minute.
         * @member {number} regularChange30Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChange30Minute = 0;

        /**
         * Quote regularChangePercent30Minute.
         * @member {number} regularChangePercent30Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChangePercent30Minute = 0;

        /**
         * Quote regularChange60Minute.
         * @member {number} regularChange60Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChange60Minute = 0;

        /**
         * Quote regularChangePercent60Minute.
         * @member {number} regularChangePercent60Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChangePercent60Minute = 0;

        /**
         * Quote afterMarketChange5Minute.
         * @member {number} afterMarketChange5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChange5Minute = 0;

        /**
         * Quote afterMarketChangePercent5Minute.
         * @member {number} afterMarketChangePercent5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChangePercent5Minute = 0;

        /**
         * Quote afterMarketChange15Minute.
         * @member {number} afterMarketChange15Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChange15Minute = 0;

        /**
         * Quote afterMarketChangePercent15Minute.
         * @member {number} afterMarketChangePercent15Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChangePercent15Minute = 0;

        /**
         * Quote afterMarketChange30Minute.
         * @member {number} afterMarketChange30Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChange30Minute = 0;

        /**
         * Quote afterMarketChangePercent30Minute.
         * @member {number} afterMarketChangePercent30Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChangePercent30Minute = 0;

        /**
         * Quote afterMarketChange60Minute.
         * @member {number} afterMarketChange60Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChange60Minute = 0;

        /**
         * Quote afterMarketChangePercent60Minute.
         * @member {number} afterMarketChangePercent60Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChangePercent60Minute = 0;

        /**
         * Quote gics.
         * @member {number} gics
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gics = 0;

        /**
         * Quote gicsSector.
         * @member {number} gicsSector
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gicsSector = 0;

        /**
         * Quote gicsSectorName.
         * @member {string} gicsSectorName
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gicsSectorName = "";

        /**
         * Quote gicsIndustryGroup.
         * @member {number} gicsIndustryGroup
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gicsIndustryGroup = 0;

        /**
         * Quote gicsIndustryGroupName.
         * @member {string} gicsIndustryGroupName
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gicsIndustryGroupName = "";

        /**
         * Quote gicsIndustry.
         * @member {number} gicsIndustry
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gicsIndustry = 0;

        /**
         * Quote gicsIndustryName.
         * @member {string} gicsIndustryName
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gicsIndustryName = "";

        /**
         * Quote gicsSubIndustry.
         * @member {number} gicsSubIndustry
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gicsSubIndustry = 0;

        /**
         * Quote gicsSubIndustryName.
         * @member {string} gicsSubIndustryName
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gicsSubIndustryName = "";

        /**
         * Quote optionable.
         * @member {number} optionable
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.optionable = 0;

        /**
         * Quote cik.
         * @member {number} cik
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.cik = 0;

        /**
         * Quote signalName.
         * @member {string} signalName
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.signalName = "";

        /**
         * Quote lastTradeTime.
         * @member {number|Long} lastTradeTime
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.lastTradeTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote country.
         * @member {string} country
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.country = "";

        /**
         * Quote sharesShort.
         * @member {number|Long} sharesShort
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShort = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote sharesShortPercentOfFloat.
         * @member {number} sharesShortPercentOfFloat
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShortPercentOfFloat = 0;

        /**
         * Quote sharesShortChangePercent.
         * @member {number} sharesShortChangePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShortChangePercent = 0;

        /**
         * Quote sharesShortReceiptDate.
         * @member {number|Long} sharesShortReceiptDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShortReceiptDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote sharesShortSettlementDate.
         * @member {number|Long} sharesShortSettlementDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShortSettlementDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote shortInterestRatio.
         * @member {number} shortInterestRatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.shortInterestRatio = 0;

        /**
         * Quote sharesShortValue.
         * @member {number} sharesShortValue
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShortValue = 0;

        /**
         * Quote sharesShortPrevious.
         * @member {number|Long} sharesShortPrevious
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShortPrevious = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote sharesShortPreviousValue.
         * @member {number} sharesShortPreviousValue
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShortPreviousValue = 0;

        /**
         * Quote sharesShortPreviousPercentOfFloat.
         * @member {number} sharesShortPreviousPercentOfFloat
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShortPreviousPercentOfFloat = 0;

        /**
         * Quote sharesShortChange.
         * @member {number|Long} sharesShortChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sharesShortChange = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote sentTime.
         * @member {number|Long} sentTime
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.sentTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote closeTime.
         * @member {number|Long} closeTime
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.closeTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote volume5Minute.
         * @member {number|Long} volume5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.volume5Minute = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote volume15Minute.
         * @member {number|Long} volume15Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.volume15Minute = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote volume30Minute.
         * @member {number|Long} volume30Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.volume30Minute = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote volume60Minute.
         * @member {number|Long} volume60Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.volume60Minute = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote relativeVolume5Minute.
         * @member {number} relativeVolume5Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.relativeVolume5Minute = 0;

        /**
         * Quote relativeVolume90Day.
         * @member {number} relativeVolume90Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.relativeVolume90Day = 0;

        /**
         * Quote rvol1m10d.
         * @member {number} rvol1m10d
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rvol1m10d = 0;

        /**
         * Quote rvol5m10d.
         * @member {number} rvol5m10d
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rvol5m10d = 0;

        /**
         * Quote rvol5m30d.
         * @member {number} rvol5m30d
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rvol5m30d = 0;

        /**
         * Quote rvol5m90d.
         * @member {number} rvol5m90d
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rvol5m90d = 0;

        /**
         * Quote averageVolume10Day.
         * @member {number|Long} averageVolume10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolume10Day = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote averageVolumeChangePercent10Day.
         * @member {number} averageVolumeChangePercent10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolumeChangePercent10Day = 0;

        /**
         * Quote high10Day.
         * @member {number} high10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.high10Day = 0;

        /**
         * Quote highChangePercent10Day.
         * @member {number} highChangePercent10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.highChangePercent10Day = 0;

        /**
         * Quote low10Day.
         * @member {number} low10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.low10Day = 0;

        /**
         * Quote lowChangePercent10Day.
         * @member {number} lowChangePercent10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.lowChangePercent10Day = 0;

        /**
         * Quote movingAverage10Day.
         * @member {number} movingAverage10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverage10Day = 0;

        /**
         * Quote movingAverageChangePercent10Day.
         * @member {number} movingAverageChangePercent10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverageChangePercent10Day = 0;

        /**
         * Quote averageVolume20Day.
         * @member {number|Long} averageVolume20Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolume20Day = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote averageVolumeChangePercent20Day.
         * @member {number} averageVolumeChangePercent20Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolumeChangePercent20Day = 0;

        /**
         * Quote high20Day.
         * @member {number} high20Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.high20Day = 0;

        /**
         * Quote highChangePercent20Day.
         * @member {number} highChangePercent20Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.highChangePercent20Day = 0;

        /**
         * Quote low20Day.
         * @member {number} low20Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.low20Day = 0;

        /**
         * Quote lowChangePercent20Day.
         * @member {number} lowChangePercent20Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.lowChangePercent20Day = 0;

        /**
         * Quote movingAverage20Day.
         * @member {number} movingAverage20Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverage20Day = 0;

        /**
         * Quote movingAverageChangePercent20Day.
         * @member {number} movingAverageChangePercent20Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverageChangePercent20Day = 0;

        /**
         * Quote averageVolume50Day.
         * @member {number|Long} averageVolume50Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolume50Day = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote averageVolumeChangePercent50Day.
         * @member {number} averageVolumeChangePercent50Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolumeChangePercent50Day = 0;

        /**
         * Quote high50Day.
         * @member {number} high50Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.high50Day = 0;

        /**
         * Quote highChangePercent50Day.
         * @member {number} highChangePercent50Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.highChangePercent50Day = 0;

        /**
         * Quote low50Day.
         * @member {number} low50Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.low50Day = 0;

        /**
         * Quote lowChangePercent50Day.
         * @member {number} lowChangePercent50Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.lowChangePercent50Day = 0;

        /**
         * Quote movingAverage50Day.
         * @member {number} movingAverage50Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverage50Day = 0;

        /**
         * Quote movingAverageChangePercent50Day.
         * @member {number} movingAverageChangePercent50Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverageChangePercent50Day = 0;

        /**
         * Quote averageVolume100Day.
         * @member {number|Long} averageVolume100Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolume100Day = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote averageVolumeChangePercent100Day.
         * @member {number} averageVolumeChangePercent100Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolumeChangePercent100Day = 0;

        /**
         * Quote high100Day.
         * @member {number} high100Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.high100Day = 0;

        /**
         * Quote highChangePercent100Day.
         * @member {number} highChangePercent100Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.highChangePercent100Day = 0;

        /**
         * Quote low100Day.
         * @member {number} low100Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.low100Day = 0;

        /**
         * Quote lowChangePercent100Day.
         * @member {number} lowChangePercent100Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.lowChangePercent100Day = 0;

        /**
         * Quote movingAverage100Day.
         * @member {number} movingAverage100Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverage100Day = 0;

        /**
         * Quote movingAverageChangePercent100Day.
         * @member {number} movingAverageChangePercent100Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverageChangePercent100Day = 0;

        /**
         * Quote averageVolume200Day.
         * @member {number|Long} averageVolume200Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolume200Day = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote averageVolumeChangePercent200Day.
         * @member {number} averageVolumeChangePercent200Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolumeChangePercent200Day = 0;

        /**
         * Quote high200Day.
         * @member {number} high200Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.high200Day = 0;

        /**
         * Quote highChangePercent200Day.
         * @member {number} highChangePercent200Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.highChangePercent200Day = 0;

        /**
         * Quote low200Day.
         * @member {number} low200Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.low200Day = 0;

        /**
         * Quote lowChangePercent200Day.
         * @member {number} lowChangePercent200Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.lowChangePercent200Day = 0;

        /**
         * Quote movingAverage200Day.
         * @member {number} movingAverage200Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverage200Day = 0;

        /**
         * Quote movingAverageChangePercent200Day.
         * @member {number} movingAverageChangePercent200Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverageChangePercent200Day = 0;

        /**
         * Quote movingAverage250Day.
         * @member {number} movingAverage250Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverage250Day = 0;

        /**
         * Quote movingAverageChangePercent250Day.
         * @member {number} movingAverageChangePercent250Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverageChangePercent250Day = 0;

        /**
         * Quote averageVolume90Day.
         * @member {number|Long} averageVolume90Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolume90Day = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote nextEarningsDate.
         * @member {number} nextEarningsDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.nextEarningsDate = 0;

        /**
         * Quote dividend.
         * @member {number} dividend
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividend = 0;

        /**
         * Quote dividendYield.
         * @member {number} dividendYield
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendYield = 0;

        /**
         * Quote dividendExDate.
         * @member {number} dividendExDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendExDate = 0;

        /**
         * Quote dividendFrequency.
         * @member {number|Long} dividendFrequency
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendFrequency = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote forwardDividendYield.
         * @member {number} forwardDividendYield
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.forwardDividendYield = 0;

        /**
         * Quote roe.
         * @member {number} roe
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roe = 0;

        /**
         * Quote roa.
         * @member {number} roa
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roa = 0;

        /**
         * Quote roic.
         * @member {number} roic
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roic = 0;

        /**
         * Quote currentRatio.
         * @member {number} currentRatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.currentRatio = 0;

        /**
         * Quote grossMargin.
         * @member {number} grossMargin
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.grossMargin = 0;

        /**
         * Quote netMargin.
         * @member {number} netMargin
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.netMargin = 0;

        /**
         * Quote operationMargin.
         * @member {number} operationMargin
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.operationMargin = 0;

        /**
         * Quote epsMrq.
         * @member {number} epsMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.epsMrq = 0;

        /**
         * Quote epsTtm.
         * @member {number} epsTtm
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.epsTtm = 0;

        /**
         * Quote dilutedEpsMrq.
         * @member {number} dilutedEpsMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dilutedEpsMrq = 0;

        /**
         * Quote dilutedEpsTtm.
         * @member {number} dilutedEpsTtm
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dilutedEpsTtm = 0;

        /**
         * Quote low52Week.
         * @member {number} low52Week
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.low52Week = 0;

        /**
         * Quote high52Week.
         * @member {number} high52Week
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.high52Week = 0;

        /**
         * Quote revenueTtm.
         * @member {number} revenueTtm
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.revenueTtm = 0;

        /**
         * Quote earningsAsOf.
         * @member {number} earningsAsOf
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.earningsAsOf = 0;

        /**
         * Quote netProfitMargin.
         * @member {number} netProfitMargin
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.netProfitMargin = 0;

        /**
         * Quote change1Week.
         * @member {number} change1Week
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change1Week = 0;

        /**
         * Quote price1Week.
         * @member {number} price1Week
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.price1Week = 0;

        /**
         * Quote priceChangePercent1Week.
         * @member {number} priceChangePercent1Week
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceChangePercent1Week = 0;

        /**
         * Quote price1Month.
         * @member {number} price1Month
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.price1Month = 0;

        /**
         * Quote priceChangePercent1Month.
         * @member {number} priceChangePercent1Month
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceChangePercent1Month = 0;

        /**
         * Quote priceHalfYear.
         * @member {number} priceHalfYear
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceHalfYear = 0;

        /**
         * Quote priceChangePercentHalfYear.
         * @member {number} priceChangePercentHalfYear
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceChangePercentHalfYear = 0;

        /**
         * Quote priceQuarter.
         * @member {number} priceQuarter
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceQuarter = 0;

        /**
         * Quote priceChangePercentQuarter.
         * @member {number} priceChangePercentQuarter
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceChangePercentQuarter = 0;

        /**
         * Quote price1Year.
         * @member {number} price1Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.price1Year = 0;

        /**
         * Quote priceChangePercent1Year.
         * @member {number} priceChangePercent1Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceChangePercent1Year = 0;

        /**
         * Quote priceYearToDate.
         * @member {number} priceYearToDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceYearToDate = 0;

        /**
         * Quote priceChangePercentYearToDate.
         * @member {number} priceChangePercentYearToDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceChangePercentYearToDate = 0;

        /**
         * Quote roeMrq.
         * @member {number} roeMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roeMrq = 0;

        /**
         * Quote roaMrq.
         * @member {number} roaMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roaMrq = 0;

        /**
         * Quote roicMrq.
         * @member {number} roicMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roicMrq = 0;

        /**
         * Quote currentRatioMrq.
         * @member {number} currentRatioMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.currentRatioMrq = 0;

        /**
         * Quote grossMarginMrq.
         * @member {number} grossMarginMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.grossMarginMrq = 0;

        /**
         * Quote netMarginMrq.
         * @member {number} netMarginMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.netMarginMrq = 0;

        /**
         * Quote operationMarginMrq.
         * @member {number} operationMarginMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.operationMarginMrq = 0;

        /**
         * Quote previousDayVolume.
         * @member {number|Long} previousDayVolume
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.previousDayVolume = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote previousDayAtr.
         * @member {number} previousDayAtr
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.previousDayAtr = 0;

        /**
         * Quote previousDayAdx.
         * @member {number} previousDayAdx
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.previousDayAdx = 0;

        /**
         * Quote previousDayPlusDMSmoothed.
         * @member {number} previousDayPlusDMSmoothed
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.previousDayPlusDMSmoothed = 0;

        /**
         * Quote previousDayMinusDMSmoothed.
         * @member {number} previousDayMinusDMSmoothed
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.previousDayMinusDMSmoothed = 0;

        /**
         * Quote previousDayHigh.
         * @member {number} previousDayHigh
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.previousDayHigh = 0;

        /**
         * Quote previousDayLow.
         * @member {number} previousDayLow
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.previousDayLow = 0;

        /**
         * Quote adx.
         * @member {number} adx
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.adx = 0;

        /**
         * Quote percentInstitutionalOwnership.
         * @member {number} percentInstitutionalOwnership
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.percentInstitutionalOwnership = 0;

        /**
         * Quote percentInstitutionalTransactions.
         * @member {number} percentInstitutionalTransactions
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.percentInstitutionalTransactions = 0;

        /**
         * Quote wiim.
         * @member {string} wiim
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.wiim = "";

        /**
         * Quote wiimAsOf.
         * @member {number|Long} wiimAsOf
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.wiimAsOf = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote vwap.
         * @member {number} vwap
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap = 0;

        /**
         * Quote vwapChangePercent.
         * @member {number} vwapChangePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwapChangePercent = 0;

        /**
         * Quote vwapChange.
         * @member {number} vwapChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwapChange = 0;

        /**
         * Quote rsiAvgGain.
         * @member {number} rsiAvgGain
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiAvgGain = 0;

        /**
         * Quote rsiAvgLoss.
         * @member {number} rsiAvgLoss
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiAvgLoss = 0;

        /**
         * Quote halted.
         * @member {string} halted
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.halted = "";

        /**
         * Quote tradeCount.
         * @member {number|Long} tradeCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.tradeCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote regularHighCount.
         * @member {number|Long} regularHighCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularHighCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote regularLowCount.
         * @member {number|Long} regularLowCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularLowCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote preMarketHighCount.
         * @member {number|Long} preMarketHighCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketHighCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote preMarketLowCount.
         * @member {number|Long} preMarketLowCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketLowCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote afterMarketHighCount.
         * @member {number|Long} afterMarketHighCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketHighCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote afterMarketLowCount.
         * @member {number|Long} afterMarketLowCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketLowCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote dayHighCount.
         * @member {number|Long} dayHighCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dayHighCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote dayLowCount.
         * @member {number|Long} dayLowCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dayLowCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote dayHigh.
         * @member {number} dayHigh
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dayHigh = 0;

        /**
         * Quote dayLow.
         * @member {number} dayLow
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dayLow = 0;

        /**
         * Quote preMarketHigh.
         * @member {number} preMarketHigh
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketHigh = 0;

        /**
         * Quote preMarketLow.
         * @member {number} preMarketLow
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketLow = 0;

        /**
         * Quote afterMarketHigh.
         * @member {number} afterMarketHigh
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketHigh = 0;

        /**
         * Quote afterMarketLow.
         * @member {number} afterMarketLow
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketLow = 0;

        /**
         * Quote regularHigh.
         * @member {number} regularHigh
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularHigh = 0;

        /**
         * Quote regularLow.
         * @member {number} regularLow
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularLow = 0;

        /**
         * Quote priceSpikeUpCount.
         * @member {number|Long} priceSpikeUpCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceSpikeUpCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote priceSpikeDownCount.
         * @member {number|Long} priceSpikeDownCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceSpikeDownCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote haltedCount.
         * @member {number|Long} haltedCount
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.haltedCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote usCongressTotal.
         * @member {number} usCongressTotal
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.usCongressTotal = 0;

        /**
         * Quote usCongressRepublicansTotal.
         * @member {number} usCongressRepublicansTotal
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.usCongressRepublicansTotal = 0;

        /**
         * Quote usCongressDemocratsTotal.
         * @member {number} usCongressDemocratsTotal
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.usCongressDemocratsTotal = 0;

        /**
         * Quote usCongressOtherTotal.
         * @member {number} usCongressOtherTotal
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.usCongressOtherTotal = 0;

        /**
         * Quote volumeFloatRatio.
         * @member {number} volumeFloatRatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.volumeFloatRatio = 0;

        /**
         * Quote atrp.
         * @member {number} atrp
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.atrp = 0;

        /**
         * Quote ytdGainLoss.
         * @member {number} ytdGainLoss
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.ytdGainLoss = 0;

        /**
         * Quote mtdGainLoss.
         * @member {number} mtdGainLoss
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.mtdGainLoss = 0;

        /**
         * Quote ytdChange.
         * @member {number} ytdChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.ytdChange = 0;

        /**
         * Quote mtdChange.
         * @member {number} mtdChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.mtdChange = 0;

        /**
         * Quote yearOpen.
         * @member {number} yearOpen
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.yearOpen = 0;

        /**
         * Quote monthOpen.
         * @member {number} monthOpen
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.monthOpen = 0;

        /**
         * Quote volumeFloatPercent.
         * @member {number} volumeFloatPercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.volumeFloatPercent = 0;

        /**
         * Quote rsi1m.
         * @member {number} rsi1m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi1m = 0;

        /**
         * Quote rsi2m.
         * @member {number} rsi2m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi2m = 0;

        /**
         * Quote rsi5m.
         * @member {number} rsi5m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi5m = 0;

        /**
         * Quote rsi15m.
         * @member {number} rsi15m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi15m = 0;

        /**
         * Quote rsi30m.
         * @member {number} rsi30m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi30m = 0;

        /**
         * Quote rsi60m.
         * @member {number} rsi60m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi60m = 0;

        /**
         * Quote rsiEth1m.
         * @member {number} rsiEth1m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth1m = 0;

        /**
         * Quote rsiEth2m.
         * @member {number} rsiEth2m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth2m = 0;

        /**
         * Quote rsiEth5m.
         * @member {number} rsiEth5m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth5m = 0;

        /**
         * Quote rsiEth15m.
         * @member {number} rsiEth15m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth15m = 0;

        /**
         * Quote rsiEth30m.
         * @member {number} rsiEth30m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth30m = 0;

        /**
         * Quote rsiEth60m.
         * @member {number} rsiEth60m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth60m = 0;

        /**
         * Quote averageDollarVolume10Day.
         * @member {number} averageDollarVolume10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageDollarVolume10Day = 0;

        /**
         * Quote averageVolume60Day.
         * @member {number|Long} averageVolume60Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageVolume60Day = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote relativeVolumePercent60Day.
         * @member {number} relativeVolumePercent60Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.relativeVolumePercent60Day = 0;

        /**
         * Quote rsi1mLowest.
         * @member {number} rsi1mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi1mLowest = 0;

        /**
         * Quote rsi2mLowest.
         * @member {number} rsi2mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi2mLowest = 0;

        /**
         * Quote rsi5mLowest.
         * @member {number} rsi5mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi5mLowest = 0;

        /**
         * Quote rsi15mLowest.
         * @member {number} rsi15mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi15mLowest = 0;

        /**
         * Quote rsi30mLowest.
         * @member {number} rsi30mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi30mLowest = 0;

        /**
         * Quote rsi60mLowest.
         * @member {number} rsi60mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi60mLowest = 0;

        /**
         * Quote rsiEth1mLowest.
         * @member {number} rsiEth1mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth1mLowest = 0;

        /**
         * Quote rsiEth2mLowest.
         * @member {number} rsiEth2mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth2mLowest = 0;

        /**
         * Quote rsiEth5mLowest.
         * @member {number} rsiEth5mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth5mLowest = 0;

        /**
         * Quote rsiEth15mLowest.
         * @member {number} rsiEth15mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth15mLowest = 0;

        /**
         * Quote rsiEth30mLowest.
         * @member {number} rsiEth30mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth30mLowest = 0;

        /**
         * Quote rsiEth60mLowest.
         * @member {number} rsiEth60mLowest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth60mLowest = 0;

        /**
         * Quote rsi1mGreatest.
         * @member {number} rsi1mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi1mGreatest = 0;

        /**
         * Quote rsi2mGreatest.
         * @member {number} rsi2mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi2mGreatest = 0;

        /**
         * Quote rsi5mGreatest.
         * @member {number} rsi5mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi5mGreatest = 0;

        /**
         * Quote rsi15mGreatest.
         * @member {number} rsi15mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi15mGreatest = 0;

        /**
         * Quote rsi30mGreatest.
         * @member {number} rsi30mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi30mGreatest = 0;

        /**
         * Quote rsi60mGreatest.
         * @member {number} rsi60mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsi60mGreatest = 0;

        /**
         * Quote rsiEth1mGreatest.
         * @member {number} rsiEth1mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth1mGreatest = 0;

        /**
         * Quote rsiEth2mGreatest.
         * @member {number} rsiEth2mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth2mGreatest = 0;

        /**
         * Quote rsiEth5mGreatest.
         * @member {number} rsiEth5mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth5mGreatest = 0;

        /**
         * Quote rsiEth15mGreatest.
         * @member {number} rsiEth15mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth15mGreatest = 0;

        /**
         * Quote rsiEth30mGreatest.
         * @member {number} rsiEth30mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth30mGreatest = 0;

        /**
         * Quote rsiEth60mGreatest.
         * @member {number} rsiEth60mGreatest
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiEth60mGreatest = 0;

        /**
         * Quote rsiCrossOver.
         * @member {number} rsiCrossOver
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rsiCrossOver = 0;

        /**
         * Quote ema12d.
         * @member {number} ema12d
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.ema12d = 0;

        /**
         * Quote ema26d.
         * @member {number} ema26d
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.ema26d = 0;

        /**
         * Quote macd.
         * @member {number} macd
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.macd = 0;

        /**
         * Quote macdSignalLine.
         * @member {number} macdSignalLine
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.macdSignalLine = 0;

        /**
         * Quote macdHistogram.
         * @member {number} macdHistogram
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.macdHistogram = 0;

        /**
         * Quote macdSignalLineBase.
         * @member {number} macdSignalLineBase
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.macdSignalLineBase = 0;

        /**
         * Quote dividendGrowthRate1Year.
         * @member {number} dividendGrowthRate1Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendGrowthRate1Year = 0;

        /**
         * Quote dividendGrowthRate3Year.
         * @member {number} dividendGrowthRate3Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendGrowthRate3Year = 0;

        /**
         * Quote dividendGrowthRate5Year.
         * @member {number} dividendGrowthRate5Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendGrowthRate5Year = 0;

        /**
         * Quote totalDividendTtm.
         * @member {number} totalDividendTtm
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.totalDividendTtm = 0;

        /**
         * Quote dividendIncreasing.
         * @member {number} dividendIncreasing
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendIncreasing = 0;

        /**
         * Quote newsBzWireTitle.
         * @member {string} newsBzWireTitle
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsBzWireTitle = "";

        /**
         * Quote newsBzWireNodeId.
         * @member {string} newsBzWireNodeId
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsBzWireNodeId = "";

        /**
         * Quote newsBzWireTimestamp.
         * @member {number|Long} newsBzWireTimestamp
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsBzWireTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote newsPRTitle.
         * @member {string} newsPRTitle
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsPRTitle = "";

        /**
         * Quote newsPRNodeId.
         * @member {string} newsPRNodeId
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsPRNodeId = "";

        /**
         * Quote newsPRTimestamp.
         * @member {number|Long} newsPRTimestamp
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsPRTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote newsSecTitle.
         * @member {string} newsSecTitle
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsSecTitle = "";

        /**
         * Quote newsSecNodeId.
         * @member {string} newsSecNodeId
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsSecNodeId = "";

        /**
         * Quote newsSecTimestamp.
         * @member {number|Long} newsSecTimestamp
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsSecTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote newsBzWireTitleWithNodeId.
         * @member {string} newsBzWireTitleWithNodeId
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsBzWireTitleWithNodeId = "";

        /**
         * Quote newsPRTitleWithNodeId.
         * @member {string} newsPRTitleWithNodeId
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsPRTitleWithNodeId = "";

        /**
         * Quote newsSecTitleWithNodeId.
         * @member {string} newsSecTitleWithNodeId
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.newsSecTitleWithNodeId = "";

        /**
         * Quote movingAverage500Day.
         * @member {number} movingAverage500Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverage500Day = 0;

        /**
         * Quote gapChange.
         * @member {number} gapChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gapChange = 0;

        /**
         * Quote gapChangePercent.
         * @member {number} gapChangePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.gapChangePercent = 0;

        /**
         * Quote adr14d.
         * @member {number} adr14d
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.adr14d = 0;

        /**
         * Quote dilutedEpsMrqSurprisePercent.
         * @member {number} dilutedEpsMrqSurprisePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dilutedEpsMrqSurprisePercent = 0;

        /**
         * Quote dilutedEpsTtmSurprisePercent.
         * @member {number} dilutedEpsTtmSurprisePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dilutedEpsTtmSurprisePercent = 0;

        /**
         * Quote dilutedRevenueMrqSurprisePercent.
         * @member {number} dilutedRevenueMrqSurprisePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dilutedRevenueMrqSurprisePercent = 0;

        /**
         * Quote dilutedRevenueTtmSurprisePercent.
         * @member {number} dilutedRevenueTtmSurprisePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dilutedRevenueTtmSurprisePercent = 0;

        /**
         * Quote epsGrowthTtm.
         * @member {number} epsGrowthTtm
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.epsGrowthTtm = 0;

        /**
         * Quote epsGrowthY2Y.
         * @member {number} epsGrowthY2Y
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.epsGrowthY2Y = 0;

        /**
         * Quote epsGrowthQ2Q.
         * @member {number} epsGrowthQ2Q
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.epsGrowthQ2Q = 0;

        /**
         * Quote epsGrowth5Year.
         * @member {number} epsGrowth5Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.epsGrowth5Year = 0;

        /**
         * Quote epsGrowthYearAgoQ.
         * @member {number} epsGrowthYearAgoQ
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.epsGrowthYearAgoQ = 0;

        /**
         * Quote revenueGrowthTtm.
         * @member {number} revenueGrowthTtm
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.revenueGrowthTtm = 0;

        /**
         * Quote revenueGrowthY2Y.
         * @member {number} revenueGrowthY2Y
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.revenueGrowthY2Y = 0;

        /**
         * Quote revenueGrowthQ2Q.
         * @member {number} revenueGrowthQ2Q
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.revenueGrowthQ2Q = 0;

        /**
         * Quote revenueGrowth5Year.
         * @member {number} revenueGrowth5Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.revenueGrowth5Year = 0;

        /**
         * Quote revenueGrowthYearAgoQ.
         * @member {number} revenueGrowthYearAgoQ
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.revenueGrowthYearAgoQ = 0;

        /**
         * Quote ltDebtEquity.
         * @member {number} ltDebtEquity
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.ltDebtEquity = 0;

        /**
         * Quote bullsSay.
         * @member {string} bullsSay
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.bullsSay = "";

        /**
         * Quote bearsSay.
         * @member {string} bearsSay
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.bearsSay = "";

        /**
         * Quote ipoDateNumber.
         * @member {number|Long} ipoDateNumber
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.ipoDateNumber = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote ffoPerShare.
         * @member {number} ffoPerShare
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.ffoPerShare = 0;

        /**
         * Quote quickRatioMrq.
         * @member {number} quickRatioMrq
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.quickRatioMrq = 0;

        /**
         * Quote highAllTime.
         * @member {number} highAllTime
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.highAllTime = 0;

        /**
         * Quote lowAllTime.
         * @member {number} lowAllTime
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.lowAllTime = 0;

        /**
         * Quote evToEbitda.
         * @member {number} evToEbitda
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.evToEbitda = 0;

        /**
         * Quote totalDebtEquityRatio.
         * @member {number} totalDebtEquityRatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.totalDebtEquityRatio = 0;

        /**
         * Quote dividendPayoutRatio.
         * @member {number} dividendPayoutRatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendPayoutRatio = 0;

        /**
         * Quote operatingCashFlow.
         * @member {number} operatingCashFlow
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.operatingCashFlow = 0;

        /**
         * Quote insiderPercentage.
         * @member {number} insiderPercentage
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.insiderPercentage = 0;

        /**
         * Quote priceToCashFlowRatio.
         * @member {number} priceToCashFlowRatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceToCashFlowRatio = 0;

        /**
         * Quote regularHoursChange.
         * @member {number} regularHoursChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularHoursChange = 0;

        /**
         * Quote regularHoursPercentChange.
         * @member {number} regularHoursPercentChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularHoursPercentChange = 0;

        /**
         * Quote postToPreHoursChange.
         * @member {number} postToPreHoursChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.postToPreHoursChange = 0;

        /**
         * Quote postToPreHoursPercentChange.
         * @member {number} postToPreHoursPercentChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.postToPreHoursPercentChange = 0;

        /**
         * Quote scannerClose.
         * @member {number} scannerClose
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.scannerClose = 0;

        /**
         * Quote scannerChange.
         * @member {number} scannerChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.scannerChange = 0;

        /**
         * Quote scannerChangePercent.
         * @member {number} scannerChangePercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.scannerChangePercent = 0;

        /**
         * Quote scannerChangePercentClose.
         * @member {number} scannerChangePercentClose
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.scannerChangePercentClose = 0;

        /**
         * Quote scannerPreviousClose.
         * @member {number} scannerPreviousClose
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.scannerPreviousClose = 0;

        /**
         * Quote freeCashFlow.
         * @member {number} freeCashFlow
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.freeCashFlow = 0;

        /**
         * Quote minPriceTarget.
         * @member {number} minPriceTarget
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.minPriceTarget = 0;

        /**
         * Quote maxPriceTarget.
         * @member {number} maxPriceTarget
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.maxPriceTarget = 0;

        /**
         * Quote meanPriceTarget.
         * @member {number} meanPriceTarget
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.meanPriceTarget = 0;

        /**
         * Quote totalNumberOfAnalyst.
         * @member {number} totalNumberOfAnalyst
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.totalNumberOfAnalyst = 0;

        /**
         * Quote averageAnalystRecommendation.
         * @member {string} averageAnalystRecommendation
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageAnalystRecommendation = "";

        /**
         * Quote pegRatio.
         * @member {number} pegRatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.pegRatio = 0;

        /**
         * Quote priceToFreeCashFlowRatio.
         * @member {number} priceToFreeCashFlowRatio
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceToFreeCashFlowRatio = 0;

        /**
         * Quote distanceToMaxPriceTarget.
         * @member {number} distanceToMaxPriceTarget
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.distanceToMaxPriceTarget = 0;

        /**
         * Quote distanceToMinPriceTarget.
         * @member {number} distanceToMinPriceTarget
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.distanceToMinPriceTarget = 0;

        /**
         * Quote distanceToMeanPriceTarget.
         * @member {number} distanceToMeanPriceTarget
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.distanceToMeanPriceTarget = 0;

        /**
         * Quote shortTermTrend.
         * @member {string} shortTermTrend
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.shortTermTrend = "";

        /**
         * Quote mediumTermTrend.
         * @member {string} mediumTermTrend
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.mediumTermTrend = "";

        /**
         * Quote longTermTrend.
         * @member {string} longTermTrend
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.longTermTrend = "";

        /**
         * Quote twentySixWeekChange.
         * @member {number} twentySixWeekChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.twentySixWeekChange = 0;

        /**
         * Quote fiftyTwoWeekChange.
         * @member {number} fiftyTwoWeekChange
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.fiftyTwoWeekChange = 0;

        /**
         * Quote annualizedStandardDeviation.
         * @member {number} annualizedStandardDeviation
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.annualizedStandardDeviation = 0;

        /**
         * Quote momentum.
         * @member {number} momentum
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.momentum = 0;

        /**
         * Quote value.
         * @member {number} value
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.value = 0;

        /**
         * Quote piotroskiFScore.
         * @member {number|Long} piotroskiFScore
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.piotroskiFScore = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Quote netIncomeTtm.
         * @member {number} netIncomeTtm
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.netIncomeTtm = 0;

        /**
         * Quote currentRatioYearAgo.
         * @member {number} currentRatioYearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.currentRatioYearAgo = 0;

        /**
         * Quote roaYearAgo.
         * @member {number} roaYearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roaYearAgo = 0;

        /**
         * Quote grossMarginYearAgo.
         * @member {number} grossMarginYearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.grossMarginYearAgo = 0;

        /**
         * Quote longTermDebt.
         * @member {number} longTermDebt
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.longTermDebt = 0;

        /**
         * Quote longTermDebtYearAgo.
         * @member {number} longTermDebtYearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.longTermDebtYearAgo = 0;

        /**
         * Quote shareIssued.
         * @member {number} shareIssued
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.shareIssued = 0;

        /**
         * Quote shareIssuedYearAgo.
         * @member {number} shareIssuedYearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.shareIssuedYearAgo = 0;

        /**
         * Quote totalAssets.
         * @member {number} totalAssets
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.totalAssets = 0;

        /**
         * Quote totalAssetsYearAgo.
         * @member {number} totalAssetsYearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.totalAssetsYearAgo = 0;

        /**
         * Quote totalAssets2YearAgo.
         * @member {number} totalAssets2YearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.totalAssets2YearAgo = 0;

        /**
         * Quote revenueTtmYearAgo.
         * @member {number} revenueTtmYearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.revenueTtmYearAgo = 0;

        /**
         * Quote longTermDebtAndCapitalLeaseObligation.
         * @member {number} longTermDebtAndCapitalLeaseObligation
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.longTermDebtAndCapitalLeaseObligation = 0;

        /**
         * Quote averageTotalAssets.
         * @member {number} averageTotalAssets
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageTotalAssets = 0;

        /**
         * Quote averageTotalAssetsYearAgo.
         * @member {number} averageTotalAssetsYearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.averageTotalAssetsYearAgo = 0;

        /**
         * Quote growth.
         * @member {number} growth
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.growth = 0;

        /**
         * Quote quality.
         * @member {number} quality
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.quality = 0;

        /**
         * Quote momentumPercentile.
         * @member {number} momentumPercentile
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.momentumPercentile = 0;

        /**
         * Quote valuePercentile.
         * @member {number} valuePercentile
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.valuePercentile = 0;

        /**
         * Quote growthPercentile.
         * @member {number} growthPercentile
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.growthPercentile = 0;

        /**
         * Quote qualityPercentile.
         * @member {number} qualityPercentile
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.qualityPercentile = 0;

        /**
         * Quote rateOfReturnDay.
         * @member {number} rateOfReturnDay
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rateOfReturnDay = 0;

        /**
         * Quote rateOfReturnWeek.
         * @member {number} rateOfReturnWeek
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rateOfReturnWeek = 0;

        /**
         * Quote rateOfReturnMonth.
         * @member {number} rateOfReturnMonth
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.rateOfReturnMonth = 0;

        /**
         * Quote dividendOneDay.
         * @member {number} dividendOneDay
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendOneDay = 0;

        /**
         * Quote dividendOneWeek.
         * @member {number} dividendOneWeek
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendOneWeek = 0;

        /**
         * Quote dividendOneMonth.
         * @member {number} dividendOneMonth
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dividendOneMonth = 0;

        /**
         * Quote totalLiabilities.
         * @member {number} totalLiabilities
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.totalLiabilities = 0;

        /**
         * Quote retainedEarnings.
         * @member {number} retainedEarnings
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.retainedEarnings = 0;

        /**
         * Quote ebit.
         * @member {number} ebit
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.ebit = 0;

        /**
         * Quote altmanZScore.
         * @member {number} altmanZScore
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.altmanZScore = 0;

        /**
         * Quote powerEarningGap.
         * @member {boolean} powerEarningGap
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.powerEarningGap = false;

        /**
         * Quote monsterPowerEarningGap.
         * @member {boolean} monsterPowerEarningGap
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.monsterPowerEarningGap = false;

        /**
         * Quote monsterGap.
         * @member {boolean} monsterGap
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.monsterGap = false;

        /**
         * Quote oelGap.
         * @member {boolean} oelGap
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.oelGap = false;

        /**
         * Quote evToEbit.
         * @member {number} evToEbit
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.evToEbit = 0;

        /**
         * Quote priceToTangibleBookValue.
         * @member {number} priceToTangibleBookValue
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceToTangibleBookValue = 0;

        /**
         * Quote tangibleBookValuePerShare.
         * @member {number} tangibleBookValuePerShare
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.tangibleBookValuePerShare = 0;

        /**
         * Quote dailyDollarVolume.
         * @member {number} dailyDollarVolume
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.dailyDollarVolume = 0;

        /**
         * Quote bookValuePerShare.
         * @member {number} bookValuePerShare
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.bookValuePerShare = 0;

        /**
         * Quote movingAverage350Day.
         * @member {number} movingAverage350Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.movingAverage350Day = 0;

        /**
         * Quote priceToAdjEarningsTtm.
         * @member {number} priceToAdjEarningsTtm
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.priceToAdjEarningsTtm = 0;

        /**
         * Quote salesGrowthYoY.
         * @member {number} salesGrowthYoY
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.salesGrowthYoY = 0;

        /**
         * Quote salesGrowth3Year.
         * @member {number} salesGrowth3Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.salesGrowth3Year = 0;

        /**
         * Quote salesGrowth5Year.
         * @member {number} salesGrowth5Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.salesGrowth5Year = 0;

        /**
         * Quote debtQoQ.
         * @member {number} debtQoQ
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.debtQoQ = 0;

        /**
         * Quote debtYoY.
         * @member {number} debtYoY
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.debtYoY = 0;

        /**
         * Quote debt5Year.
         * @member {number} debt5Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.debt5Year = 0;

        /**
         * Quote epsGrowth3Year.
         * @member {number} epsGrowth3Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.epsGrowth3Year = 0;

        /**
         * Quote epsGrowth3NormalizedYear.
         * @member {number} epsGrowth3NormalizedYear
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.epsGrowth3NormalizedYear = 0;

        /**
         * Quote roe5YrAvg.
         * @member {number} roe5YrAvg
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roe5YrAvg = 0;

        /**
         * Quote stockholdersEquity.
         * @member {number} stockholdersEquity
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.stockholdersEquity = 0;

        /**
         * Quote stockholdersEquityYearAgo.
         * @member {number} stockholdersEquityYearAgo
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.stockholdersEquityYearAgo = 0;

        /**
         * Quote stockholdersEquityGrowthYoY.
         * @member {number} stockholdersEquityGrowthYoY
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.stockholdersEquityGrowthYoY = 0;

        /**
         * Quote vwap1Day.
         * @member {number} vwap1Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap1Day = 0;

        /**
         * Quote vwap5Day.
         * @member {number} vwap5Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap5Day = 0;

        /**
         * Quote vwap10Day.
         * @member {number} vwap10Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap10Day = 0;

        /**
         * Quote vwap50Day.
         * @member {number} vwap50Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap50Day = 0;

        /**
         * Quote vwap100Day.
         * @member {number} vwap100Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap100Day = 0;

        /**
         * Quote vwap200Day.
         * @member {number} vwap200Day
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap200Day = 0;

        /**
         * Quote roic1YearAvg.
         * @member {number} roic1YearAvg
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roic1YearAvg = 0;

        /**
         * Quote roic5YearAvg.
         * @member {number} roic5YearAvg
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.roic5YearAvg = 0;

        /**
         * Quote vwap1m.
         * @member {number} vwap1m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap1m = 0;

        /**
         * Quote vwap5m.
         * @member {number} vwap5m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap5m = 0;

        /**
         * Quote vwap15m.
         * @member {number} vwap15m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap15m = 0;

        /**
         * Quote vwap30m.
         * @member {number} vwap30m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap30m = 0;

        /**
         * Quote vwap60m.
         * @member {number} vwap60m
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.vwap60m = 0;

        /**
         * Quote candleStick.
         * @member {string} candleStick
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.candleStick = "";

        /**
         * Quote patterns.
         * @member {string} patterns
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.patterns = "";

        /**
         * Quote earningsForwardGrowth3Year.
         * @member {number} earningsForwardGrowth3Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.earningsForwardGrowth3Year = 0;

        /**
         * Quote earningsForwardGrowth5Year.
         * @member {number} earningsForwardGrowth5Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.earningsForwardGrowth5Year = 0;

        /**
         * Quote revenueForwardGrowth3Year.
         * @member {number} revenueForwardGrowth3Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.revenueForwardGrowth3Year = 0;

        /**
         * Quote revenueForwardGrowth5Year.
         * @member {number} revenueForwardGrowth5Year
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.revenueForwardGrowth5Year = 0;

        /**
         * Quote bidAskSpread.
         * @member {number} bidAskSpread
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.bidAskSpread = 0;

        /**
         * Quote bidAskSpreadPercent.
         * @member {number} bidAskSpreadPercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.bidAskSpreadPercent = 0;

        /**
         * Quote change1Minute.
         * @member {number} change1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.change1Minute = 0;

        /**
         * Quote preMarketChange1Minute.
         * @member {number} preMarketChange1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChange1Minute = 0;

        /**
         * Quote preMarketChangePercent1Minute.
         * @member {number} preMarketChangePercent1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.preMarketChangePercent1Minute = 0;

        /**
         * Quote regularChange1Minute.
         * @member {number} regularChange1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChange1Minute = 0;

        /**
         * Quote regularChangePercent1Minute.
         * @member {number} regularChangePercent1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.regularChangePercent1Minute = 0;

        /**
         * Quote afterMarketChange1Minute.
         * @member {number} afterMarketChange1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChange1Minute = 0;

        /**
         * Quote afterMarketChangePercent1Minute.
         * @member {number} afterMarketChangePercent1Minute
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.afterMarketChangePercent1Minute = 0;

        /**
         * Quote previousCloseDate.
         * @member {string} previousCloseDate
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.previousCloseDate = "";

        /**
         * Quote distanceToMaxPriceTargetPercent.
         * @member {number} distanceToMaxPriceTargetPercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.distanceToMaxPriceTargetPercent = 0;

        /**
         * Quote distanceToMinPriceTargetPercent.
         * @member {number} distanceToMinPriceTargetPercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.distanceToMinPriceTargetPercent = 0;

        /**
         * Quote distanceToMeanPriceTargetPercent.
         * @member {number} distanceToMeanPriceTargetPercent
         * @memberof QuoteProtos.Quote
         * @instance
         */
        Quote.prototype.distanceToMeanPriceTargetPercent = 0;

        /**
         * Creates a new Quote instance using the specified properties.
         * @function create
         * @memberof QuoteProtos.Quote
         * @static
         * @param {QuoteProtos.IQuote=} [properties] Properties to set
         * @returns {QuoteProtos.Quote} Quote instance
         */
        Quote.create = function create(properties) {
            return new Quote(properties);
        };

        /**
         * Encodes the specified Quote message. Does not implicitly {@link QuoteProtos.Quote.verify|verify} messages.
         * @function encode
         * @memberof QuoteProtos.Quote
         * @static
         * @param {QuoteProtos.IQuote} message Quote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Quote.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.symbol);
            if (message.previousClose != null && Object.hasOwnProperty.call(message, "previousClose"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.previousClose);
            if (message.close != null && Object.hasOwnProperty.call(message, "close"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.close);
            if (message.change != null && Object.hasOwnProperty.call(message, "change"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.change);
            if (message.changePercent != null && Object.hasOwnProperty.call(message, "changePercent"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.changePercent);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.name);
            if (message.ipoDate != null && Object.hasOwnProperty.call(message, "ipoDate"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.ipoDate);
            if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.exchange);
            if (message.tradeExchange != null && Object.hasOwnProperty.call(message, "tradeExchange"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.tradeExchange);
            if (message.marketCap != null && Object.hasOwnProperty.call(message, "marketCap"))
                writer.uint32(/* id 10, wireType 0 =*/80).int64(message.marketCap);
            if (message.rsi != null && Object.hasOwnProperty.call(message, "rsi"))
                writer.uint32(/* id 11, wireType 1 =*/89).double(message.rsi);
            if (message.atr != null && Object.hasOwnProperty.call(message, "atr"))
                writer.uint32(/* id 12, wireType 1 =*/97).double(message.atr);
            if (message.priceToEarnings != null && Object.hasOwnProperty.call(message, "priceToEarnings"))
                writer.uint32(/* id 13, wireType 1 =*/105).double(message.priceToEarnings);
            if (message.averageVolume != null && Object.hasOwnProperty.call(message, "averageVolume"))
                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.averageVolume);
            if (message.sharesOutstanding != null && Object.hasOwnProperty.call(message, "sharesOutstanding"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.sharesOutstanding);
            if (message.sector != null && Object.hasOwnProperty.call(message, "sector"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.sector);
            if (message.sectorCode != null && Object.hasOwnProperty.call(message, "sectorCode"))
                writer.uint32(/* id 17, wireType 0 =*/136).int32(message.sectorCode);
            if (message.industry != null && Object.hasOwnProperty.call(message, "industry"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.industry);
            if (message.industryCode != null && Object.hasOwnProperty.call(message, "industryCode"))
                writer.uint32(/* id 19, wireType 0 =*/152).int32(message.industryCode);
            if (message.forwardPERatio != null && Object.hasOwnProperty.call(message, "forwardPERatio"))
                writer.uint32(/* id 20, wireType 1 =*/161).double(message.forwardPERatio);
            if (message.pricetoEBITDA != null && Object.hasOwnProperty.call(message, "pricetoEBITDA"))
                writer.uint32(/* id 21, wireType 1 =*/169).double(message.pricetoEBITDA);
            if (message.trailingDividendYield != null && Object.hasOwnProperty.call(message, "trailingDividendYield"))
                writer.uint32(/* id 22, wireType 1 =*/177).double(message.trailingDividendYield);
            if (message.PBRatio != null && Object.hasOwnProperty.call(message, "PBRatio"))
                writer.uint32(/* id 23, wireType 1 =*/185).double(message.PBRatio);
            if (message.priceToSales != null && Object.hasOwnProperty.call(message, "priceToSales"))
                writer.uint32(/* id 24, wireType 1 =*/193).double(message.priceToSales);
            if (message.FCFPerShare != null && Object.hasOwnProperty.call(message, "FCFPerShare"))
                writer.uint32(/* id 25, wireType 1 =*/201).double(message.FCFPerShare);
            if (message.buyBackYield != null && Object.hasOwnProperty.call(message, "buyBackYield"))
                writer.uint32(/* id 26, wireType 1 =*/209).double(message.buyBackYield);
            if (message.open != null && Object.hasOwnProperty.call(message, "open"))
                writer.uint32(/* id 27, wireType 1 =*/217).double(message.open);
            if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                writer.uint32(/* id 28, wireType 1 =*/225).double(message.price);
            if (message.high != null && Object.hasOwnProperty.call(message, "high"))
                writer.uint32(/* id 29, wireType 1 =*/233).double(message.high);
            if (message.low != null && Object.hasOwnProperty.call(message, "low"))
                writer.uint32(/* id 30, wireType 1 =*/241).double(message.low);
            if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                writer.uint32(/* id 31, wireType 0 =*/248).int64(message.time);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 32, wireType 0 =*/256).int32(message.size);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 33, wireType 2 =*/266).string(message.type);
            if (message.dayVolume != null && Object.hasOwnProperty.call(message, "dayVolume"))
                writer.uint32(/* id 34, wireType 0 =*/272).int64(message.dayVolume);
            if (message.askPrice != null && Object.hasOwnProperty.call(message, "askPrice"))
                writer.uint32(/* id 35, wireType 1 =*/281).double(message.askPrice);
            if (message.bidPrice != null && Object.hasOwnProperty.call(message, "bidPrice"))
                writer.uint32(/* id 36, wireType 1 =*/289).double(message.bidPrice);
            if (message.shareFloatDate != null && Object.hasOwnProperty.call(message, "shareFloatDate"))
                writer.uint32(/* id 37, wireType 2 =*/298).string(message.shareFloatDate);
            if (message.sharesOutstandingDate != null && Object.hasOwnProperty.call(message, "sharesOutstandingDate"))
                writer.uint32(/* id 38, wireType 2 =*/306).string(message.sharesOutstandingDate);
            if (message.cik != null && Object.hasOwnProperty.call(message, "cik"))
                writer.uint32(/* id 39, wireType 0 =*/312).int32(message.cik);
            if (message.updateType != null && Object.hasOwnProperty.call(message, "updateType"))
                writer.uint32(/* id 40, wireType 0 =*/320).int32(message.updateType);
            if (message.sessionType != null && Object.hasOwnProperty.call(message, "sessionType"))
                writer.uint32(/* id 41, wireType 0 =*/328).int32(message.sessionType);
            if (message.change1Month != null && Object.hasOwnProperty.call(message, "change1Month"))
                writer.uint32(/* id 42, wireType 1 =*/337).double(message.change1Month);
            if (message.change3Month != null && Object.hasOwnProperty.call(message, "change3Month"))
                writer.uint32(/* id 43, wireType 1 =*/345).double(message.change3Month);
            if (message.changePercent3Month != null && Object.hasOwnProperty.call(message, "changePercent3Month"))
                writer.uint32(/* id 44, wireType 1 =*/353).double(message.changePercent3Month);
            if (message.price6Month != null && Object.hasOwnProperty.call(message, "price6Month"))
                writer.uint32(/* id 45, wireType 1 =*/361).double(message.price6Month);
            if (message.change1Year != null && Object.hasOwnProperty.call(message, "change1Year"))
                writer.uint32(/* id 46, wireType 1 =*/369).double(message.change1Year);
            if (message.preMarketChange5Minute != null && Object.hasOwnProperty.call(message, "preMarketChange5Minute"))
                writer.uint32(/* id 47, wireType 1 =*/377).double(message.preMarketChange5Minute);
            if (message.preMarketChangePercent5Minute != null && Object.hasOwnProperty.call(message, "preMarketChangePercent5Minute"))
                writer.uint32(/* id 48, wireType 1 =*/385).double(message.preMarketChangePercent5Minute);
            if (message.afterMarketChangePercent != null && Object.hasOwnProperty.call(message, "afterMarketChangePercent"))
                writer.uint32(/* id 49, wireType 1 =*/393).double(message.afterMarketChangePercent);
            if (message.changePercent1Minute != null && Object.hasOwnProperty.call(message, "changePercent1Minute"))
                writer.uint32(/* id 50, wireType 1 =*/401).double(message.changePercent1Minute);
            if (message.changePercentClose != null && Object.hasOwnProperty.call(message, "changePercentClose"))
                writer.uint32(/* id 51, wireType 1 =*/409).double(message.changePercentClose);
            if (message.changePercent5Minute != null && Object.hasOwnProperty.call(message, "changePercent5Minute"))
                writer.uint32(/* id 52, wireType 1 =*/417).double(message.changePercent5Minute);
            if (message.volume1Minute != null && Object.hasOwnProperty.call(message, "volume1Minute"))
                writer.uint32(/* id 53, wireType 0 =*/424).int64(message.volume1Minute);
            if (message.relativeVolume1Minute != null && Object.hasOwnProperty.call(message, "relativeVolume1Minute"))
                writer.uint32(/* id 54, wireType 1 =*/433).double(message.relativeVolume1Minute);
            if (message.change15Minute != null && Object.hasOwnProperty.call(message, "change15Minute"))
                writer.uint32(/* id 55, wireType 1 =*/441).double(message.change15Minute);
            if (message.changePercent15Minute != null && Object.hasOwnProperty.call(message, "changePercent15Minute"))
                writer.uint32(/* id 56, wireType 1 =*/449).double(message.changePercent15Minute);
            if (message.change30Minute != null && Object.hasOwnProperty.call(message, "change30Minute"))
                writer.uint32(/* id 57, wireType 1 =*/457).double(message.change30Minute);
            if (message.changePercent30Minute != null && Object.hasOwnProperty.call(message, "changePercent30Minute"))
                writer.uint32(/* id 58, wireType 1 =*/465).double(message.changePercent30Minute);
            if (message.change60Minute != null && Object.hasOwnProperty.call(message, "change60Minute"))
                writer.uint32(/* id 59, wireType 1 =*/473).double(message.change60Minute);
            if (message.changePercent60Minute != null && Object.hasOwnProperty.call(message, "changePercent60Minute"))
                writer.uint32(/* id 60, wireType 1 =*/481).double(message.changePercent60Minute);
            if (message.changePercentOpen != null && Object.hasOwnProperty.call(message, "changePercentOpen"))
                writer.uint32(/* id 61, wireType 1 =*/489).double(message.changePercentOpen);
            if (message.changeOpen != null && Object.hasOwnProperty.call(message, "changeOpen"))
                writer.uint32(/* id 62, wireType 1 =*/497).double(message.changeOpen);
            if (message.change5Minute != null && Object.hasOwnProperty.call(message, "change5Minute"))
                writer.uint32(/* id 63, wireType 1 =*/505).double(message.change5Minute);
            if (message.customChange != null && Object.hasOwnProperty.call(message, "customChange"))
                writer.uint32(/* id 64, wireType 1 =*/513).double(message.customChange);
            if (message.customChangePercent != null && Object.hasOwnProperty.call(message, "customChangePercent"))
                writer.uint32(/* id 65, wireType 1 =*/521).double(message.customChangePercent);
            if (message.customDate != null && Object.hasOwnProperty.call(message, "customDate"))
                writer.uint32(/* id 66, wireType 0 =*/528).int64(message.customDate);
            if (message.preMarketChange != null && Object.hasOwnProperty.call(message, "preMarketChange"))
                writer.uint32(/* id 67, wireType 1 =*/537).double(message.preMarketChange);
            if (message.preMarketChangePercent != null && Object.hasOwnProperty.call(message, "preMarketChangePercent"))
                writer.uint32(/* id 68, wireType 1 =*/545).double(message.preMarketChangePercent);
            if (message.afterMarketChange != null && Object.hasOwnProperty.call(message, "afterMarketChange"))
                writer.uint32(/* id 69, wireType 1 =*/553).double(message.afterMarketChange);
            if (message.gics != null && Object.hasOwnProperty.call(message, "gics"))
                writer.uint32(/* id 70, wireType 0 =*/560).int32(message.gics);
            if (message.gicsSector != null && Object.hasOwnProperty.call(message, "gicsSector"))
                writer.uint32(/* id 71, wireType 0 =*/568).int32(message.gicsSector);
            if (message.gicsSectorName != null && Object.hasOwnProperty.call(message, "gicsSectorName"))
                writer.uint32(/* id 72, wireType 2 =*/578).string(message.gicsSectorName);
            if (message.gicsIndustryGroup != null && Object.hasOwnProperty.call(message, "gicsIndustryGroup"))
                writer.uint32(/* id 73, wireType 0 =*/584).int32(message.gicsIndustryGroup);
            if (message.gicsIndustryGroupName != null && Object.hasOwnProperty.call(message, "gicsIndustryGroupName"))
                writer.uint32(/* id 74, wireType 2 =*/594).string(message.gicsIndustryGroupName);
            if (message.gicsIndustry != null && Object.hasOwnProperty.call(message, "gicsIndustry"))
                writer.uint32(/* id 75, wireType 0 =*/600).int32(message.gicsIndustry);
            if (message.gicsIndustryName != null && Object.hasOwnProperty.call(message, "gicsIndustryName"))
                writer.uint32(/* id 76, wireType 2 =*/610).string(message.gicsIndustryName);
            if (message.gicsSubIndustry != null && Object.hasOwnProperty.call(message, "gicsSubIndustry"))
                writer.uint32(/* id 77, wireType 0 =*/616).int32(message.gicsSubIndustry);
            if (message.gicsSubIndustryName != null && Object.hasOwnProperty.call(message, "gicsSubIndustryName"))
                writer.uint32(/* id 78, wireType 2 =*/626).string(message.gicsSubIndustryName);
            if (message.optionable != null && Object.hasOwnProperty.call(message, "optionable"))
                writer.uint32(/* id 79, wireType 0 =*/632).int32(message.optionable);
            if (message.signalName != null && Object.hasOwnProperty.call(message, "signalName"))
                writer.uint32(/* id 80, wireType 2 =*/642).string(message.signalName);
            if (message.shareFloat != null && Object.hasOwnProperty.call(message, "shareFloat"))
                writer.uint32(/* id 81, wireType 0 =*/648).int64(message.shareFloat);
            if (message.lastTradeTime != null && Object.hasOwnProperty.call(message, "lastTradeTime"))
                writer.uint32(/* id 82, wireType 0 =*/656).int64(message.lastTradeTime);
            if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                writer.uint32(/* id 83, wireType 2 =*/666).string(message.country);
            if (message.preMarketChange15Minute != null && Object.hasOwnProperty.call(message, "preMarketChange15Minute"))
                writer.uint32(/* id 84, wireType 1 =*/673).double(message.preMarketChange15Minute);
            if (message.preMarketChangePercent15Minute != null && Object.hasOwnProperty.call(message, "preMarketChangePercent15Minute"))
                writer.uint32(/* id 85, wireType 1 =*/681).double(message.preMarketChangePercent15Minute);
            if (message.preMarketChange30Minute != null && Object.hasOwnProperty.call(message, "preMarketChange30Minute"))
                writer.uint32(/* id 86, wireType 1 =*/689).double(message.preMarketChange30Minute);
            if (message.preMarketChangePercent30Minute != null && Object.hasOwnProperty.call(message, "preMarketChangePercent30Minute"))
                writer.uint32(/* id 87, wireType 1 =*/697).double(message.preMarketChangePercent30Minute);
            if (message.preMarketChange60Minute != null && Object.hasOwnProperty.call(message, "preMarketChange60Minute"))
                writer.uint32(/* id 88, wireType 1 =*/705).double(message.preMarketChange60Minute);
            if (message.preMarketChangePercent60Minute != null && Object.hasOwnProperty.call(message, "preMarketChangePercent60Minute"))
                writer.uint32(/* id 89, wireType 1 =*/713).double(message.preMarketChangePercent60Minute);
            if (message.regularChange5Minute != null && Object.hasOwnProperty.call(message, "regularChange5Minute"))
                writer.uint32(/* id 90, wireType 1 =*/721).double(message.regularChange5Minute);
            if (message.regularChangePercent5Minute != null && Object.hasOwnProperty.call(message, "regularChangePercent5Minute"))
                writer.uint32(/* id 91, wireType 1 =*/729).double(message.regularChangePercent5Minute);
            if (message.regularChange15Minute != null && Object.hasOwnProperty.call(message, "regularChange15Minute"))
                writer.uint32(/* id 92, wireType 1 =*/737).double(message.regularChange15Minute);
            if (message.regularChangePercent15Minute != null && Object.hasOwnProperty.call(message, "regularChangePercent15Minute"))
                writer.uint32(/* id 93, wireType 1 =*/745).double(message.regularChangePercent15Minute);
            if (message.regularChange30Minute != null && Object.hasOwnProperty.call(message, "regularChange30Minute"))
                writer.uint32(/* id 94, wireType 1 =*/753).double(message.regularChange30Minute);
            if (message.regularChangePercent30Minute != null && Object.hasOwnProperty.call(message, "regularChangePercent30Minute"))
                writer.uint32(/* id 95, wireType 1 =*/761).double(message.regularChangePercent30Minute);
            if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                writer.uint32(/* id 96, wireType 0 =*/768).int64(message.volume);
            if (message.regularChange60Minute != null && Object.hasOwnProperty.call(message, "regularChange60Minute"))
                writer.uint32(/* id 97, wireType 1 =*/777).double(message.regularChange60Minute);
            if (message.regularChangePercent60Minute != null && Object.hasOwnProperty.call(message, "regularChangePercent60Minute"))
                writer.uint32(/* id 98, wireType 1 =*/785).double(message.regularChangePercent60Minute);
            if (message.afterMarketChange5Minute != null && Object.hasOwnProperty.call(message, "afterMarketChange5Minute"))
                writer.uint32(/* id 99, wireType 1 =*/793).double(message.afterMarketChange5Minute);
            if (message.opol != null && Object.hasOwnProperty.call(message, "opol"))
                writer.uint32(/* id 100, wireType 2 =*/802).string(message.opol);
            if (message.subtype != null && Object.hasOwnProperty.call(message, "subtype"))
                writer.uint32(/* id 101, wireType 2 =*/810).string(message.subtype);
            if (message.afterMarketChange15Minute != null && Object.hasOwnProperty.call(message, "afterMarketChange15Minute"))
                writer.uint32(/* id 102, wireType 1 =*/817).double(message.afterMarketChange15Minute);
            if (message.afterMarketChangePercent15Minute != null && Object.hasOwnProperty.call(message, "afterMarketChangePercent15Minute"))
                writer.uint32(/* id 103, wireType 1 =*/825).double(message.afterMarketChangePercent15Minute);
            if (message.afterMarketChange30Minute != null && Object.hasOwnProperty.call(message, "afterMarketChange30Minute"))
                writer.uint32(/* id 104, wireType 1 =*/833).double(message.afterMarketChange30Minute);
            if (message.afterMarketChangePercent30Minute != null && Object.hasOwnProperty.call(message, "afterMarketChangePercent30Minute"))
                writer.uint32(/* id 105, wireType 1 =*/841).double(message.afterMarketChangePercent30Minute);
            if (message.afterMarketChange60Minute != null && Object.hasOwnProperty.call(message, "afterMarketChange60Minute"))
                writer.uint32(/* id 106, wireType 1 =*/849).double(message.afterMarketChange60Minute);
            if (message.afterMarketChangePercent60Minute != null && Object.hasOwnProperty.call(message, "afterMarketChangePercent60Minute"))
                writer.uint32(/* id 107, wireType 1 =*/857).double(message.afterMarketChangePercent60Minute);
            if (message.change6Month != null && Object.hasOwnProperty.call(message, "change6Month"))
                writer.uint32(/* id 109, wireType 1 =*/873).double(message.change6Month);
            if (message.sharesShort != null && Object.hasOwnProperty.call(message, "sharesShort"))
                writer.uint32(/* id 110, wireType 0 =*/880).int64(message.sharesShort);
            if (message.sharesShortPercentOfFloat != null && Object.hasOwnProperty.call(message, "sharesShortPercentOfFloat"))
                writer.uint32(/* id 111, wireType 1 =*/889).double(message.sharesShortPercentOfFloat);
            if (message.sharesShortChangePercent != null && Object.hasOwnProperty.call(message, "sharesShortChangePercent"))
                writer.uint32(/* id 112, wireType 1 =*/897).double(message.sharesShortChangePercent);
            if (message.sharesShortReceiptDate != null && Object.hasOwnProperty.call(message, "sharesShortReceiptDate"))
                writer.uint32(/* id 113, wireType 0 =*/904).int64(message.sharesShortReceiptDate);
            if (message.sharesShortSettlementDate != null && Object.hasOwnProperty.call(message, "sharesShortSettlementDate"))
                writer.uint32(/* id 114, wireType 0 =*/912).int64(message.sharesShortSettlementDate);
            if (message.shortInterestRatio != null && Object.hasOwnProperty.call(message, "shortInterestRatio"))
                writer.uint32(/* id 115, wireType 1 =*/921).double(message.shortInterestRatio);
            if (message.sharesShortValue != null && Object.hasOwnProperty.call(message, "sharesShortValue"))
                writer.uint32(/* id 116, wireType 1 =*/929).double(message.sharesShortValue);
            if (message.sharesShortPrevious != null && Object.hasOwnProperty.call(message, "sharesShortPrevious"))
                writer.uint32(/* id 117, wireType 0 =*/936).int64(message.sharesShortPrevious);
            if (message.sharesShortPreviousValue != null && Object.hasOwnProperty.call(message, "sharesShortPreviousValue"))
                writer.uint32(/* id 118, wireType 1 =*/945).double(message.sharesShortPreviousValue);
            if (message.sharesShortPreviousPercentOfFloat != null && Object.hasOwnProperty.call(message, "sharesShortPreviousPercentOfFloat"))
                writer.uint32(/* id 119, wireType 1 =*/953).double(message.sharesShortPreviousPercentOfFloat);
            if (message.sharesShortChange != null && Object.hasOwnProperty.call(message, "sharesShortChange"))
                writer.uint32(/* id 120, wireType 0 =*/960).int64(message.sharesShortChange);
            if (message.afterMarketChangePercent5Minute != null && Object.hasOwnProperty.call(message, "afterMarketChangePercent5Minute"))
                writer.uint32(/* id 121, wireType 1 =*/969).double(message.afterMarketChangePercent5Minute);
            if (message.price3Month != null && Object.hasOwnProperty.call(message, "price3Month"))
                writer.uint32(/* id 122, wireType 1 =*/977).double(message.price3Month);
            if (message.changePercent6Month != null && Object.hasOwnProperty.call(message, "changePercent6Month"))
                writer.uint32(/* id 123, wireType 1 =*/985).double(message.changePercent6Month);
            if (message.preMarketPrice != null && Object.hasOwnProperty.call(message, "preMarketPrice"))
                writer.uint32(/* id 124, wireType 1 =*/993).double(message.preMarketPrice);
            if (message.afterMarketPrice != null && Object.hasOwnProperty.call(message, "afterMarketPrice"))
                writer.uint32(/* id 125, wireType 1 =*/1001).double(message.afterMarketPrice);
            if (message.sentTime != null && Object.hasOwnProperty.call(message, "sentTime"))
                writer.uint32(/* id 200, wireType 0 =*/1600).int64(message.sentTime);
            if (message.closeTime != null && Object.hasOwnProperty.call(message, "closeTime"))
                writer.uint32(/* id 201, wireType 0 =*/1608).int64(message.closeTime);
            if (message.volume5Minute != null && Object.hasOwnProperty.call(message, "volume5Minute"))
                writer.uint32(/* id 300, wireType 0 =*/2400).int64(message.volume5Minute);
            if (message.volume15Minute != null && Object.hasOwnProperty.call(message, "volume15Minute"))
                writer.uint32(/* id 301, wireType 0 =*/2408).int64(message.volume15Minute);
            if (message.volume30Minute != null && Object.hasOwnProperty.call(message, "volume30Minute"))
                writer.uint32(/* id 302, wireType 0 =*/2416).int64(message.volume30Minute);
            if (message.volume60Minute != null && Object.hasOwnProperty.call(message, "volume60Minute"))
                writer.uint32(/* id 303, wireType 0 =*/2424).int64(message.volume60Minute);
            if (message.relativeVolume5Minute != null && Object.hasOwnProperty.call(message, "relativeVolume5Minute"))
                writer.uint32(/* id 304, wireType 1 =*/2433).double(message.relativeVolume5Minute);
            if (message.relativeVolume90Day != null && Object.hasOwnProperty.call(message, "relativeVolume90Day"))
                writer.uint32(/* id 305, wireType 1 =*/2441).double(message.relativeVolume90Day);
            if (message.rvol1m10d != null && Object.hasOwnProperty.call(message, "rvol1m10d"))
                writer.uint32(/* id 306, wireType 1 =*/2449).double(message.rvol1m10d);
            if (message.rvol5m10d != null && Object.hasOwnProperty.call(message, "rvol5m10d"))
                writer.uint32(/* id 307, wireType 1 =*/2457).double(message.rvol5m10d);
            if (message.rvol5m30d != null && Object.hasOwnProperty.call(message, "rvol5m30d"))
                writer.uint32(/* id 308, wireType 1 =*/2465).double(message.rvol5m30d);
            if (message.rvol5m90d != null && Object.hasOwnProperty.call(message, "rvol5m90d"))
                writer.uint32(/* id 309, wireType 1 =*/2473).double(message.rvol5m90d);
            if (message.nextEarningsDate != null && Object.hasOwnProperty.call(message, "nextEarningsDate"))
                writer.uint32(/* id 400, wireType 0 =*/3200).int32(message.nextEarningsDate);
            if (message.dividend != null && Object.hasOwnProperty.call(message, "dividend"))
                writer.uint32(/* id 401, wireType 1 =*/3209).double(message.dividend);
            if (message.dividendYield != null && Object.hasOwnProperty.call(message, "dividendYield"))
                writer.uint32(/* id 402, wireType 1 =*/3217).double(message.dividendYield);
            if (message.dividendExDate != null && Object.hasOwnProperty.call(message, "dividendExDate"))
                writer.uint32(/* id 403, wireType 0 =*/3224).int32(message.dividendExDate);
            if (message.dividendFrequency != null && Object.hasOwnProperty.call(message, "dividendFrequency"))
                writer.uint32(/* id 404, wireType 0 =*/3232).int64(message.dividendFrequency);
            if (message.forwardDividendYield != null && Object.hasOwnProperty.call(message, "forwardDividendYield"))
                writer.uint32(/* id 405, wireType 1 =*/3241).double(message.forwardDividendYield);
            if (message.roe != null && Object.hasOwnProperty.call(message, "roe"))
                writer.uint32(/* id 501, wireType 1 =*/4009).double(message.roe);
            if (message.roa != null && Object.hasOwnProperty.call(message, "roa"))
                writer.uint32(/* id 502, wireType 1 =*/4017).double(message.roa);
            if (message.roic != null && Object.hasOwnProperty.call(message, "roic"))
                writer.uint32(/* id 503, wireType 1 =*/4025).double(message.roic);
            if (message.currentRatio != null && Object.hasOwnProperty.call(message, "currentRatio"))
                writer.uint32(/* id 504, wireType 1 =*/4033).double(message.currentRatio);
            if (message.grossMargin != null && Object.hasOwnProperty.call(message, "grossMargin"))
                writer.uint32(/* id 505, wireType 1 =*/4041).double(message.grossMargin);
            if (message.netMargin != null && Object.hasOwnProperty.call(message, "netMargin"))
                writer.uint32(/* id 506, wireType 1 =*/4049).double(message.netMargin);
            if (message.operationMargin != null && Object.hasOwnProperty.call(message, "operationMargin"))
                writer.uint32(/* id 507, wireType 1 =*/4057).double(message.operationMargin);
            if (message.epsMrq != null && Object.hasOwnProperty.call(message, "epsMrq"))
                writer.uint32(/* id 508, wireType 1 =*/4065).double(message.epsMrq);
            if (message.epsTtm != null && Object.hasOwnProperty.call(message, "epsTtm"))
                writer.uint32(/* id 509, wireType 1 =*/4073).double(message.epsTtm);
            if (message.dilutedEpsMrq != null && Object.hasOwnProperty.call(message, "dilutedEpsMrq"))
                writer.uint32(/* id 510, wireType 1 =*/4081).double(message.dilutedEpsMrq);
            if (message.dilutedEpsTtm != null && Object.hasOwnProperty.call(message, "dilutedEpsTtm"))
                writer.uint32(/* id 511, wireType 1 =*/4089).double(message.dilutedEpsTtm);
            if (message.low52Week != null && Object.hasOwnProperty.call(message, "low52Week"))
                writer.uint32(/* id 512, wireType 1 =*/4097).double(message.low52Week);
            if (message.high52Week != null && Object.hasOwnProperty.call(message, "high52Week"))
                writer.uint32(/* id 513, wireType 1 =*/4105).double(message.high52Week);
            if (message.revenueTtm != null && Object.hasOwnProperty.call(message, "revenueTtm"))
                writer.uint32(/* id 514, wireType 1 =*/4113).double(message.revenueTtm);
            if (message.earningsAsOf != null && Object.hasOwnProperty.call(message, "earningsAsOf"))
                writer.uint32(/* id 515, wireType 0 =*/4120).int32(message.earningsAsOf);
            if (message.netProfitMargin != null && Object.hasOwnProperty.call(message, "netProfitMargin"))
                writer.uint32(/* id 516, wireType 1 =*/4129).double(message.netProfitMargin);
            if (message.roeMrq != null && Object.hasOwnProperty.call(message, "roeMrq"))
                writer.uint32(/* id 520, wireType 1 =*/4161).double(message.roeMrq);
            if (message.roaMrq != null && Object.hasOwnProperty.call(message, "roaMrq"))
                writer.uint32(/* id 521, wireType 1 =*/4169).double(message.roaMrq);
            if (message.roicMrq != null && Object.hasOwnProperty.call(message, "roicMrq"))
                writer.uint32(/* id 522, wireType 1 =*/4177).double(message.roicMrq);
            if (message.currentRatioMrq != null && Object.hasOwnProperty.call(message, "currentRatioMrq"))
                writer.uint32(/* id 523, wireType 1 =*/4185).double(message.currentRatioMrq);
            if (message.grossMarginMrq != null && Object.hasOwnProperty.call(message, "grossMarginMrq"))
                writer.uint32(/* id 524, wireType 1 =*/4193).double(message.grossMarginMrq);
            if (message.netMarginMrq != null && Object.hasOwnProperty.call(message, "netMarginMrq"))
                writer.uint32(/* id 525, wireType 1 =*/4201).double(message.netMarginMrq);
            if (message.operationMarginMrq != null && Object.hasOwnProperty.call(message, "operationMarginMrq"))
                writer.uint32(/* id 526, wireType 1 =*/4209).double(message.operationMarginMrq);
            if (message.previousDayVolume != null && Object.hasOwnProperty.call(message, "previousDayVolume"))
                writer.uint32(/* id 527, wireType 0 =*/4216).int64(message.previousDayVolume);
            if (message.previousDayAtr != null && Object.hasOwnProperty.call(message, "previousDayAtr"))
                writer.uint32(/* id 528, wireType 1 =*/4225).double(message.previousDayAtr);
            if (message.previousDayAdx != null && Object.hasOwnProperty.call(message, "previousDayAdx"))
                writer.uint32(/* id 529, wireType 1 =*/4233).double(message.previousDayAdx);
            if (message.previousDayPlusDMSmoothed != null && Object.hasOwnProperty.call(message, "previousDayPlusDMSmoothed"))
                writer.uint32(/* id 530, wireType 1 =*/4241).double(message.previousDayPlusDMSmoothed);
            if (message.previousDayMinusDMSmoothed != null && Object.hasOwnProperty.call(message, "previousDayMinusDMSmoothed"))
                writer.uint32(/* id 531, wireType 1 =*/4249).double(message.previousDayMinusDMSmoothed);
            if (message.previousDayHigh != null && Object.hasOwnProperty.call(message, "previousDayHigh"))
                writer.uint32(/* id 532, wireType 1 =*/4257).double(message.previousDayHigh);
            if (message.previousDayLow != null && Object.hasOwnProperty.call(message, "previousDayLow"))
                writer.uint32(/* id 533, wireType 1 =*/4265).double(message.previousDayLow);
            if (message.adx != null && Object.hasOwnProperty.call(message, "adx"))
                writer.uint32(/* id 534, wireType 1 =*/4273).double(message.adx);
            if (message.percentInstitutionalOwnership != null && Object.hasOwnProperty.call(message, "percentInstitutionalOwnership"))
                writer.uint32(/* id 535, wireType 1 =*/4281).double(message.percentInstitutionalOwnership);
            if (message.percentInstitutionalTransactions != null && Object.hasOwnProperty.call(message, "percentInstitutionalTransactions"))
                writer.uint32(/* id 536, wireType 1 =*/4289).double(message.percentInstitutionalTransactions);
            if (message.averageVolume10Day != null && Object.hasOwnProperty.call(message, "averageVolume10Day"))
                writer.uint32(/* id 600, wireType 0 =*/4800).int64(message.averageVolume10Day);
            if (message.averageVolumeChangePercent10Day != null && Object.hasOwnProperty.call(message, "averageVolumeChangePercent10Day"))
                writer.uint32(/* id 601, wireType 1 =*/4809).double(message.averageVolumeChangePercent10Day);
            if (message.high10Day != null && Object.hasOwnProperty.call(message, "high10Day"))
                writer.uint32(/* id 602, wireType 1 =*/4817).double(message.high10Day);
            if (message.highChangePercent10Day != null && Object.hasOwnProperty.call(message, "highChangePercent10Day"))
                writer.uint32(/* id 603, wireType 1 =*/4825).double(message.highChangePercent10Day);
            if (message.low10Day != null && Object.hasOwnProperty.call(message, "low10Day"))
                writer.uint32(/* id 604, wireType 1 =*/4833).double(message.low10Day);
            if (message.lowChangePercent10Day != null && Object.hasOwnProperty.call(message, "lowChangePercent10Day"))
                writer.uint32(/* id 605, wireType 1 =*/4841).double(message.lowChangePercent10Day);
            if (message.movingAverage10Day != null && Object.hasOwnProperty.call(message, "movingAverage10Day"))
                writer.uint32(/* id 606, wireType 1 =*/4849).double(message.movingAverage10Day);
            if (message.movingAverageChangePercent10Day != null && Object.hasOwnProperty.call(message, "movingAverageChangePercent10Day"))
                writer.uint32(/* id 607, wireType 1 =*/4857).double(message.movingAverageChangePercent10Day);
            if (message.averageVolume20Day != null && Object.hasOwnProperty.call(message, "averageVolume20Day"))
                writer.uint32(/* id 610, wireType 0 =*/4880).int64(message.averageVolume20Day);
            if (message.averageVolumeChangePercent20Day != null && Object.hasOwnProperty.call(message, "averageVolumeChangePercent20Day"))
                writer.uint32(/* id 611, wireType 1 =*/4889).double(message.averageVolumeChangePercent20Day);
            if (message.high20Day != null && Object.hasOwnProperty.call(message, "high20Day"))
                writer.uint32(/* id 612, wireType 1 =*/4897).double(message.high20Day);
            if (message.highChangePercent20Day != null && Object.hasOwnProperty.call(message, "highChangePercent20Day"))
                writer.uint32(/* id 613, wireType 1 =*/4905).double(message.highChangePercent20Day);
            if (message.low20Day != null && Object.hasOwnProperty.call(message, "low20Day"))
                writer.uint32(/* id 614, wireType 1 =*/4913).double(message.low20Day);
            if (message.lowChangePercent20Day != null && Object.hasOwnProperty.call(message, "lowChangePercent20Day"))
                writer.uint32(/* id 615, wireType 1 =*/4921).double(message.lowChangePercent20Day);
            if (message.movingAverage20Day != null && Object.hasOwnProperty.call(message, "movingAverage20Day"))
                writer.uint32(/* id 616, wireType 1 =*/4929).double(message.movingAverage20Day);
            if (message.movingAverageChangePercent20Day != null && Object.hasOwnProperty.call(message, "movingAverageChangePercent20Day"))
                writer.uint32(/* id 617, wireType 1 =*/4937).double(message.movingAverageChangePercent20Day);
            if (message.averageVolume50Day != null && Object.hasOwnProperty.call(message, "averageVolume50Day"))
                writer.uint32(/* id 620, wireType 0 =*/4960).int64(message.averageVolume50Day);
            if (message.averageVolumeChangePercent50Day != null && Object.hasOwnProperty.call(message, "averageVolumeChangePercent50Day"))
                writer.uint32(/* id 621, wireType 1 =*/4969).double(message.averageVolumeChangePercent50Day);
            if (message.high50Day != null && Object.hasOwnProperty.call(message, "high50Day"))
                writer.uint32(/* id 622, wireType 1 =*/4977).double(message.high50Day);
            if (message.highChangePercent50Day != null && Object.hasOwnProperty.call(message, "highChangePercent50Day"))
                writer.uint32(/* id 623, wireType 1 =*/4985).double(message.highChangePercent50Day);
            if (message.low50Day != null && Object.hasOwnProperty.call(message, "low50Day"))
                writer.uint32(/* id 624, wireType 1 =*/4993).double(message.low50Day);
            if (message.lowChangePercent50Day != null && Object.hasOwnProperty.call(message, "lowChangePercent50Day"))
                writer.uint32(/* id 625, wireType 1 =*/5001).double(message.lowChangePercent50Day);
            if (message.movingAverage50Day != null && Object.hasOwnProperty.call(message, "movingAverage50Day"))
                writer.uint32(/* id 626, wireType 1 =*/5009).double(message.movingAverage50Day);
            if (message.movingAverageChangePercent50Day != null && Object.hasOwnProperty.call(message, "movingAverageChangePercent50Day"))
                writer.uint32(/* id 627, wireType 1 =*/5017).double(message.movingAverageChangePercent50Day);
            if (message.averageVolume100Day != null && Object.hasOwnProperty.call(message, "averageVolume100Day"))
                writer.uint32(/* id 630, wireType 0 =*/5040).int64(message.averageVolume100Day);
            if (message.averageVolumeChangePercent100Day != null && Object.hasOwnProperty.call(message, "averageVolumeChangePercent100Day"))
                writer.uint32(/* id 631, wireType 1 =*/5049).double(message.averageVolumeChangePercent100Day);
            if (message.high100Day != null && Object.hasOwnProperty.call(message, "high100Day"))
                writer.uint32(/* id 632, wireType 1 =*/5057).double(message.high100Day);
            if (message.highChangePercent100Day != null && Object.hasOwnProperty.call(message, "highChangePercent100Day"))
                writer.uint32(/* id 633, wireType 1 =*/5065).double(message.highChangePercent100Day);
            if (message.low100Day != null && Object.hasOwnProperty.call(message, "low100Day"))
                writer.uint32(/* id 634, wireType 1 =*/5073).double(message.low100Day);
            if (message.lowChangePercent100Day != null && Object.hasOwnProperty.call(message, "lowChangePercent100Day"))
                writer.uint32(/* id 635, wireType 1 =*/5081).double(message.lowChangePercent100Day);
            if (message.movingAverage100Day != null && Object.hasOwnProperty.call(message, "movingAverage100Day"))
                writer.uint32(/* id 636, wireType 1 =*/5089).double(message.movingAverage100Day);
            if (message.movingAverageChangePercent100Day != null && Object.hasOwnProperty.call(message, "movingAverageChangePercent100Day"))
                writer.uint32(/* id 637, wireType 1 =*/5097).double(message.movingAverageChangePercent100Day);
            if (message.averageVolume200Day != null && Object.hasOwnProperty.call(message, "averageVolume200Day"))
                writer.uint32(/* id 640, wireType 0 =*/5120).int64(message.averageVolume200Day);
            if (message.averageVolumeChangePercent200Day != null && Object.hasOwnProperty.call(message, "averageVolumeChangePercent200Day"))
                writer.uint32(/* id 641, wireType 1 =*/5129).double(message.averageVolumeChangePercent200Day);
            if (message.high200Day != null && Object.hasOwnProperty.call(message, "high200Day"))
                writer.uint32(/* id 642, wireType 1 =*/5137).double(message.high200Day);
            if (message.highChangePercent200Day != null && Object.hasOwnProperty.call(message, "highChangePercent200Day"))
                writer.uint32(/* id 643, wireType 1 =*/5145).double(message.highChangePercent200Day);
            if (message.low200Day != null && Object.hasOwnProperty.call(message, "low200Day"))
                writer.uint32(/* id 644, wireType 1 =*/5153).double(message.low200Day);
            if (message.lowChangePercent200Day != null && Object.hasOwnProperty.call(message, "lowChangePercent200Day"))
                writer.uint32(/* id 645, wireType 1 =*/5161).double(message.lowChangePercent200Day);
            if (message.movingAverage200Day != null && Object.hasOwnProperty.call(message, "movingAverage200Day"))
                writer.uint32(/* id 646, wireType 1 =*/5169).double(message.movingAverage200Day);
            if (message.movingAverageChangePercent200Day != null && Object.hasOwnProperty.call(message, "movingAverageChangePercent200Day"))
                writer.uint32(/* id 647, wireType 1 =*/5177).double(message.movingAverageChangePercent200Day);
            if (message.movingAverage250Day != null && Object.hasOwnProperty.call(message, "movingAverage250Day"))
                writer.uint32(/* id 648, wireType 1 =*/5185).double(message.movingAverage250Day);
            if (message.movingAverageChangePercent250Day != null && Object.hasOwnProperty.call(message, "movingAverageChangePercent250Day"))
                writer.uint32(/* id 649, wireType 1 =*/5193).double(message.movingAverageChangePercent250Day);
            if (message.averageVolume90Day != null && Object.hasOwnProperty.call(message, "averageVolume90Day"))
                writer.uint32(/* id 650, wireType 0 =*/5200).int64(message.averageVolume90Day);
            if (message.evToEbitda != null && Object.hasOwnProperty.call(message, "evToEbitda"))
                writer.uint32(/* id 652, wireType 1 =*/5217).double(message.evToEbitda);
            if (message.lowAllTime != null && Object.hasOwnProperty.call(message, "lowAllTime"))
                writer.uint32(/* id 653, wireType 1 =*/5225).double(message.lowAllTime);
            if (message.highAllTime != null && Object.hasOwnProperty.call(message, "highAllTime"))
                writer.uint32(/* id 654, wireType 1 =*/5233).double(message.highAllTime);
            if (message.quickRatioMrq != null && Object.hasOwnProperty.call(message, "quickRatioMrq"))
                writer.uint32(/* id 655, wireType 1 =*/5241).double(message.quickRatioMrq);
            if (message.ffoPerShare != null && Object.hasOwnProperty.call(message, "ffoPerShare"))
                writer.uint32(/* id 656, wireType 1 =*/5249).double(message.ffoPerShare);
            if (message.ipoDateNumber != null && Object.hasOwnProperty.call(message, "ipoDateNumber"))
                writer.uint32(/* id 657, wireType 0 =*/5256).int64(message.ipoDateNumber);
            if (message.ltDebtEquity != null && Object.hasOwnProperty.call(message, "ltDebtEquity"))
                writer.uint32(/* id 658, wireType 1 =*/5265).double(message.ltDebtEquity);
            if (message.epsGrowthYearAgoQ != null && Object.hasOwnProperty.call(message, "epsGrowthYearAgoQ"))
                writer.uint32(/* id 659, wireType 1 =*/5273).double(message.epsGrowthYearAgoQ);
            if (message.revenueGrowthYearAgoQ != null && Object.hasOwnProperty.call(message, "revenueGrowthYearAgoQ"))
                writer.uint32(/* id 660, wireType 1 =*/5281).double(message.revenueGrowthYearAgoQ);
            if (message.revenueGrowth5Year != null && Object.hasOwnProperty.call(message, "revenueGrowth5Year"))
                writer.uint32(/* id 661, wireType 1 =*/5289).double(message.revenueGrowth5Year);
            if (message.revenueGrowthQ2Q != null && Object.hasOwnProperty.call(message, "revenueGrowthQ2Q"))
                writer.uint32(/* id 662, wireType 1 =*/5297).double(message.revenueGrowthQ2Q);
            if (message.revenueGrowthY2Y != null && Object.hasOwnProperty.call(message, "revenueGrowthY2Y"))
                writer.uint32(/* id 663, wireType 1 =*/5305).double(message.revenueGrowthY2Y);
            if (message.revenueGrowthTtm != null && Object.hasOwnProperty.call(message, "revenueGrowthTtm"))
                writer.uint32(/* id 664, wireType 1 =*/5313).double(message.revenueGrowthTtm);
            if (message.epsGrowth5Year != null && Object.hasOwnProperty.call(message, "epsGrowth5Year"))
                writer.uint32(/* id 665, wireType 1 =*/5321).double(message.epsGrowth5Year);
            if (message.epsGrowthQ2Q != null && Object.hasOwnProperty.call(message, "epsGrowthQ2Q"))
                writer.uint32(/* id 666, wireType 1 =*/5329).double(message.epsGrowthQ2Q);
            if (message.epsGrowthY2Y != null && Object.hasOwnProperty.call(message, "epsGrowthY2Y"))
                writer.uint32(/* id 667, wireType 1 =*/5337).double(message.epsGrowthY2Y);
            if (message.epsGrowthTtm != null && Object.hasOwnProperty.call(message, "epsGrowthTtm"))
                writer.uint32(/* id 668, wireType 1 =*/5345).double(message.epsGrowthTtm);
            if (message.dilutedRevenueTtmSurprisePercent != null && Object.hasOwnProperty.call(message, "dilutedRevenueTtmSurprisePercent"))
                writer.uint32(/* id 669, wireType 1 =*/5353).double(message.dilutedRevenueTtmSurprisePercent);
            if (message.dilutedRevenueMrqSurprisePercent != null && Object.hasOwnProperty.call(message, "dilutedRevenueMrqSurprisePercent"))
                writer.uint32(/* id 670, wireType 1 =*/5361).double(message.dilutedRevenueMrqSurprisePercent);
            if (message.dilutedEpsTtmSurprisePercent != null && Object.hasOwnProperty.call(message, "dilutedEpsTtmSurprisePercent"))
                writer.uint32(/* id 671, wireType 1 =*/5369).double(message.dilutedEpsTtmSurprisePercent);
            if (message.dilutedEpsMrqSurprisePercent != null && Object.hasOwnProperty.call(message, "dilutedEpsMrqSurprisePercent"))
                writer.uint32(/* id 672, wireType 1 =*/5377).double(message.dilutedEpsMrqSurprisePercent);
            if (message.adr14d != null && Object.hasOwnProperty.call(message, "adr14d"))
                writer.uint32(/* id 673, wireType 1 =*/5385).double(message.adr14d);
            if (message.gapChangePercent != null && Object.hasOwnProperty.call(message, "gapChangePercent"))
                writer.uint32(/* id 674, wireType 1 =*/5393).double(message.gapChangePercent);
            if (message.gapChange != null && Object.hasOwnProperty.call(message, "gapChange"))
                writer.uint32(/* id 675, wireType 1 =*/5401).double(message.gapChange);
            if (message.movingAverage500Day != null && Object.hasOwnProperty.call(message, "movingAverage500Day"))
                writer.uint32(/* id 676, wireType 1 =*/5409).double(message.movingAverage500Day);
            if (message.dividendGrowthRate5Year != null && Object.hasOwnProperty.call(message, "dividendGrowthRate5Year"))
                writer.uint32(/* id 677, wireType 1 =*/5417).double(message.dividendGrowthRate5Year);
            if (message.dividendGrowthRate3Year != null && Object.hasOwnProperty.call(message, "dividendGrowthRate3Year"))
                writer.uint32(/* id 678, wireType 1 =*/5425).double(message.dividendGrowthRate3Year);
            if (message.dividendGrowthRate1Year != null && Object.hasOwnProperty.call(message, "dividendGrowthRate1Year"))
                writer.uint32(/* id 679, wireType 1 =*/5433).double(message.dividendGrowthRate1Year);
            if (message.newsBzWireTitle != null && Object.hasOwnProperty.call(message, "newsBzWireTitle"))
                writer.uint32(/* id 680, wireType 2 =*/5442).string(message.newsBzWireTitle);
            if (message.newsBzWireNodeId != null && Object.hasOwnProperty.call(message, "newsBzWireNodeId"))
                writer.uint32(/* id 681, wireType 2 =*/5450).string(message.newsBzWireNodeId);
            if (message.newsBzWireTimestamp != null && Object.hasOwnProperty.call(message, "newsBzWireTimestamp"))
                writer.uint32(/* id 682, wireType 0 =*/5456).int64(message.newsBzWireTimestamp);
            if (message.newsPRTitle != null && Object.hasOwnProperty.call(message, "newsPRTitle"))
                writer.uint32(/* id 683, wireType 2 =*/5466).string(message.newsPRTitle);
            if (message.newsPRNodeId != null && Object.hasOwnProperty.call(message, "newsPRNodeId"))
                writer.uint32(/* id 684, wireType 2 =*/5474).string(message.newsPRNodeId);
            if (message.newsPRTimestamp != null && Object.hasOwnProperty.call(message, "newsPRTimestamp"))
                writer.uint32(/* id 685, wireType 0 =*/5480).int64(message.newsPRTimestamp);
            if (message.newsSecTitle != null && Object.hasOwnProperty.call(message, "newsSecTitle"))
                writer.uint32(/* id 686, wireType 2 =*/5490).string(message.newsSecTitle);
            if (message.newsSecNodeId != null && Object.hasOwnProperty.call(message, "newsSecNodeId"))
                writer.uint32(/* id 687, wireType 2 =*/5498).string(message.newsSecNodeId);
            if (message.newsSecTimestamp != null && Object.hasOwnProperty.call(message, "newsSecTimestamp"))
                writer.uint32(/* id 688, wireType 0 =*/5504).int64(message.newsSecTimestamp);
            if (message.newsBzWireTitleWithNodeId != null && Object.hasOwnProperty.call(message, "newsBzWireTitleWithNodeId"))
                writer.uint32(/* id 689, wireType 2 =*/5514).string(message.newsBzWireTitleWithNodeId);
            if (message.newsPRTitleWithNodeId != null && Object.hasOwnProperty.call(message, "newsPRTitleWithNodeId"))
                writer.uint32(/* id 690, wireType 2 =*/5522).string(message.newsPRTitleWithNodeId);
            if (message.newsSecTitleWithNodeId != null && Object.hasOwnProperty.call(message, "newsSecTitleWithNodeId"))
                writer.uint32(/* id 691, wireType 2 =*/5530).string(message.newsSecTitleWithNodeId);
            if (message.mtdChange != null && Object.hasOwnProperty.call(message, "mtdChange"))
                writer.uint32(/* id 694, wireType 1 =*/5553).double(message.mtdChange);
            if (message.ytdChange != null && Object.hasOwnProperty.call(message, "ytdChange"))
                writer.uint32(/* id 695, wireType 1 =*/5561).double(message.ytdChange);
            if (message.macdSignalLineBase != null && Object.hasOwnProperty.call(message, "macdSignalLineBase"))
                writer.uint32(/* id 696, wireType 1 =*/5569).double(message.macdSignalLineBase);
            if (message.macdHistogram != null && Object.hasOwnProperty.call(message, "macdHistogram"))
                writer.uint32(/* id 697, wireType 1 =*/5577).double(message.macdHistogram);
            if (message.macdSignalLine != null && Object.hasOwnProperty.call(message, "macdSignalLine"))
                writer.uint32(/* id 698, wireType 1 =*/5585).double(message.macdSignalLine);
            if (message.macd != null && Object.hasOwnProperty.call(message, "macd"))
                writer.uint32(/* id 699, wireType 1 =*/5593).double(message.macd);
            if (message.wiim != null && Object.hasOwnProperty.call(message, "wiim"))
                writer.uint32(/* id 700, wireType 2 =*/5602).string(message.wiim);
            if (message.wiimAsOf != null && Object.hasOwnProperty.call(message, "wiimAsOf"))
                writer.uint32(/* id 701, wireType 0 =*/5608).int64(message.wiimAsOf);
            if (message.vwap != null && Object.hasOwnProperty.call(message, "vwap"))
                writer.uint32(/* id 702, wireType 1 =*/5617).double(message.vwap);
            if (message.vwapChangePercent != null && Object.hasOwnProperty.call(message, "vwapChangePercent"))
                writer.uint32(/* id 704, wireType 1 =*/5633).double(message.vwapChangePercent);
            if (message.vwapChange != null && Object.hasOwnProperty.call(message, "vwapChange"))
                writer.uint32(/* id 705, wireType 1 =*/5641).double(message.vwapChange);
            if (message.rsiAvgGain != null && Object.hasOwnProperty.call(message, "rsiAvgGain"))
                writer.uint32(/* id 706, wireType 1 =*/5649).double(message.rsiAvgGain);
            if (message.rsiAvgLoss != null && Object.hasOwnProperty.call(message, "rsiAvgLoss"))
                writer.uint32(/* id 707, wireType 1 =*/5657).double(message.rsiAvgLoss);
            if (message.halted != null && Object.hasOwnProperty.call(message, "halted"))
                writer.uint32(/* id 708, wireType 2 =*/5666).string(message.halted);
            if (message.tradeCount != null && Object.hasOwnProperty.call(message, "tradeCount"))
                writer.uint32(/* id 709, wireType 0 =*/5672).int64(message.tradeCount);
            if (message.regularHighCount != null && Object.hasOwnProperty.call(message, "regularHighCount"))
                writer.uint32(/* id 710, wireType 0 =*/5680).int64(message.regularHighCount);
            if (message.regularLowCount != null && Object.hasOwnProperty.call(message, "regularLowCount"))
                writer.uint32(/* id 711, wireType 0 =*/5688).int64(message.regularLowCount);
            if (message.preMarketHighCount != null && Object.hasOwnProperty.call(message, "preMarketHighCount"))
                writer.uint32(/* id 712, wireType 0 =*/5696).int64(message.preMarketHighCount);
            if (message.preMarketLowCount != null && Object.hasOwnProperty.call(message, "preMarketLowCount"))
                writer.uint32(/* id 713, wireType 0 =*/5704).int64(message.preMarketLowCount);
            if (message.afterMarketHighCount != null && Object.hasOwnProperty.call(message, "afterMarketHighCount"))
                writer.uint32(/* id 714, wireType 0 =*/5712).int64(message.afterMarketHighCount);
            if (message.afterMarketLowCount != null && Object.hasOwnProperty.call(message, "afterMarketLowCount"))
                writer.uint32(/* id 715, wireType 0 =*/5720).int64(message.afterMarketLowCount);
            if (message.dayHighCount != null && Object.hasOwnProperty.call(message, "dayHighCount"))
                writer.uint32(/* id 716, wireType 0 =*/5728).int64(message.dayHighCount);
            if (message.dayLowCount != null && Object.hasOwnProperty.call(message, "dayLowCount"))
                writer.uint32(/* id 717, wireType 0 =*/5736).int64(message.dayLowCount);
            if (message.ema12d != null && Object.hasOwnProperty.call(message, "ema12d"))
                writer.uint32(/* id 718, wireType 1 =*/5745).double(message.ema12d);
            if (message.ema26d != null && Object.hasOwnProperty.call(message, "ema26d"))
                writer.uint32(/* id 719, wireType 1 =*/5753).double(message.ema26d);
            if (message.dayHigh != null && Object.hasOwnProperty.call(message, "dayHigh"))
                writer.uint32(/* id 720, wireType 1 =*/5761).double(message.dayHigh);
            if (message.dayLow != null && Object.hasOwnProperty.call(message, "dayLow"))
                writer.uint32(/* id 721, wireType 1 =*/5769).double(message.dayLow);
            if (message.preMarketHigh != null && Object.hasOwnProperty.call(message, "preMarketHigh"))
                writer.uint32(/* id 722, wireType 1 =*/5777).double(message.preMarketHigh);
            if (message.preMarketLow != null && Object.hasOwnProperty.call(message, "preMarketLow"))
                writer.uint32(/* id 723, wireType 1 =*/5785).double(message.preMarketLow);
            if (message.afterMarketHigh != null && Object.hasOwnProperty.call(message, "afterMarketHigh"))
                writer.uint32(/* id 724, wireType 1 =*/5793).double(message.afterMarketHigh);
            if (message.afterMarketLow != null && Object.hasOwnProperty.call(message, "afterMarketLow"))
                writer.uint32(/* id 725, wireType 1 =*/5801).double(message.afterMarketLow);
            if (message.regularHigh != null && Object.hasOwnProperty.call(message, "regularHigh"))
                writer.uint32(/* id 726, wireType 1 =*/5809).double(message.regularHigh);
            if (message.regularLow != null && Object.hasOwnProperty.call(message, "regularLow"))
                writer.uint32(/* id 727, wireType 1 =*/5817).double(message.regularLow);
            if (message.priceSpikeUpCount != null && Object.hasOwnProperty.call(message, "priceSpikeUpCount"))
                writer.uint32(/* id 728, wireType 0 =*/5824).int64(message.priceSpikeUpCount);
            if (message.priceSpikeDownCount != null && Object.hasOwnProperty.call(message, "priceSpikeDownCount"))
                writer.uint32(/* id 729, wireType 0 =*/5832).int64(message.priceSpikeDownCount);
            if (message.haltedCount != null && Object.hasOwnProperty.call(message, "haltedCount"))
                writer.uint32(/* id 730, wireType 0 =*/5840).int64(message.haltedCount);
            if (message.usCongressTotal != null && Object.hasOwnProperty.call(message, "usCongressTotal"))
                writer.uint32(/* id 731, wireType 1 =*/5849).double(message.usCongressTotal);
            if (message.usCongressRepublicansTotal != null && Object.hasOwnProperty.call(message, "usCongressRepublicansTotal"))
                writer.uint32(/* id 732, wireType 1 =*/5857).double(message.usCongressRepublicansTotal);
            if (message.usCongressDemocratsTotal != null && Object.hasOwnProperty.call(message, "usCongressDemocratsTotal"))
                writer.uint32(/* id 733, wireType 1 =*/5865).double(message.usCongressDemocratsTotal);
            if (message.usCongressOtherTotal != null && Object.hasOwnProperty.call(message, "usCongressOtherTotal"))
                writer.uint32(/* id 734, wireType 1 =*/5873).double(message.usCongressOtherTotal);
            if (message.volumeFloatRatio != null && Object.hasOwnProperty.call(message, "volumeFloatRatio"))
                writer.uint32(/* id 735, wireType 1 =*/5881).double(message.volumeFloatRatio);
            if (message.atrp != null && Object.hasOwnProperty.call(message, "atrp"))
                writer.uint32(/* id 736, wireType 1 =*/5889).double(message.atrp);
            if (message.ytdGainLoss != null && Object.hasOwnProperty.call(message, "ytdGainLoss"))
                writer.uint32(/* id 737, wireType 1 =*/5897).double(message.ytdGainLoss);
            if (message.mtdGainLoss != null && Object.hasOwnProperty.call(message, "mtdGainLoss"))
                writer.uint32(/* id 738, wireType 1 =*/5905).double(message.mtdGainLoss);
            if (message.yearOpen != null && Object.hasOwnProperty.call(message, "yearOpen"))
                writer.uint32(/* id 739, wireType 1 =*/5913).double(message.yearOpen);
            if (message.rsi1m != null && Object.hasOwnProperty.call(message, "rsi1m"))
                writer.uint32(/* id 740, wireType 1 =*/5921).double(message.rsi1m);
            if (message.rsi2m != null && Object.hasOwnProperty.call(message, "rsi2m"))
                writer.uint32(/* id 741, wireType 1 =*/5929).double(message.rsi2m);
            if (message.rsi5m != null && Object.hasOwnProperty.call(message, "rsi5m"))
                writer.uint32(/* id 742, wireType 1 =*/5937).double(message.rsi5m);
            if (message.rsi15m != null && Object.hasOwnProperty.call(message, "rsi15m"))
                writer.uint32(/* id 743, wireType 1 =*/5945).double(message.rsi15m);
            if (message.rsi30m != null && Object.hasOwnProperty.call(message, "rsi30m"))
                writer.uint32(/* id 745, wireType 1 =*/5961).double(message.rsi30m);
            if (message.rsi60m != null && Object.hasOwnProperty.call(message, "rsi60m"))
                writer.uint32(/* id 746, wireType 1 =*/5969).double(message.rsi60m);
            if (message.rsiEth1m != null && Object.hasOwnProperty.call(message, "rsiEth1m"))
                writer.uint32(/* id 747, wireType 1 =*/5977).double(message.rsiEth1m);
            if (message.rsiEth2m != null && Object.hasOwnProperty.call(message, "rsiEth2m"))
                writer.uint32(/* id 748, wireType 1 =*/5985).double(message.rsiEth2m);
            if (message.rsiEth5m != null && Object.hasOwnProperty.call(message, "rsiEth5m"))
                writer.uint32(/* id 749, wireType 1 =*/5993).double(message.rsiEth5m);
            if (message.rsiEth15m != null && Object.hasOwnProperty.call(message, "rsiEth15m"))
                writer.uint32(/* id 750, wireType 1 =*/6001).double(message.rsiEth15m);
            if (message.rsiEth30m != null && Object.hasOwnProperty.call(message, "rsiEth30m"))
                writer.uint32(/* id 751, wireType 1 =*/6009).double(message.rsiEth30m);
            if (message.rsiEth60m != null && Object.hasOwnProperty.call(message, "rsiEth60m"))
                writer.uint32(/* id 752, wireType 1 =*/6017).double(message.rsiEth60m);
            if (message.monthOpen != null && Object.hasOwnProperty.call(message, "monthOpen"))
                writer.uint32(/* id 753, wireType 1 =*/6025).double(message.monthOpen);
            if (message.volumeFloatPercent != null && Object.hasOwnProperty.call(message, "volumeFloatPercent"))
                writer.uint32(/* id 754, wireType 1 =*/6033).double(message.volumeFloatPercent);
            if (message.averageDollarVolume10Day != null && Object.hasOwnProperty.call(message, "averageDollarVolume10Day"))
                writer.uint32(/* id 755, wireType 1 =*/6041).double(message.averageDollarVolume10Day);
            if (message.averageVolume60Day != null && Object.hasOwnProperty.call(message, "averageVolume60Day"))
                writer.uint32(/* id 756, wireType 0 =*/6048).int64(message.averageVolume60Day);
            if (message.relativeVolumePercent60Day != null && Object.hasOwnProperty.call(message, "relativeVolumePercent60Day"))
                writer.uint32(/* id 757, wireType 1 =*/6057).double(message.relativeVolumePercent60Day);
            if (message.rsi1mLowest != null && Object.hasOwnProperty.call(message, "rsi1mLowest"))
                writer.uint32(/* id 758, wireType 1 =*/6065).double(message.rsi1mLowest);
            if (message.rsi2mLowest != null && Object.hasOwnProperty.call(message, "rsi2mLowest"))
                writer.uint32(/* id 759, wireType 1 =*/6073).double(message.rsi2mLowest);
            if (message.rsi5mLowest != null && Object.hasOwnProperty.call(message, "rsi5mLowest"))
                writer.uint32(/* id 760, wireType 1 =*/6081).double(message.rsi5mLowest);
            if (message.rsi15mLowest != null && Object.hasOwnProperty.call(message, "rsi15mLowest"))
                writer.uint32(/* id 761, wireType 1 =*/6089).double(message.rsi15mLowest);
            if (message.rsi30mLowest != null && Object.hasOwnProperty.call(message, "rsi30mLowest"))
                writer.uint32(/* id 762, wireType 1 =*/6097).double(message.rsi30mLowest);
            if (message.rsi60mLowest != null && Object.hasOwnProperty.call(message, "rsi60mLowest"))
                writer.uint32(/* id 763, wireType 1 =*/6105).double(message.rsi60mLowest);
            if (message.rsiEth1mLowest != null && Object.hasOwnProperty.call(message, "rsiEth1mLowest"))
                writer.uint32(/* id 764, wireType 1 =*/6113).double(message.rsiEth1mLowest);
            if (message.rsiEth2mLowest != null && Object.hasOwnProperty.call(message, "rsiEth2mLowest"))
                writer.uint32(/* id 765, wireType 1 =*/6121).double(message.rsiEth2mLowest);
            if (message.rsiEth5mLowest != null && Object.hasOwnProperty.call(message, "rsiEth5mLowest"))
                writer.uint32(/* id 766, wireType 1 =*/6129).double(message.rsiEth5mLowest);
            if (message.rsiEth15mLowest != null && Object.hasOwnProperty.call(message, "rsiEth15mLowest"))
                writer.uint32(/* id 767, wireType 1 =*/6137).double(message.rsiEth15mLowest);
            if (message.rsiEth30mLowest != null && Object.hasOwnProperty.call(message, "rsiEth30mLowest"))
                writer.uint32(/* id 768, wireType 1 =*/6145).double(message.rsiEth30mLowest);
            if (message.rsiEth60mLowest != null && Object.hasOwnProperty.call(message, "rsiEth60mLowest"))
                writer.uint32(/* id 769, wireType 1 =*/6153).double(message.rsiEth60mLowest);
            if (message.rsi1mGreatest != null && Object.hasOwnProperty.call(message, "rsi1mGreatest"))
                writer.uint32(/* id 770, wireType 1 =*/6161).double(message.rsi1mGreatest);
            if (message.rsi2mGreatest != null && Object.hasOwnProperty.call(message, "rsi2mGreatest"))
                writer.uint32(/* id 771, wireType 1 =*/6169).double(message.rsi2mGreatest);
            if (message.rsi5mGreatest != null && Object.hasOwnProperty.call(message, "rsi5mGreatest"))
                writer.uint32(/* id 772, wireType 1 =*/6177).double(message.rsi5mGreatest);
            if (message.rsi15mGreatest != null && Object.hasOwnProperty.call(message, "rsi15mGreatest"))
                writer.uint32(/* id 773, wireType 1 =*/6185).double(message.rsi15mGreatest);
            if (message.rsi30mGreatest != null && Object.hasOwnProperty.call(message, "rsi30mGreatest"))
                writer.uint32(/* id 774, wireType 1 =*/6193).double(message.rsi30mGreatest);
            if (message.rsi60mGreatest != null && Object.hasOwnProperty.call(message, "rsi60mGreatest"))
                writer.uint32(/* id 775, wireType 1 =*/6201).double(message.rsi60mGreatest);
            if (message.rsiEth1mGreatest != null && Object.hasOwnProperty.call(message, "rsiEth1mGreatest"))
                writer.uint32(/* id 776, wireType 1 =*/6209).double(message.rsiEth1mGreatest);
            if (message.rsiEth2mGreatest != null && Object.hasOwnProperty.call(message, "rsiEth2mGreatest"))
                writer.uint32(/* id 777, wireType 1 =*/6217).double(message.rsiEth2mGreatest);
            if (message.rsiEth5mGreatest != null && Object.hasOwnProperty.call(message, "rsiEth5mGreatest"))
                writer.uint32(/* id 778, wireType 1 =*/6225).double(message.rsiEth5mGreatest);
            if (message.rsiEth15mGreatest != null && Object.hasOwnProperty.call(message, "rsiEth15mGreatest"))
                writer.uint32(/* id 779, wireType 1 =*/6233).double(message.rsiEth15mGreatest);
            if (message.rsiEth30mGreatest != null && Object.hasOwnProperty.call(message, "rsiEth30mGreatest"))
                writer.uint32(/* id 780, wireType 1 =*/6241).double(message.rsiEth30mGreatest);
            if (message.rsiEth60mGreatest != null && Object.hasOwnProperty.call(message, "rsiEth60mGreatest"))
                writer.uint32(/* id 781, wireType 1 =*/6249).double(message.rsiEth60mGreatest);
            if (message.rsiCrossOver != null && Object.hasOwnProperty.call(message, "rsiCrossOver"))
                writer.uint32(/* id 782, wireType 1 =*/6257).double(message.rsiCrossOver);
            if (message.change1Week != null && Object.hasOwnProperty.call(message, "change1Week"))
                writer.uint32(/* id 799, wireType 1 =*/6393).double(message.change1Week);
            if (message.price1Week != null && Object.hasOwnProperty.call(message, "price1Week"))
                writer.uint32(/* id 800, wireType 1 =*/6401).double(message.price1Week);
            if (message.priceChangePercent1Week != null && Object.hasOwnProperty.call(message, "priceChangePercent1Week"))
                writer.uint32(/* id 801, wireType 1 =*/6409).double(message.priceChangePercent1Week);
            if (message.price1Month != null && Object.hasOwnProperty.call(message, "price1Month"))
                writer.uint32(/* id 802, wireType 1 =*/6417).double(message.price1Month);
            if (message.priceChangePercent1Month != null && Object.hasOwnProperty.call(message, "priceChangePercent1Month"))
                writer.uint32(/* id 803, wireType 1 =*/6425).double(message.priceChangePercent1Month);
            if (message.priceHalfYear != null && Object.hasOwnProperty.call(message, "priceHalfYear"))
                writer.uint32(/* id 804, wireType 1 =*/6433).double(message.priceHalfYear);
            if (message.priceChangePercentHalfYear != null && Object.hasOwnProperty.call(message, "priceChangePercentHalfYear"))
                writer.uint32(/* id 805, wireType 1 =*/6441).double(message.priceChangePercentHalfYear);
            if (message.priceQuarter != null && Object.hasOwnProperty.call(message, "priceQuarter"))
                writer.uint32(/* id 806, wireType 1 =*/6449).double(message.priceQuarter);
            if (message.priceChangePercentQuarter != null && Object.hasOwnProperty.call(message, "priceChangePercentQuarter"))
                writer.uint32(/* id 807, wireType 1 =*/6457).double(message.priceChangePercentQuarter);
            if (message.price1Year != null && Object.hasOwnProperty.call(message, "price1Year"))
                writer.uint32(/* id 808, wireType 1 =*/6465).double(message.price1Year);
            if (message.priceChangePercent1Year != null && Object.hasOwnProperty.call(message, "priceChangePercent1Year"))
                writer.uint32(/* id 809, wireType 1 =*/6473).double(message.priceChangePercent1Year);
            if (message.priceYearToDate != null && Object.hasOwnProperty.call(message, "priceYearToDate"))
                writer.uint32(/* id 810, wireType 1 =*/6481).double(message.priceYearToDate);
            if (message.priceChangePercentYearToDate != null && Object.hasOwnProperty.call(message, "priceChangePercentYearToDate"))
                writer.uint32(/* id 811, wireType 1 =*/6489).double(message.priceChangePercentYearToDate);
            if (message.bullsSay != null && Object.hasOwnProperty.call(message, "bullsSay"))
                writer.uint32(/* id 812, wireType 2 =*/6498).string(message.bullsSay);
            if (message.bearsSay != null && Object.hasOwnProperty.call(message, "bearsSay"))
                writer.uint32(/* id 813, wireType 2 =*/6506).string(message.bearsSay);
            if (message.afterMarketVolume != null && Object.hasOwnProperty.call(message, "afterMarketVolume"))
                writer.uint32(/* id 899, wireType 0 =*/7192).int64(message.afterMarketVolume);
            if (message.preMarketOpen != null && Object.hasOwnProperty.call(message, "preMarketOpen"))
                writer.uint32(/* id 900, wireType 1 =*/7201).double(message.preMarketOpen);
            if (message.preMarketOpenTime != null && Object.hasOwnProperty.call(message, "preMarketOpenTime"))
                writer.uint32(/* id 901, wireType 0 =*/7208).int64(message.preMarketOpenTime);
            if (message.preMarketVolume != null && Object.hasOwnProperty.call(message, "preMarketVolume"))
                writer.uint32(/* id 902, wireType 0 =*/7216).int64(message.preMarketVolume);
            if (message.preMarketOpenChange != null && Object.hasOwnProperty.call(message, "preMarketOpenChange"))
                writer.uint32(/* id 903, wireType 1 =*/7225).double(message.preMarketOpenChange);
            if (message.preMarketOpenChangePercent != null && Object.hasOwnProperty.call(message, "preMarketOpenChangePercent"))
                writer.uint32(/* id 904, wireType 1 =*/7233).double(message.preMarketOpenChangePercent);
            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                writer.uint32(/* id 905, wireType 0 =*/7240).int32(message.source);
            if (message.clearFieldNumbers != null && message.clearFieldNumbers.length) {
                writer.uint32(/* id 906, wireType 2 =*/7250).fork();
                for (let i = 0; i < message.clearFieldNumbers.length; ++i)
                    writer.int32(message.clearFieldNumbers[i]);
                writer.ldelim();
            }
            if (message.totalDebtEquityRatio != null && Object.hasOwnProperty.call(message, "totalDebtEquityRatio"))
                writer.uint32(/* id 907, wireType 1 =*/7257).double(message.totalDebtEquityRatio);
            if (message.dividendPayoutRatio != null && Object.hasOwnProperty.call(message, "dividendPayoutRatio"))
                writer.uint32(/* id 908, wireType 1 =*/7265).double(message.dividendPayoutRatio);
            if (message.operatingCashFlow != null && Object.hasOwnProperty.call(message, "operatingCashFlow"))
                writer.uint32(/* id 909, wireType 1 =*/7273).double(message.operatingCashFlow);
            if (message.insiderPercentage != null && Object.hasOwnProperty.call(message, "insiderPercentage"))
                writer.uint32(/* id 910, wireType 1 =*/7281).double(message.insiderPercentage);
            if (message.priceToCashFlowRatio != null && Object.hasOwnProperty.call(message, "priceToCashFlowRatio"))
                writer.uint32(/* id 911, wireType 1 =*/7289).double(message.priceToCashFlowRatio);
            if (message.regularHoursChange != null && Object.hasOwnProperty.call(message, "regularHoursChange"))
                writer.uint32(/* id 912, wireType 1 =*/7297).double(message.regularHoursChange);
            if (message.regularHoursPercentChange != null && Object.hasOwnProperty.call(message, "regularHoursPercentChange"))
                writer.uint32(/* id 913, wireType 1 =*/7305).double(message.regularHoursPercentChange);
            if (message.postToPreHoursChange != null && Object.hasOwnProperty.call(message, "postToPreHoursChange"))
                writer.uint32(/* id 914, wireType 1 =*/7313).double(message.postToPreHoursChange);
            if (message.postToPreHoursPercentChange != null && Object.hasOwnProperty.call(message, "postToPreHoursPercentChange"))
                writer.uint32(/* id 915, wireType 1 =*/7321).double(message.postToPreHoursPercentChange);
            if (message.scannerClose != null && Object.hasOwnProperty.call(message, "scannerClose"))
                writer.uint32(/* id 916, wireType 1 =*/7329).double(message.scannerClose);
            if (message.scannerChange != null && Object.hasOwnProperty.call(message, "scannerChange"))
                writer.uint32(/* id 917, wireType 1 =*/7337).double(message.scannerChange);
            if (message.scannerChangePercent != null && Object.hasOwnProperty.call(message, "scannerChangePercent"))
                writer.uint32(/* id 918, wireType 1 =*/7345).double(message.scannerChangePercent);
            if (message.scannerChangePercentClose != null && Object.hasOwnProperty.call(message, "scannerChangePercentClose"))
                writer.uint32(/* id 919, wireType 1 =*/7353).double(message.scannerChangePercentClose);
            if (message.scannerPreviousClose != null && Object.hasOwnProperty.call(message, "scannerPreviousClose"))
                writer.uint32(/* id 920, wireType 1 =*/7361).double(message.scannerPreviousClose);
            if (message.freeCashFlow != null && Object.hasOwnProperty.call(message, "freeCashFlow"))
                writer.uint32(/* id 921, wireType 1 =*/7369).double(message.freeCashFlow);
            if (message.minPriceTarget != null && Object.hasOwnProperty.call(message, "minPriceTarget"))
                writer.uint32(/* id 922, wireType 1 =*/7377).double(message.minPriceTarget);
            if (message.maxPriceTarget != null && Object.hasOwnProperty.call(message, "maxPriceTarget"))
                writer.uint32(/* id 923, wireType 1 =*/7385).double(message.maxPriceTarget);
            if (message.meanPriceTarget != null && Object.hasOwnProperty.call(message, "meanPriceTarget"))
                writer.uint32(/* id 924, wireType 1 =*/7393).double(message.meanPriceTarget);
            if (message.totalNumberOfAnalyst != null && Object.hasOwnProperty.call(message, "totalNumberOfAnalyst"))
                writer.uint32(/* id 925, wireType 1 =*/7401).double(message.totalNumberOfAnalyst);
            if (message.averageAnalystRecommendation != null && Object.hasOwnProperty.call(message, "averageAnalystRecommendation"))
                writer.uint32(/* id 926, wireType 2 =*/7410).string(message.averageAnalystRecommendation);
            if (message.pegRatio != null && Object.hasOwnProperty.call(message, "pegRatio"))
                writer.uint32(/* id 927, wireType 1 =*/7417).double(message.pegRatio);
            if (message.priceToFreeCashFlowRatio != null && Object.hasOwnProperty.call(message, "priceToFreeCashFlowRatio"))
                writer.uint32(/* id 928, wireType 1 =*/7425).double(message.priceToFreeCashFlowRatio);
            if (message.distanceToMaxPriceTarget != null && Object.hasOwnProperty.call(message, "distanceToMaxPriceTarget"))
                writer.uint32(/* id 929, wireType 1 =*/7433).double(message.distanceToMaxPriceTarget);
            if (message.distanceToMinPriceTarget != null && Object.hasOwnProperty.call(message, "distanceToMinPriceTarget"))
                writer.uint32(/* id 930, wireType 1 =*/7441).double(message.distanceToMinPriceTarget);
            if (message.distanceToMeanPriceTarget != null && Object.hasOwnProperty.call(message, "distanceToMeanPriceTarget"))
                writer.uint32(/* id 931, wireType 1 =*/7449).double(message.distanceToMeanPriceTarget);
            if (message.shortTermTrend != null && Object.hasOwnProperty.call(message, "shortTermTrend"))
                writer.uint32(/* id 932, wireType 2 =*/7458).string(message.shortTermTrend);
            if (message.mediumTermTrend != null && Object.hasOwnProperty.call(message, "mediumTermTrend"))
                writer.uint32(/* id 933, wireType 2 =*/7466).string(message.mediumTermTrend);
            if (message.longTermTrend != null && Object.hasOwnProperty.call(message, "longTermTrend"))
                writer.uint32(/* id 934, wireType 2 =*/7474).string(message.longTermTrend);
            if (message.twentySixWeekChange != null && Object.hasOwnProperty.call(message, "twentySixWeekChange"))
                writer.uint32(/* id 935, wireType 1 =*/7481).double(message.twentySixWeekChange);
            if (message.fiftyTwoWeekChange != null && Object.hasOwnProperty.call(message, "fiftyTwoWeekChange"))
                writer.uint32(/* id 936, wireType 1 =*/7489).double(message.fiftyTwoWeekChange);
            if (message.annualizedStandardDeviation != null && Object.hasOwnProperty.call(message, "annualizedStandardDeviation"))
                writer.uint32(/* id 937, wireType 1 =*/7497).double(message.annualizedStandardDeviation);
            if (message.momentum != null && Object.hasOwnProperty.call(message, "momentum"))
                writer.uint32(/* id 938, wireType 1 =*/7505).double(message.momentum);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 939, wireType 1 =*/7513).double(message.value);
            if (message.piotroskiFScore != null && Object.hasOwnProperty.call(message, "piotroskiFScore"))
                writer.uint32(/* id 940, wireType 0 =*/7520).int64(message.piotroskiFScore);
            if (message.netIncomeTtm != null && Object.hasOwnProperty.call(message, "netIncomeTtm"))
                writer.uint32(/* id 941, wireType 1 =*/7529).double(message.netIncomeTtm);
            if (message.growth != null && Object.hasOwnProperty.call(message, "growth"))
                writer.uint32(/* id 942, wireType 1 =*/7537).double(message.growth);
            if (message.currentRatioYearAgo != null && Object.hasOwnProperty.call(message, "currentRatioYearAgo"))
                writer.uint32(/* id 943, wireType 1 =*/7545).double(message.currentRatioYearAgo);
            if (message.roaYearAgo != null && Object.hasOwnProperty.call(message, "roaYearAgo"))
                writer.uint32(/* id 944, wireType 1 =*/7553).double(message.roaYearAgo);
            if (message.grossMarginYearAgo != null && Object.hasOwnProperty.call(message, "grossMarginYearAgo"))
                writer.uint32(/* id 945, wireType 1 =*/7561).double(message.grossMarginYearAgo);
            if (message.longTermDebt != null && Object.hasOwnProperty.call(message, "longTermDebt"))
                writer.uint32(/* id 946, wireType 1 =*/7569).double(message.longTermDebt);
            if (message.longTermDebtYearAgo != null && Object.hasOwnProperty.call(message, "longTermDebtYearAgo"))
                writer.uint32(/* id 947, wireType 1 =*/7577).double(message.longTermDebtYearAgo);
            if (message.shareIssued != null && Object.hasOwnProperty.call(message, "shareIssued"))
                writer.uint32(/* id 948, wireType 1 =*/7585).double(message.shareIssued);
            if (message.shareIssuedYearAgo != null && Object.hasOwnProperty.call(message, "shareIssuedYearAgo"))
                writer.uint32(/* id 949, wireType 1 =*/7593).double(message.shareIssuedYearAgo);
            if (message.totalAssets != null && Object.hasOwnProperty.call(message, "totalAssets"))
                writer.uint32(/* id 950, wireType 1 =*/7601).double(message.totalAssets);
            if (message.totalAssetsYearAgo != null && Object.hasOwnProperty.call(message, "totalAssetsYearAgo"))
                writer.uint32(/* id 951, wireType 1 =*/7609).double(message.totalAssetsYearAgo);
            if (message.totalAssets2YearAgo != null && Object.hasOwnProperty.call(message, "totalAssets2YearAgo"))
                writer.uint32(/* id 952, wireType 1 =*/7617).double(message.totalAssets2YearAgo);
            if (message.revenueTtmYearAgo != null && Object.hasOwnProperty.call(message, "revenueTtmYearAgo"))
                writer.uint32(/* id 953, wireType 1 =*/7625).double(message.revenueTtmYearAgo);
            if (message.longTermDebtAndCapitalLeaseObligation != null && Object.hasOwnProperty.call(message, "longTermDebtAndCapitalLeaseObligation"))
                writer.uint32(/* id 954, wireType 1 =*/7633).double(message.longTermDebtAndCapitalLeaseObligation);
            if (message.averageTotalAssets != null && Object.hasOwnProperty.call(message, "averageTotalAssets"))
                writer.uint32(/* id 955, wireType 1 =*/7641).double(message.averageTotalAssets);
            if (message.averageTotalAssetsYearAgo != null && Object.hasOwnProperty.call(message, "averageTotalAssetsYearAgo"))
                writer.uint32(/* id 956, wireType 1 =*/7649).double(message.averageTotalAssetsYearAgo);
            if (message.quality != null && Object.hasOwnProperty.call(message, "quality"))
                writer.uint32(/* id 957, wireType 1 =*/7657).double(message.quality);
            if (message.momentumPercentile != null && Object.hasOwnProperty.call(message, "momentumPercentile"))
                writer.uint32(/* id 958, wireType 1 =*/7665).double(message.momentumPercentile);
            if (message.valuePercentile != null && Object.hasOwnProperty.call(message, "valuePercentile"))
                writer.uint32(/* id 959, wireType 1 =*/7673).double(message.valuePercentile);
            if (message.growthPercentile != null && Object.hasOwnProperty.call(message, "growthPercentile"))
                writer.uint32(/* id 960, wireType 1 =*/7681).double(message.growthPercentile);
            if (message.qualityPercentile != null && Object.hasOwnProperty.call(message, "qualityPercentile"))
                writer.uint32(/* id 961, wireType 1 =*/7689).double(message.qualityPercentile);
            if (message.totalDividendTtm != null && Object.hasOwnProperty.call(message, "totalDividendTtm"))
                writer.uint32(/* id 962, wireType 1 =*/7697).double(message.totalDividendTtm);
            if (message.dividendIncreasing != null && Object.hasOwnProperty.call(message, "dividendIncreasing"))
                writer.uint32(/* id 963, wireType 0 =*/7704).int32(message.dividendIncreasing);
            if (message.rateOfReturnDay != null && Object.hasOwnProperty.call(message, "rateOfReturnDay"))
                writer.uint32(/* id 965, wireType 1 =*/7721).double(message.rateOfReturnDay);
            if (message.rateOfReturnWeek != null && Object.hasOwnProperty.call(message, "rateOfReturnWeek"))
                writer.uint32(/* id 966, wireType 1 =*/7729).double(message.rateOfReturnWeek);
            if (message.rateOfReturnMonth != null && Object.hasOwnProperty.call(message, "rateOfReturnMonth"))
                writer.uint32(/* id 967, wireType 1 =*/7737).double(message.rateOfReturnMonth);
            if (message.dividendOneDay != null && Object.hasOwnProperty.call(message, "dividendOneDay"))
                writer.uint32(/* id 968, wireType 1 =*/7745).double(message.dividendOneDay);
            if (message.dividendOneWeek != null && Object.hasOwnProperty.call(message, "dividendOneWeek"))
                writer.uint32(/* id 969, wireType 1 =*/7753).double(message.dividendOneWeek);
            if (message.dividendOneMonth != null && Object.hasOwnProperty.call(message, "dividendOneMonth"))
                writer.uint32(/* id 970, wireType 1 =*/7761).double(message.dividendOneMonth);
            if (message.totalLiabilities != null && Object.hasOwnProperty.call(message, "totalLiabilities"))
                writer.uint32(/* id 971, wireType 1 =*/7769).double(message.totalLiabilities);
            if (message.retainedEarnings != null && Object.hasOwnProperty.call(message, "retainedEarnings"))
                writer.uint32(/* id 972, wireType 1 =*/7777).double(message.retainedEarnings);
            if (message.ebit != null && Object.hasOwnProperty.call(message, "ebit"))
                writer.uint32(/* id 973, wireType 1 =*/7785).double(message.ebit);
            if (message.altmanZScore != null && Object.hasOwnProperty.call(message, "altmanZScore"))
                writer.uint32(/* id 974, wireType 1 =*/7793).double(message.altmanZScore);
            if (message.powerEarningGap != null && Object.hasOwnProperty.call(message, "powerEarningGap"))
                writer.uint32(/* id 975, wireType 0 =*/7800).bool(message.powerEarningGap);
            if (message.monsterPowerEarningGap != null && Object.hasOwnProperty.call(message, "monsterPowerEarningGap"))
                writer.uint32(/* id 976, wireType 0 =*/7808).bool(message.monsterPowerEarningGap);
            if (message.monsterGap != null && Object.hasOwnProperty.call(message, "monsterGap"))
                writer.uint32(/* id 977, wireType 0 =*/7816).bool(message.monsterGap);
            if (message.oelGap != null && Object.hasOwnProperty.call(message, "oelGap"))
                writer.uint32(/* id 978, wireType 0 =*/7824).bool(message.oelGap);
            if (message.evToEbit != null && Object.hasOwnProperty.call(message, "evToEbit"))
                writer.uint32(/* id 980, wireType 1 =*/7841).double(message.evToEbit);
            if (message.priceToTangibleBookValue != null && Object.hasOwnProperty.call(message, "priceToTangibleBookValue"))
                writer.uint32(/* id 981, wireType 1 =*/7849).double(message.priceToTangibleBookValue);
            if (message.tangibleBookValuePerShare != null && Object.hasOwnProperty.call(message, "tangibleBookValuePerShare"))
                writer.uint32(/* id 982, wireType 1 =*/7857).double(message.tangibleBookValuePerShare);
            if (message.dailyDollarVolume != null && Object.hasOwnProperty.call(message, "dailyDollarVolume"))
                writer.uint32(/* id 983, wireType 1 =*/7865).double(message.dailyDollarVolume);
            if (message.bookValuePerShare != null && Object.hasOwnProperty.call(message, "bookValuePerShare"))
                writer.uint32(/* id 984, wireType 1 =*/7873).double(message.bookValuePerShare);
            if (message.movingAverage350Day != null && Object.hasOwnProperty.call(message, "movingAverage350Day"))
                writer.uint32(/* id 985, wireType 1 =*/7881).double(message.movingAverage350Day);
            if (message.priceToAdjEarningsTtm != null && Object.hasOwnProperty.call(message, "priceToAdjEarningsTtm"))
                writer.uint32(/* id 986, wireType 1 =*/7889).double(message.priceToAdjEarningsTtm);
            if (message.salesGrowthYoY != null && Object.hasOwnProperty.call(message, "salesGrowthYoY"))
                writer.uint32(/* id 987, wireType 1 =*/7897).double(message.salesGrowthYoY);
            if (message.salesGrowth3Year != null && Object.hasOwnProperty.call(message, "salesGrowth3Year"))
                writer.uint32(/* id 988, wireType 1 =*/7905).double(message.salesGrowth3Year);
            if (message.salesGrowth5Year != null && Object.hasOwnProperty.call(message, "salesGrowth5Year"))
                writer.uint32(/* id 989, wireType 1 =*/7913).double(message.salesGrowth5Year);
            if (message.debtQoQ != null && Object.hasOwnProperty.call(message, "debtQoQ"))
                writer.uint32(/* id 990, wireType 1 =*/7921).double(message.debtQoQ);
            if (message.debtYoY != null && Object.hasOwnProperty.call(message, "debtYoY"))
                writer.uint32(/* id 991, wireType 1 =*/7929).double(message.debtYoY);
            if (message.debt5Year != null && Object.hasOwnProperty.call(message, "debt5Year"))
                writer.uint32(/* id 992, wireType 1 =*/7937).double(message.debt5Year);
            if (message.epsGrowth3Year != null && Object.hasOwnProperty.call(message, "epsGrowth3Year"))
                writer.uint32(/* id 993, wireType 1 =*/7945).double(message.epsGrowth3Year);
            if (message.epsGrowth3NormalizedYear != null && Object.hasOwnProperty.call(message, "epsGrowth3NormalizedYear"))
                writer.uint32(/* id 994, wireType 1 =*/7953).double(message.epsGrowth3NormalizedYear);
            if (message.roe5YrAvg != null && Object.hasOwnProperty.call(message, "roe5YrAvg"))
                writer.uint32(/* id 995, wireType 1 =*/7961).double(message.roe5YrAvg);
            if (message.stockholdersEquity != null && Object.hasOwnProperty.call(message, "stockholdersEquity"))
                writer.uint32(/* id 996, wireType 1 =*/7969).double(message.stockholdersEquity);
            if (message.stockholdersEquityYearAgo != null && Object.hasOwnProperty.call(message, "stockholdersEquityYearAgo"))
                writer.uint32(/* id 997, wireType 1 =*/7977).double(message.stockholdersEquityYearAgo);
            if (message.stockholdersEquityGrowthYoY != null && Object.hasOwnProperty.call(message, "stockholdersEquityGrowthYoY"))
                writer.uint32(/* id 998, wireType 1 =*/7985).double(message.stockholdersEquityGrowthYoY);
            if (message.vwap1Day != null && Object.hasOwnProperty.call(message, "vwap1Day"))
                writer.uint32(/* id 1000, wireType 1 =*/8001).double(message.vwap1Day);
            if (message.vwap5Day != null && Object.hasOwnProperty.call(message, "vwap5Day"))
                writer.uint32(/* id 1001, wireType 1 =*/8009).double(message.vwap5Day);
            if (message.vwap10Day != null && Object.hasOwnProperty.call(message, "vwap10Day"))
                writer.uint32(/* id 1002, wireType 1 =*/8017).double(message.vwap10Day);
            if (message.vwap50Day != null && Object.hasOwnProperty.call(message, "vwap50Day"))
                writer.uint32(/* id 1003, wireType 1 =*/8025).double(message.vwap50Day);
            if (message.vwap100Day != null && Object.hasOwnProperty.call(message, "vwap100Day"))
                writer.uint32(/* id 1004, wireType 1 =*/8033).double(message.vwap100Day);
            if (message.vwap200Day != null && Object.hasOwnProperty.call(message, "vwap200Day"))
                writer.uint32(/* id 1005, wireType 1 =*/8041).double(message.vwap200Day);
            if (message.roic1YearAvg != null && Object.hasOwnProperty.call(message, "roic1YearAvg"))
                writer.uint32(/* id 1006, wireType 1 =*/8049).double(message.roic1YearAvg);
            if (message.roic5YearAvg != null && Object.hasOwnProperty.call(message, "roic5YearAvg"))
                writer.uint32(/* id 1007, wireType 1 =*/8057).double(message.roic5YearAvg);
            if (message.vwap1m != null && Object.hasOwnProperty.call(message, "vwap1m"))
                writer.uint32(/* id 1008, wireType 1 =*/8065).double(message.vwap1m);
            if (message.vwap5m != null && Object.hasOwnProperty.call(message, "vwap5m"))
                writer.uint32(/* id 1009, wireType 1 =*/8073).double(message.vwap5m);
            if (message.vwap15m != null && Object.hasOwnProperty.call(message, "vwap15m"))
                writer.uint32(/* id 1010, wireType 1 =*/8081).double(message.vwap15m);
            if (message.vwap30m != null && Object.hasOwnProperty.call(message, "vwap30m"))
                writer.uint32(/* id 1011, wireType 1 =*/8089).double(message.vwap30m);
            if (message.vwap60m != null && Object.hasOwnProperty.call(message, "vwap60m"))
                writer.uint32(/* id 1012, wireType 1 =*/8097).double(message.vwap60m);
            if (message.candleStick != null && Object.hasOwnProperty.call(message, "candleStick"))
                writer.uint32(/* id 1013, wireType 2 =*/8106).string(message.candleStick);
            if (message.patterns != null && Object.hasOwnProperty.call(message, "patterns"))
                writer.uint32(/* id 1014, wireType 2 =*/8114).string(message.patterns);
            if (message.earningsForwardGrowth3Year != null && Object.hasOwnProperty.call(message, "earningsForwardGrowth3Year"))
                writer.uint32(/* id 1015, wireType 1 =*/8121).double(message.earningsForwardGrowth3Year);
            if (message.earningsForwardGrowth5Year != null && Object.hasOwnProperty.call(message, "earningsForwardGrowth5Year"))
                writer.uint32(/* id 1016, wireType 1 =*/8129).double(message.earningsForwardGrowth5Year);
            if (message.revenueForwardGrowth3Year != null && Object.hasOwnProperty.call(message, "revenueForwardGrowth3Year"))
                writer.uint32(/* id 1017, wireType 1 =*/8137).double(message.revenueForwardGrowth3Year);
            if (message.revenueForwardGrowth5Year != null && Object.hasOwnProperty.call(message, "revenueForwardGrowth5Year"))
                writer.uint32(/* id 1018, wireType 1 =*/8145).double(message.revenueForwardGrowth5Year);
            if (message.bidAskSpread != null && Object.hasOwnProperty.call(message, "bidAskSpread"))
                writer.uint32(/* id 1019, wireType 1 =*/8153).double(message.bidAskSpread);
            if (message.bidAskSpreadPercent != null && Object.hasOwnProperty.call(message, "bidAskSpreadPercent"))
                writer.uint32(/* id 1020, wireType 1 =*/8161).double(message.bidAskSpreadPercent);
            if (message.change1Minute != null && Object.hasOwnProperty.call(message, "change1Minute"))
                writer.uint32(/* id 1021, wireType 1 =*/8169).double(message.change1Minute);
            if (message.preMarketChange1Minute != null && Object.hasOwnProperty.call(message, "preMarketChange1Minute"))
                writer.uint32(/* id 1022, wireType 1 =*/8177).double(message.preMarketChange1Minute);
            if (message.preMarketChangePercent1Minute != null && Object.hasOwnProperty.call(message, "preMarketChangePercent1Minute"))
                writer.uint32(/* id 1023, wireType 1 =*/8185).double(message.preMarketChangePercent1Minute);
            if (message.regularChange1Minute != null && Object.hasOwnProperty.call(message, "regularChange1Minute"))
                writer.uint32(/* id 1024, wireType 1 =*/8193).double(message.regularChange1Minute);
            if (message.regularChangePercent1Minute != null && Object.hasOwnProperty.call(message, "regularChangePercent1Minute"))
                writer.uint32(/* id 1025, wireType 1 =*/8201).double(message.regularChangePercent1Minute);
            if (message.afterMarketChange1Minute != null && Object.hasOwnProperty.call(message, "afterMarketChange1Minute"))
                writer.uint32(/* id 1026, wireType 1 =*/8209).double(message.afterMarketChange1Minute);
            if (message.afterMarketChangePercent1Minute != null && Object.hasOwnProperty.call(message, "afterMarketChangePercent1Minute"))
                writer.uint32(/* id 1027, wireType 1 =*/8217).double(message.afterMarketChangePercent1Minute);
            if (message.previousCloseDate != null && Object.hasOwnProperty.call(message, "previousCloseDate"))
                writer.uint32(/* id 1028, wireType 2 =*/8226).string(message.previousCloseDate);
            if (message.distanceToMaxPriceTargetPercent != null && Object.hasOwnProperty.call(message, "distanceToMaxPriceTargetPercent"))
                writer.uint32(/* id 1029, wireType 1 =*/8233).double(message.distanceToMaxPriceTargetPercent);
            if (message.distanceToMinPriceTargetPercent != null && Object.hasOwnProperty.call(message, "distanceToMinPriceTargetPercent"))
                writer.uint32(/* id 1030, wireType 1 =*/8241).double(message.distanceToMinPriceTargetPercent);
            if (message.distanceToMeanPriceTargetPercent != null && Object.hasOwnProperty.call(message, "distanceToMeanPriceTargetPercent"))
                writer.uint32(/* id 1031, wireType 1 =*/8249).double(message.distanceToMeanPriceTargetPercent);
            return writer;
        };

        /**
         * Encodes the specified Quote message, length delimited. Does not implicitly {@link QuoteProtos.Quote.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteProtos.Quote
         * @static
         * @param {QuoteProtos.IQuote} message Quote message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Quote.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Quote message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteProtos.Quote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {QuoteProtos.Quote} Quote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Quote.decode = function decode(reader, length, error, long) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (long === undefined)
                long = 0;
            if (long > $Reader.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.QuoteProtos.Quote();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.symbol = reader.string();
                        break;
                    }
                case 100: {
                        message.opol = reader.string();
                        break;
                    }
                case 2: {
                        message.previousClose = reader.double();
                        break;
                    }
                case 3: {
                        message.close = reader.double();
                        break;
                    }
                case 4: {
                        message.change = reader.double();
                        break;
                    }
                case 5: {
                        message.changePercent = reader.double();
                        break;
                    }
                case 6: {
                        message.name = reader.string();
                        break;
                    }
                case 7: {
                        message.ipoDate = reader.string();
                        break;
                    }
                case 8: {
                        message.exchange = reader.string();
                        break;
                    }
                case 9: {
                        message.tradeExchange = reader.string();
                        break;
                    }
                case 900: {
                        message.preMarketOpen = reader.double();
                        break;
                    }
                case 901: {
                        message.preMarketOpenTime = reader.int64();
                        break;
                    }
                case 902: {
                        message.preMarketVolume = reader.int64();
                        break;
                    }
                case 899: {
                        message.afterMarketVolume = reader.int64();
                        break;
                    }
                case 124: {
                        message.preMarketPrice = reader.double();
                        break;
                    }
                case 125: {
                        message.afterMarketPrice = reader.double();
                        break;
                    }
                case 903: {
                        message.preMarketOpenChange = reader.double();
                        break;
                    }
                case 904: {
                        message.preMarketOpenChangePercent = reader.double();
                        break;
                    }
                case 905: {
                        message.source = reader.int32();
                        break;
                    }
                case 906: {
                        if (!(message.clearFieldNumbers && message.clearFieldNumbers.length))
                            message.clearFieldNumbers = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.clearFieldNumbers.push(reader.int32());
                        } else
                            message.clearFieldNumbers.push(reader.int32());
                        break;
                    }
                case 10: {
                        message.marketCap = reader.int64();
                        break;
                    }
                case 11: {
                        message.rsi = reader.double();
                        break;
                    }
                case 12: {
                        message.atr = reader.double();
                        break;
                    }
                case 13: {
                        message.priceToEarnings = reader.double();
                        break;
                    }
                case 14: {
                        message.averageVolume = reader.int64();
                        break;
                    }
                case 15: {
                        message.sharesOutstanding = reader.int64();
                        break;
                    }
                case 16: {
                        message.sector = reader.string();
                        break;
                    }
                case 17: {
                        message.sectorCode = reader.int32();
                        break;
                    }
                case 18: {
                        message.industry = reader.string();
                        break;
                    }
                case 19: {
                        message.industryCode = reader.int32();
                        break;
                    }
                case 20: {
                        message.forwardPERatio = reader.double();
                        break;
                    }
                case 21: {
                        message.pricetoEBITDA = reader.double();
                        break;
                    }
                case 22: {
                        message.trailingDividendYield = reader.double();
                        break;
                    }
                case 23: {
                        message.PBRatio = reader.double();
                        break;
                    }
                case 24: {
                        message.priceToSales = reader.double();
                        break;
                    }
                case 25: {
                        message.FCFPerShare = reader.double();
                        break;
                    }
                case 26: {
                        message.buyBackYield = reader.double();
                        break;
                    }
                case 27: {
                        message.open = reader.double();
                        break;
                    }
                case 28: {
                        message.price = reader.double();
                        break;
                    }
                case 29: {
                        message.high = reader.double();
                        break;
                    }
                case 30: {
                        message.low = reader.double();
                        break;
                    }
                case 31: {
                        message.time = reader.int64();
                        break;
                    }
                case 32: {
                        message.size = reader.int32();
                        break;
                    }
                case 33: {
                        message.type = reader.string();
                        break;
                    }
                case 34: {
                        message.dayVolume = reader.int64();
                        break;
                    }
                case 35: {
                        message.askPrice = reader.double();
                        break;
                    }
                case 36: {
                        message.bidPrice = reader.double();
                        break;
                    }
                case 37: {
                        message.shareFloatDate = reader.string();
                        break;
                    }
                case 38: {
                        message.sharesOutstandingDate = reader.string();
                        break;
                    }
                case 81: {
                        message.shareFloat = reader.int64();
                        break;
                    }
                case 40: {
                        message.updateType = reader.int32();
                        break;
                    }
                case 101: {
                        message.subtype = reader.string();
                        break;
                    }
                case 41: {
                        message.sessionType = reader.int32();
                        break;
                    }
                case 96: {
                        message.volume = reader.int64();
                        break;
                    }
                case 50: {
                        message.changePercent1Minute = reader.double();
                        break;
                    }
                case 51: {
                        message.changePercentClose = reader.double();
                        break;
                    }
                case 63: {
                        message.change5Minute = reader.double();
                        break;
                    }
                case 52: {
                        message.changePercent5Minute = reader.double();
                        break;
                    }
                case 53: {
                        message.volume1Minute = reader.int64();
                        break;
                    }
                case 54: {
                        message.relativeVolume1Minute = reader.double();
                        break;
                    }
                case 55: {
                        message.change15Minute = reader.double();
                        break;
                    }
                case 56: {
                        message.changePercent15Minute = reader.double();
                        break;
                    }
                case 57: {
                        message.change30Minute = reader.double();
                        break;
                    }
                case 58: {
                        message.changePercent30Minute = reader.double();
                        break;
                    }
                case 59: {
                        message.change60Minute = reader.double();
                        break;
                    }
                case 60: {
                        message.changePercent60Minute = reader.double();
                        break;
                    }
                case 61: {
                        message.changePercentOpen = reader.double();
                        break;
                    }
                case 62: {
                        message.changeOpen = reader.double();
                        break;
                    }
                case 64: {
                        message.customChange = reader.double();
                        break;
                    }
                case 65: {
                        message.customChangePercent = reader.double();
                        break;
                    }
                case 66: {
                        message.customDate = reader.int64();
                        break;
                    }
                case 67: {
                        message.preMarketChange = reader.double();
                        break;
                    }
                case 68: {
                        message.preMarketChangePercent = reader.double();
                        break;
                    }
                case 69: {
                        message.afterMarketChange = reader.double();
                        break;
                    }
                case 49: {
                        message.afterMarketChangePercent = reader.double();
                        break;
                    }
                case 42: {
                        message.change1Month = reader.double();
                        break;
                    }
                case 122: {
                        message.price3Month = reader.double();
                        break;
                    }
                case 43: {
                        message.change3Month = reader.double();
                        break;
                    }
                case 44: {
                        message.changePercent3Month = reader.double();
                        break;
                    }
                case 45: {
                        message.price6Month = reader.double();
                        break;
                    }
                case 109: {
                        message.change6Month = reader.double();
                        break;
                    }
                case 123: {
                        message.changePercent6Month = reader.double();
                        break;
                    }
                case 46: {
                        message.change1Year = reader.double();
                        break;
                    }
                case 47: {
                        message.preMarketChange5Minute = reader.double();
                        break;
                    }
                case 48: {
                        message.preMarketChangePercent5Minute = reader.double();
                        break;
                    }
                case 84: {
                        message.preMarketChange15Minute = reader.double();
                        break;
                    }
                case 85: {
                        message.preMarketChangePercent15Minute = reader.double();
                        break;
                    }
                case 86: {
                        message.preMarketChange30Minute = reader.double();
                        break;
                    }
                case 87: {
                        message.preMarketChangePercent30Minute = reader.double();
                        break;
                    }
                case 88: {
                        message.preMarketChange60Minute = reader.double();
                        break;
                    }
                case 89: {
                        message.preMarketChangePercent60Minute = reader.double();
                        break;
                    }
                case 90: {
                        message.regularChange5Minute = reader.double();
                        break;
                    }
                case 91: {
                        message.regularChangePercent5Minute = reader.double();
                        break;
                    }
                case 92: {
                        message.regularChange15Minute = reader.double();
                        break;
                    }
                case 93: {
                        message.regularChangePercent15Minute = reader.double();
                        break;
                    }
                case 94: {
                        message.regularChange30Minute = reader.double();
                        break;
                    }
                case 95: {
                        message.regularChangePercent30Minute = reader.double();
                        break;
                    }
                case 97: {
                        message.regularChange60Minute = reader.double();
                        break;
                    }
                case 98: {
                        message.regularChangePercent60Minute = reader.double();
                        break;
                    }
                case 99: {
                        message.afterMarketChange5Minute = reader.double();
                        break;
                    }
                case 121: {
                        message.afterMarketChangePercent5Minute = reader.double();
                        break;
                    }
                case 102: {
                        message.afterMarketChange15Minute = reader.double();
                        break;
                    }
                case 103: {
                        message.afterMarketChangePercent15Minute = reader.double();
                        break;
                    }
                case 104: {
                        message.afterMarketChange30Minute = reader.double();
                        break;
                    }
                case 105: {
                        message.afterMarketChangePercent30Minute = reader.double();
                        break;
                    }
                case 106: {
                        message.afterMarketChange60Minute = reader.double();
                        break;
                    }
                case 107: {
                        message.afterMarketChangePercent60Minute = reader.double();
                        break;
                    }
                case 70: {
                        message.gics = reader.int32();
                        break;
                    }
                case 71: {
                        message.gicsSector = reader.int32();
                        break;
                    }
                case 72: {
                        message.gicsSectorName = reader.string();
                        break;
                    }
                case 73: {
                        message.gicsIndustryGroup = reader.int32();
                        break;
                    }
                case 74: {
                        message.gicsIndustryGroupName = reader.string();
                        break;
                    }
                case 75: {
                        message.gicsIndustry = reader.int32();
                        break;
                    }
                case 76: {
                        message.gicsIndustryName = reader.string();
                        break;
                    }
                case 77: {
                        message.gicsSubIndustry = reader.int32();
                        break;
                    }
                case 78: {
                        message.gicsSubIndustryName = reader.string();
                        break;
                    }
                case 79: {
                        message.optionable = reader.int32();
                        break;
                    }
                case 39: {
                        message.cik = reader.int32();
                        break;
                    }
                case 80: {
                        message.signalName = reader.string();
                        break;
                    }
                case 82: {
                        message.lastTradeTime = reader.int64();
                        break;
                    }
                case 83: {
                        message.country = reader.string();
                        break;
                    }
                case 110: {
                        message.sharesShort = reader.int64();
                        break;
                    }
                case 111: {
                        message.sharesShortPercentOfFloat = reader.double();
                        break;
                    }
                case 112: {
                        message.sharesShortChangePercent = reader.double();
                        break;
                    }
                case 113: {
                        message.sharesShortReceiptDate = reader.int64();
                        break;
                    }
                case 114: {
                        message.sharesShortSettlementDate = reader.int64();
                        break;
                    }
                case 115: {
                        message.shortInterestRatio = reader.double();
                        break;
                    }
                case 116: {
                        message.sharesShortValue = reader.double();
                        break;
                    }
                case 117: {
                        message.sharesShortPrevious = reader.int64();
                        break;
                    }
                case 118: {
                        message.sharesShortPreviousValue = reader.double();
                        break;
                    }
                case 119: {
                        message.sharesShortPreviousPercentOfFloat = reader.double();
                        break;
                    }
                case 120: {
                        message.sharesShortChange = reader.int64();
                        break;
                    }
                case 200: {
                        message.sentTime = reader.int64();
                        break;
                    }
                case 201: {
                        message.closeTime = reader.int64();
                        break;
                    }
                case 300: {
                        message.volume5Minute = reader.int64();
                        break;
                    }
                case 301: {
                        message.volume15Minute = reader.int64();
                        break;
                    }
                case 302: {
                        message.volume30Minute = reader.int64();
                        break;
                    }
                case 303: {
                        message.volume60Minute = reader.int64();
                        break;
                    }
                case 304: {
                        message.relativeVolume5Minute = reader.double();
                        break;
                    }
                case 305: {
                        message.relativeVolume90Day = reader.double();
                        break;
                    }
                case 306: {
                        message.rvol1m10d = reader.double();
                        break;
                    }
                case 307: {
                        message.rvol5m10d = reader.double();
                        break;
                    }
                case 308: {
                        message.rvol5m30d = reader.double();
                        break;
                    }
                case 309: {
                        message.rvol5m90d = reader.double();
                        break;
                    }
                case 600: {
                        message.averageVolume10Day = reader.int64();
                        break;
                    }
                case 601: {
                        message.averageVolumeChangePercent10Day = reader.double();
                        break;
                    }
                case 602: {
                        message.high10Day = reader.double();
                        break;
                    }
                case 603: {
                        message.highChangePercent10Day = reader.double();
                        break;
                    }
                case 604: {
                        message.low10Day = reader.double();
                        break;
                    }
                case 605: {
                        message.lowChangePercent10Day = reader.double();
                        break;
                    }
                case 606: {
                        message.movingAverage10Day = reader.double();
                        break;
                    }
                case 607: {
                        message.movingAverageChangePercent10Day = reader.double();
                        break;
                    }
                case 610: {
                        message.averageVolume20Day = reader.int64();
                        break;
                    }
                case 611: {
                        message.averageVolumeChangePercent20Day = reader.double();
                        break;
                    }
                case 612: {
                        message.high20Day = reader.double();
                        break;
                    }
                case 613: {
                        message.highChangePercent20Day = reader.double();
                        break;
                    }
                case 614: {
                        message.low20Day = reader.double();
                        break;
                    }
                case 615: {
                        message.lowChangePercent20Day = reader.double();
                        break;
                    }
                case 616: {
                        message.movingAverage20Day = reader.double();
                        break;
                    }
                case 617: {
                        message.movingAverageChangePercent20Day = reader.double();
                        break;
                    }
                case 620: {
                        message.averageVolume50Day = reader.int64();
                        break;
                    }
                case 621: {
                        message.averageVolumeChangePercent50Day = reader.double();
                        break;
                    }
                case 622: {
                        message.high50Day = reader.double();
                        break;
                    }
                case 623: {
                        message.highChangePercent50Day = reader.double();
                        break;
                    }
                case 624: {
                        message.low50Day = reader.double();
                        break;
                    }
                case 625: {
                        message.lowChangePercent50Day = reader.double();
                        break;
                    }
                case 626: {
                        message.movingAverage50Day = reader.double();
                        break;
                    }
                case 627: {
                        message.movingAverageChangePercent50Day = reader.double();
                        break;
                    }
                case 630: {
                        message.averageVolume100Day = reader.int64();
                        break;
                    }
                case 631: {
                        message.averageVolumeChangePercent100Day = reader.double();
                        break;
                    }
                case 632: {
                        message.high100Day = reader.double();
                        break;
                    }
                case 633: {
                        message.highChangePercent100Day = reader.double();
                        break;
                    }
                case 634: {
                        message.low100Day = reader.double();
                        break;
                    }
                case 635: {
                        message.lowChangePercent100Day = reader.double();
                        break;
                    }
                case 636: {
                        message.movingAverage100Day = reader.double();
                        break;
                    }
                case 637: {
                        message.movingAverageChangePercent100Day = reader.double();
                        break;
                    }
                case 640: {
                        message.averageVolume200Day = reader.int64();
                        break;
                    }
                case 641: {
                        message.averageVolumeChangePercent200Day = reader.double();
                        break;
                    }
                case 642: {
                        message.high200Day = reader.double();
                        break;
                    }
                case 643: {
                        message.highChangePercent200Day = reader.double();
                        break;
                    }
                case 644: {
                        message.low200Day = reader.double();
                        break;
                    }
                case 645: {
                        message.lowChangePercent200Day = reader.double();
                        break;
                    }
                case 646: {
                        message.movingAverage200Day = reader.double();
                        break;
                    }
                case 647: {
                        message.movingAverageChangePercent200Day = reader.double();
                        break;
                    }
                case 648: {
                        message.movingAverage250Day = reader.double();
                        break;
                    }
                case 649: {
                        message.movingAverageChangePercent250Day = reader.double();
                        break;
                    }
                case 650: {
                        message.averageVolume90Day = reader.int64();
                        break;
                    }
                case 400: {
                        message.nextEarningsDate = reader.int32();
                        break;
                    }
                case 401: {
                        message.dividend = reader.double();
                        break;
                    }
                case 402: {
                        message.dividendYield = reader.double();
                        break;
                    }
                case 403: {
                        message.dividendExDate = reader.int32();
                        break;
                    }
                case 404: {
                        message.dividendFrequency = reader.int64();
                        break;
                    }
                case 405: {
                        message.forwardDividendYield = reader.double();
                        break;
                    }
                case 501: {
                        message.roe = reader.double();
                        break;
                    }
                case 502: {
                        message.roa = reader.double();
                        break;
                    }
                case 503: {
                        message.roic = reader.double();
                        break;
                    }
                case 504: {
                        message.currentRatio = reader.double();
                        break;
                    }
                case 505: {
                        message.grossMargin = reader.double();
                        break;
                    }
                case 506: {
                        message.netMargin = reader.double();
                        break;
                    }
                case 507: {
                        message.operationMargin = reader.double();
                        break;
                    }
                case 508: {
                        message.epsMrq = reader.double();
                        break;
                    }
                case 509: {
                        message.epsTtm = reader.double();
                        break;
                    }
                case 510: {
                        message.dilutedEpsMrq = reader.double();
                        break;
                    }
                case 511: {
                        message.dilutedEpsTtm = reader.double();
                        break;
                    }
                case 512: {
                        message.low52Week = reader.double();
                        break;
                    }
                case 513: {
                        message.high52Week = reader.double();
                        break;
                    }
                case 514: {
                        message.revenueTtm = reader.double();
                        break;
                    }
                case 515: {
                        message.earningsAsOf = reader.int32();
                        break;
                    }
                case 516: {
                        message.netProfitMargin = reader.double();
                        break;
                    }
                case 799: {
                        message.change1Week = reader.double();
                        break;
                    }
                case 800: {
                        message.price1Week = reader.double();
                        break;
                    }
                case 801: {
                        message.priceChangePercent1Week = reader.double();
                        break;
                    }
                case 802: {
                        message.price1Month = reader.double();
                        break;
                    }
                case 803: {
                        message.priceChangePercent1Month = reader.double();
                        break;
                    }
                case 804: {
                        message.priceHalfYear = reader.double();
                        break;
                    }
                case 805: {
                        message.priceChangePercentHalfYear = reader.double();
                        break;
                    }
                case 806: {
                        message.priceQuarter = reader.double();
                        break;
                    }
                case 807: {
                        message.priceChangePercentQuarter = reader.double();
                        break;
                    }
                case 808: {
                        message.price1Year = reader.double();
                        break;
                    }
                case 809: {
                        message.priceChangePercent1Year = reader.double();
                        break;
                    }
                case 810: {
                        message.priceYearToDate = reader.double();
                        break;
                    }
                case 811: {
                        message.priceChangePercentYearToDate = reader.double();
                        break;
                    }
                case 520: {
                        message.roeMrq = reader.double();
                        break;
                    }
                case 521: {
                        message.roaMrq = reader.double();
                        break;
                    }
                case 522: {
                        message.roicMrq = reader.double();
                        break;
                    }
                case 523: {
                        message.currentRatioMrq = reader.double();
                        break;
                    }
                case 524: {
                        message.grossMarginMrq = reader.double();
                        break;
                    }
                case 525: {
                        message.netMarginMrq = reader.double();
                        break;
                    }
                case 526: {
                        message.operationMarginMrq = reader.double();
                        break;
                    }
                case 527: {
                        message.previousDayVolume = reader.int64();
                        break;
                    }
                case 528: {
                        message.previousDayAtr = reader.double();
                        break;
                    }
                case 529: {
                        message.previousDayAdx = reader.double();
                        break;
                    }
                case 530: {
                        message.previousDayPlusDMSmoothed = reader.double();
                        break;
                    }
                case 531: {
                        message.previousDayMinusDMSmoothed = reader.double();
                        break;
                    }
                case 532: {
                        message.previousDayHigh = reader.double();
                        break;
                    }
                case 533: {
                        message.previousDayLow = reader.double();
                        break;
                    }
                case 534: {
                        message.adx = reader.double();
                        break;
                    }
                case 535: {
                        message.percentInstitutionalOwnership = reader.double();
                        break;
                    }
                case 536: {
                        message.percentInstitutionalTransactions = reader.double();
                        break;
                    }
                case 700: {
                        message.wiim = reader.string();
                        break;
                    }
                case 701: {
                        message.wiimAsOf = reader.int64();
                        break;
                    }
                case 702: {
                        message.vwap = reader.double();
                        break;
                    }
                case 704: {
                        message.vwapChangePercent = reader.double();
                        break;
                    }
                case 705: {
                        message.vwapChange = reader.double();
                        break;
                    }
                case 706: {
                        message.rsiAvgGain = reader.double();
                        break;
                    }
                case 707: {
                        message.rsiAvgLoss = reader.double();
                        break;
                    }
                case 708: {
                        message.halted = reader.string();
                        break;
                    }
                case 709: {
                        message.tradeCount = reader.int64();
                        break;
                    }
                case 710: {
                        message.regularHighCount = reader.int64();
                        break;
                    }
                case 711: {
                        message.regularLowCount = reader.int64();
                        break;
                    }
                case 712: {
                        message.preMarketHighCount = reader.int64();
                        break;
                    }
                case 713: {
                        message.preMarketLowCount = reader.int64();
                        break;
                    }
                case 714: {
                        message.afterMarketHighCount = reader.int64();
                        break;
                    }
                case 715: {
                        message.afterMarketLowCount = reader.int64();
                        break;
                    }
                case 716: {
                        message.dayHighCount = reader.int64();
                        break;
                    }
                case 717: {
                        message.dayLowCount = reader.int64();
                        break;
                    }
                case 720: {
                        message.dayHigh = reader.double();
                        break;
                    }
                case 721: {
                        message.dayLow = reader.double();
                        break;
                    }
                case 722: {
                        message.preMarketHigh = reader.double();
                        break;
                    }
                case 723: {
                        message.preMarketLow = reader.double();
                        break;
                    }
                case 724: {
                        message.afterMarketHigh = reader.double();
                        break;
                    }
                case 725: {
                        message.afterMarketLow = reader.double();
                        break;
                    }
                case 726: {
                        message.regularHigh = reader.double();
                        break;
                    }
                case 727: {
                        message.regularLow = reader.double();
                        break;
                    }
                case 728: {
                        message.priceSpikeUpCount = reader.int64();
                        break;
                    }
                case 729: {
                        message.priceSpikeDownCount = reader.int64();
                        break;
                    }
                case 730: {
                        message.haltedCount = reader.int64();
                        break;
                    }
                case 731: {
                        message.usCongressTotal = reader.double();
                        break;
                    }
                case 732: {
                        message.usCongressRepublicansTotal = reader.double();
                        break;
                    }
                case 733: {
                        message.usCongressDemocratsTotal = reader.double();
                        break;
                    }
                case 734: {
                        message.usCongressOtherTotal = reader.double();
                        break;
                    }
                case 735: {
                        message.volumeFloatRatio = reader.double();
                        break;
                    }
                case 736: {
                        message.atrp = reader.double();
                        break;
                    }
                case 737: {
                        message.ytdGainLoss = reader.double();
                        break;
                    }
                case 738: {
                        message.mtdGainLoss = reader.double();
                        break;
                    }
                case 695: {
                        message.ytdChange = reader.double();
                        break;
                    }
                case 694: {
                        message.mtdChange = reader.double();
                        break;
                    }
                case 739: {
                        message.yearOpen = reader.double();
                        break;
                    }
                case 753: {
                        message.monthOpen = reader.double();
                        break;
                    }
                case 754: {
                        message.volumeFloatPercent = reader.double();
                        break;
                    }
                case 740: {
                        message.rsi1m = reader.double();
                        break;
                    }
                case 741: {
                        message.rsi2m = reader.double();
                        break;
                    }
                case 742: {
                        message.rsi5m = reader.double();
                        break;
                    }
                case 743: {
                        message.rsi15m = reader.double();
                        break;
                    }
                case 745: {
                        message.rsi30m = reader.double();
                        break;
                    }
                case 746: {
                        message.rsi60m = reader.double();
                        break;
                    }
                case 747: {
                        message.rsiEth1m = reader.double();
                        break;
                    }
                case 748: {
                        message.rsiEth2m = reader.double();
                        break;
                    }
                case 749: {
                        message.rsiEth5m = reader.double();
                        break;
                    }
                case 750: {
                        message.rsiEth15m = reader.double();
                        break;
                    }
                case 751: {
                        message.rsiEth30m = reader.double();
                        break;
                    }
                case 752: {
                        message.rsiEth60m = reader.double();
                        break;
                    }
                case 755: {
                        message.averageDollarVolume10Day = reader.double();
                        break;
                    }
                case 756: {
                        message.averageVolume60Day = reader.int64();
                        break;
                    }
                case 757: {
                        message.relativeVolumePercent60Day = reader.double();
                        break;
                    }
                case 758: {
                        message.rsi1mLowest = reader.double();
                        break;
                    }
                case 759: {
                        message.rsi2mLowest = reader.double();
                        break;
                    }
                case 760: {
                        message.rsi5mLowest = reader.double();
                        break;
                    }
                case 761: {
                        message.rsi15mLowest = reader.double();
                        break;
                    }
                case 762: {
                        message.rsi30mLowest = reader.double();
                        break;
                    }
                case 763: {
                        message.rsi60mLowest = reader.double();
                        break;
                    }
                case 764: {
                        message.rsiEth1mLowest = reader.double();
                        break;
                    }
                case 765: {
                        message.rsiEth2mLowest = reader.double();
                        break;
                    }
                case 766: {
                        message.rsiEth5mLowest = reader.double();
                        break;
                    }
                case 767: {
                        message.rsiEth15mLowest = reader.double();
                        break;
                    }
                case 768: {
                        message.rsiEth30mLowest = reader.double();
                        break;
                    }
                case 769: {
                        message.rsiEth60mLowest = reader.double();
                        break;
                    }
                case 770: {
                        message.rsi1mGreatest = reader.double();
                        break;
                    }
                case 771: {
                        message.rsi2mGreatest = reader.double();
                        break;
                    }
                case 772: {
                        message.rsi5mGreatest = reader.double();
                        break;
                    }
                case 773: {
                        message.rsi15mGreatest = reader.double();
                        break;
                    }
                case 774: {
                        message.rsi30mGreatest = reader.double();
                        break;
                    }
                case 775: {
                        message.rsi60mGreatest = reader.double();
                        break;
                    }
                case 776: {
                        message.rsiEth1mGreatest = reader.double();
                        break;
                    }
                case 777: {
                        message.rsiEth2mGreatest = reader.double();
                        break;
                    }
                case 778: {
                        message.rsiEth5mGreatest = reader.double();
                        break;
                    }
                case 779: {
                        message.rsiEth15mGreatest = reader.double();
                        break;
                    }
                case 780: {
                        message.rsiEth30mGreatest = reader.double();
                        break;
                    }
                case 781: {
                        message.rsiEth60mGreatest = reader.double();
                        break;
                    }
                case 782: {
                        message.rsiCrossOver = reader.double();
                        break;
                    }
                case 718: {
                        message.ema12d = reader.double();
                        break;
                    }
                case 719: {
                        message.ema26d = reader.double();
                        break;
                    }
                case 699: {
                        message.macd = reader.double();
                        break;
                    }
                case 698: {
                        message.macdSignalLine = reader.double();
                        break;
                    }
                case 697: {
                        message.macdHistogram = reader.double();
                        break;
                    }
                case 696: {
                        message.macdSignalLineBase = reader.double();
                        break;
                    }
                case 679: {
                        message.dividendGrowthRate1Year = reader.double();
                        break;
                    }
                case 678: {
                        message.dividendGrowthRate3Year = reader.double();
                        break;
                    }
                case 677: {
                        message.dividendGrowthRate5Year = reader.double();
                        break;
                    }
                case 962: {
                        message.totalDividendTtm = reader.double();
                        break;
                    }
                case 963: {
                        message.dividendIncreasing = reader.int32();
                        break;
                    }
                case 680: {
                        message.newsBzWireTitle = reader.string();
                        break;
                    }
                case 681: {
                        message.newsBzWireNodeId = reader.string();
                        break;
                    }
                case 682: {
                        message.newsBzWireTimestamp = reader.int64();
                        break;
                    }
                case 683: {
                        message.newsPRTitle = reader.string();
                        break;
                    }
                case 684: {
                        message.newsPRNodeId = reader.string();
                        break;
                    }
                case 685: {
                        message.newsPRTimestamp = reader.int64();
                        break;
                    }
                case 686: {
                        message.newsSecTitle = reader.string();
                        break;
                    }
                case 687: {
                        message.newsSecNodeId = reader.string();
                        break;
                    }
                case 688: {
                        message.newsSecTimestamp = reader.int64();
                        break;
                    }
                case 689: {
                        message.newsBzWireTitleWithNodeId = reader.string();
                        break;
                    }
                case 690: {
                        message.newsPRTitleWithNodeId = reader.string();
                        break;
                    }
                case 691: {
                        message.newsSecTitleWithNodeId = reader.string();
                        break;
                    }
                case 676: {
                        message.movingAverage500Day = reader.double();
                        break;
                    }
                case 675: {
                        message.gapChange = reader.double();
                        break;
                    }
                case 674: {
                        message.gapChangePercent = reader.double();
                        break;
                    }
                case 673: {
                        message.adr14d = reader.double();
                        break;
                    }
                case 672: {
                        message.dilutedEpsMrqSurprisePercent = reader.double();
                        break;
                    }
                case 671: {
                        message.dilutedEpsTtmSurprisePercent = reader.double();
                        break;
                    }
                case 670: {
                        message.dilutedRevenueMrqSurprisePercent = reader.double();
                        break;
                    }
                case 669: {
                        message.dilutedRevenueTtmSurprisePercent = reader.double();
                        break;
                    }
                case 668: {
                        message.epsGrowthTtm = reader.double();
                        break;
                    }
                case 667: {
                        message.epsGrowthY2Y = reader.double();
                        break;
                    }
                case 666: {
                        message.epsGrowthQ2Q = reader.double();
                        break;
                    }
                case 665: {
                        message.epsGrowth5Year = reader.double();
                        break;
                    }
                case 659: {
                        message.epsGrowthYearAgoQ = reader.double();
                        break;
                    }
                case 664: {
                        message.revenueGrowthTtm = reader.double();
                        break;
                    }
                case 663: {
                        message.revenueGrowthY2Y = reader.double();
                        break;
                    }
                case 662: {
                        message.revenueGrowthQ2Q = reader.double();
                        break;
                    }
                case 661: {
                        message.revenueGrowth5Year = reader.double();
                        break;
                    }
                case 660: {
                        message.revenueGrowthYearAgoQ = reader.double();
                        break;
                    }
                case 658: {
                        message.ltDebtEquity = reader.double();
                        break;
                    }
                case 812: {
                        message.bullsSay = reader.string();
                        break;
                    }
                case 813: {
                        message.bearsSay = reader.string();
                        break;
                    }
                case 657: {
                        message.ipoDateNumber = reader.int64();
                        break;
                    }
                case 656: {
                        message.ffoPerShare = reader.double();
                        break;
                    }
                case 655: {
                        message.quickRatioMrq = reader.double();
                        break;
                    }
                case 654: {
                        message.highAllTime = reader.double();
                        break;
                    }
                case 653: {
                        message.lowAllTime = reader.double();
                        break;
                    }
                case 652: {
                        message.evToEbitda = reader.double();
                        break;
                    }
                case 907: {
                        message.totalDebtEquityRatio = reader.double();
                        break;
                    }
                case 908: {
                        message.dividendPayoutRatio = reader.double();
                        break;
                    }
                case 909: {
                        message.operatingCashFlow = reader.double();
                        break;
                    }
                case 910: {
                        message.insiderPercentage = reader.double();
                        break;
                    }
                case 911: {
                        message.priceToCashFlowRatio = reader.double();
                        break;
                    }
                case 912: {
                        message.regularHoursChange = reader.double();
                        break;
                    }
                case 913: {
                        message.regularHoursPercentChange = reader.double();
                        break;
                    }
                case 914: {
                        message.postToPreHoursChange = reader.double();
                        break;
                    }
                case 915: {
                        message.postToPreHoursPercentChange = reader.double();
                        break;
                    }
                case 916: {
                        message.scannerClose = reader.double();
                        break;
                    }
                case 917: {
                        message.scannerChange = reader.double();
                        break;
                    }
                case 918: {
                        message.scannerChangePercent = reader.double();
                        break;
                    }
                case 919: {
                        message.scannerChangePercentClose = reader.double();
                        break;
                    }
                case 920: {
                        message.scannerPreviousClose = reader.double();
                        break;
                    }
                case 921: {
                        message.freeCashFlow = reader.double();
                        break;
                    }
                case 922: {
                        message.minPriceTarget = reader.double();
                        break;
                    }
                case 923: {
                        message.maxPriceTarget = reader.double();
                        break;
                    }
                case 924: {
                        message.meanPriceTarget = reader.double();
                        break;
                    }
                case 925: {
                        message.totalNumberOfAnalyst = reader.double();
                        break;
                    }
                case 926: {
                        message.averageAnalystRecommendation = reader.string();
                        break;
                    }
                case 927: {
                        message.pegRatio = reader.double();
                        break;
                    }
                case 928: {
                        message.priceToFreeCashFlowRatio = reader.double();
                        break;
                    }
                case 929: {
                        message.distanceToMaxPriceTarget = reader.double();
                        break;
                    }
                case 930: {
                        message.distanceToMinPriceTarget = reader.double();
                        break;
                    }
                case 931: {
                        message.distanceToMeanPriceTarget = reader.double();
                        break;
                    }
                case 932: {
                        message.shortTermTrend = reader.string();
                        break;
                    }
                case 933: {
                        message.mediumTermTrend = reader.string();
                        break;
                    }
                case 934: {
                        message.longTermTrend = reader.string();
                        break;
                    }
                case 935: {
                        message.twentySixWeekChange = reader.double();
                        break;
                    }
                case 936: {
                        message.fiftyTwoWeekChange = reader.double();
                        break;
                    }
                case 937: {
                        message.annualizedStandardDeviation = reader.double();
                        break;
                    }
                case 938: {
                        message.momentum = reader.double();
                        break;
                    }
                case 939: {
                        message.value = reader.double();
                        break;
                    }
                case 940: {
                        message.piotroskiFScore = reader.int64();
                        break;
                    }
                case 941: {
                        message.netIncomeTtm = reader.double();
                        break;
                    }
                case 943: {
                        message.currentRatioYearAgo = reader.double();
                        break;
                    }
                case 944: {
                        message.roaYearAgo = reader.double();
                        break;
                    }
                case 945: {
                        message.grossMarginYearAgo = reader.double();
                        break;
                    }
                case 946: {
                        message.longTermDebt = reader.double();
                        break;
                    }
                case 947: {
                        message.longTermDebtYearAgo = reader.double();
                        break;
                    }
                case 948: {
                        message.shareIssued = reader.double();
                        break;
                    }
                case 949: {
                        message.shareIssuedYearAgo = reader.double();
                        break;
                    }
                case 950: {
                        message.totalAssets = reader.double();
                        break;
                    }
                case 951: {
                        message.totalAssetsYearAgo = reader.double();
                        break;
                    }
                case 952: {
                        message.totalAssets2YearAgo = reader.double();
                        break;
                    }
                case 953: {
                        message.revenueTtmYearAgo = reader.double();
                        break;
                    }
                case 954: {
                        message.longTermDebtAndCapitalLeaseObligation = reader.double();
                        break;
                    }
                case 955: {
                        message.averageTotalAssets = reader.double();
                        break;
                    }
                case 956: {
                        message.averageTotalAssetsYearAgo = reader.double();
                        break;
                    }
                case 942: {
                        message.growth = reader.double();
                        break;
                    }
                case 957: {
                        message.quality = reader.double();
                        break;
                    }
                case 958: {
                        message.momentumPercentile = reader.double();
                        break;
                    }
                case 959: {
                        message.valuePercentile = reader.double();
                        break;
                    }
                case 960: {
                        message.growthPercentile = reader.double();
                        break;
                    }
                case 961: {
                        message.qualityPercentile = reader.double();
                        break;
                    }
                case 965: {
                        message.rateOfReturnDay = reader.double();
                        break;
                    }
                case 966: {
                        message.rateOfReturnWeek = reader.double();
                        break;
                    }
                case 967: {
                        message.rateOfReturnMonth = reader.double();
                        break;
                    }
                case 968: {
                        message.dividendOneDay = reader.double();
                        break;
                    }
                case 969: {
                        message.dividendOneWeek = reader.double();
                        break;
                    }
                case 970: {
                        message.dividendOneMonth = reader.double();
                        break;
                    }
                case 971: {
                        message.totalLiabilities = reader.double();
                        break;
                    }
                case 972: {
                        message.retainedEarnings = reader.double();
                        break;
                    }
                case 973: {
                        message.ebit = reader.double();
                        break;
                    }
                case 974: {
                        message.altmanZScore = reader.double();
                        break;
                    }
                case 975: {
                        message.powerEarningGap = reader.bool();
                        break;
                    }
                case 976: {
                        message.monsterPowerEarningGap = reader.bool();
                        break;
                    }
                case 977: {
                        message.monsterGap = reader.bool();
                        break;
                    }
                case 978: {
                        message.oelGap = reader.bool();
                        break;
                    }
                case 980: {
                        message.evToEbit = reader.double();
                        break;
                    }
                case 981: {
                        message.priceToTangibleBookValue = reader.double();
                        break;
                    }
                case 982: {
                        message.tangibleBookValuePerShare = reader.double();
                        break;
                    }
                case 983: {
                        message.dailyDollarVolume = reader.double();
                        break;
                    }
                case 984: {
                        message.bookValuePerShare = reader.double();
                        break;
                    }
                case 985: {
                        message.movingAverage350Day = reader.double();
                        break;
                    }
                case 986: {
                        message.priceToAdjEarningsTtm = reader.double();
                        break;
                    }
                case 987: {
                        message.salesGrowthYoY = reader.double();
                        break;
                    }
                case 988: {
                        message.salesGrowth3Year = reader.double();
                        break;
                    }
                case 989: {
                        message.salesGrowth5Year = reader.double();
                        break;
                    }
                case 990: {
                        message.debtQoQ = reader.double();
                        break;
                    }
                case 991: {
                        message.debtYoY = reader.double();
                        break;
                    }
                case 992: {
                        message.debt5Year = reader.double();
                        break;
                    }
                case 993: {
                        message.epsGrowth3Year = reader.double();
                        break;
                    }
                case 994: {
                        message.epsGrowth3NormalizedYear = reader.double();
                        break;
                    }
                case 995: {
                        message.roe5YrAvg = reader.double();
                        break;
                    }
                case 996: {
                        message.stockholdersEquity = reader.double();
                        break;
                    }
                case 997: {
                        message.stockholdersEquityYearAgo = reader.double();
                        break;
                    }
                case 998: {
                        message.stockholdersEquityGrowthYoY = reader.double();
                        break;
                    }
                case 1000: {
                        message.vwap1Day = reader.double();
                        break;
                    }
                case 1001: {
                        message.vwap5Day = reader.double();
                        break;
                    }
                case 1002: {
                        message.vwap10Day = reader.double();
                        break;
                    }
                case 1003: {
                        message.vwap50Day = reader.double();
                        break;
                    }
                case 1004: {
                        message.vwap100Day = reader.double();
                        break;
                    }
                case 1005: {
                        message.vwap200Day = reader.double();
                        break;
                    }
                case 1006: {
                        message.roic1YearAvg = reader.double();
                        break;
                    }
                case 1007: {
                        message.roic5YearAvg = reader.double();
                        break;
                    }
                case 1008: {
                        message.vwap1m = reader.double();
                        break;
                    }
                case 1009: {
                        message.vwap5m = reader.double();
                        break;
                    }
                case 1010: {
                        message.vwap15m = reader.double();
                        break;
                    }
                case 1011: {
                        message.vwap30m = reader.double();
                        break;
                    }
                case 1012: {
                        message.vwap60m = reader.double();
                        break;
                    }
                case 1013: {
                        message.candleStick = reader.string();
                        break;
                    }
                case 1014: {
                        message.patterns = reader.string();
                        break;
                    }
                case 1015: {
                        message.earningsForwardGrowth3Year = reader.double();
                        break;
                    }
                case 1016: {
                        message.earningsForwardGrowth5Year = reader.double();
                        break;
                    }
                case 1017: {
                        message.revenueForwardGrowth3Year = reader.double();
                        break;
                    }
                case 1018: {
                        message.revenueForwardGrowth5Year = reader.double();
                        break;
                    }
                case 1019: {
                        message.bidAskSpread = reader.double();
                        break;
                    }
                case 1020: {
                        message.bidAskSpreadPercent = reader.double();
                        break;
                    }
                case 1021: {
                        message.change1Minute = reader.double();
                        break;
                    }
                case 1022: {
                        message.preMarketChange1Minute = reader.double();
                        break;
                    }
                case 1023: {
                        message.preMarketChangePercent1Minute = reader.double();
                        break;
                    }
                case 1024: {
                        message.regularChange1Minute = reader.double();
                        break;
                    }
                case 1025: {
                        message.regularChangePercent1Minute = reader.double();
                        break;
                    }
                case 1026: {
                        message.afterMarketChange1Minute = reader.double();
                        break;
                    }
                case 1027: {
                        message.afterMarketChangePercent1Minute = reader.double();
                        break;
                    }
                case 1028: {
                        message.previousCloseDate = reader.string();
                        break;
                    }
                case 1029: {
                        message.distanceToMaxPriceTargetPercent = reader.double();
                        break;
                    }
                case 1030: {
                        message.distanceToMinPriceTargetPercent = reader.double();
                        break;
                    }
                case 1031: {
                        message.distanceToMeanPriceTargetPercent = reader.double();
                        break;
                    }
                default:
                    reader.skipType(tag & 7, long);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Quote message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteProtos.Quote
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteProtos.Quote} Quote
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Quote.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Quote message.
         * @function verify
         * @memberof QuoteProtos.Quote
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Quote.verify = function verify(message, long) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                return "maximum nesting depth exceeded";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isString(message.symbol))
                    return "symbol: string expected";
            if (message.opol != null && message.hasOwnProperty("opol"))
                if (!$util.isString(message.opol))
                    return "opol: string expected";
            if (message.previousClose != null && message.hasOwnProperty("previousClose"))
                if (typeof message.previousClose !== "number")
                    return "previousClose: number expected";
            if (message.close != null && message.hasOwnProperty("close"))
                if (typeof message.close !== "number")
                    return "close: number expected";
            if (message.change != null && message.hasOwnProperty("change"))
                if (typeof message.change !== "number")
                    return "change: number expected";
            if (message.changePercent != null && message.hasOwnProperty("changePercent"))
                if (typeof message.changePercent !== "number")
                    return "changePercent: number expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.ipoDate != null && message.hasOwnProperty("ipoDate"))
                if (!$util.isString(message.ipoDate))
                    return "ipoDate: string expected";
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                if (!$util.isString(message.exchange))
                    return "exchange: string expected";
            if (message.tradeExchange != null && message.hasOwnProperty("tradeExchange"))
                if (!$util.isString(message.tradeExchange))
                    return "tradeExchange: string expected";
            if (message.preMarketOpen != null && message.hasOwnProperty("preMarketOpen"))
                if (typeof message.preMarketOpen !== "number")
                    return "preMarketOpen: number expected";
            if (message.preMarketOpenTime != null && message.hasOwnProperty("preMarketOpenTime"))
                if (!$util.isInteger(message.preMarketOpenTime) && !(message.preMarketOpenTime && $util.isInteger(message.preMarketOpenTime.low) && $util.isInteger(message.preMarketOpenTime.high)))
                    return "preMarketOpenTime: integer|Long expected";
            if (message.preMarketVolume != null && message.hasOwnProperty("preMarketVolume"))
                if (!$util.isInteger(message.preMarketVolume) && !(message.preMarketVolume && $util.isInteger(message.preMarketVolume.low) && $util.isInteger(message.preMarketVolume.high)))
                    return "preMarketVolume: integer|Long expected";
            if (message.afterMarketVolume != null && message.hasOwnProperty("afterMarketVolume"))
                if (!$util.isInteger(message.afterMarketVolume) && !(message.afterMarketVolume && $util.isInteger(message.afterMarketVolume.low) && $util.isInteger(message.afterMarketVolume.high)))
                    return "afterMarketVolume: integer|Long expected";
            if (message.preMarketPrice != null && message.hasOwnProperty("preMarketPrice"))
                if (typeof message.preMarketPrice !== "number")
                    return "preMarketPrice: number expected";
            if (message.afterMarketPrice != null && message.hasOwnProperty("afterMarketPrice"))
                if (typeof message.afterMarketPrice !== "number")
                    return "afterMarketPrice: number expected";
            if (message.preMarketOpenChange != null && message.hasOwnProperty("preMarketOpenChange"))
                if (typeof message.preMarketOpenChange !== "number")
                    return "preMarketOpenChange: number expected";
            if (message.preMarketOpenChangePercent != null && message.hasOwnProperty("preMarketOpenChangePercent"))
                if (typeof message.preMarketOpenChangePercent !== "number")
                    return "preMarketOpenChangePercent: number expected";
            if (message.source != null && message.hasOwnProperty("source"))
                switch (message.source) {
                default:
                    return "source: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
                }
            if (message.clearFieldNumbers != null && message.hasOwnProperty("clearFieldNumbers")) {
                if (!Array.isArray(message.clearFieldNumbers))
                    return "clearFieldNumbers: array expected";
                for (let i = 0; i < message.clearFieldNumbers.length; ++i)
                    if (!$util.isInteger(message.clearFieldNumbers[i]))
                        return "clearFieldNumbers: integer[] expected";
            }
            if (message.marketCap != null && message.hasOwnProperty("marketCap"))
                if (!$util.isInteger(message.marketCap) && !(message.marketCap && $util.isInteger(message.marketCap.low) && $util.isInteger(message.marketCap.high)))
                    return "marketCap: integer|Long expected";
            if (message.rsi != null && message.hasOwnProperty("rsi"))
                if (typeof message.rsi !== "number")
                    return "rsi: number expected";
            if (message.atr != null && message.hasOwnProperty("atr"))
                if (typeof message.atr !== "number")
                    return "atr: number expected";
            if (message.priceToEarnings != null && message.hasOwnProperty("priceToEarnings"))
                if (typeof message.priceToEarnings !== "number")
                    return "priceToEarnings: number expected";
            if (message.averageVolume != null && message.hasOwnProperty("averageVolume"))
                if (!$util.isInteger(message.averageVolume) && !(message.averageVolume && $util.isInteger(message.averageVolume.low) && $util.isInteger(message.averageVolume.high)))
                    return "averageVolume: integer|Long expected";
            if (message.sharesOutstanding != null && message.hasOwnProperty("sharesOutstanding"))
                if (!$util.isInteger(message.sharesOutstanding) && !(message.sharesOutstanding && $util.isInteger(message.sharesOutstanding.low) && $util.isInteger(message.sharesOutstanding.high)))
                    return "sharesOutstanding: integer|Long expected";
            if (message.sector != null && message.hasOwnProperty("sector"))
                if (!$util.isString(message.sector))
                    return "sector: string expected";
            if (message.sectorCode != null && message.hasOwnProperty("sectorCode"))
                if (!$util.isInteger(message.sectorCode))
                    return "sectorCode: integer expected";
            if (message.industry != null && message.hasOwnProperty("industry"))
                if (!$util.isString(message.industry))
                    return "industry: string expected";
            if (message.industryCode != null && message.hasOwnProperty("industryCode"))
                if (!$util.isInteger(message.industryCode))
                    return "industryCode: integer expected";
            if (message.forwardPERatio != null && message.hasOwnProperty("forwardPERatio"))
                if (typeof message.forwardPERatio !== "number")
                    return "forwardPERatio: number expected";
            if (message.pricetoEBITDA != null && message.hasOwnProperty("pricetoEBITDA"))
                if (typeof message.pricetoEBITDA !== "number")
                    return "pricetoEBITDA: number expected";
            if (message.trailingDividendYield != null && message.hasOwnProperty("trailingDividendYield"))
                if (typeof message.trailingDividendYield !== "number")
                    return "trailingDividendYield: number expected";
            if (message.PBRatio != null && message.hasOwnProperty("PBRatio"))
                if (typeof message.PBRatio !== "number")
                    return "PBRatio: number expected";
            if (message.priceToSales != null && message.hasOwnProperty("priceToSales"))
                if (typeof message.priceToSales !== "number")
                    return "priceToSales: number expected";
            if (message.FCFPerShare != null && message.hasOwnProperty("FCFPerShare"))
                if (typeof message.FCFPerShare !== "number")
                    return "FCFPerShare: number expected";
            if (message.buyBackYield != null && message.hasOwnProperty("buyBackYield"))
                if (typeof message.buyBackYield !== "number")
                    return "buyBackYield: number expected";
            if (message.open != null && message.hasOwnProperty("open"))
                if (typeof message.open !== "number")
                    return "open: number expected";
            if (message.price != null && message.hasOwnProperty("price"))
                if (typeof message.price !== "number")
                    return "price: number expected";
            if (message.high != null && message.hasOwnProperty("high"))
                if (typeof message.high !== "number")
                    return "high: number expected";
            if (message.low != null && message.hasOwnProperty("low"))
                if (typeof message.low !== "number")
                    return "low: number expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                    return "time: integer|Long expected";
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size))
                    return "size: integer expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.dayVolume != null && message.hasOwnProperty("dayVolume"))
                if (!$util.isInteger(message.dayVolume) && !(message.dayVolume && $util.isInteger(message.dayVolume.low) && $util.isInteger(message.dayVolume.high)))
                    return "dayVolume: integer|Long expected";
            if (message.askPrice != null && message.hasOwnProperty("askPrice"))
                if (typeof message.askPrice !== "number")
                    return "askPrice: number expected";
            if (message.bidPrice != null && message.hasOwnProperty("bidPrice"))
                if (typeof message.bidPrice !== "number")
                    return "bidPrice: number expected";
            if (message.shareFloatDate != null && message.hasOwnProperty("shareFloatDate"))
                if (!$util.isString(message.shareFloatDate))
                    return "shareFloatDate: string expected";
            if (message.sharesOutstandingDate != null && message.hasOwnProperty("sharesOutstandingDate"))
                if (!$util.isString(message.sharesOutstandingDate))
                    return "sharesOutstandingDate: string expected";
            if (message.shareFloat != null && message.hasOwnProperty("shareFloat"))
                if (!$util.isInteger(message.shareFloat) && !(message.shareFloat && $util.isInteger(message.shareFloat.low) && $util.isInteger(message.shareFloat.high)))
                    return "shareFloat: integer|Long expected";
            if (message.updateType != null && message.hasOwnProperty("updateType"))
                switch (message.updateType) {
                default:
                    return "updateType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                if (!$util.isString(message.subtype))
                    return "subtype: string expected";
            if (message.sessionType != null && message.hasOwnProperty("sessionType"))
                switch (message.sessionType) {
                default:
                    return "sessionType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.volume != null && message.hasOwnProperty("volume"))
                if (!$util.isInteger(message.volume) && !(message.volume && $util.isInteger(message.volume.low) && $util.isInteger(message.volume.high)))
                    return "volume: integer|Long expected";
            if (message.changePercent1Minute != null && message.hasOwnProperty("changePercent1Minute"))
                if (typeof message.changePercent1Minute !== "number")
                    return "changePercent1Minute: number expected";
            if (message.changePercentClose != null && message.hasOwnProperty("changePercentClose"))
                if (typeof message.changePercentClose !== "number")
                    return "changePercentClose: number expected";
            if (message.change5Minute != null && message.hasOwnProperty("change5Minute"))
                if (typeof message.change5Minute !== "number")
                    return "change5Minute: number expected";
            if (message.changePercent5Minute != null && message.hasOwnProperty("changePercent5Minute"))
                if (typeof message.changePercent5Minute !== "number")
                    return "changePercent5Minute: number expected";
            if (message.volume1Minute != null && message.hasOwnProperty("volume1Minute"))
                if (!$util.isInteger(message.volume1Minute) && !(message.volume1Minute && $util.isInteger(message.volume1Minute.low) && $util.isInteger(message.volume1Minute.high)))
                    return "volume1Minute: integer|Long expected";
            if (message.relativeVolume1Minute != null && message.hasOwnProperty("relativeVolume1Minute"))
                if (typeof message.relativeVolume1Minute !== "number")
                    return "relativeVolume1Minute: number expected";
            if (message.change15Minute != null && message.hasOwnProperty("change15Minute"))
                if (typeof message.change15Minute !== "number")
                    return "change15Minute: number expected";
            if (message.changePercent15Minute != null && message.hasOwnProperty("changePercent15Minute"))
                if (typeof message.changePercent15Minute !== "number")
                    return "changePercent15Minute: number expected";
            if (message.change30Minute != null && message.hasOwnProperty("change30Minute"))
                if (typeof message.change30Minute !== "number")
                    return "change30Minute: number expected";
            if (message.changePercent30Minute != null && message.hasOwnProperty("changePercent30Minute"))
                if (typeof message.changePercent30Minute !== "number")
                    return "changePercent30Minute: number expected";
            if (message.change60Minute != null && message.hasOwnProperty("change60Minute"))
                if (typeof message.change60Minute !== "number")
                    return "change60Minute: number expected";
            if (message.changePercent60Minute != null && message.hasOwnProperty("changePercent60Minute"))
                if (typeof message.changePercent60Minute !== "number")
                    return "changePercent60Minute: number expected";
            if (message.changePercentOpen != null && message.hasOwnProperty("changePercentOpen"))
                if (typeof message.changePercentOpen !== "number")
                    return "changePercentOpen: number expected";
            if (message.changeOpen != null && message.hasOwnProperty("changeOpen"))
                if (typeof message.changeOpen !== "number")
                    return "changeOpen: number expected";
            if (message.customChange != null && message.hasOwnProperty("customChange"))
                if (typeof message.customChange !== "number")
                    return "customChange: number expected";
            if (message.customChangePercent != null && message.hasOwnProperty("customChangePercent"))
                if (typeof message.customChangePercent !== "number")
                    return "customChangePercent: number expected";
            if (message.customDate != null && message.hasOwnProperty("customDate"))
                if (!$util.isInteger(message.customDate) && !(message.customDate && $util.isInteger(message.customDate.low) && $util.isInteger(message.customDate.high)))
                    return "customDate: integer|Long expected";
            if (message.preMarketChange != null && message.hasOwnProperty("preMarketChange"))
                if (typeof message.preMarketChange !== "number")
                    return "preMarketChange: number expected";
            if (message.preMarketChangePercent != null && message.hasOwnProperty("preMarketChangePercent"))
                if (typeof message.preMarketChangePercent !== "number")
                    return "preMarketChangePercent: number expected";
            if (message.afterMarketChange != null && message.hasOwnProperty("afterMarketChange"))
                if (typeof message.afterMarketChange !== "number")
                    return "afterMarketChange: number expected";
            if (message.afterMarketChangePercent != null && message.hasOwnProperty("afterMarketChangePercent"))
                if (typeof message.afterMarketChangePercent !== "number")
                    return "afterMarketChangePercent: number expected";
            if (message.change1Month != null && message.hasOwnProperty("change1Month"))
                if (typeof message.change1Month !== "number")
                    return "change1Month: number expected";
            if (message.price3Month != null && message.hasOwnProperty("price3Month"))
                if (typeof message.price3Month !== "number")
                    return "price3Month: number expected";
            if (message.change3Month != null && message.hasOwnProperty("change3Month"))
                if (typeof message.change3Month !== "number")
                    return "change3Month: number expected";
            if (message.changePercent3Month != null && message.hasOwnProperty("changePercent3Month"))
                if (typeof message.changePercent3Month !== "number")
                    return "changePercent3Month: number expected";
            if (message.price6Month != null && message.hasOwnProperty("price6Month"))
                if (typeof message.price6Month !== "number")
                    return "price6Month: number expected";
            if (message.change6Month != null && message.hasOwnProperty("change6Month"))
                if (typeof message.change6Month !== "number")
                    return "change6Month: number expected";
            if (message.changePercent6Month != null && message.hasOwnProperty("changePercent6Month"))
                if (typeof message.changePercent6Month !== "number")
                    return "changePercent6Month: number expected";
            if (message.change1Year != null && message.hasOwnProperty("change1Year"))
                if (typeof message.change1Year !== "number")
                    return "change1Year: number expected";
            if (message.preMarketChange5Minute != null && message.hasOwnProperty("preMarketChange5Minute"))
                if (typeof message.preMarketChange5Minute !== "number")
                    return "preMarketChange5Minute: number expected";
            if (message.preMarketChangePercent5Minute != null && message.hasOwnProperty("preMarketChangePercent5Minute"))
                if (typeof message.preMarketChangePercent5Minute !== "number")
                    return "preMarketChangePercent5Minute: number expected";
            if (message.preMarketChange15Minute != null && message.hasOwnProperty("preMarketChange15Minute"))
                if (typeof message.preMarketChange15Minute !== "number")
                    return "preMarketChange15Minute: number expected";
            if (message.preMarketChangePercent15Minute != null && message.hasOwnProperty("preMarketChangePercent15Minute"))
                if (typeof message.preMarketChangePercent15Minute !== "number")
                    return "preMarketChangePercent15Minute: number expected";
            if (message.preMarketChange30Minute != null && message.hasOwnProperty("preMarketChange30Minute"))
                if (typeof message.preMarketChange30Minute !== "number")
                    return "preMarketChange30Minute: number expected";
            if (message.preMarketChangePercent30Minute != null && message.hasOwnProperty("preMarketChangePercent30Minute"))
                if (typeof message.preMarketChangePercent30Minute !== "number")
                    return "preMarketChangePercent30Minute: number expected";
            if (message.preMarketChange60Minute != null && message.hasOwnProperty("preMarketChange60Minute"))
                if (typeof message.preMarketChange60Minute !== "number")
                    return "preMarketChange60Minute: number expected";
            if (message.preMarketChangePercent60Minute != null && message.hasOwnProperty("preMarketChangePercent60Minute"))
                if (typeof message.preMarketChangePercent60Minute !== "number")
                    return "preMarketChangePercent60Minute: number expected";
            if (message.regularChange5Minute != null && message.hasOwnProperty("regularChange5Minute"))
                if (typeof message.regularChange5Minute !== "number")
                    return "regularChange5Minute: number expected";
            if (message.regularChangePercent5Minute != null && message.hasOwnProperty("regularChangePercent5Minute"))
                if (typeof message.regularChangePercent5Minute !== "number")
                    return "regularChangePercent5Minute: number expected";
            if (message.regularChange15Minute != null && message.hasOwnProperty("regularChange15Minute"))
                if (typeof message.regularChange15Minute !== "number")
                    return "regularChange15Minute: number expected";
            if (message.regularChangePercent15Minute != null && message.hasOwnProperty("regularChangePercent15Minute"))
                if (typeof message.regularChangePercent15Minute !== "number")
                    return "regularChangePercent15Minute: number expected";
            if (message.regularChange30Minute != null && message.hasOwnProperty("regularChange30Minute"))
                if (typeof message.regularChange30Minute !== "number")
                    return "regularChange30Minute: number expected";
            if (message.regularChangePercent30Minute != null && message.hasOwnProperty("regularChangePercent30Minute"))
                if (typeof message.regularChangePercent30Minute !== "number")
                    return "regularChangePercent30Minute: number expected";
            if (message.regularChange60Minute != null && message.hasOwnProperty("regularChange60Minute"))
                if (typeof message.regularChange60Minute !== "number")
                    return "regularChange60Minute: number expected";
            if (message.regularChangePercent60Minute != null && message.hasOwnProperty("regularChangePercent60Minute"))
                if (typeof message.regularChangePercent60Minute !== "number")
                    return "regularChangePercent60Minute: number expected";
            if (message.afterMarketChange5Minute != null && message.hasOwnProperty("afterMarketChange5Minute"))
                if (typeof message.afterMarketChange5Minute !== "number")
                    return "afterMarketChange5Minute: number expected";
            if (message.afterMarketChangePercent5Minute != null && message.hasOwnProperty("afterMarketChangePercent5Minute"))
                if (typeof message.afterMarketChangePercent5Minute !== "number")
                    return "afterMarketChangePercent5Minute: number expected";
            if (message.afterMarketChange15Minute != null && message.hasOwnProperty("afterMarketChange15Minute"))
                if (typeof message.afterMarketChange15Minute !== "number")
                    return "afterMarketChange15Minute: number expected";
            if (message.afterMarketChangePercent15Minute != null && message.hasOwnProperty("afterMarketChangePercent15Minute"))
                if (typeof message.afterMarketChangePercent15Minute !== "number")
                    return "afterMarketChangePercent15Minute: number expected";
            if (message.afterMarketChange30Minute != null && message.hasOwnProperty("afterMarketChange30Minute"))
                if (typeof message.afterMarketChange30Minute !== "number")
                    return "afterMarketChange30Minute: number expected";
            if (message.afterMarketChangePercent30Minute != null && message.hasOwnProperty("afterMarketChangePercent30Minute"))
                if (typeof message.afterMarketChangePercent30Minute !== "number")
                    return "afterMarketChangePercent30Minute: number expected";
            if (message.afterMarketChange60Minute != null && message.hasOwnProperty("afterMarketChange60Minute"))
                if (typeof message.afterMarketChange60Minute !== "number")
                    return "afterMarketChange60Minute: number expected";
            if (message.afterMarketChangePercent60Minute != null && message.hasOwnProperty("afterMarketChangePercent60Minute"))
                if (typeof message.afterMarketChangePercent60Minute !== "number")
                    return "afterMarketChangePercent60Minute: number expected";
            if (message.gics != null && message.hasOwnProperty("gics"))
                if (!$util.isInteger(message.gics))
                    return "gics: integer expected";
            if (message.gicsSector != null && message.hasOwnProperty("gicsSector"))
                if (!$util.isInteger(message.gicsSector))
                    return "gicsSector: integer expected";
            if (message.gicsSectorName != null && message.hasOwnProperty("gicsSectorName"))
                if (!$util.isString(message.gicsSectorName))
                    return "gicsSectorName: string expected";
            if (message.gicsIndustryGroup != null && message.hasOwnProperty("gicsIndustryGroup"))
                if (!$util.isInteger(message.gicsIndustryGroup))
                    return "gicsIndustryGroup: integer expected";
            if (message.gicsIndustryGroupName != null && message.hasOwnProperty("gicsIndustryGroupName"))
                if (!$util.isString(message.gicsIndustryGroupName))
                    return "gicsIndustryGroupName: string expected";
            if (message.gicsIndustry != null && message.hasOwnProperty("gicsIndustry"))
                if (!$util.isInteger(message.gicsIndustry))
                    return "gicsIndustry: integer expected";
            if (message.gicsIndustryName != null && message.hasOwnProperty("gicsIndustryName"))
                if (!$util.isString(message.gicsIndustryName))
                    return "gicsIndustryName: string expected";
            if (message.gicsSubIndustry != null && message.hasOwnProperty("gicsSubIndustry"))
                if (!$util.isInteger(message.gicsSubIndustry))
                    return "gicsSubIndustry: integer expected";
            if (message.gicsSubIndustryName != null && message.hasOwnProperty("gicsSubIndustryName"))
                if (!$util.isString(message.gicsSubIndustryName))
                    return "gicsSubIndustryName: string expected";
            if (message.optionable != null && message.hasOwnProperty("optionable"))
                if (!$util.isInteger(message.optionable))
                    return "optionable: integer expected";
            if (message.cik != null && message.hasOwnProperty("cik"))
                if (!$util.isInteger(message.cik))
                    return "cik: integer expected";
            if (message.signalName != null && message.hasOwnProperty("signalName"))
                if (!$util.isString(message.signalName))
                    return "signalName: string expected";
            if (message.lastTradeTime != null && message.hasOwnProperty("lastTradeTime"))
                if (!$util.isInteger(message.lastTradeTime) && !(message.lastTradeTime && $util.isInteger(message.lastTradeTime.low) && $util.isInteger(message.lastTradeTime.high)))
                    return "lastTradeTime: integer|Long expected";
            if (message.country != null && message.hasOwnProperty("country"))
                if (!$util.isString(message.country))
                    return "country: string expected";
            if (message.sharesShort != null && message.hasOwnProperty("sharesShort"))
                if (!$util.isInteger(message.sharesShort) && !(message.sharesShort && $util.isInteger(message.sharesShort.low) && $util.isInteger(message.sharesShort.high)))
                    return "sharesShort: integer|Long expected";
            if (message.sharesShortPercentOfFloat != null && message.hasOwnProperty("sharesShortPercentOfFloat"))
                if (typeof message.sharesShortPercentOfFloat !== "number")
                    return "sharesShortPercentOfFloat: number expected";
            if (message.sharesShortChangePercent != null && message.hasOwnProperty("sharesShortChangePercent"))
                if (typeof message.sharesShortChangePercent !== "number")
                    return "sharesShortChangePercent: number expected";
            if (message.sharesShortReceiptDate != null && message.hasOwnProperty("sharesShortReceiptDate"))
                if (!$util.isInteger(message.sharesShortReceiptDate) && !(message.sharesShortReceiptDate && $util.isInteger(message.sharesShortReceiptDate.low) && $util.isInteger(message.sharesShortReceiptDate.high)))
                    return "sharesShortReceiptDate: integer|Long expected";
            if (message.sharesShortSettlementDate != null && message.hasOwnProperty("sharesShortSettlementDate"))
                if (!$util.isInteger(message.sharesShortSettlementDate) && !(message.sharesShortSettlementDate && $util.isInteger(message.sharesShortSettlementDate.low) && $util.isInteger(message.sharesShortSettlementDate.high)))
                    return "sharesShortSettlementDate: integer|Long expected";
            if (message.shortInterestRatio != null && message.hasOwnProperty("shortInterestRatio"))
                if (typeof message.shortInterestRatio !== "number")
                    return "shortInterestRatio: number expected";
            if (message.sharesShortValue != null && message.hasOwnProperty("sharesShortValue"))
                if (typeof message.sharesShortValue !== "number")
                    return "sharesShortValue: number expected";
            if (message.sharesShortPrevious != null && message.hasOwnProperty("sharesShortPrevious"))
                if (!$util.isInteger(message.sharesShortPrevious) && !(message.sharesShortPrevious && $util.isInteger(message.sharesShortPrevious.low) && $util.isInteger(message.sharesShortPrevious.high)))
                    return "sharesShortPrevious: integer|Long expected";
            if (message.sharesShortPreviousValue != null && message.hasOwnProperty("sharesShortPreviousValue"))
                if (typeof message.sharesShortPreviousValue !== "number")
                    return "sharesShortPreviousValue: number expected";
            if (message.sharesShortPreviousPercentOfFloat != null && message.hasOwnProperty("sharesShortPreviousPercentOfFloat"))
                if (typeof message.sharesShortPreviousPercentOfFloat !== "number")
                    return "sharesShortPreviousPercentOfFloat: number expected";
            if (message.sharesShortChange != null && message.hasOwnProperty("sharesShortChange"))
                if (!$util.isInteger(message.sharesShortChange) && !(message.sharesShortChange && $util.isInteger(message.sharesShortChange.low) && $util.isInteger(message.sharesShortChange.high)))
                    return "sharesShortChange: integer|Long expected";
            if (message.sentTime != null && message.hasOwnProperty("sentTime"))
                if (!$util.isInteger(message.sentTime) && !(message.sentTime && $util.isInteger(message.sentTime.low) && $util.isInteger(message.sentTime.high)))
                    return "sentTime: integer|Long expected";
            if (message.closeTime != null && message.hasOwnProperty("closeTime"))
                if (!$util.isInteger(message.closeTime) && !(message.closeTime && $util.isInteger(message.closeTime.low) && $util.isInteger(message.closeTime.high)))
                    return "closeTime: integer|Long expected";
            if (message.volume5Minute != null && message.hasOwnProperty("volume5Minute"))
                if (!$util.isInteger(message.volume5Minute) && !(message.volume5Minute && $util.isInteger(message.volume5Minute.low) && $util.isInteger(message.volume5Minute.high)))
                    return "volume5Minute: integer|Long expected";
            if (message.volume15Minute != null && message.hasOwnProperty("volume15Minute"))
                if (!$util.isInteger(message.volume15Minute) && !(message.volume15Minute && $util.isInteger(message.volume15Minute.low) && $util.isInteger(message.volume15Minute.high)))
                    return "volume15Minute: integer|Long expected";
            if (message.volume30Minute != null && message.hasOwnProperty("volume30Minute"))
                if (!$util.isInteger(message.volume30Minute) && !(message.volume30Minute && $util.isInteger(message.volume30Minute.low) && $util.isInteger(message.volume30Minute.high)))
                    return "volume30Minute: integer|Long expected";
            if (message.volume60Minute != null && message.hasOwnProperty("volume60Minute"))
                if (!$util.isInteger(message.volume60Minute) && !(message.volume60Minute && $util.isInteger(message.volume60Minute.low) && $util.isInteger(message.volume60Minute.high)))
                    return "volume60Minute: integer|Long expected";
            if (message.relativeVolume5Minute != null && message.hasOwnProperty("relativeVolume5Minute"))
                if (typeof message.relativeVolume5Minute !== "number")
                    return "relativeVolume5Minute: number expected";
            if (message.relativeVolume90Day != null && message.hasOwnProperty("relativeVolume90Day"))
                if (typeof message.relativeVolume90Day !== "number")
                    return "relativeVolume90Day: number expected";
            if (message.rvol1m10d != null && message.hasOwnProperty("rvol1m10d"))
                if (typeof message.rvol1m10d !== "number")
                    return "rvol1m10d: number expected";
            if (message.rvol5m10d != null && message.hasOwnProperty("rvol5m10d"))
                if (typeof message.rvol5m10d !== "number")
                    return "rvol5m10d: number expected";
            if (message.rvol5m30d != null && message.hasOwnProperty("rvol5m30d"))
                if (typeof message.rvol5m30d !== "number")
                    return "rvol5m30d: number expected";
            if (message.rvol5m90d != null && message.hasOwnProperty("rvol5m90d"))
                if (typeof message.rvol5m90d !== "number")
                    return "rvol5m90d: number expected";
            if (message.averageVolume10Day != null && message.hasOwnProperty("averageVolume10Day"))
                if (!$util.isInteger(message.averageVolume10Day) && !(message.averageVolume10Day && $util.isInteger(message.averageVolume10Day.low) && $util.isInteger(message.averageVolume10Day.high)))
                    return "averageVolume10Day: integer|Long expected";
            if (message.averageVolumeChangePercent10Day != null && message.hasOwnProperty("averageVolumeChangePercent10Day"))
                if (typeof message.averageVolumeChangePercent10Day !== "number")
                    return "averageVolumeChangePercent10Day: number expected";
            if (message.high10Day != null && message.hasOwnProperty("high10Day"))
                if (typeof message.high10Day !== "number")
                    return "high10Day: number expected";
            if (message.highChangePercent10Day != null && message.hasOwnProperty("highChangePercent10Day"))
                if (typeof message.highChangePercent10Day !== "number")
                    return "highChangePercent10Day: number expected";
            if (message.low10Day != null && message.hasOwnProperty("low10Day"))
                if (typeof message.low10Day !== "number")
                    return "low10Day: number expected";
            if (message.lowChangePercent10Day != null && message.hasOwnProperty("lowChangePercent10Day"))
                if (typeof message.lowChangePercent10Day !== "number")
                    return "lowChangePercent10Day: number expected";
            if (message.movingAverage10Day != null && message.hasOwnProperty("movingAverage10Day"))
                if (typeof message.movingAverage10Day !== "number")
                    return "movingAverage10Day: number expected";
            if (message.movingAverageChangePercent10Day != null && message.hasOwnProperty("movingAverageChangePercent10Day"))
                if (typeof message.movingAverageChangePercent10Day !== "number")
                    return "movingAverageChangePercent10Day: number expected";
            if (message.averageVolume20Day != null && message.hasOwnProperty("averageVolume20Day"))
                if (!$util.isInteger(message.averageVolume20Day) && !(message.averageVolume20Day && $util.isInteger(message.averageVolume20Day.low) && $util.isInteger(message.averageVolume20Day.high)))
                    return "averageVolume20Day: integer|Long expected";
            if (message.averageVolumeChangePercent20Day != null && message.hasOwnProperty("averageVolumeChangePercent20Day"))
                if (typeof message.averageVolumeChangePercent20Day !== "number")
                    return "averageVolumeChangePercent20Day: number expected";
            if (message.high20Day != null && message.hasOwnProperty("high20Day"))
                if (typeof message.high20Day !== "number")
                    return "high20Day: number expected";
            if (message.highChangePercent20Day != null && message.hasOwnProperty("highChangePercent20Day"))
                if (typeof message.highChangePercent20Day !== "number")
                    return "highChangePercent20Day: number expected";
            if (message.low20Day != null && message.hasOwnProperty("low20Day"))
                if (typeof message.low20Day !== "number")
                    return "low20Day: number expected";
            if (message.lowChangePercent20Day != null && message.hasOwnProperty("lowChangePercent20Day"))
                if (typeof message.lowChangePercent20Day !== "number")
                    return "lowChangePercent20Day: number expected";
            if (message.movingAverage20Day != null && message.hasOwnProperty("movingAverage20Day"))
                if (typeof message.movingAverage20Day !== "number")
                    return "movingAverage20Day: number expected";
            if (message.movingAverageChangePercent20Day != null && message.hasOwnProperty("movingAverageChangePercent20Day"))
                if (typeof message.movingAverageChangePercent20Day !== "number")
                    return "movingAverageChangePercent20Day: number expected";
            if (message.averageVolume50Day != null && message.hasOwnProperty("averageVolume50Day"))
                if (!$util.isInteger(message.averageVolume50Day) && !(message.averageVolume50Day && $util.isInteger(message.averageVolume50Day.low) && $util.isInteger(message.averageVolume50Day.high)))
                    return "averageVolume50Day: integer|Long expected";
            if (message.averageVolumeChangePercent50Day != null && message.hasOwnProperty("averageVolumeChangePercent50Day"))
                if (typeof message.averageVolumeChangePercent50Day !== "number")
                    return "averageVolumeChangePercent50Day: number expected";
            if (message.high50Day != null && message.hasOwnProperty("high50Day"))
                if (typeof message.high50Day !== "number")
                    return "high50Day: number expected";
            if (message.highChangePercent50Day != null && message.hasOwnProperty("highChangePercent50Day"))
                if (typeof message.highChangePercent50Day !== "number")
                    return "highChangePercent50Day: number expected";
            if (message.low50Day != null && message.hasOwnProperty("low50Day"))
                if (typeof message.low50Day !== "number")
                    return "low50Day: number expected";
            if (message.lowChangePercent50Day != null && message.hasOwnProperty("lowChangePercent50Day"))
                if (typeof message.lowChangePercent50Day !== "number")
                    return "lowChangePercent50Day: number expected";
            if (message.movingAverage50Day != null && message.hasOwnProperty("movingAverage50Day"))
                if (typeof message.movingAverage50Day !== "number")
                    return "movingAverage50Day: number expected";
            if (message.movingAverageChangePercent50Day != null && message.hasOwnProperty("movingAverageChangePercent50Day"))
                if (typeof message.movingAverageChangePercent50Day !== "number")
                    return "movingAverageChangePercent50Day: number expected";
            if (message.averageVolume100Day != null && message.hasOwnProperty("averageVolume100Day"))
                if (!$util.isInteger(message.averageVolume100Day) && !(message.averageVolume100Day && $util.isInteger(message.averageVolume100Day.low) && $util.isInteger(message.averageVolume100Day.high)))
                    return "averageVolume100Day: integer|Long expected";
            if (message.averageVolumeChangePercent100Day != null && message.hasOwnProperty("averageVolumeChangePercent100Day"))
                if (typeof message.averageVolumeChangePercent100Day !== "number")
                    return "averageVolumeChangePercent100Day: number expected";
            if (message.high100Day != null && message.hasOwnProperty("high100Day"))
                if (typeof message.high100Day !== "number")
                    return "high100Day: number expected";
            if (message.highChangePercent100Day != null && message.hasOwnProperty("highChangePercent100Day"))
                if (typeof message.highChangePercent100Day !== "number")
                    return "highChangePercent100Day: number expected";
            if (message.low100Day != null && message.hasOwnProperty("low100Day"))
                if (typeof message.low100Day !== "number")
                    return "low100Day: number expected";
            if (message.lowChangePercent100Day != null && message.hasOwnProperty("lowChangePercent100Day"))
                if (typeof message.lowChangePercent100Day !== "number")
                    return "lowChangePercent100Day: number expected";
            if (message.movingAverage100Day != null && message.hasOwnProperty("movingAverage100Day"))
                if (typeof message.movingAverage100Day !== "number")
                    return "movingAverage100Day: number expected";
            if (message.movingAverageChangePercent100Day != null && message.hasOwnProperty("movingAverageChangePercent100Day"))
                if (typeof message.movingAverageChangePercent100Day !== "number")
                    return "movingAverageChangePercent100Day: number expected";
            if (message.averageVolume200Day != null && message.hasOwnProperty("averageVolume200Day"))
                if (!$util.isInteger(message.averageVolume200Day) && !(message.averageVolume200Day && $util.isInteger(message.averageVolume200Day.low) && $util.isInteger(message.averageVolume200Day.high)))
                    return "averageVolume200Day: integer|Long expected";
            if (message.averageVolumeChangePercent200Day != null && message.hasOwnProperty("averageVolumeChangePercent200Day"))
                if (typeof message.averageVolumeChangePercent200Day !== "number")
                    return "averageVolumeChangePercent200Day: number expected";
            if (message.high200Day != null && message.hasOwnProperty("high200Day"))
                if (typeof message.high200Day !== "number")
                    return "high200Day: number expected";
            if (message.highChangePercent200Day != null && message.hasOwnProperty("highChangePercent200Day"))
                if (typeof message.highChangePercent200Day !== "number")
                    return "highChangePercent200Day: number expected";
            if (message.low200Day != null && message.hasOwnProperty("low200Day"))
                if (typeof message.low200Day !== "number")
                    return "low200Day: number expected";
            if (message.lowChangePercent200Day != null && message.hasOwnProperty("lowChangePercent200Day"))
                if (typeof message.lowChangePercent200Day !== "number")
                    return "lowChangePercent200Day: number expected";
            if (message.movingAverage200Day != null && message.hasOwnProperty("movingAverage200Day"))
                if (typeof message.movingAverage200Day !== "number")
                    return "movingAverage200Day: number expected";
            if (message.movingAverageChangePercent200Day != null && message.hasOwnProperty("movingAverageChangePercent200Day"))
                if (typeof message.movingAverageChangePercent200Day !== "number")
                    return "movingAverageChangePercent200Day: number expected";
            if (message.movingAverage250Day != null && message.hasOwnProperty("movingAverage250Day"))
                if (typeof message.movingAverage250Day !== "number")
                    return "movingAverage250Day: number expected";
            if (message.movingAverageChangePercent250Day != null && message.hasOwnProperty("movingAverageChangePercent250Day"))
                if (typeof message.movingAverageChangePercent250Day !== "number")
                    return "movingAverageChangePercent250Day: number expected";
            if (message.averageVolume90Day != null && message.hasOwnProperty("averageVolume90Day"))
                if (!$util.isInteger(message.averageVolume90Day) && !(message.averageVolume90Day && $util.isInteger(message.averageVolume90Day.low) && $util.isInteger(message.averageVolume90Day.high)))
                    return "averageVolume90Day: integer|Long expected";
            if (message.nextEarningsDate != null && message.hasOwnProperty("nextEarningsDate"))
                if (!$util.isInteger(message.nextEarningsDate))
                    return "nextEarningsDate: integer expected";
            if (message.dividend != null && message.hasOwnProperty("dividend"))
                if (typeof message.dividend !== "number")
                    return "dividend: number expected";
            if (message.dividendYield != null && message.hasOwnProperty("dividendYield"))
                if (typeof message.dividendYield !== "number")
                    return "dividendYield: number expected";
            if (message.dividendExDate != null && message.hasOwnProperty("dividendExDate"))
                if (!$util.isInteger(message.dividendExDate))
                    return "dividendExDate: integer expected";
            if (message.dividendFrequency != null && message.hasOwnProperty("dividendFrequency"))
                if (!$util.isInteger(message.dividendFrequency) && !(message.dividendFrequency && $util.isInteger(message.dividendFrequency.low) && $util.isInteger(message.dividendFrequency.high)))
                    return "dividendFrequency: integer|Long expected";
            if (message.forwardDividendYield != null && message.hasOwnProperty("forwardDividendYield"))
                if (typeof message.forwardDividendYield !== "number")
                    return "forwardDividendYield: number expected";
            if (message.roe != null && message.hasOwnProperty("roe"))
                if (typeof message.roe !== "number")
                    return "roe: number expected";
            if (message.roa != null && message.hasOwnProperty("roa"))
                if (typeof message.roa !== "number")
                    return "roa: number expected";
            if (message.roic != null && message.hasOwnProperty("roic"))
                if (typeof message.roic !== "number")
                    return "roic: number expected";
            if (message.currentRatio != null && message.hasOwnProperty("currentRatio"))
                if (typeof message.currentRatio !== "number")
                    return "currentRatio: number expected";
            if (message.grossMargin != null && message.hasOwnProperty("grossMargin"))
                if (typeof message.grossMargin !== "number")
                    return "grossMargin: number expected";
            if (message.netMargin != null && message.hasOwnProperty("netMargin"))
                if (typeof message.netMargin !== "number")
                    return "netMargin: number expected";
            if (message.operationMargin != null && message.hasOwnProperty("operationMargin"))
                if (typeof message.operationMargin !== "number")
                    return "operationMargin: number expected";
            if (message.epsMrq != null && message.hasOwnProperty("epsMrq"))
                if (typeof message.epsMrq !== "number")
                    return "epsMrq: number expected";
            if (message.epsTtm != null && message.hasOwnProperty("epsTtm"))
                if (typeof message.epsTtm !== "number")
                    return "epsTtm: number expected";
            if (message.dilutedEpsMrq != null && message.hasOwnProperty("dilutedEpsMrq"))
                if (typeof message.dilutedEpsMrq !== "number")
                    return "dilutedEpsMrq: number expected";
            if (message.dilutedEpsTtm != null && message.hasOwnProperty("dilutedEpsTtm"))
                if (typeof message.dilutedEpsTtm !== "number")
                    return "dilutedEpsTtm: number expected";
            if (message.low52Week != null && message.hasOwnProperty("low52Week"))
                if (typeof message.low52Week !== "number")
                    return "low52Week: number expected";
            if (message.high52Week != null && message.hasOwnProperty("high52Week"))
                if (typeof message.high52Week !== "number")
                    return "high52Week: number expected";
            if (message.revenueTtm != null && message.hasOwnProperty("revenueTtm"))
                if (typeof message.revenueTtm !== "number")
                    return "revenueTtm: number expected";
            if (message.earningsAsOf != null && message.hasOwnProperty("earningsAsOf"))
                if (!$util.isInteger(message.earningsAsOf))
                    return "earningsAsOf: integer expected";
            if (message.netProfitMargin != null && message.hasOwnProperty("netProfitMargin"))
                if (typeof message.netProfitMargin !== "number")
                    return "netProfitMargin: number expected";
            if (message.change1Week != null && message.hasOwnProperty("change1Week"))
                if (typeof message.change1Week !== "number")
                    return "change1Week: number expected";
            if (message.price1Week != null && message.hasOwnProperty("price1Week"))
                if (typeof message.price1Week !== "number")
                    return "price1Week: number expected";
            if (message.priceChangePercent1Week != null && message.hasOwnProperty("priceChangePercent1Week"))
                if (typeof message.priceChangePercent1Week !== "number")
                    return "priceChangePercent1Week: number expected";
            if (message.price1Month != null && message.hasOwnProperty("price1Month"))
                if (typeof message.price1Month !== "number")
                    return "price1Month: number expected";
            if (message.priceChangePercent1Month != null && message.hasOwnProperty("priceChangePercent1Month"))
                if (typeof message.priceChangePercent1Month !== "number")
                    return "priceChangePercent1Month: number expected";
            if (message.priceHalfYear != null && message.hasOwnProperty("priceHalfYear"))
                if (typeof message.priceHalfYear !== "number")
                    return "priceHalfYear: number expected";
            if (message.priceChangePercentHalfYear != null && message.hasOwnProperty("priceChangePercentHalfYear"))
                if (typeof message.priceChangePercentHalfYear !== "number")
                    return "priceChangePercentHalfYear: number expected";
            if (message.priceQuarter != null && message.hasOwnProperty("priceQuarter"))
                if (typeof message.priceQuarter !== "number")
                    return "priceQuarter: number expected";
            if (message.priceChangePercentQuarter != null && message.hasOwnProperty("priceChangePercentQuarter"))
                if (typeof message.priceChangePercentQuarter !== "number")
                    return "priceChangePercentQuarter: number expected";
            if (message.price1Year != null && message.hasOwnProperty("price1Year"))
                if (typeof message.price1Year !== "number")
                    return "price1Year: number expected";
            if (message.priceChangePercent1Year != null && message.hasOwnProperty("priceChangePercent1Year"))
                if (typeof message.priceChangePercent1Year !== "number")
                    return "priceChangePercent1Year: number expected";
            if (message.priceYearToDate != null && message.hasOwnProperty("priceYearToDate"))
                if (typeof message.priceYearToDate !== "number")
                    return "priceYearToDate: number expected";
            if (message.priceChangePercentYearToDate != null && message.hasOwnProperty("priceChangePercentYearToDate"))
                if (typeof message.priceChangePercentYearToDate !== "number")
                    return "priceChangePercentYearToDate: number expected";
            if (message.roeMrq != null && message.hasOwnProperty("roeMrq"))
                if (typeof message.roeMrq !== "number")
                    return "roeMrq: number expected";
            if (message.roaMrq != null && message.hasOwnProperty("roaMrq"))
                if (typeof message.roaMrq !== "number")
                    return "roaMrq: number expected";
            if (message.roicMrq != null && message.hasOwnProperty("roicMrq"))
                if (typeof message.roicMrq !== "number")
                    return "roicMrq: number expected";
            if (message.currentRatioMrq != null && message.hasOwnProperty("currentRatioMrq"))
                if (typeof message.currentRatioMrq !== "number")
                    return "currentRatioMrq: number expected";
            if (message.grossMarginMrq != null && message.hasOwnProperty("grossMarginMrq"))
                if (typeof message.grossMarginMrq !== "number")
                    return "grossMarginMrq: number expected";
            if (message.netMarginMrq != null && message.hasOwnProperty("netMarginMrq"))
                if (typeof message.netMarginMrq !== "number")
                    return "netMarginMrq: number expected";
            if (message.operationMarginMrq != null && message.hasOwnProperty("operationMarginMrq"))
                if (typeof message.operationMarginMrq !== "number")
                    return "operationMarginMrq: number expected";
            if (message.previousDayVolume != null && message.hasOwnProperty("previousDayVolume"))
                if (!$util.isInteger(message.previousDayVolume) && !(message.previousDayVolume && $util.isInteger(message.previousDayVolume.low) && $util.isInteger(message.previousDayVolume.high)))
                    return "previousDayVolume: integer|Long expected";
            if (message.previousDayAtr != null && message.hasOwnProperty("previousDayAtr"))
                if (typeof message.previousDayAtr !== "number")
                    return "previousDayAtr: number expected";
            if (message.previousDayAdx != null && message.hasOwnProperty("previousDayAdx"))
                if (typeof message.previousDayAdx !== "number")
                    return "previousDayAdx: number expected";
            if (message.previousDayPlusDMSmoothed != null && message.hasOwnProperty("previousDayPlusDMSmoothed"))
                if (typeof message.previousDayPlusDMSmoothed !== "number")
                    return "previousDayPlusDMSmoothed: number expected";
            if (message.previousDayMinusDMSmoothed != null && message.hasOwnProperty("previousDayMinusDMSmoothed"))
                if (typeof message.previousDayMinusDMSmoothed !== "number")
                    return "previousDayMinusDMSmoothed: number expected";
            if (message.previousDayHigh != null && message.hasOwnProperty("previousDayHigh"))
                if (typeof message.previousDayHigh !== "number")
                    return "previousDayHigh: number expected";
            if (message.previousDayLow != null && message.hasOwnProperty("previousDayLow"))
                if (typeof message.previousDayLow !== "number")
                    return "previousDayLow: number expected";
            if (message.adx != null && message.hasOwnProperty("adx"))
                if (typeof message.adx !== "number")
                    return "adx: number expected";
            if (message.percentInstitutionalOwnership != null && message.hasOwnProperty("percentInstitutionalOwnership"))
                if (typeof message.percentInstitutionalOwnership !== "number")
                    return "percentInstitutionalOwnership: number expected";
            if (message.percentInstitutionalTransactions != null && message.hasOwnProperty("percentInstitutionalTransactions"))
                if (typeof message.percentInstitutionalTransactions !== "number")
                    return "percentInstitutionalTransactions: number expected";
            if (message.wiim != null && message.hasOwnProperty("wiim"))
                if (!$util.isString(message.wiim))
                    return "wiim: string expected";
            if (message.wiimAsOf != null && message.hasOwnProperty("wiimAsOf"))
                if (!$util.isInteger(message.wiimAsOf) && !(message.wiimAsOf && $util.isInteger(message.wiimAsOf.low) && $util.isInteger(message.wiimAsOf.high)))
                    return "wiimAsOf: integer|Long expected";
            if (message.vwap != null && message.hasOwnProperty("vwap"))
                if (typeof message.vwap !== "number")
                    return "vwap: number expected";
            if (message.vwapChangePercent != null && message.hasOwnProperty("vwapChangePercent"))
                if (typeof message.vwapChangePercent !== "number")
                    return "vwapChangePercent: number expected";
            if (message.vwapChange != null && message.hasOwnProperty("vwapChange"))
                if (typeof message.vwapChange !== "number")
                    return "vwapChange: number expected";
            if (message.rsiAvgGain != null && message.hasOwnProperty("rsiAvgGain"))
                if (typeof message.rsiAvgGain !== "number")
                    return "rsiAvgGain: number expected";
            if (message.rsiAvgLoss != null && message.hasOwnProperty("rsiAvgLoss"))
                if (typeof message.rsiAvgLoss !== "number")
                    return "rsiAvgLoss: number expected";
            if (message.halted != null && message.hasOwnProperty("halted"))
                if (!$util.isString(message.halted))
                    return "halted: string expected";
            if (message.tradeCount != null && message.hasOwnProperty("tradeCount"))
                if (!$util.isInteger(message.tradeCount) && !(message.tradeCount && $util.isInteger(message.tradeCount.low) && $util.isInteger(message.tradeCount.high)))
                    return "tradeCount: integer|Long expected";
            if (message.regularHighCount != null && message.hasOwnProperty("regularHighCount"))
                if (!$util.isInteger(message.regularHighCount) && !(message.regularHighCount && $util.isInteger(message.regularHighCount.low) && $util.isInteger(message.regularHighCount.high)))
                    return "regularHighCount: integer|Long expected";
            if (message.regularLowCount != null && message.hasOwnProperty("regularLowCount"))
                if (!$util.isInteger(message.regularLowCount) && !(message.regularLowCount && $util.isInteger(message.regularLowCount.low) && $util.isInteger(message.regularLowCount.high)))
                    return "regularLowCount: integer|Long expected";
            if (message.preMarketHighCount != null && message.hasOwnProperty("preMarketHighCount"))
                if (!$util.isInteger(message.preMarketHighCount) && !(message.preMarketHighCount && $util.isInteger(message.preMarketHighCount.low) && $util.isInteger(message.preMarketHighCount.high)))
                    return "preMarketHighCount: integer|Long expected";
            if (message.preMarketLowCount != null && message.hasOwnProperty("preMarketLowCount"))
                if (!$util.isInteger(message.preMarketLowCount) && !(message.preMarketLowCount && $util.isInteger(message.preMarketLowCount.low) && $util.isInteger(message.preMarketLowCount.high)))
                    return "preMarketLowCount: integer|Long expected";
            if (message.afterMarketHighCount != null && message.hasOwnProperty("afterMarketHighCount"))
                if (!$util.isInteger(message.afterMarketHighCount) && !(message.afterMarketHighCount && $util.isInteger(message.afterMarketHighCount.low) && $util.isInteger(message.afterMarketHighCount.high)))
                    return "afterMarketHighCount: integer|Long expected";
            if (message.afterMarketLowCount != null && message.hasOwnProperty("afterMarketLowCount"))
                if (!$util.isInteger(message.afterMarketLowCount) && !(message.afterMarketLowCount && $util.isInteger(message.afterMarketLowCount.low) && $util.isInteger(message.afterMarketLowCount.high)))
                    return "afterMarketLowCount: integer|Long expected";
            if (message.dayHighCount != null && message.hasOwnProperty("dayHighCount"))
                if (!$util.isInteger(message.dayHighCount) && !(message.dayHighCount && $util.isInteger(message.dayHighCount.low) && $util.isInteger(message.dayHighCount.high)))
                    return "dayHighCount: integer|Long expected";
            if (message.dayLowCount != null && message.hasOwnProperty("dayLowCount"))
                if (!$util.isInteger(message.dayLowCount) && !(message.dayLowCount && $util.isInteger(message.dayLowCount.low) && $util.isInteger(message.dayLowCount.high)))
                    return "dayLowCount: integer|Long expected";
            if (message.dayHigh != null && message.hasOwnProperty("dayHigh"))
                if (typeof message.dayHigh !== "number")
                    return "dayHigh: number expected";
            if (message.dayLow != null && message.hasOwnProperty("dayLow"))
                if (typeof message.dayLow !== "number")
                    return "dayLow: number expected";
            if (message.preMarketHigh != null && message.hasOwnProperty("preMarketHigh"))
                if (typeof message.preMarketHigh !== "number")
                    return "preMarketHigh: number expected";
            if (message.preMarketLow != null && message.hasOwnProperty("preMarketLow"))
                if (typeof message.preMarketLow !== "number")
                    return "preMarketLow: number expected";
            if (message.afterMarketHigh != null && message.hasOwnProperty("afterMarketHigh"))
                if (typeof message.afterMarketHigh !== "number")
                    return "afterMarketHigh: number expected";
            if (message.afterMarketLow != null && message.hasOwnProperty("afterMarketLow"))
                if (typeof message.afterMarketLow !== "number")
                    return "afterMarketLow: number expected";
            if (message.regularHigh != null && message.hasOwnProperty("regularHigh"))
                if (typeof message.regularHigh !== "number")
                    return "regularHigh: number expected";
            if (message.regularLow != null && message.hasOwnProperty("regularLow"))
                if (typeof message.regularLow !== "number")
                    return "regularLow: number expected";
            if (message.priceSpikeUpCount != null && message.hasOwnProperty("priceSpikeUpCount"))
                if (!$util.isInteger(message.priceSpikeUpCount) && !(message.priceSpikeUpCount && $util.isInteger(message.priceSpikeUpCount.low) && $util.isInteger(message.priceSpikeUpCount.high)))
                    return "priceSpikeUpCount: integer|Long expected";
            if (message.priceSpikeDownCount != null && message.hasOwnProperty("priceSpikeDownCount"))
                if (!$util.isInteger(message.priceSpikeDownCount) && !(message.priceSpikeDownCount && $util.isInteger(message.priceSpikeDownCount.low) && $util.isInteger(message.priceSpikeDownCount.high)))
                    return "priceSpikeDownCount: integer|Long expected";
            if (message.haltedCount != null && message.hasOwnProperty("haltedCount"))
                if (!$util.isInteger(message.haltedCount) && !(message.haltedCount && $util.isInteger(message.haltedCount.low) && $util.isInteger(message.haltedCount.high)))
                    return "haltedCount: integer|Long expected";
            if (message.usCongressTotal != null && message.hasOwnProperty("usCongressTotal"))
                if (typeof message.usCongressTotal !== "number")
                    return "usCongressTotal: number expected";
            if (message.usCongressRepublicansTotal != null && message.hasOwnProperty("usCongressRepublicansTotal"))
                if (typeof message.usCongressRepublicansTotal !== "number")
                    return "usCongressRepublicansTotal: number expected";
            if (message.usCongressDemocratsTotal != null && message.hasOwnProperty("usCongressDemocratsTotal"))
                if (typeof message.usCongressDemocratsTotal !== "number")
                    return "usCongressDemocratsTotal: number expected";
            if (message.usCongressOtherTotal != null && message.hasOwnProperty("usCongressOtherTotal"))
                if (typeof message.usCongressOtherTotal !== "number")
                    return "usCongressOtherTotal: number expected";
            if (message.volumeFloatRatio != null && message.hasOwnProperty("volumeFloatRatio"))
                if (typeof message.volumeFloatRatio !== "number")
                    return "volumeFloatRatio: number expected";
            if (message.atrp != null && message.hasOwnProperty("atrp"))
                if (typeof message.atrp !== "number")
                    return "atrp: number expected";
            if (message.ytdGainLoss != null && message.hasOwnProperty("ytdGainLoss"))
                if (typeof message.ytdGainLoss !== "number")
                    return "ytdGainLoss: number expected";
            if (message.mtdGainLoss != null && message.hasOwnProperty("mtdGainLoss"))
                if (typeof message.mtdGainLoss !== "number")
                    return "mtdGainLoss: number expected";
            if (message.ytdChange != null && message.hasOwnProperty("ytdChange"))
                if (typeof message.ytdChange !== "number")
                    return "ytdChange: number expected";
            if (message.mtdChange != null && message.hasOwnProperty("mtdChange"))
                if (typeof message.mtdChange !== "number")
                    return "mtdChange: number expected";
            if (message.yearOpen != null && message.hasOwnProperty("yearOpen"))
                if (typeof message.yearOpen !== "number")
                    return "yearOpen: number expected";
            if (message.monthOpen != null && message.hasOwnProperty("monthOpen"))
                if (typeof message.monthOpen !== "number")
                    return "monthOpen: number expected";
            if (message.volumeFloatPercent != null && message.hasOwnProperty("volumeFloatPercent"))
                if (typeof message.volumeFloatPercent !== "number")
                    return "volumeFloatPercent: number expected";
            if (message.rsi1m != null && message.hasOwnProperty("rsi1m"))
                if (typeof message.rsi1m !== "number")
                    return "rsi1m: number expected";
            if (message.rsi2m != null && message.hasOwnProperty("rsi2m"))
                if (typeof message.rsi2m !== "number")
                    return "rsi2m: number expected";
            if (message.rsi5m != null && message.hasOwnProperty("rsi5m"))
                if (typeof message.rsi5m !== "number")
                    return "rsi5m: number expected";
            if (message.rsi15m != null && message.hasOwnProperty("rsi15m"))
                if (typeof message.rsi15m !== "number")
                    return "rsi15m: number expected";
            if (message.rsi30m != null && message.hasOwnProperty("rsi30m"))
                if (typeof message.rsi30m !== "number")
                    return "rsi30m: number expected";
            if (message.rsi60m != null && message.hasOwnProperty("rsi60m"))
                if (typeof message.rsi60m !== "number")
                    return "rsi60m: number expected";
            if (message.rsiEth1m != null && message.hasOwnProperty("rsiEth1m"))
                if (typeof message.rsiEth1m !== "number")
                    return "rsiEth1m: number expected";
            if (message.rsiEth2m != null && message.hasOwnProperty("rsiEth2m"))
                if (typeof message.rsiEth2m !== "number")
                    return "rsiEth2m: number expected";
            if (message.rsiEth5m != null && message.hasOwnProperty("rsiEth5m"))
                if (typeof message.rsiEth5m !== "number")
                    return "rsiEth5m: number expected";
            if (message.rsiEth15m != null && message.hasOwnProperty("rsiEth15m"))
                if (typeof message.rsiEth15m !== "number")
                    return "rsiEth15m: number expected";
            if (message.rsiEth30m != null && message.hasOwnProperty("rsiEth30m"))
                if (typeof message.rsiEth30m !== "number")
                    return "rsiEth30m: number expected";
            if (message.rsiEth60m != null && message.hasOwnProperty("rsiEth60m"))
                if (typeof message.rsiEth60m !== "number")
                    return "rsiEth60m: number expected";
            if (message.averageDollarVolume10Day != null && message.hasOwnProperty("averageDollarVolume10Day"))
                if (typeof message.averageDollarVolume10Day !== "number")
                    return "averageDollarVolume10Day: number expected";
            if (message.averageVolume60Day != null && message.hasOwnProperty("averageVolume60Day"))
                if (!$util.isInteger(message.averageVolume60Day) && !(message.averageVolume60Day && $util.isInteger(message.averageVolume60Day.low) && $util.isInteger(message.averageVolume60Day.high)))
                    return "averageVolume60Day: integer|Long expected";
            if (message.relativeVolumePercent60Day != null && message.hasOwnProperty("relativeVolumePercent60Day"))
                if (typeof message.relativeVolumePercent60Day !== "number")
                    return "relativeVolumePercent60Day: number expected";
            if (message.rsi1mLowest != null && message.hasOwnProperty("rsi1mLowest"))
                if (typeof message.rsi1mLowest !== "number")
                    return "rsi1mLowest: number expected";
            if (message.rsi2mLowest != null && message.hasOwnProperty("rsi2mLowest"))
                if (typeof message.rsi2mLowest !== "number")
                    return "rsi2mLowest: number expected";
            if (message.rsi5mLowest != null && message.hasOwnProperty("rsi5mLowest"))
                if (typeof message.rsi5mLowest !== "number")
                    return "rsi5mLowest: number expected";
            if (message.rsi15mLowest != null && message.hasOwnProperty("rsi15mLowest"))
                if (typeof message.rsi15mLowest !== "number")
                    return "rsi15mLowest: number expected";
            if (message.rsi30mLowest != null && message.hasOwnProperty("rsi30mLowest"))
                if (typeof message.rsi30mLowest !== "number")
                    return "rsi30mLowest: number expected";
            if (message.rsi60mLowest != null && message.hasOwnProperty("rsi60mLowest"))
                if (typeof message.rsi60mLowest !== "number")
                    return "rsi60mLowest: number expected";
            if (message.rsiEth1mLowest != null && message.hasOwnProperty("rsiEth1mLowest"))
                if (typeof message.rsiEth1mLowest !== "number")
                    return "rsiEth1mLowest: number expected";
            if (message.rsiEth2mLowest != null && message.hasOwnProperty("rsiEth2mLowest"))
                if (typeof message.rsiEth2mLowest !== "number")
                    return "rsiEth2mLowest: number expected";
            if (message.rsiEth5mLowest != null && message.hasOwnProperty("rsiEth5mLowest"))
                if (typeof message.rsiEth5mLowest !== "number")
                    return "rsiEth5mLowest: number expected";
            if (message.rsiEth15mLowest != null && message.hasOwnProperty("rsiEth15mLowest"))
                if (typeof message.rsiEth15mLowest !== "number")
                    return "rsiEth15mLowest: number expected";
            if (message.rsiEth30mLowest != null && message.hasOwnProperty("rsiEth30mLowest"))
                if (typeof message.rsiEth30mLowest !== "number")
                    return "rsiEth30mLowest: number expected";
            if (message.rsiEth60mLowest != null && message.hasOwnProperty("rsiEth60mLowest"))
                if (typeof message.rsiEth60mLowest !== "number")
                    return "rsiEth60mLowest: number expected";
            if (message.rsi1mGreatest != null && message.hasOwnProperty("rsi1mGreatest"))
                if (typeof message.rsi1mGreatest !== "number")
                    return "rsi1mGreatest: number expected";
            if (message.rsi2mGreatest != null && message.hasOwnProperty("rsi2mGreatest"))
                if (typeof message.rsi2mGreatest !== "number")
                    return "rsi2mGreatest: number expected";
            if (message.rsi5mGreatest != null && message.hasOwnProperty("rsi5mGreatest"))
                if (typeof message.rsi5mGreatest !== "number")
                    return "rsi5mGreatest: number expected";
            if (message.rsi15mGreatest != null && message.hasOwnProperty("rsi15mGreatest"))
                if (typeof message.rsi15mGreatest !== "number")
                    return "rsi15mGreatest: number expected";
            if (message.rsi30mGreatest != null && message.hasOwnProperty("rsi30mGreatest"))
                if (typeof message.rsi30mGreatest !== "number")
                    return "rsi30mGreatest: number expected";
            if (message.rsi60mGreatest != null && message.hasOwnProperty("rsi60mGreatest"))
                if (typeof message.rsi60mGreatest !== "number")
                    return "rsi60mGreatest: number expected";
            if (message.rsiEth1mGreatest != null && message.hasOwnProperty("rsiEth1mGreatest"))
                if (typeof message.rsiEth1mGreatest !== "number")
                    return "rsiEth1mGreatest: number expected";
            if (message.rsiEth2mGreatest != null && message.hasOwnProperty("rsiEth2mGreatest"))
                if (typeof message.rsiEth2mGreatest !== "number")
                    return "rsiEth2mGreatest: number expected";
            if (message.rsiEth5mGreatest != null && message.hasOwnProperty("rsiEth5mGreatest"))
                if (typeof message.rsiEth5mGreatest !== "number")
                    return "rsiEth5mGreatest: number expected";
            if (message.rsiEth15mGreatest != null && message.hasOwnProperty("rsiEth15mGreatest"))
                if (typeof message.rsiEth15mGreatest !== "number")
                    return "rsiEth15mGreatest: number expected";
            if (message.rsiEth30mGreatest != null && message.hasOwnProperty("rsiEth30mGreatest"))
                if (typeof message.rsiEth30mGreatest !== "number")
                    return "rsiEth30mGreatest: number expected";
            if (message.rsiEth60mGreatest != null && message.hasOwnProperty("rsiEth60mGreatest"))
                if (typeof message.rsiEth60mGreatest !== "number")
                    return "rsiEth60mGreatest: number expected";
            if (message.rsiCrossOver != null && message.hasOwnProperty("rsiCrossOver"))
                if (typeof message.rsiCrossOver !== "number")
                    return "rsiCrossOver: number expected";
            if (message.ema12d != null && message.hasOwnProperty("ema12d"))
                if (typeof message.ema12d !== "number")
                    return "ema12d: number expected";
            if (message.ema26d != null && message.hasOwnProperty("ema26d"))
                if (typeof message.ema26d !== "number")
                    return "ema26d: number expected";
            if (message.macd != null && message.hasOwnProperty("macd"))
                if (typeof message.macd !== "number")
                    return "macd: number expected";
            if (message.macdSignalLine != null && message.hasOwnProperty("macdSignalLine"))
                if (typeof message.macdSignalLine !== "number")
                    return "macdSignalLine: number expected";
            if (message.macdHistogram != null && message.hasOwnProperty("macdHistogram"))
                if (typeof message.macdHistogram !== "number")
                    return "macdHistogram: number expected";
            if (message.macdSignalLineBase != null && message.hasOwnProperty("macdSignalLineBase"))
                if (typeof message.macdSignalLineBase !== "number")
                    return "macdSignalLineBase: number expected";
            if (message.dividendGrowthRate1Year != null && message.hasOwnProperty("dividendGrowthRate1Year"))
                if (typeof message.dividendGrowthRate1Year !== "number")
                    return "dividendGrowthRate1Year: number expected";
            if (message.dividendGrowthRate3Year != null && message.hasOwnProperty("dividendGrowthRate3Year"))
                if (typeof message.dividendGrowthRate3Year !== "number")
                    return "dividendGrowthRate3Year: number expected";
            if (message.dividendGrowthRate5Year != null && message.hasOwnProperty("dividendGrowthRate5Year"))
                if (typeof message.dividendGrowthRate5Year !== "number")
                    return "dividendGrowthRate5Year: number expected";
            if (message.totalDividendTtm != null && message.hasOwnProperty("totalDividendTtm"))
                if (typeof message.totalDividendTtm !== "number")
                    return "totalDividendTtm: number expected";
            if (message.dividendIncreasing != null && message.hasOwnProperty("dividendIncreasing"))
                if (!$util.isInteger(message.dividendIncreasing))
                    return "dividendIncreasing: integer expected";
            if (message.newsBzWireTitle != null && message.hasOwnProperty("newsBzWireTitle"))
                if (!$util.isString(message.newsBzWireTitle))
                    return "newsBzWireTitle: string expected";
            if (message.newsBzWireNodeId != null && message.hasOwnProperty("newsBzWireNodeId"))
                if (!$util.isString(message.newsBzWireNodeId))
                    return "newsBzWireNodeId: string expected";
            if (message.newsBzWireTimestamp != null && message.hasOwnProperty("newsBzWireTimestamp"))
                if (!$util.isInteger(message.newsBzWireTimestamp) && !(message.newsBzWireTimestamp && $util.isInteger(message.newsBzWireTimestamp.low) && $util.isInteger(message.newsBzWireTimestamp.high)))
                    return "newsBzWireTimestamp: integer|Long expected";
            if (message.newsPRTitle != null && message.hasOwnProperty("newsPRTitle"))
                if (!$util.isString(message.newsPRTitle))
                    return "newsPRTitle: string expected";
            if (message.newsPRNodeId != null && message.hasOwnProperty("newsPRNodeId"))
                if (!$util.isString(message.newsPRNodeId))
                    return "newsPRNodeId: string expected";
            if (message.newsPRTimestamp != null && message.hasOwnProperty("newsPRTimestamp"))
                if (!$util.isInteger(message.newsPRTimestamp) && !(message.newsPRTimestamp && $util.isInteger(message.newsPRTimestamp.low) && $util.isInteger(message.newsPRTimestamp.high)))
                    return "newsPRTimestamp: integer|Long expected";
            if (message.newsSecTitle != null && message.hasOwnProperty("newsSecTitle"))
                if (!$util.isString(message.newsSecTitle))
                    return "newsSecTitle: string expected";
            if (message.newsSecNodeId != null && message.hasOwnProperty("newsSecNodeId"))
                if (!$util.isString(message.newsSecNodeId))
                    return "newsSecNodeId: string expected";
            if (message.newsSecTimestamp != null && message.hasOwnProperty("newsSecTimestamp"))
                if (!$util.isInteger(message.newsSecTimestamp) && !(message.newsSecTimestamp && $util.isInteger(message.newsSecTimestamp.low) && $util.isInteger(message.newsSecTimestamp.high)))
                    return "newsSecTimestamp: integer|Long expected";
            if (message.newsBzWireTitleWithNodeId != null && message.hasOwnProperty("newsBzWireTitleWithNodeId"))
                if (!$util.isString(message.newsBzWireTitleWithNodeId))
                    return "newsBzWireTitleWithNodeId: string expected";
            if (message.newsPRTitleWithNodeId != null && message.hasOwnProperty("newsPRTitleWithNodeId"))
                if (!$util.isString(message.newsPRTitleWithNodeId))
                    return "newsPRTitleWithNodeId: string expected";
            if (message.newsSecTitleWithNodeId != null && message.hasOwnProperty("newsSecTitleWithNodeId"))
                if (!$util.isString(message.newsSecTitleWithNodeId))
                    return "newsSecTitleWithNodeId: string expected";
            if (message.movingAverage500Day != null && message.hasOwnProperty("movingAverage500Day"))
                if (typeof message.movingAverage500Day !== "number")
                    return "movingAverage500Day: number expected";
            if (message.gapChange != null && message.hasOwnProperty("gapChange"))
                if (typeof message.gapChange !== "number")
                    return "gapChange: number expected";
            if (message.gapChangePercent != null && message.hasOwnProperty("gapChangePercent"))
                if (typeof message.gapChangePercent !== "number")
                    return "gapChangePercent: number expected";
            if (message.adr14d != null && message.hasOwnProperty("adr14d"))
                if (typeof message.adr14d !== "number")
                    return "adr14d: number expected";
            if (message.dilutedEpsMrqSurprisePercent != null && message.hasOwnProperty("dilutedEpsMrqSurprisePercent"))
                if (typeof message.dilutedEpsMrqSurprisePercent !== "number")
                    return "dilutedEpsMrqSurprisePercent: number expected";
            if (message.dilutedEpsTtmSurprisePercent != null && message.hasOwnProperty("dilutedEpsTtmSurprisePercent"))
                if (typeof message.dilutedEpsTtmSurprisePercent !== "number")
                    return "dilutedEpsTtmSurprisePercent: number expected";
            if (message.dilutedRevenueMrqSurprisePercent != null && message.hasOwnProperty("dilutedRevenueMrqSurprisePercent"))
                if (typeof message.dilutedRevenueMrqSurprisePercent !== "number")
                    return "dilutedRevenueMrqSurprisePercent: number expected";
            if (message.dilutedRevenueTtmSurprisePercent != null && message.hasOwnProperty("dilutedRevenueTtmSurprisePercent"))
                if (typeof message.dilutedRevenueTtmSurprisePercent !== "number")
                    return "dilutedRevenueTtmSurprisePercent: number expected";
            if (message.epsGrowthTtm != null && message.hasOwnProperty("epsGrowthTtm"))
                if (typeof message.epsGrowthTtm !== "number")
                    return "epsGrowthTtm: number expected";
            if (message.epsGrowthY2Y != null && message.hasOwnProperty("epsGrowthY2Y"))
                if (typeof message.epsGrowthY2Y !== "number")
                    return "epsGrowthY2Y: number expected";
            if (message.epsGrowthQ2Q != null && message.hasOwnProperty("epsGrowthQ2Q"))
                if (typeof message.epsGrowthQ2Q !== "number")
                    return "epsGrowthQ2Q: number expected";
            if (message.epsGrowth5Year != null && message.hasOwnProperty("epsGrowth5Year"))
                if (typeof message.epsGrowth5Year !== "number")
                    return "epsGrowth5Year: number expected";
            if (message.epsGrowthYearAgoQ != null && message.hasOwnProperty("epsGrowthYearAgoQ"))
                if (typeof message.epsGrowthYearAgoQ !== "number")
                    return "epsGrowthYearAgoQ: number expected";
            if (message.revenueGrowthTtm != null && message.hasOwnProperty("revenueGrowthTtm"))
                if (typeof message.revenueGrowthTtm !== "number")
                    return "revenueGrowthTtm: number expected";
            if (message.revenueGrowthY2Y != null && message.hasOwnProperty("revenueGrowthY2Y"))
                if (typeof message.revenueGrowthY2Y !== "number")
                    return "revenueGrowthY2Y: number expected";
            if (message.revenueGrowthQ2Q != null && message.hasOwnProperty("revenueGrowthQ2Q"))
                if (typeof message.revenueGrowthQ2Q !== "number")
                    return "revenueGrowthQ2Q: number expected";
            if (message.revenueGrowth5Year != null && message.hasOwnProperty("revenueGrowth5Year"))
                if (typeof message.revenueGrowth5Year !== "number")
                    return "revenueGrowth5Year: number expected";
            if (message.revenueGrowthYearAgoQ != null && message.hasOwnProperty("revenueGrowthYearAgoQ"))
                if (typeof message.revenueGrowthYearAgoQ !== "number")
                    return "revenueGrowthYearAgoQ: number expected";
            if (message.ltDebtEquity != null && message.hasOwnProperty("ltDebtEquity"))
                if (typeof message.ltDebtEquity !== "number")
                    return "ltDebtEquity: number expected";
            if (message.bullsSay != null && message.hasOwnProperty("bullsSay"))
                if (!$util.isString(message.bullsSay))
                    return "bullsSay: string expected";
            if (message.bearsSay != null && message.hasOwnProperty("bearsSay"))
                if (!$util.isString(message.bearsSay))
                    return "bearsSay: string expected";
            if (message.ipoDateNumber != null && message.hasOwnProperty("ipoDateNumber"))
                if (!$util.isInteger(message.ipoDateNumber) && !(message.ipoDateNumber && $util.isInteger(message.ipoDateNumber.low) && $util.isInteger(message.ipoDateNumber.high)))
                    return "ipoDateNumber: integer|Long expected";
            if (message.ffoPerShare != null && message.hasOwnProperty("ffoPerShare"))
                if (typeof message.ffoPerShare !== "number")
                    return "ffoPerShare: number expected";
            if (message.quickRatioMrq != null && message.hasOwnProperty("quickRatioMrq"))
                if (typeof message.quickRatioMrq !== "number")
                    return "quickRatioMrq: number expected";
            if (message.highAllTime != null && message.hasOwnProperty("highAllTime"))
                if (typeof message.highAllTime !== "number")
                    return "highAllTime: number expected";
            if (message.lowAllTime != null && message.hasOwnProperty("lowAllTime"))
                if (typeof message.lowAllTime !== "number")
                    return "lowAllTime: number expected";
            if (message.evToEbitda != null && message.hasOwnProperty("evToEbitda"))
                if (typeof message.evToEbitda !== "number")
                    return "evToEbitda: number expected";
            if (message.totalDebtEquityRatio != null && message.hasOwnProperty("totalDebtEquityRatio"))
                if (typeof message.totalDebtEquityRatio !== "number")
                    return "totalDebtEquityRatio: number expected";
            if (message.dividendPayoutRatio != null && message.hasOwnProperty("dividendPayoutRatio"))
                if (typeof message.dividendPayoutRatio !== "number")
                    return "dividendPayoutRatio: number expected";
            if (message.operatingCashFlow != null && message.hasOwnProperty("operatingCashFlow"))
                if (typeof message.operatingCashFlow !== "number")
                    return "operatingCashFlow: number expected";
            if (message.insiderPercentage != null && message.hasOwnProperty("insiderPercentage"))
                if (typeof message.insiderPercentage !== "number")
                    return "insiderPercentage: number expected";
            if (message.priceToCashFlowRatio != null && message.hasOwnProperty("priceToCashFlowRatio"))
                if (typeof message.priceToCashFlowRatio !== "number")
                    return "priceToCashFlowRatio: number expected";
            if (message.regularHoursChange != null && message.hasOwnProperty("regularHoursChange"))
                if (typeof message.regularHoursChange !== "number")
                    return "regularHoursChange: number expected";
            if (message.regularHoursPercentChange != null && message.hasOwnProperty("regularHoursPercentChange"))
                if (typeof message.regularHoursPercentChange !== "number")
                    return "regularHoursPercentChange: number expected";
            if (message.postToPreHoursChange != null && message.hasOwnProperty("postToPreHoursChange"))
                if (typeof message.postToPreHoursChange !== "number")
                    return "postToPreHoursChange: number expected";
            if (message.postToPreHoursPercentChange != null && message.hasOwnProperty("postToPreHoursPercentChange"))
                if (typeof message.postToPreHoursPercentChange !== "number")
                    return "postToPreHoursPercentChange: number expected";
            if (message.scannerClose != null && message.hasOwnProperty("scannerClose"))
                if (typeof message.scannerClose !== "number")
                    return "scannerClose: number expected";
            if (message.scannerChange != null && message.hasOwnProperty("scannerChange"))
                if (typeof message.scannerChange !== "number")
                    return "scannerChange: number expected";
            if (message.scannerChangePercent != null && message.hasOwnProperty("scannerChangePercent"))
                if (typeof message.scannerChangePercent !== "number")
                    return "scannerChangePercent: number expected";
            if (message.scannerChangePercentClose != null && message.hasOwnProperty("scannerChangePercentClose"))
                if (typeof message.scannerChangePercentClose !== "number")
                    return "scannerChangePercentClose: number expected";
            if (message.scannerPreviousClose != null && message.hasOwnProperty("scannerPreviousClose"))
                if (typeof message.scannerPreviousClose !== "number")
                    return "scannerPreviousClose: number expected";
            if (message.freeCashFlow != null && message.hasOwnProperty("freeCashFlow"))
                if (typeof message.freeCashFlow !== "number")
                    return "freeCashFlow: number expected";
            if (message.minPriceTarget != null && message.hasOwnProperty("minPriceTarget"))
                if (typeof message.minPriceTarget !== "number")
                    return "minPriceTarget: number expected";
            if (message.maxPriceTarget != null && message.hasOwnProperty("maxPriceTarget"))
                if (typeof message.maxPriceTarget !== "number")
                    return "maxPriceTarget: number expected";
            if (message.meanPriceTarget != null && message.hasOwnProperty("meanPriceTarget"))
                if (typeof message.meanPriceTarget !== "number")
                    return "meanPriceTarget: number expected";
            if (message.totalNumberOfAnalyst != null && message.hasOwnProperty("totalNumberOfAnalyst"))
                if (typeof message.totalNumberOfAnalyst !== "number")
                    return "totalNumberOfAnalyst: number expected";
            if (message.averageAnalystRecommendation != null && message.hasOwnProperty("averageAnalystRecommendation"))
                if (!$util.isString(message.averageAnalystRecommendation))
                    return "averageAnalystRecommendation: string expected";
            if (message.pegRatio != null && message.hasOwnProperty("pegRatio"))
                if (typeof message.pegRatio !== "number")
                    return "pegRatio: number expected";
            if (message.priceToFreeCashFlowRatio != null && message.hasOwnProperty("priceToFreeCashFlowRatio"))
                if (typeof message.priceToFreeCashFlowRatio !== "number")
                    return "priceToFreeCashFlowRatio: number expected";
            if (message.distanceToMaxPriceTarget != null && message.hasOwnProperty("distanceToMaxPriceTarget"))
                if (typeof message.distanceToMaxPriceTarget !== "number")
                    return "distanceToMaxPriceTarget: number expected";
            if (message.distanceToMinPriceTarget != null && message.hasOwnProperty("distanceToMinPriceTarget"))
                if (typeof message.distanceToMinPriceTarget !== "number")
                    return "distanceToMinPriceTarget: number expected";
            if (message.distanceToMeanPriceTarget != null && message.hasOwnProperty("distanceToMeanPriceTarget"))
                if (typeof message.distanceToMeanPriceTarget !== "number")
                    return "distanceToMeanPriceTarget: number expected";
            if (message.shortTermTrend != null && message.hasOwnProperty("shortTermTrend"))
                if (!$util.isString(message.shortTermTrend))
                    return "shortTermTrend: string expected";
            if (message.mediumTermTrend != null && message.hasOwnProperty("mediumTermTrend"))
                if (!$util.isString(message.mediumTermTrend))
                    return "mediumTermTrend: string expected";
            if (message.longTermTrend != null && message.hasOwnProperty("longTermTrend"))
                if (!$util.isString(message.longTermTrend))
                    return "longTermTrend: string expected";
            if (message.twentySixWeekChange != null && message.hasOwnProperty("twentySixWeekChange"))
                if (typeof message.twentySixWeekChange !== "number")
                    return "twentySixWeekChange: number expected";
            if (message.fiftyTwoWeekChange != null && message.hasOwnProperty("fiftyTwoWeekChange"))
                if (typeof message.fiftyTwoWeekChange !== "number")
                    return "fiftyTwoWeekChange: number expected";
            if (message.annualizedStandardDeviation != null && message.hasOwnProperty("annualizedStandardDeviation"))
                if (typeof message.annualizedStandardDeviation !== "number")
                    return "annualizedStandardDeviation: number expected";
            if (message.momentum != null && message.hasOwnProperty("momentum"))
                if (typeof message.momentum !== "number")
                    return "momentum: number expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (typeof message.value !== "number")
                    return "value: number expected";
            if (message.piotroskiFScore != null && message.hasOwnProperty("piotroskiFScore"))
                if (!$util.isInteger(message.piotroskiFScore) && !(message.piotroskiFScore && $util.isInteger(message.piotroskiFScore.low) && $util.isInteger(message.piotroskiFScore.high)))
                    return "piotroskiFScore: integer|Long expected";
            if (message.netIncomeTtm != null && message.hasOwnProperty("netIncomeTtm"))
                if (typeof message.netIncomeTtm !== "number")
                    return "netIncomeTtm: number expected";
            if (message.currentRatioYearAgo != null && message.hasOwnProperty("currentRatioYearAgo"))
                if (typeof message.currentRatioYearAgo !== "number")
                    return "currentRatioYearAgo: number expected";
            if (message.roaYearAgo != null && message.hasOwnProperty("roaYearAgo"))
                if (typeof message.roaYearAgo !== "number")
                    return "roaYearAgo: number expected";
            if (message.grossMarginYearAgo != null && message.hasOwnProperty("grossMarginYearAgo"))
                if (typeof message.grossMarginYearAgo !== "number")
                    return "grossMarginYearAgo: number expected";
            if (message.longTermDebt != null && message.hasOwnProperty("longTermDebt"))
                if (typeof message.longTermDebt !== "number")
                    return "longTermDebt: number expected";
            if (message.longTermDebtYearAgo != null && message.hasOwnProperty("longTermDebtYearAgo"))
                if (typeof message.longTermDebtYearAgo !== "number")
                    return "longTermDebtYearAgo: number expected";
            if (message.shareIssued != null && message.hasOwnProperty("shareIssued"))
                if (typeof message.shareIssued !== "number")
                    return "shareIssued: number expected";
            if (message.shareIssuedYearAgo != null && message.hasOwnProperty("shareIssuedYearAgo"))
                if (typeof message.shareIssuedYearAgo !== "number")
                    return "shareIssuedYearAgo: number expected";
            if (message.totalAssets != null && message.hasOwnProperty("totalAssets"))
                if (typeof message.totalAssets !== "number")
                    return "totalAssets: number expected";
            if (message.totalAssetsYearAgo != null && message.hasOwnProperty("totalAssetsYearAgo"))
                if (typeof message.totalAssetsYearAgo !== "number")
                    return "totalAssetsYearAgo: number expected";
            if (message.totalAssets2YearAgo != null && message.hasOwnProperty("totalAssets2YearAgo"))
                if (typeof message.totalAssets2YearAgo !== "number")
                    return "totalAssets2YearAgo: number expected";
            if (message.revenueTtmYearAgo != null && message.hasOwnProperty("revenueTtmYearAgo"))
                if (typeof message.revenueTtmYearAgo !== "number")
                    return "revenueTtmYearAgo: number expected";
            if (message.longTermDebtAndCapitalLeaseObligation != null && message.hasOwnProperty("longTermDebtAndCapitalLeaseObligation"))
                if (typeof message.longTermDebtAndCapitalLeaseObligation !== "number")
                    return "longTermDebtAndCapitalLeaseObligation: number expected";
            if (message.averageTotalAssets != null && message.hasOwnProperty("averageTotalAssets"))
                if (typeof message.averageTotalAssets !== "number")
                    return "averageTotalAssets: number expected";
            if (message.averageTotalAssetsYearAgo != null && message.hasOwnProperty("averageTotalAssetsYearAgo"))
                if (typeof message.averageTotalAssetsYearAgo !== "number")
                    return "averageTotalAssetsYearAgo: number expected";
            if (message.growth != null && message.hasOwnProperty("growth"))
                if (typeof message.growth !== "number")
                    return "growth: number expected";
            if (message.quality != null && message.hasOwnProperty("quality"))
                if (typeof message.quality !== "number")
                    return "quality: number expected";
            if (message.momentumPercentile != null && message.hasOwnProperty("momentumPercentile"))
                if (typeof message.momentumPercentile !== "number")
                    return "momentumPercentile: number expected";
            if (message.valuePercentile != null && message.hasOwnProperty("valuePercentile"))
                if (typeof message.valuePercentile !== "number")
                    return "valuePercentile: number expected";
            if (message.growthPercentile != null && message.hasOwnProperty("growthPercentile"))
                if (typeof message.growthPercentile !== "number")
                    return "growthPercentile: number expected";
            if (message.qualityPercentile != null && message.hasOwnProperty("qualityPercentile"))
                if (typeof message.qualityPercentile !== "number")
                    return "qualityPercentile: number expected";
            if (message.rateOfReturnDay != null && message.hasOwnProperty("rateOfReturnDay"))
                if (typeof message.rateOfReturnDay !== "number")
                    return "rateOfReturnDay: number expected";
            if (message.rateOfReturnWeek != null && message.hasOwnProperty("rateOfReturnWeek"))
                if (typeof message.rateOfReturnWeek !== "number")
                    return "rateOfReturnWeek: number expected";
            if (message.rateOfReturnMonth != null && message.hasOwnProperty("rateOfReturnMonth"))
                if (typeof message.rateOfReturnMonth !== "number")
                    return "rateOfReturnMonth: number expected";
            if (message.dividendOneDay != null && message.hasOwnProperty("dividendOneDay"))
                if (typeof message.dividendOneDay !== "number")
                    return "dividendOneDay: number expected";
            if (message.dividendOneWeek != null && message.hasOwnProperty("dividendOneWeek"))
                if (typeof message.dividendOneWeek !== "number")
                    return "dividendOneWeek: number expected";
            if (message.dividendOneMonth != null && message.hasOwnProperty("dividendOneMonth"))
                if (typeof message.dividendOneMonth !== "number")
                    return "dividendOneMonth: number expected";
            if (message.totalLiabilities != null && message.hasOwnProperty("totalLiabilities"))
                if (typeof message.totalLiabilities !== "number")
                    return "totalLiabilities: number expected";
            if (message.retainedEarnings != null && message.hasOwnProperty("retainedEarnings"))
                if (typeof message.retainedEarnings !== "number")
                    return "retainedEarnings: number expected";
            if (message.ebit != null && message.hasOwnProperty("ebit"))
                if (typeof message.ebit !== "number")
                    return "ebit: number expected";
            if (message.altmanZScore != null && message.hasOwnProperty("altmanZScore"))
                if (typeof message.altmanZScore !== "number")
                    return "altmanZScore: number expected";
            if (message.powerEarningGap != null && message.hasOwnProperty("powerEarningGap"))
                if (typeof message.powerEarningGap !== "boolean")
                    return "powerEarningGap: boolean expected";
            if (message.monsterPowerEarningGap != null && message.hasOwnProperty("monsterPowerEarningGap"))
                if (typeof message.monsterPowerEarningGap !== "boolean")
                    return "monsterPowerEarningGap: boolean expected";
            if (message.monsterGap != null && message.hasOwnProperty("monsterGap"))
                if (typeof message.monsterGap !== "boolean")
                    return "monsterGap: boolean expected";
            if (message.oelGap != null && message.hasOwnProperty("oelGap"))
                if (typeof message.oelGap !== "boolean")
                    return "oelGap: boolean expected";
            if (message.evToEbit != null && message.hasOwnProperty("evToEbit"))
                if (typeof message.evToEbit !== "number")
                    return "evToEbit: number expected";
            if (message.priceToTangibleBookValue != null && message.hasOwnProperty("priceToTangibleBookValue"))
                if (typeof message.priceToTangibleBookValue !== "number")
                    return "priceToTangibleBookValue: number expected";
            if (message.tangibleBookValuePerShare != null && message.hasOwnProperty("tangibleBookValuePerShare"))
                if (typeof message.tangibleBookValuePerShare !== "number")
                    return "tangibleBookValuePerShare: number expected";
            if (message.dailyDollarVolume != null && message.hasOwnProperty("dailyDollarVolume"))
                if (typeof message.dailyDollarVolume !== "number")
                    return "dailyDollarVolume: number expected";
            if (message.bookValuePerShare != null && message.hasOwnProperty("bookValuePerShare"))
                if (typeof message.bookValuePerShare !== "number")
                    return "bookValuePerShare: number expected";
            if (message.movingAverage350Day != null && message.hasOwnProperty("movingAverage350Day"))
                if (typeof message.movingAverage350Day !== "number")
                    return "movingAverage350Day: number expected";
            if (message.priceToAdjEarningsTtm != null && message.hasOwnProperty("priceToAdjEarningsTtm"))
                if (typeof message.priceToAdjEarningsTtm !== "number")
                    return "priceToAdjEarningsTtm: number expected";
            if (message.salesGrowthYoY != null && message.hasOwnProperty("salesGrowthYoY"))
                if (typeof message.salesGrowthYoY !== "number")
                    return "salesGrowthYoY: number expected";
            if (message.salesGrowth3Year != null && message.hasOwnProperty("salesGrowth3Year"))
                if (typeof message.salesGrowth3Year !== "number")
                    return "salesGrowth3Year: number expected";
            if (message.salesGrowth5Year != null && message.hasOwnProperty("salesGrowth5Year"))
                if (typeof message.salesGrowth5Year !== "number")
                    return "salesGrowth5Year: number expected";
            if (message.debtQoQ != null && message.hasOwnProperty("debtQoQ"))
                if (typeof message.debtQoQ !== "number")
                    return "debtQoQ: number expected";
            if (message.debtYoY != null && message.hasOwnProperty("debtYoY"))
                if (typeof message.debtYoY !== "number")
                    return "debtYoY: number expected";
            if (message.debt5Year != null && message.hasOwnProperty("debt5Year"))
                if (typeof message.debt5Year !== "number")
                    return "debt5Year: number expected";
            if (message.epsGrowth3Year != null && message.hasOwnProperty("epsGrowth3Year"))
                if (typeof message.epsGrowth3Year !== "number")
                    return "epsGrowth3Year: number expected";
            if (message.epsGrowth3NormalizedYear != null && message.hasOwnProperty("epsGrowth3NormalizedYear"))
                if (typeof message.epsGrowth3NormalizedYear !== "number")
                    return "epsGrowth3NormalizedYear: number expected";
            if (message.roe5YrAvg != null && message.hasOwnProperty("roe5YrAvg"))
                if (typeof message.roe5YrAvg !== "number")
                    return "roe5YrAvg: number expected";
            if (message.stockholdersEquity != null && message.hasOwnProperty("stockholdersEquity"))
                if (typeof message.stockholdersEquity !== "number")
                    return "stockholdersEquity: number expected";
            if (message.stockholdersEquityYearAgo != null && message.hasOwnProperty("stockholdersEquityYearAgo"))
                if (typeof message.stockholdersEquityYearAgo !== "number")
                    return "stockholdersEquityYearAgo: number expected";
            if (message.stockholdersEquityGrowthYoY != null && message.hasOwnProperty("stockholdersEquityGrowthYoY"))
                if (typeof message.stockholdersEquityGrowthYoY !== "number")
                    return "stockholdersEquityGrowthYoY: number expected";
            if (message.vwap1Day != null && message.hasOwnProperty("vwap1Day"))
                if (typeof message.vwap1Day !== "number")
                    return "vwap1Day: number expected";
            if (message.vwap5Day != null && message.hasOwnProperty("vwap5Day"))
                if (typeof message.vwap5Day !== "number")
                    return "vwap5Day: number expected";
            if (message.vwap10Day != null && message.hasOwnProperty("vwap10Day"))
                if (typeof message.vwap10Day !== "number")
                    return "vwap10Day: number expected";
            if (message.vwap50Day != null && message.hasOwnProperty("vwap50Day"))
                if (typeof message.vwap50Day !== "number")
                    return "vwap50Day: number expected";
            if (message.vwap100Day != null && message.hasOwnProperty("vwap100Day"))
                if (typeof message.vwap100Day !== "number")
                    return "vwap100Day: number expected";
            if (message.vwap200Day != null && message.hasOwnProperty("vwap200Day"))
                if (typeof message.vwap200Day !== "number")
                    return "vwap200Day: number expected";
            if (message.roic1YearAvg != null && message.hasOwnProperty("roic1YearAvg"))
                if (typeof message.roic1YearAvg !== "number")
                    return "roic1YearAvg: number expected";
            if (message.roic5YearAvg != null && message.hasOwnProperty("roic5YearAvg"))
                if (typeof message.roic5YearAvg !== "number")
                    return "roic5YearAvg: number expected";
            if (message.vwap1m != null && message.hasOwnProperty("vwap1m"))
                if (typeof message.vwap1m !== "number")
                    return "vwap1m: number expected";
            if (message.vwap5m != null && message.hasOwnProperty("vwap5m"))
                if (typeof message.vwap5m !== "number")
                    return "vwap5m: number expected";
            if (message.vwap15m != null && message.hasOwnProperty("vwap15m"))
                if (typeof message.vwap15m !== "number")
                    return "vwap15m: number expected";
            if (message.vwap30m != null && message.hasOwnProperty("vwap30m"))
                if (typeof message.vwap30m !== "number")
                    return "vwap30m: number expected";
            if (message.vwap60m != null && message.hasOwnProperty("vwap60m"))
                if (typeof message.vwap60m !== "number")
                    return "vwap60m: number expected";
            if (message.candleStick != null && message.hasOwnProperty("candleStick"))
                if (!$util.isString(message.candleStick))
                    return "candleStick: string expected";
            if (message.patterns != null && message.hasOwnProperty("patterns"))
                if (!$util.isString(message.patterns))
                    return "patterns: string expected";
            if (message.earningsForwardGrowth3Year != null && message.hasOwnProperty("earningsForwardGrowth3Year"))
                if (typeof message.earningsForwardGrowth3Year !== "number")
                    return "earningsForwardGrowth3Year: number expected";
            if (message.earningsForwardGrowth5Year != null && message.hasOwnProperty("earningsForwardGrowth5Year"))
                if (typeof message.earningsForwardGrowth5Year !== "number")
                    return "earningsForwardGrowth5Year: number expected";
            if (message.revenueForwardGrowth3Year != null && message.hasOwnProperty("revenueForwardGrowth3Year"))
                if (typeof message.revenueForwardGrowth3Year !== "number")
                    return "revenueForwardGrowth3Year: number expected";
            if (message.revenueForwardGrowth5Year != null && message.hasOwnProperty("revenueForwardGrowth5Year"))
                if (typeof message.revenueForwardGrowth5Year !== "number")
                    return "revenueForwardGrowth5Year: number expected";
            if (message.bidAskSpread != null && message.hasOwnProperty("bidAskSpread"))
                if (typeof message.bidAskSpread !== "number")
                    return "bidAskSpread: number expected";
            if (message.bidAskSpreadPercent != null && message.hasOwnProperty("bidAskSpreadPercent"))
                if (typeof message.bidAskSpreadPercent !== "number")
                    return "bidAskSpreadPercent: number expected";
            if (message.change1Minute != null && message.hasOwnProperty("change1Minute"))
                if (typeof message.change1Minute !== "number")
                    return "change1Minute: number expected";
            if (message.preMarketChange1Minute != null && message.hasOwnProperty("preMarketChange1Minute"))
                if (typeof message.preMarketChange1Minute !== "number")
                    return "preMarketChange1Minute: number expected";
            if (message.preMarketChangePercent1Minute != null && message.hasOwnProperty("preMarketChangePercent1Minute"))
                if (typeof message.preMarketChangePercent1Minute !== "number")
                    return "preMarketChangePercent1Minute: number expected";
            if (message.regularChange1Minute != null && message.hasOwnProperty("regularChange1Minute"))
                if (typeof message.regularChange1Minute !== "number")
                    return "regularChange1Minute: number expected";
            if (message.regularChangePercent1Minute != null && message.hasOwnProperty("regularChangePercent1Minute"))
                if (typeof message.regularChangePercent1Minute !== "number")
                    return "regularChangePercent1Minute: number expected";
            if (message.afterMarketChange1Minute != null && message.hasOwnProperty("afterMarketChange1Minute"))
                if (typeof message.afterMarketChange1Minute !== "number")
                    return "afterMarketChange1Minute: number expected";
            if (message.afterMarketChangePercent1Minute != null && message.hasOwnProperty("afterMarketChangePercent1Minute"))
                if (typeof message.afterMarketChangePercent1Minute !== "number")
                    return "afterMarketChangePercent1Minute: number expected";
            if (message.previousCloseDate != null && message.hasOwnProperty("previousCloseDate"))
                if (!$util.isString(message.previousCloseDate))
                    return "previousCloseDate: string expected";
            if (message.distanceToMaxPriceTargetPercent != null && message.hasOwnProperty("distanceToMaxPriceTargetPercent"))
                if (typeof message.distanceToMaxPriceTargetPercent !== "number")
                    return "distanceToMaxPriceTargetPercent: number expected";
            if (message.distanceToMinPriceTargetPercent != null && message.hasOwnProperty("distanceToMinPriceTargetPercent"))
                if (typeof message.distanceToMinPriceTargetPercent !== "number")
                    return "distanceToMinPriceTargetPercent: number expected";
            if (message.distanceToMeanPriceTargetPercent != null && message.hasOwnProperty("distanceToMeanPriceTargetPercent"))
                if (typeof message.distanceToMeanPriceTargetPercent !== "number")
                    return "distanceToMeanPriceTargetPercent: number expected";
            return null;
        };

        /**
         * Creates a Quote message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof QuoteProtos.Quote
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {QuoteProtos.Quote} Quote
         */
        Quote.fromObject = function fromObject(object, long) {
            if (object instanceof $root.QuoteProtos.Quote)
                return object;
            if (long === undefined)
                long = 0;
            if (long > $util.recursionLimit)
                throw Error("maximum nesting depth exceeded");
            let message = new $root.QuoteProtos.Quote();
            if (object.symbol != null)
                message.symbol = String(object.symbol);
            if (object.opol != null)
                message.opol = String(object.opol);
            if (object.previousClose != null)
                message.previousClose = Number(object.previousClose);
            if (object.close != null)
                message.close = Number(object.close);
            if (object.change != null)
                message.change = Number(object.change);
            if (object.changePercent != null)
                message.changePercent = Number(object.changePercent);
            if (object.name != null)
                message.name = String(object.name);
            if (object.ipoDate != null)
                message.ipoDate = String(object.ipoDate);
            if (object.exchange != null)
                message.exchange = String(object.exchange);
            if (object.tradeExchange != null)
                message.tradeExchange = String(object.tradeExchange);
            if (object.preMarketOpen != null)
                message.preMarketOpen = Number(object.preMarketOpen);
            if (object.preMarketOpenTime != null)
                if ($util.Long)
                    (message.preMarketOpenTime = $util.Long.fromValue(object.preMarketOpenTime)).unsigned = false;
                else if (typeof object.preMarketOpenTime === "string")
                    message.preMarketOpenTime = parseInt(object.preMarketOpenTime, 10);
                else if (typeof object.preMarketOpenTime === "number")
                    message.preMarketOpenTime = object.preMarketOpenTime;
                else if (typeof object.preMarketOpenTime === "object")
                    message.preMarketOpenTime = new $util.LongBits(object.preMarketOpenTime.low >>> 0, object.preMarketOpenTime.high >>> 0).toNumber();
            if (object.preMarketVolume != null)
                if ($util.Long)
                    (message.preMarketVolume = $util.Long.fromValue(object.preMarketVolume)).unsigned = false;
                else if (typeof object.preMarketVolume === "string")
                    message.preMarketVolume = parseInt(object.preMarketVolume, 10);
                else if (typeof object.preMarketVolume === "number")
                    message.preMarketVolume = object.preMarketVolume;
                else if (typeof object.preMarketVolume === "object")
                    message.preMarketVolume = new $util.LongBits(object.preMarketVolume.low >>> 0, object.preMarketVolume.high >>> 0).toNumber();
            if (object.afterMarketVolume != null)
                if ($util.Long)
                    (message.afterMarketVolume = $util.Long.fromValue(object.afterMarketVolume)).unsigned = false;
                else if (typeof object.afterMarketVolume === "string")
                    message.afterMarketVolume = parseInt(object.afterMarketVolume, 10);
                else if (typeof object.afterMarketVolume === "number")
                    message.afterMarketVolume = object.afterMarketVolume;
                else if (typeof object.afterMarketVolume === "object")
                    message.afterMarketVolume = new $util.LongBits(object.afterMarketVolume.low >>> 0, object.afterMarketVolume.high >>> 0).toNumber();
            if (object.preMarketPrice != null)
                message.preMarketPrice = Number(object.preMarketPrice);
            if (object.afterMarketPrice != null)
                message.afterMarketPrice = Number(object.afterMarketPrice);
            if (object.preMarketOpenChange != null)
                message.preMarketOpenChange = Number(object.preMarketOpenChange);
            if (object.preMarketOpenChangePercent != null)
                message.preMarketOpenChangePercent = Number(object.preMarketOpenChangePercent);
            switch (object.source) {
            default:
                if (typeof object.source === "number") {
                    message.source = object.source;
                    break;
                }
                break;
            case "UNKNOWN_SOURCE":
            case 0:
                message.source = 0;
                break;
            case "QUOTE_STORE":
            case 1:
                message.source = 1;
                break;
            case "QUOTE_CALCULATOR":
            case 2:
                message.source = 2;
                break;
            case "POLLED_DATA":
            case 3:
                message.source = 3;
                break;
            case "ROLLING_FIELDS":
            case 4:
                message.source = 4;
                break;
            case "RSI_FIELDS":
            case 5:
                message.source = 5;
                break;
            case "CONTENT_EVENT_PUBLISHER":
            case 6:
                message.source = 6;
                break;
            case "SWAP":
            case 7:
                message.source = 7;
                break;
            case "VWAP_CALCULATOR":
            case 8:
                message.source = 8;
                break;
            }
            if (object.clearFieldNumbers) {
                if (!Array.isArray(object.clearFieldNumbers))
                    throw TypeError(".QuoteProtos.Quote.clearFieldNumbers: array expected");
                message.clearFieldNumbers = [];
                for (let i = 0; i < object.clearFieldNumbers.length; ++i)
                    message.clearFieldNumbers[i] = object.clearFieldNumbers[i] | 0;
            }
            if (object.marketCap != null)
                if ($util.Long)
                    (message.marketCap = $util.Long.fromValue(object.marketCap)).unsigned = false;
                else if (typeof object.marketCap === "string")
                    message.marketCap = parseInt(object.marketCap, 10);
                else if (typeof object.marketCap === "number")
                    message.marketCap = object.marketCap;
                else if (typeof object.marketCap === "object")
                    message.marketCap = new $util.LongBits(object.marketCap.low >>> 0, object.marketCap.high >>> 0).toNumber();
            if (object.rsi != null)
                message.rsi = Number(object.rsi);
            if (object.atr != null)
                message.atr = Number(object.atr);
            if (object.priceToEarnings != null)
                message.priceToEarnings = Number(object.priceToEarnings);
            if (object.averageVolume != null)
                if ($util.Long)
                    (message.averageVolume = $util.Long.fromValue(object.averageVolume)).unsigned = false;
                else if (typeof object.averageVolume === "string")
                    message.averageVolume = parseInt(object.averageVolume, 10);
                else if (typeof object.averageVolume === "number")
                    message.averageVolume = object.averageVolume;
                else if (typeof object.averageVolume === "object")
                    message.averageVolume = new $util.LongBits(object.averageVolume.low >>> 0, object.averageVolume.high >>> 0).toNumber();
            if (object.sharesOutstanding != null)
                if ($util.Long)
                    (message.sharesOutstanding = $util.Long.fromValue(object.sharesOutstanding)).unsigned = false;
                else if (typeof object.sharesOutstanding === "string")
                    message.sharesOutstanding = parseInt(object.sharesOutstanding, 10);
                else if (typeof object.sharesOutstanding === "number")
                    message.sharesOutstanding = object.sharesOutstanding;
                else if (typeof object.sharesOutstanding === "object")
                    message.sharesOutstanding = new $util.LongBits(object.sharesOutstanding.low >>> 0, object.sharesOutstanding.high >>> 0).toNumber();
            if (object.sector != null)
                message.sector = String(object.sector);
            if (object.sectorCode != null)
                message.sectorCode = object.sectorCode | 0;
            if (object.industry != null)
                message.industry = String(object.industry);
            if (object.industryCode != null)
                message.industryCode = object.industryCode | 0;
            if (object.forwardPERatio != null)
                message.forwardPERatio = Number(object.forwardPERatio);
            if (object.pricetoEBITDA != null)
                message.pricetoEBITDA = Number(object.pricetoEBITDA);
            if (object.trailingDividendYield != null)
                message.trailingDividendYield = Number(object.trailingDividendYield);
            if (object.PBRatio != null)
                message.PBRatio = Number(object.PBRatio);
            if (object.priceToSales != null)
                message.priceToSales = Number(object.priceToSales);
            if (object.FCFPerShare != null)
                message.FCFPerShare = Number(object.FCFPerShare);
            if (object.buyBackYield != null)
                message.buyBackYield = Number(object.buyBackYield);
            if (object.open != null)
                message.open = Number(object.open);
            if (object.price != null)
                message.price = Number(object.price);
            if (object.high != null)
                message.high = Number(object.high);
            if (object.low != null)
                message.low = Number(object.low);
            if (object.time != null)
                if ($util.Long)
                    (message.time = $util.Long.fromValue(object.time)).unsigned = false;
                else if (typeof object.time === "string")
                    message.time = parseInt(object.time, 10);
                else if (typeof object.time === "number")
                    message.time = object.time;
                else if (typeof object.time === "object")
                    message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
            if (object.size != null)
                message.size = object.size | 0;
            if (object.type != null)
                message.type = String(object.type);
            if (object.dayVolume != null)
                if ($util.Long)
                    (message.dayVolume = $util.Long.fromValue(object.dayVolume)).unsigned = false;
                else if (typeof object.dayVolume === "string")
                    message.dayVolume = parseInt(object.dayVolume, 10);
                else if (typeof object.dayVolume === "number")
                    message.dayVolume = object.dayVolume;
                else if (typeof object.dayVolume === "object")
                    message.dayVolume = new $util.LongBits(object.dayVolume.low >>> 0, object.dayVolume.high >>> 0).toNumber();
            if (object.askPrice != null)
                message.askPrice = Number(object.askPrice);
            if (object.bidPrice != null)
                message.bidPrice = Number(object.bidPrice);
            if (object.shareFloatDate != null)
                message.shareFloatDate = String(object.shareFloatDate);
            if (object.sharesOutstandingDate != null)
                message.sharesOutstandingDate = String(object.sharesOutstandingDate);
            if (object.shareFloat != null)
                if ($util.Long)
                    (message.shareFloat = $util.Long.fromValue(object.shareFloat)).unsigned = false;
                else if (typeof object.shareFloat === "string")
                    message.shareFloat = parseInt(object.shareFloat, 10);
                else if (typeof object.shareFloat === "number")
                    message.shareFloat = object.shareFloat;
                else if (typeof object.shareFloat === "object")
                    message.shareFloat = new $util.LongBits(object.shareFloat.low >>> 0, object.shareFloat.high >>> 0).toNumber();
            switch (object.updateType) {
            default:
                if (typeof object.updateType === "number") {
                    message.updateType = object.updateType;
                    break;
                }
                break;
            case "UNKNOWN":
            case 0:
                message.updateType = 0;
                break;
            case "VALID":
            case 1:
                message.updateType = 1;
                break;
            case "IN_VALID":
            case 2:
                message.updateType = 2;
                break;
            }
            if (object.subtype != null)
                message.subtype = String(object.subtype);
            switch (object.sessionType) {
            default:
                if (typeof object.sessionType === "number") {
                    message.sessionType = object.sessionType;
                    break;
                }
                break;
            case "NA":
            case 0:
                message.sessionType = 0;
                break;
            case "PRE_MARKET":
            case 1:
                message.sessionType = 1;
                break;
            case "REGULAR":
            case 2:
                message.sessionType = 2;
                break;
            case "AFTER_MARKET":
            case 3:
                message.sessionType = 3;
                break;
            }
            if (object.volume != null)
                if ($util.Long)
                    (message.volume = $util.Long.fromValue(object.volume)).unsigned = false;
                else if (typeof object.volume === "string")
                    message.volume = parseInt(object.volume, 10);
                else if (typeof object.volume === "number")
                    message.volume = object.volume;
                else if (typeof object.volume === "object")
                    message.volume = new $util.LongBits(object.volume.low >>> 0, object.volume.high >>> 0).toNumber();
            if (object.changePercent1Minute != null)
                message.changePercent1Minute = Number(object.changePercent1Minute);
            if (object.changePercentClose != null)
                message.changePercentClose = Number(object.changePercentClose);
            if (object.change5Minute != null)
                message.change5Minute = Number(object.change5Minute);
            if (object.changePercent5Minute != null)
                message.changePercent5Minute = Number(object.changePercent5Minute);
            if (object.volume1Minute != null)
                if ($util.Long)
                    (message.volume1Minute = $util.Long.fromValue(object.volume1Minute)).unsigned = false;
                else if (typeof object.volume1Minute === "string")
                    message.volume1Minute = parseInt(object.volume1Minute, 10);
                else if (typeof object.volume1Minute === "number")
                    message.volume1Minute = object.volume1Minute;
                else if (typeof object.volume1Minute === "object")
                    message.volume1Minute = new $util.LongBits(object.volume1Minute.low >>> 0, object.volume1Minute.high >>> 0).toNumber();
            if (object.relativeVolume1Minute != null)
                message.relativeVolume1Minute = Number(object.relativeVolume1Minute);
            if (object.change15Minute != null)
                message.change15Minute = Number(object.change15Minute);
            if (object.changePercent15Minute != null)
                message.changePercent15Minute = Number(object.changePercent15Minute);
            if (object.change30Minute != null)
                message.change30Minute = Number(object.change30Minute);
            if (object.changePercent30Minute != null)
                message.changePercent30Minute = Number(object.changePercent30Minute);
            if (object.change60Minute != null)
                message.change60Minute = Number(object.change60Minute);
            if (object.changePercent60Minute != null)
                message.changePercent60Minute = Number(object.changePercent60Minute);
            if (object.changePercentOpen != null)
                message.changePercentOpen = Number(object.changePercentOpen);
            if (object.changeOpen != null)
                message.changeOpen = Number(object.changeOpen);
            if (object.customChange != null)
                message.customChange = Number(object.customChange);
            if (object.customChangePercent != null)
                message.customChangePercent = Number(object.customChangePercent);
            if (object.customDate != null)
                if ($util.Long)
                    (message.customDate = $util.Long.fromValue(object.customDate)).unsigned = false;
                else if (typeof object.customDate === "string")
                    message.customDate = parseInt(object.customDate, 10);
                else if (typeof object.customDate === "number")
                    message.customDate = object.customDate;
                else if (typeof object.customDate === "object")
                    message.customDate = new $util.LongBits(object.customDate.low >>> 0, object.customDate.high >>> 0).toNumber();
            if (object.preMarketChange != null)
                message.preMarketChange = Number(object.preMarketChange);
            if (object.preMarketChangePercent != null)
                message.preMarketChangePercent = Number(object.preMarketChangePercent);
            if (object.afterMarketChange != null)
                message.afterMarketChange = Number(object.afterMarketChange);
            if (object.afterMarketChangePercent != null)
                message.afterMarketChangePercent = Number(object.afterMarketChangePercent);
            if (object.change1Month != null)
                message.change1Month = Number(object.change1Month);
            if (object.price3Month != null)
                message.price3Month = Number(object.price3Month);
            if (object.change3Month != null)
                message.change3Month = Number(object.change3Month);
            if (object.changePercent3Month != null)
                message.changePercent3Month = Number(object.changePercent3Month);
            if (object.price6Month != null)
                message.price6Month = Number(object.price6Month);
            if (object.change6Month != null)
                message.change6Month = Number(object.change6Month);
            if (object.changePercent6Month != null)
                message.changePercent6Month = Number(object.changePercent6Month);
            if (object.change1Year != null)
                message.change1Year = Number(object.change1Year);
            if (object.preMarketChange5Minute != null)
                message.preMarketChange5Minute = Number(object.preMarketChange5Minute);
            if (object.preMarketChangePercent5Minute != null)
                message.preMarketChangePercent5Minute = Number(object.preMarketChangePercent5Minute);
            if (object.preMarketChange15Minute != null)
                message.preMarketChange15Minute = Number(object.preMarketChange15Minute);
            if (object.preMarketChangePercent15Minute != null)
                message.preMarketChangePercent15Minute = Number(object.preMarketChangePercent15Minute);
            if (object.preMarketChange30Minute != null)
                message.preMarketChange30Minute = Number(object.preMarketChange30Minute);
            if (object.preMarketChangePercent30Minute != null)
                message.preMarketChangePercent30Minute = Number(object.preMarketChangePercent30Minute);
            if (object.preMarketChange60Minute != null)
                message.preMarketChange60Minute = Number(object.preMarketChange60Minute);
            if (object.preMarketChangePercent60Minute != null)
                message.preMarketChangePercent60Minute = Number(object.preMarketChangePercent60Minute);
            if (object.regularChange5Minute != null)
                message.regularChange5Minute = Number(object.regularChange5Minute);
            if (object.regularChangePercent5Minute != null)
                message.regularChangePercent5Minute = Number(object.regularChangePercent5Minute);
            if (object.regularChange15Minute != null)
                message.regularChange15Minute = Number(object.regularChange15Minute);
            if (object.regularChangePercent15Minute != null)
                message.regularChangePercent15Minute = Number(object.regularChangePercent15Minute);
            if (object.regularChange30Minute != null)
                message.regularChange30Minute = Number(object.regularChange30Minute);
            if (object.regularChangePercent30Minute != null)
                message.regularChangePercent30Minute = Number(object.regularChangePercent30Minute);
            if (object.regularChange60Minute != null)
                message.regularChange60Minute = Number(object.regularChange60Minute);
            if (object.regularChangePercent60Minute != null)
                message.regularChangePercent60Minute = Number(object.regularChangePercent60Minute);
            if (object.afterMarketChange5Minute != null)
                message.afterMarketChange5Minute = Number(object.afterMarketChange5Minute);
            if (object.afterMarketChangePercent5Minute != null)
                message.afterMarketChangePercent5Minute = Number(object.afterMarketChangePercent5Minute);
            if (object.afterMarketChange15Minute != null)
                message.afterMarketChange15Minute = Number(object.afterMarketChange15Minute);
            if (object.afterMarketChangePercent15Minute != null)
                message.afterMarketChangePercent15Minute = Number(object.afterMarketChangePercent15Minute);
            if (object.afterMarketChange30Minute != null)
                message.afterMarketChange30Minute = Number(object.afterMarketChange30Minute);
            if (object.afterMarketChangePercent30Minute != null)
                message.afterMarketChangePercent30Minute = Number(object.afterMarketChangePercent30Minute);
            if (object.afterMarketChange60Minute != null)
                message.afterMarketChange60Minute = Number(object.afterMarketChange60Minute);
            if (object.afterMarketChangePercent60Minute != null)
                message.afterMarketChangePercent60Minute = Number(object.afterMarketChangePercent60Minute);
            if (object.gics != null)
                message.gics = object.gics | 0;
            if (object.gicsSector != null)
                message.gicsSector = object.gicsSector | 0;
            if (object.gicsSectorName != null)
                message.gicsSectorName = String(object.gicsSectorName);
            if (object.gicsIndustryGroup != null)
                message.gicsIndustryGroup = object.gicsIndustryGroup | 0;
            if (object.gicsIndustryGroupName != null)
                message.gicsIndustryGroupName = String(object.gicsIndustryGroupName);
            if (object.gicsIndustry != null)
                message.gicsIndustry = object.gicsIndustry | 0;
            if (object.gicsIndustryName != null)
                message.gicsIndustryName = String(object.gicsIndustryName);
            if (object.gicsSubIndustry != null)
                message.gicsSubIndustry = object.gicsSubIndustry | 0;
            if (object.gicsSubIndustryName != null)
                message.gicsSubIndustryName = String(object.gicsSubIndustryName);
            if (object.optionable != null)
                message.optionable = object.optionable | 0;
            if (object.cik != null)
                message.cik = object.cik | 0;
            if (object.signalName != null)
                message.signalName = String(object.signalName);
            if (object.lastTradeTime != null)
                if ($util.Long)
                    (message.lastTradeTime = $util.Long.fromValue(object.lastTradeTime)).unsigned = false;
                else if (typeof object.lastTradeTime === "string")
                    message.lastTradeTime = parseInt(object.lastTradeTime, 10);
                else if (typeof object.lastTradeTime === "number")
                    message.lastTradeTime = object.lastTradeTime;
                else if (typeof object.lastTradeTime === "object")
                    message.lastTradeTime = new $util.LongBits(object.lastTradeTime.low >>> 0, object.lastTradeTime.high >>> 0).toNumber();
            if (object.country != null)
                message.country = String(object.country);
            if (object.sharesShort != null)
                if ($util.Long)
                    (message.sharesShort = $util.Long.fromValue(object.sharesShort)).unsigned = false;
                else if (typeof object.sharesShort === "string")
                    message.sharesShort = parseInt(object.sharesShort, 10);
                else if (typeof object.sharesShort === "number")
                    message.sharesShort = object.sharesShort;
                else if (typeof object.sharesShort === "object")
                    message.sharesShort = new $util.LongBits(object.sharesShort.low >>> 0, object.sharesShort.high >>> 0).toNumber();
            if (object.sharesShortPercentOfFloat != null)
                message.sharesShortPercentOfFloat = Number(object.sharesShortPercentOfFloat);
            if (object.sharesShortChangePercent != null)
                message.sharesShortChangePercent = Number(object.sharesShortChangePercent);
            if (object.sharesShortReceiptDate != null)
                if ($util.Long)
                    (message.sharesShortReceiptDate = $util.Long.fromValue(object.sharesShortReceiptDate)).unsigned = false;
                else if (typeof object.sharesShortReceiptDate === "string")
                    message.sharesShortReceiptDate = parseInt(object.sharesShortReceiptDate, 10);
                else if (typeof object.sharesShortReceiptDate === "number")
                    message.sharesShortReceiptDate = object.sharesShortReceiptDate;
                else if (typeof object.sharesShortReceiptDate === "object")
                    message.sharesShortReceiptDate = new $util.LongBits(object.sharesShortReceiptDate.low >>> 0, object.sharesShortReceiptDate.high >>> 0).toNumber();
            if (object.sharesShortSettlementDate != null)
                if ($util.Long)
                    (message.sharesShortSettlementDate = $util.Long.fromValue(object.sharesShortSettlementDate)).unsigned = false;
                else if (typeof object.sharesShortSettlementDate === "string")
                    message.sharesShortSettlementDate = parseInt(object.sharesShortSettlementDate, 10);
                else if (typeof object.sharesShortSettlementDate === "number")
                    message.sharesShortSettlementDate = object.sharesShortSettlementDate;
                else if (typeof object.sharesShortSettlementDate === "object")
                    message.sharesShortSettlementDate = new $util.LongBits(object.sharesShortSettlementDate.low >>> 0, object.sharesShortSettlementDate.high >>> 0).toNumber();
            if (object.shortInterestRatio != null)
                message.shortInterestRatio = Number(object.shortInterestRatio);
            if (object.sharesShortValue != null)
                message.sharesShortValue = Number(object.sharesShortValue);
            if (object.sharesShortPrevious != null)
                if ($util.Long)
                    (message.sharesShortPrevious = $util.Long.fromValue(object.sharesShortPrevious)).unsigned = false;
                else if (typeof object.sharesShortPrevious === "string")
                    message.sharesShortPrevious = parseInt(object.sharesShortPrevious, 10);
                else if (typeof object.sharesShortPrevious === "number")
                    message.sharesShortPrevious = object.sharesShortPrevious;
                else if (typeof object.sharesShortPrevious === "object")
                    message.sharesShortPrevious = new $util.LongBits(object.sharesShortPrevious.low >>> 0, object.sharesShortPrevious.high >>> 0).toNumber();
            if (object.sharesShortPreviousValue != null)
                message.sharesShortPreviousValue = Number(object.sharesShortPreviousValue);
            if (object.sharesShortPreviousPercentOfFloat != null)
                message.sharesShortPreviousPercentOfFloat = Number(object.sharesShortPreviousPercentOfFloat);
            if (object.sharesShortChange != null)
                if ($util.Long)
                    (message.sharesShortChange = $util.Long.fromValue(object.sharesShortChange)).unsigned = false;
                else if (typeof object.sharesShortChange === "string")
                    message.sharesShortChange = parseInt(object.sharesShortChange, 10);
                else if (typeof object.sharesShortChange === "number")
                    message.sharesShortChange = object.sharesShortChange;
                else if (typeof object.sharesShortChange === "object")
                    message.sharesShortChange = new $util.LongBits(object.sharesShortChange.low >>> 0, object.sharesShortChange.high >>> 0).toNumber();
            if (object.sentTime != null)
                if ($util.Long)
                    (message.sentTime = $util.Long.fromValue(object.sentTime)).unsigned = false;
                else if (typeof object.sentTime === "string")
                    message.sentTime = parseInt(object.sentTime, 10);
                else if (typeof object.sentTime === "number")
                    message.sentTime = object.sentTime;
                else if (typeof object.sentTime === "object")
                    message.sentTime = new $util.LongBits(object.sentTime.low >>> 0, object.sentTime.high >>> 0).toNumber();
            if (object.closeTime != null)
                if ($util.Long)
                    (message.closeTime = $util.Long.fromValue(object.closeTime)).unsigned = false;
                else if (typeof object.closeTime === "string")
                    message.closeTime = parseInt(object.closeTime, 10);
                else if (typeof object.closeTime === "number")
                    message.closeTime = object.closeTime;
                else if (typeof object.closeTime === "object")
                    message.closeTime = new $util.LongBits(object.closeTime.low >>> 0, object.closeTime.high >>> 0).toNumber();
            if (object.volume5Minute != null)
                if ($util.Long)
                    (message.volume5Minute = $util.Long.fromValue(object.volume5Minute)).unsigned = false;
                else if (typeof object.volume5Minute === "string")
                    message.volume5Minute = parseInt(object.volume5Minute, 10);
                else if (typeof object.volume5Minute === "number")
                    message.volume5Minute = object.volume5Minute;
                else if (typeof object.volume5Minute === "object")
                    message.volume5Minute = new $util.LongBits(object.volume5Minute.low >>> 0, object.volume5Minute.high >>> 0).toNumber();
            if (object.volume15Minute != null)
                if ($util.Long)
                    (message.volume15Minute = $util.Long.fromValue(object.volume15Minute)).unsigned = false;
                else if (typeof object.volume15Minute === "string")
                    message.volume15Minute = parseInt(object.volume15Minute, 10);
                else if (typeof object.volume15Minute === "number")
                    message.volume15Minute = object.volume15Minute;
                else if (typeof object.volume15Minute === "object")
                    message.volume15Minute = new $util.LongBits(object.volume15Minute.low >>> 0, object.volume15Minute.high >>> 0).toNumber();
            if (object.volume30Minute != null)
                if ($util.Long)
                    (message.volume30Minute = $util.Long.fromValue(object.volume30Minute)).unsigned = false;
                else if (typeof object.volume30Minute === "string")
                    message.volume30Minute = parseInt(object.volume30Minute, 10);
                else if (typeof object.volume30Minute === "number")
                    message.volume30Minute = object.volume30Minute;
                else if (typeof object.volume30Minute === "object")
                    message.volume30Minute = new $util.LongBits(object.volume30Minute.low >>> 0, object.volume30Minute.high >>> 0).toNumber();
            if (object.volume60Minute != null)
                if ($util.Long)
                    (message.volume60Minute = $util.Long.fromValue(object.volume60Minute)).unsigned = false;
                else if (typeof object.volume60Minute === "string")
                    message.volume60Minute = parseInt(object.volume60Minute, 10);
                else if (typeof object.volume60Minute === "number")
                    message.volume60Minute = object.volume60Minute;
                else if (typeof object.volume60Minute === "object")
                    message.volume60Minute = new $util.LongBits(object.volume60Minute.low >>> 0, object.volume60Minute.high >>> 0).toNumber();
            if (object.relativeVolume5Minute != null)
                message.relativeVolume5Minute = Number(object.relativeVolume5Minute);
            if (object.relativeVolume90Day != null)
                message.relativeVolume90Day = Number(object.relativeVolume90Day);
            if (object.rvol1m10d != null)
                message.rvol1m10d = Number(object.rvol1m10d);
            if (object.rvol5m10d != null)
                message.rvol5m10d = Number(object.rvol5m10d);
            if (object.rvol5m30d != null)
                message.rvol5m30d = Number(object.rvol5m30d);
            if (object.rvol5m90d != null)
                message.rvol5m90d = Number(object.rvol5m90d);
            if (object.averageVolume10Day != null)
                if ($util.Long)
                    (message.averageVolume10Day = $util.Long.fromValue(object.averageVolume10Day)).unsigned = false;
                else if (typeof object.averageVolume10Day === "string")
                    message.averageVolume10Day = parseInt(object.averageVolume10Day, 10);
                else if (typeof object.averageVolume10Day === "number")
                    message.averageVolume10Day = object.averageVolume10Day;
                else if (typeof object.averageVolume10Day === "object")
                    message.averageVolume10Day = new $util.LongBits(object.averageVolume10Day.low >>> 0, object.averageVolume10Day.high >>> 0).toNumber();
            if (object.averageVolumeChangePercent10Day != null)
                message.averageVolumeChangePercent10Day = Number(object.averageVolumeChangePercent10Day);
            if (object.high10Day != null)
                message.high10Day = Number(object.high10Day);
            if (object.highChangePercent10Day != null)
                message.highChangePercent10Day = Number(object.highChangePercent10Day);
            if (object.low10Day != null)
                message.low10Day = Number(object.low10Day);
            if (object.lowChangePercent10Day != null)
                message.lowChangePercent10Day = Number(object.lowChangePercent10Day);
            if (object.movingAverage10Day != null)
                message.movingAverage10Day = Number(object.movingAverage10Day);
            if (object.movingAverageChangePercent10Day != null)
                message.movingAverageChangePercent10Day = Number(object.movingAverageChangePercent10Day);
            if (object.averageVolume20Day != null)
                if ($util.Long)
                    (message.averageVolume20Day = $util.Long.fromValue(object.averageVolume20Day)).unsigned = false;
                else if (typeof object.averageVolume20Day === "string")
                    message.averageVolume20Day = parseInt(object.averageVolume20Day, 10);
                else if (typeof object.averageVolume20Day === "number")
                    message.averageVolume20Day = object.averageVolume20Day;
                else if (typeof object.averageVolume20Day === "object")
                    message.averageVolume20Day = new $util.LongBits(object.averageVolume20Day.low >>> 0, object.averageVolume20Day.high >>> 0).toNumber();
            if (object.averageVolumeChangePercent20Day != null)
                message.averageVolumeChangePercent20Day = Number(object.averageVolumeChangePercent20Day);
            if (object.high20Day != null)
                message.high20Day = Number(object.high20Day);
            if (object.highChangePercent20Day != null)
                message.highChangePercent20Day = Number(object.highChangePercent20Day);
            if (object.low20Day != null)
                message.low20Day = Number(object.low20Day);
            if (object.lowChangePercent20Day != null)
                message.lowChangePercent20Day = Number(object.lowChangePercent20Day);
            if (object.movingAverage20Day != null)
                message.movingAverage20Day = Number(object.movingAverage20Day);
            if (object.movingAverageChangePercent20Day != null)
                message.movingAverageChangePercent20Day = Number(object.movingAverageChangePercent20Day);
            if (object.averageVolume50Day != null)
                if ($util.Long)
                    (message.averageVolume50Day = $util.Long.fromValue(object.averageVolume50Day)).unsigned = false;
                else if (typeof object.averageVolume50Day === "string")
                    message.averageVolume50Day = parseInt(object.averageVolume50Day, 10);
                else if (typeof object.averageVolume50Day === "number")
                    message.averageVolume50Day = object.averageVolume50Day;
                else if (typeof object.averageVolume50Day === "object")
                    message.averageVolume50Day = new $util.LongBits(object.averageVolume50Day.low >>> 0, object.averageVolume50Day.high >>> 0).toNumber();
            if (object.averageVolumeChangePercent50Day != null)
                message.averageVolumeChangePercent50Day = Number(object.averageVolumeChangePercent50Day);
            if (object.high50Day != null)
                message.high50Day = Number(object.high50Day);
            if (object.highChangePercent50Day != null)
                message.highChangePercent50Day = Number(object.highChangePercent50Day);
            if (object.low50Day != null)
                message.low50Day = Number(object.low50Day);
            if (object.lowChangePercent50Day != null)
                message.lowChangePercent50Day = Number(object.lowChangePercent50Day);
            if (object.movingAverage50Day != null)
                message.movingAverage50Day = Number(object.movingAverage50Day);
            if (object.movingAverageChangePercent50Day != null)
                message.movingAverageChangePercent50Day = Number(object.movingAverageChangePercent50Day);
            if (object.averageVolume100Day != null)
                if ($util.Long)
                    (message.averageVolume100Day = $util.Long.fromValue(object.averageVolume100Day)).unsigned = false;
                else if (typeof object.averageVolume100Day === "string")
                    message.averageVolume100Day = parseInt(object.averageVolume100Day, 10);
                else if (typeof object.averageVolume100Day === "number")
                    message.averageVolume100Day = object.averageVolume100Day;
                else if (typeof object.averageVolume100Day === "object")
                    message.averageVolume100Day = new $util.LongBits(object.averageVolume100Day.low >>> 0, object.averageVolume100Day.high >>> 0).toNumber();
            if (object.averageVolumeChangePercent100Day != null)
                message.averageVolumeChangePercent100Day = Number(object.averageVolumeChangePercent100Day);
            if (object.high100Day != null)
                message.high100Day = Number(object.high100Day);
            if (object.highChangePercent100Day != null)
                message.highChangePercent100Day = Number(object.highChangePercent100Day);
            if (object.low100Day != null)
                message.low100Day = Number(object.low100Day);
            if (object.lowChangePercent100Day != null)
                message.lowChangePercent100Day = Number(object.lowChangePercent100Day);
            if (object.movingAverage100Day != null)
                message.movingAverage100Day = Number(object.movingAverage100Day);
            if (object.movingAverageChangePercent100Day != null)
                message.movingAverageChangePercent100Day = Number(object.movingAverageChangePercent100Day);
            if (object.averageVolume200Day != null)
                if ($util.Long)
                    (message.averageVolume200Day = $util.Long.fromValue(object.averageVolume200Day)).unsigned = false;
                else if (typeof object.averageVolume200Day === "string")
                    message.averageVolume200Day = parseInt(object.averageVolume200Day, 10);
                else if (typeof object.averageVolume200Day === "number")
                    message.averageVolume200Day = object.averageVolume200Day;
                else if (typeof object.averageVolume200Day === "object")
                    message.averageVolume200Day = new $util.LongBits(object.averageVolume200Day.low >>> 0, object.averageVolume200Day.high >>> 0).toNumber();
            if (object.averageVolumeChangePercent200Day != null)
                message.averageVolumeChangePercent200Day = Number(object.averageVolumeChangePercent200Day);
            if (object.high200Day != null)
                message.high200Day = Number(object.high200Day);
            if (object.highChangePercent200Day != null)
                message.highChangePercent200Day = Number(object.highChangePercent200Day);
            if (object.low200Day != null)
                message.low200Day = Number(object.low200Day);
            if (object.lowChangePercent200Day != null)
                message.lowChangePercent200Day = Number(object.lowChangePercent200Day);
            if (object.movingAverage200Day != null)
                message.movingAverage200Day = Number(object.movingAverage200Day);
            if (object.movingAverageChangePercent200Day != null)
                message.movingAverageChangePercent200Day = Number(object.movingAverageChangePercent200Day);
            if (object.movingAverage250Day != null)
                message.movingAverage250Day = Number(object.movingAverage250Day);
            if (object.movingAverageChangePercent250Day != null)
                message.movingAverageChangePercent250Day = Number(object.movingAverageChangePercent250Day);
            if (object.averageVolume90Day != null)
                if ($util.Long)
                    (message.averageVolume90Day = $util.Long.fromValue(object.averageVolume90Day)).unsigned = false;
                else if (typeof object.averageVolume90Day === "string")
                    message.averageVolume90Day = parseInt(object.averageVolume90Day, 10);
                else if (typeof object.averageVolume90Day === "number")
                    message.averageVolume90Day = object.averageVolume90Day;
                else if (typeof object.averageVolume90Day === "object")
                    message.averageVolume90Day = new $util.LongBits(object.averageVolume90Day.low >>> 0, object.averageVolume90Day.high >>> 0).toNumber();
            if (object.nextEarningsDate != null)
                message.nextEarningsDate = object.nextEarningsDate | 0;
            if (object.dividend != null)
                message.dividend = Number(object.dividend);
            if (object.dividendYield != null)
                message.dividendYield = Number(object.dividendYield);
            if (object.dividendExDate != null)
                message.dividendExDate = object.dividendExDate | 0;
            if (object.dividendFrequency != null)
                if ($util.Long)
                    (message.dividendFrequency = $util.Long.fromValue(object.dividendFrequency)).unsigned = false;
                else if (typeof object.dividendFrequency === "string")
                    message.dividendFrequency = parseInt(object.dividendFrequency, 10);
                else if (typeof object.dividendFrequency === "number")
                    message.dividendFrequency = object.dividendFrequency;
                else if (typeof object.dividendFrequency === "object")
                    message.dividendFrequency = new $util.LongBits(object.dividendFrequency.low >>> 0, object.dividendFrequency.high >>> 0).toNumber();
            if (object.forwardDividendYield != null)
                message.forwardDividendYield = Number(object.forwardDividendYield);
            if (object.roe != null)
                message.roe = Number(object.roe);
            if (object.roa != null)
                message.roa = Number(object.roa);
            if (object.roic != null)
                message.roic = Number(object.roic);
            if (object.currentRatio != null)
                message.currentRatio = Number(object.currentRatio);
            if (object.grossMargin != null)
                message.grossMargin = Number(object.grossMargin);
            if (object.netMargin != null)
                message.netMargin = Number(object.netMargin);
            if (object.operationMargin != null)
                message.operationMargin = Number(object.operationMargin);
            if (object.epsMrq != null)
                message.epsMrq = Number(object.epsMrq);
            if (object.epsTtm != null)
                message.epsTtm = Number(object.epsTtm);
            if (object.dilutedEpsMrq != null)
                message.dilutedEpsMrq = Number(object.dilutedEpsMrq);
            if (object.dilutedEpsTtm != null)
                message.dilutedEpsTtm = Number(object.dilutedEpsTtm);
            if (object.low52Week != null)
                message.low52Week = Number(object.low52Week);
            if (object.high52Week != null)
                message.high52Week = Number(object.high52Week);
            if (object.revenueTtm != null)
                message.revenueTtm = Number(object.revenueTtm);
            if (object.earningsAsOf != null)
                message.earningsAsOf = object.earningsAsOf | 0;
            if (object.netProfitMargin != null)
                message.netProfitMargin = Number(object.netProfitMargin);
            if (object.change1Week != null)
                message.change1Week = Number(object.change1Week);
            if (object.price1Week != null)
                message.price1Week = Number(object.price1Week);
            if (object.priceChangePercent1Week != null)
                message.priceChangePercent1Week = Number(object.priceChangePercent1Week);
            if (object.price1Month != null)
                message.price1Month = Number(object.price1Month);
            if (object.priceChangePercent1Month != null)
                message.priceChangePercent1Month = Number(object.priceChangePercent1Month);
            if (object.priceHalfYear != null)
                message.priceHalfYear = Number(object.priceHalfYear);
            if (object.priceChangePercentHalfYear != null)
                message.priceChangePercentHalfYear = Number(object.priceChangePercentHalfYear);
            if (object.priceQuarter != null)
                message.priceQuarter = Number(object.priceQuarter);
            if (object.priceChangePercentQuarter != null)
                message.priceChangePercentQuarter = Number(object.priceChangePercentQuarter);
            if (object.price1Year != null)
                message.price1Year = Number(object.price1Year);
            if (object.priceChangePercent1Year != null)
                message.priceChangePercent1Year = Number(object.priceChangePercent1Year);
            if (object.priceYearToDate != null)
                message.priceYearToDate = Number(object.priceYearToDate);
            if (object.priceChangePercentYearToDate != null)
                message.priceChangePercentYearToDate = Number(object.priceChangePercentYearToDate);
            if (object.roeMrq != null)
                message.roeMrq = Number(object.roeMrq);
            if (object.roaMrq != null)
                message.roaMrq = Number(object.roaMrq);
            if (object.roicMrq != null)
                message.roicMrq = Number(object.roicMrq);
            if (object.currentRatioMrq != null)
                message.currentRatioMrq = Number(object.currentRatioMrq);
            if (object.grossMarginMrq != null)
                message.grossMarginMrq = Number(object.grossMarginMrq);
            if (object.netMarginMrq != null)
                message.netMarginMrq = Number(object.netMarginMrq);
            if (object.operationMarginMrq != null)
                message.operationMarginMrq = Number(object.operationMarginMrq);
            if (object.previousDayVolume != null)
                if ($util.Long)
                    (message.previousDayVolume = $util.Long.fromValue(object.previousDayVolume)).unsigned = false;
                else if (typeof object.previousDayVolume === "string")
                    message.previousDayVolume = parseInt(object.previousDayVolume, 10);
                else if (typeof object.previousDayVolume === "number")
                    message.previousDayVolume = object.previousDayVolume;
                else if (typeof object.previousDayVolume === "object")
                    message.previousDayVolume = new $util.LongBits(object.previousDayVolume.low >>> 0, object.previousDayVolume.high >>> 0).toNumber();
            if (object.previousDayAtr != null)
                message.previousDayAtr = Number(object.previousDayAtr);
            if (object.previousDayAdx != null)
                message.previousDayAdx = Number(object.previousDayAdx);
            if (object.previousDayPlusDMSmoothed != null)
                message.previousDayPlusDMSmoothed = Number(object.previousDayPlusDMSmoothed);
            if (object.previousDayMinusDMSmoothed != null)
                message.previousDayMinusDMSmoothed = Number(object.previousDayMinusDMSmoothed);
            if (object.previousDayHigh != null)
                message.previousDayHigh = Number(object.previousDayHigh);
            if (object.previousDayLow != null)
                message.previousDayLow = Number(object.previousDayLow);
            if (object.adx != null)
                message.adx = Number(object.adx);
            if (object.percentInstitutionalOwnership != null)
                message.percentInstitutionalOwnership = Number(object.percentInstitutionalOwnership);
            if (object.percentInstitutionalTransactions != null)
                message.percentInstitutionalTransactions = Number(object.percentInstitutionalTransactions);
            if (object.wiim != null)
                message.wiim = String(object.wiim);
            if (object.wiimAsOf != null)
                if ($util.Long)
                    (message.wiimAsOf = $util.Long.fromValue(object.wiimAsOf)).unsigned = false;
                else if (typeof object.wiimAsOf === "string")
                    message.wiimAsOf = parseInt(object.wiimAsOf, 10);
                else if (typeof object.wiimAsOf === "number")
                    message.wiimAsOf = object.wiimAsOf;
                else if (typeof object.wiimAsOf === "object")
                    message.wiimAsOf = new $util.LongBits(object.wiimAsOf.low >>> 0, object.wiimAsOf.high >>> 0).toNumber();
            if (object.vwap != null)
                message.vwap = Number(object.vwap);
            if (object.vwapChangePercent != null)
                message.vwapChangePercent = Number(object.vwapChangePercent);
            if (object.vwapChange != null)
                message.vwapChange = Number(object.vwapChange);
            if (object.rsiAvgGain != null)
                message.rsiAvgGain = Number(object.rsiAvgGain);
            if (object.rsiAvgLoss != null)
                message.rsiAvgLoss = Number(object.rsiAvgLoss);
            if (object.halted != null)
                message.halted = String(object.halted);
            if (object.tradeCount != null)
                if ($util.Long)
                    (message.tradeCount = $util.Long.fromValue(object.tradeCount)).unsigned = false;
                else if (typeof object.tradeCount === "string")
                    message.tradeCount = parseInt(object.tradeCount, 10);
                else if (typeof object.tradeCount === "number")
                    message.tradeCount = object.tradeCount;
                else if (typeof object.tradeCount === "object")
                    message.tradeCount = new $util.LongBits(object.tradeCount.low >>> 0, object.tradeCount.high >>> 0).toNumber();
            if (object.regularHighCount != null)
                if ($util.Long)
                    (message.regularHighCount = $util.Long.fromValue(object.regularHighCount)).unsigned = false;
                else if (typeof object.regularHighCount === "string")
                    message.regularHighCount = parseInt(object.regularHighCount, 10);
                else if (typeof object.regularHighCount === "number")
                    message.regularHighCount = object.regularHighCount;
                else if (typeof object.regularHighCount === "object")
                    message.regularHighCount = new $util.LongBits(object.regularHighCount.low >>> 0, object.regularHighCount.high >>> 0).toNumber();
            if (object.regularLowCount != null)
                if ($util.Long)
                    (message.regularLowCount = $util.Long.fromValue(object.regularLowCount)).unsigned = false;
                else if (typeof object.regularLowCount === "string")
                    message.regularLowCount = parseInt(object.regularLowCount, 10);
                else if (typeof object.regularLowCount === "number")
                    message.regularLowCount = object.regularLowCount;
                else if (typeof object.regularLowCount === "object")
                    message.regularLowCount = new $util.LongBits(object.regularLowCount.low >>> 0, object.regularLowCount.high >>> 0).toNumber();
            if (object.preMarketHighCount != null)
                if ($util.Long)
                    (message.preMarketHighCount = $util.Long.fromValue(object.preMarketHighCount)).unsigned = false;
                else if (typeof object.preMarketHighCount === "string")
                    message.preMarketHighCount = parseInt(object.preMarketHighCount, 10);
                else if (typeof object.preMarketHighCount === "number")
                    message.preMarketHighCount = object.preMarketHighCount;
                else if (typeof object.preMarketHighCount === "object")
                    message.preMarketHighCount = new $util.LongBits(object.preMarketHighCount.low >>> 0, object.preMarketHighCount.high >>> 0).toNumber();
            if (object.preMarketLowCount != null)
                if ($util.Long)
                    (message.preMarketLowCount = $util.Long.fromValue(object.preMarketLowCount)).unsigned = false;
                else if (typeof object.preMarketLowCount === "string")
                    message.preMarketLowCount = parseInt(object.preMarketLowCount, 10);
                else if (typeof object.preMarketLowCount === "number")
                    message.preMarketLowCount = object.preMarketLowCount;
                else if (typeof object.preMarketLowCount === "object")
                    message.preMarketLowCount = new $util.LongBits(object.preMarketLowCount.low >>> 0, object.preMarketLowCount.high >>> 0).toNumber();
            if (object.afterMarketHighCount != null)
                if ($util.Long)
                    (message.afterMarketHighCount = $util.Long.fromValue(object.afterMarketHighCount)).unsigned = false;
                else if (typeof object.afterMarketHighCount === "string")
                    message.afterMarketHighCount = parseInt(object.afterMarketHighCount, 10);
                else if (typeof object.afterMarketHighCount === "number")
                    message.afterMarketHighCount = object.afterMarketHighCount;
                else if (typeof object.afterMarketHighCount === "object")
                    message.afterMarketHighCount = new $util.LongBits(object.afterMarketHighCount.low >>> 0, object.afterMarketHighCount.high >>> 0).toNumber();
            if (object.afterMarketLowCount != null)
                if ($util.Long)
                    (message.afterMarketLowCount = $util.Long.fromValue(object.afterMarketLowCount)).unsigned = false;
                else if (typeof object.afterMarketLowCount === "string")
                    message.afterMarketLowCount = parseInt(object.afterMarketLowCount, 10);
                else if (typeof object.afterMarketLowCount === "number")
                    message.afterMarketLowCount = object.afterMarketLowCount;
                else if (typeof object.afterMarketLowCount === "object")
                    message.afterMarketLowCount = new $util.LongBits(object.afterMarketLowCount.low >>> 0, object.afterMarketLowCount.high >>> 0).toNumber();
            if (object.dayHighCount != null)
                if ($util.Long)
                    (message.dayHighCount = $util.Long.fromValue(object.dayHighCount)).unsigned = false;
                else if (typeof object.dayHighCount === "string")
                    message.dayHighCount = parseInt(object.dayHighCount, 10);
                else if (typeof object.dayHighCount === "number")
                    message.dayHighCount = object.dayHighCount;
                else if (typeof object.dayHighCount === "object")
                    message.dayHighCount = new $util.LongBits(object.dayHighCount.low >>> 0, object.dayHighCount.high >>> 0).toNumber();
            if (object.dayLowCount != null)
                if ($util.Long)
                    (message.dayLowCount = $util.Long.fromValue(object.dayLowCount)).unsigned = false;
                else if (typeof object.dayLowCount === "string")
                    message.dayLowCount = parseInt(object.dayLowCount, 10);
                else if (typeof object.dayLowCount === "number")
                    message.dayLowCount = object.dayLowCount;
                else if (typeof object.dayLowCount === "object")
                    message.dayLowCount = new $util.LongBits(object.dayLowCount.low >>> 0, object.dayLowCount.high >>> 0).toNumber();
            if (object.dayHigh != null)
                message.dayHigh = Number(object.dayHigh);
            if (object.dayLow != null)
                message.dayLow = Number(object.dayLow);
            if (object.preMarketHigh != null)
                message.preMarketHigh = Number(object.preMarketHigh);
            if (object.preMarketLow != null)
                message.preMarketLow = Number(object.preMarketLow);
            if (object.afterMarketHigh != null)
                message.afterMarketHigh = Number(object.afterMarketHigh);
            if (object.afterMarketLow != null)
                message.afterMarketLow = Number(object.afterMarketLow);
            if (object.regularHigh != null)
                message.regularHigh = Number(object.regularHigh);
            if (object.regularLow != null)
                message.regularLow = Number(object.regularLow);
            if (object.priceSpikeUpCount != null)
                if ($util.Long)
                    (message.priceSpikeUpCount = $util.Long.fromValue(object.priceSpikeUpCount)).unsigned = false;
                else if (typeof object.priceSpikeUpCount === "string")
                    message.priceSpikeUpCount = parseInt(object.priceSpikeUpCount, 10);
                else if (typeof object.priceSpikeUpCount === "number")
                    message.priceSpikeUpCount = object.priceSpikeUpCount;
                else if (typeof object.priceSpikeUpCount === "object")
                    message.priceSpikeUpCount = new $util.LongBits(object.priceSpikeUpCount.low >>> 0, object.priceSpikeUpCount.high >>> 0).toNumber();
            if (object.priceSpikeDownCount != null)
                if ($util.Long)
                    (message.priceSpikeDownCount = $util.Long.fromValue(object.priceSpikeDownCount)).unsigned = false;
                else if (typeof object.priceSpikeDownCount === "string")
                    message.priceSpikeDownCount = parseInt(object.priceSpikeDownCount, 10);
                else if (typeof object.priceSpikeDownCount === "number")
                    message.priceSpikeDownCount = object.priceSpikeDownCount;
                else if (typeof object.priceSpikeDownCount === "object")
                    message.priceSpikeDownCount = new $util.LongBits(object.priceSpikeDownCount.low >>> 0, object.priceSpikeDownCount.high >>> 0).toNumber();
            if (object.haltedCount != null)
                if ($util.Long)
                    (message.haltedCount = $util.Long.fromValue(object.haltedCount)).unsigned = false;
                else if (typeof object.haltedCount === "string")
                    message.haltedCount = parseInt(object.haltedCount, 10);
                else if (typeof object.haltedCount === "number")
                    message.haltedCount = object.haltedCount;
                else if (typeof object.haltedCount === "object")
                    message.haltedCount = new $util.LongBits(object.haltedCount.low >>> 0, object.haltedCount.high >>> 0).toNumber();
            if (object.usCongressTotal != null)
                message.usCongressTotal = Number(object.usCongressTotal);
            if (object.usCongressRepublicansTotal != null)
                message.usCongressRepublicansTotal = Number(object.usCongressRepublicansTotal);
            if (object.usCongressDemocratsTotal != null)
                message.usCongressDemocratsTotal = Number(object.usCongressDemocratsTotal);
            if (object.usCongressOtherTotal != null)
                message.usCongressOtherTotal = Number(object.usCongressOtherTotal);
            if (object.volumeFloatRatio != null)
                message.volumeFloatRatio = Number(object.volumeFloatRatio);
            if (object.atrp != null)
                message.atrp = Number(object.atrp);
            if (object.ytdGainLoss != null)
                message.ytdGainLoss = Number(object.ytdGainLoss);
            if (object.mtdGainLoss != null)
                message.mtdGainLoss = Number(object.mtdGainLoss);
            if (object.ytdChange != null)
                message.ytdChange = Number(object.ytdChange);
            if (object.mtdChange != null)
                message.mtdChange = Number(object.mtdChange);
            if (object.yearOpen != null)
                message.yearOpen = Number(object.yearOpen);
            if (object.monthOpen != null)
                message.monthOpen = Number(object.monthOpen);
            if (object.volumeFloatPercent != null)
                message.volumeFloatPercent = Number(object.volumeFloatPercent);
            if (object.rsi1m != null)
                message.rsi1m = Number(object.rsi1m);
            if (object.rsi2m != null)
                message.rsi2m = Number(object.rsi2m);
            if (object.rsi5m != null)
                message.rsi5m = Number(object.rsi5m);
            if (object.rsi15m != null)
                message.rsi15m = Number(object.rsi15m);
            if (object.rsi30m != null)
                message.rsi30m = Number(object.rsi30m);
            if (object.rsi60m != null)
                message.rsi60m = Number(object.rsi60m);
            if (object.rsiEth1m != null)
                message.rsiEth1m = Number(object.rsiEth1m);
            if (object.rsiEth2m != null)
                message.rsiEth2m = Number(object.rsiEth2m);
            if (object.rsiEth5m != null)
                message.rsiEth5m = Number(object.rsiEth5m);
            if (object.rsiEth15m != null)
                message.rsiEth15m = Number(object.rsiEth15m);
            if (object.rsiEth30m != null)
                message.rsiEth30m = Number(object.rsiEth30m);
            if (object.rsiEth60m != null)
                message.rsiEth60m = Number(object.rsiEth60m);
            if (object.averageDollarVolume10Day != null)
                message.averageDollarVolume10Day = Number(object.averageDollarVolume10Day);
            if (object.averageVolume60Day != null)
                if ($util.Long)
                    (message.averageVolume60Day = $util.Long.fromValue(object.averageVolume60Day)).unsigned = false;
                else if (typeof object.averageVolume60Day === "string")
                    message.averageVolume60Day = parseInt(object.averageVolume60Day, 10);
                else if (typeof object.averageVolume60Day === "number")
                    message.averageVolume60Day = object.averageVolume60Day;
                else if (typeof object.averageVolume60Day === "object")
                    message.averageVolume60Day = new $util.LongBits(object.averageVolume60Day.low >>> 0, object.averageVolume60Day.high >>> 0).toNumber();
            if (object.relativeVolumePercent60Day != null)
                message.relativeVolumePercent60Day = Number(object.relativeVolumePercent60Day);
            if (object.rsi1mLowest != null)
                message.rsi1mLowest = Number(object.rsi1mLowest);
            if (object.rsi2mLowest != null)
                message.rsi2mLowest = Number(object.rsi2mLowest);
            if (object.rsi5mLowest != null)
                message.rsi5mLowest = Number(object.rsi5mLowest);
            if (object.rsi15mLowest != null)
                message.rsi15mLowest = Number(object.rsi15mLowest);
            if (object.rsi30mLowest != null)
                message.rsi30mLowest = Number(object.rsi30mLowest);
            if (object.rsi60mLowest != null)
                message.rsi60mLowest = Number(object.rsi60mLowest);
            if (object.rsiEth1mLowest != null)
                message.rsiEth1mLowest = Number(object.rsiEth1mLowest);
            if (object.rsiEth2mLowest != null)
                message.rsiEth2mLowest = Number(object.rsiEth2mLowest);
            if (object.rsiEth5mLowest != null)
                message.rsiEth5mLowest = Number(object.rsiEth5mLowest);
            if (object.rsiEth15mLowest != null)
                message.rsiEth15mLowest = Number(object.rsiEth15mLowest);
            if (object.rsiEth30mLowest != null)
                message.rsiEth30mLowest = Number(object.rsiEth30mLowest);
            if (object.rsiEth60mLowest != null)
                message.rsiEth60mLowest = Number(object.rsiEth60mLowest);
            if (object.rsi1mGreatest != null)
                message.rsi1mGreatest = Number(object.rsi1mGreatest);
            if (object.rsi2mGreatest != null)
                message.rsi2mGreatest = Number(object.rsi2mGreatest);
            if (object.rsi5mGreatest != null)
                message.rsi5mGreatest = Number(object.rsi5mGreatest);
            if (object.rsi15mGreatest != null)
                message.rsi15mGreatest = Number(object.rsi15mGreatest);
            if (object.rsi30mGreatest != null)
                message.rsi30mGreatest = Number(object.rsi30mGreatest);
            if (object.rsi60mGreatest != null)
                message.rsi60mGreatest = Number(object.rsi60mGreatest);
            if (object.rsiEth1mGreatest != null)
                message.rsiEth1mGreatest = Number(object.rsiEth1mGreatest);
            if (object.rsiEth2mGreatest != null)
                message.rsiEth2mGreatest = Number(object.rsiEth2mGreatest);
            if (object.rsiEth5mGreatest != null)
                message.rsiEth5mGreatest = Number(object.rsiEth5mGreatest);
            if (object.rsiEth15mGreatest != null)
                message.rsiEth15mGreatest = Number(object.rsiEth15mGreatest);
            if (object.rsiEth30mGreatest != null)
                message.rsiEth30mGreatest = Number(object.rsiEth30mGreatest);
            if (object.rsiEth60mGreatest != null)
                message.rsiEth60mGreatest = Number(object.rsiEth60mGreatest);
            if (object.rsiCrossOver != null)
                message.rsiCrossOver = Number(object.rsiCrossOver);
            if (object.ema12d != null)
                message.ema12d = Number(object.ema12d);
            if (object.ema26d != null)
                message.ema26d = Number(object.ema26d);
            if (object.macd != null)
                message.macd = Number(object.macd);
            if (object.macdSignalLine != null)
                message.macdSignalLine = Number(object.macdSignalLine);
            if (object.macdHistogram != null)
                message.macdHistogram = Number(object.macdHistogram);
            if (object.macdSignalLineBase != null)
                message.macdSignalLineBase = Number(object.macdSignalLineBase);
            if (object.dividendGrowthRate1Year != null)
                message.dividendGrowthRate1Year = Number(object.dividendGrowthRate1Year);
            if (object.dividendGrowthRate3Year != null)
                message.dividendGrowthRate3Year = Number(object.dividendGrowthRate3Year);
            if (object.dividendGrowthRate5Year != null)
                message.dividendGrowthRate5Year = Number(object.dividendGrowthRate5Year);
            if (object.totalDividendTtm != null)
                message.totalDividendTtm = Number(object.totalDividendTtm);
            if (object.dividendIncreasing != null)
                message.dividendIncreasing = object.dividendIncreasing | 0;
            if (object.newsBzWireTitle != null)
                message.newsBzWireTitle = String(object.newsBzWireTitle);
            if (object.newsBzWireNodeId != null)
                message.newsBzWireNodeId = String(object.newsBzWireNodeId);
            if (object.newsBzWireTimestamp != null)
                if ($util.Long)
                    (message.newsBzWireTimestamp = $util.Long.fromValue(object.newsBzWireTimestamp)).unsigned = false;
                else if (typeof object.newsBzWireTimestamp === "string")
                    message.newsBzWireTimestamp = parseInt(object.newsBzWireTimestamp, 10);
                else if (typeof object.newsBzWireTimestamp === "number")
                    message.newsBzWireTimestamp = object.newsBzWireTimestamp;
                else if (typeof object.newsBzWireTimestamp === "object")
                    message.newsBzWireTimestamp = new $util.LongBits(object.newsBzWireTimestamp.low >>> 0, object.newsBzWireTimestamp.high >>> 0).toNumber();
            if (object.newsPRTitle != null)
                message.newsPRTitle = String(object.newsPRTitle);
            if (object.newsPRNodeId != null)
                message.newsPRNodeId = String(object.newsPRNodeId);
            if (object.newsPRTimestamp != null)
                if ($util.Long)
                    (message.newsPRTimestamp = $util.Long.fromValue(object.newsPRTimestamp)).unsigned = false;
                else if (typeof object.newsPRTimestamp === "string")
                    message.newsPRTimestamp = parseInt(object.newsPRTimestamp, 10);
                else if (typeof object.newsPRTimestamp === "number")
                    message.newsPRTimestamp = object.newsPRTimestamp;
                else if (typeof object.newsPRTimestamp === "object")
                    message.newsPRTimestamp = new $util.LongBits(object.newsPRTimestamp.low >>> 0, object.newsPRTimestamp.high >>> 0).toNumber();
            if (object.newsSecTitle != null)
                message.newsSecTitle = String(object.newsSecTitle);
            if (object.newsSecNodeId != null)
                message.newsSecNodeId = String(object.newsSecNodeId);
            if (object.newsSecTimestamp != null)
                if ($util.Long)
                    (message.newsSecTimestamp = $util.Long.fromValue(object.newsSecTimestamp)).unsigned = false;
                else if (typeof object.newsSecTimestamp === "string")
                    message.newsSecTimestamp = parseInt(object.newsSecTimestamp, 10);
                else if (typeof object.newsSecTimestamp === "number")
                    message.newsSecTimestamp = object.newsSecTimestamp;
                else if (typeof object.newsSecTimestamp === "object")
                    message.newsSecTimestamp = new $util.LongBits(object.newsSecTimestamp.low >>> 0, object.newsSecTimestamp.high >>> 0).toNumber();
            if (object.newsBzWireTitleWithNodeId != null)
                message.newsBzWireTitleWithNodeId = String(object.newsBzWireTitleWithNodeId);
            if (object.newsPRTitleWithNodeId != null)
                message.newsPRTitleWithNodeId = String(object.newsPRTitleWithNodeId);
            if (object.newsSecTitleWithNodeId != null)
                message.newsSecTitleWithNodeId = String(object.newsSecTitleWithNodeId);
            if (object.movingAverage500Day != null)
                message.movingAverage500Day = Number(object.movingAverage500Day);
            if (object.gapChange != null)
                message.gapChange = Number(object.gapChange);
            if (object.gapChangePercent != null)
                message.gapChangePercent = Number(object.gapChangePercent);
            if (object.adr14d != null)
                message.adr14d = Number(object.adr14d);
            if (object.dilutedEpsMrqSurprisePercent != null)
                message.dilutedEpsMrqSurprisePercent = Number(object.dilutedEpsMrqSurprisePercent);
            if (object.dilutedEpsTtmSurprisePercent != null)
                message.dilutedEpsTtmSurprisePercent = Number(object.dilutedEpsTtmSurprisePercent);
            if (object.dilutedRevenueMrqSurprisePercent != null)
                message.dilutedRevenueMrqSurprisePercent = Number(object.dilutedRevenueMrqSurprisePercent);
            if (object.dilutedRevenueTtmSurprisePercent != null)
                message.dilutedRevenueTtmSurprisePercent = Number(object.dilutedRevenueTtmSurprisePercent);
            if (object.epsGrowthTtm != null)
                message.epsGrowthTtm = Number(object.epsGrowthTtm);
            if (object.epsGrowthY2Y != null)
                message.epsGrowthY2Y = Number(object.epsGrowthY2Y);
            if (object.epsGrowthQ2Q != null)
                message.epsGrowthQ2Q = Number(object.epsGrowthQ2Q);
            if (object.epsGrowth5Year != null)
                message.epsGrowth5Year = Number(object.epsGrowth5Year);
            if (object.epsGrowthYearAgoQ != null)
                message.epsGrowthYearAgoQ = Number(object.epsGrowthYearAgoQ);
            if (object.revenueGrowthTtm != null)
                message.revenueGrowthTtm = Number(object.revenueGrowthTtm);
            if (object.revenueGrowthY2Y != null)
                message.revenueGrowthY2Y = Number(object.revenueGrowthY2Y);
            if (object.revenueGrowthQ2Q != null)
                message.revenueGrowthQ2Q = Number(object.revenueGrowthQ2Q);
            if (object.revenueGrowth5Year != null)
                message.revenueGrowth5Year = Number(object.revenueGrowth5Year);
            if (object.revenueGrowthYearAgoQ != null)
                message.revenueGrowthYearAgoQ = Number(object.revenueGrowthYearAgoQ);
            if (object.ltDebtEquity != null)
                message.ltDebtEquity = Number(object.ltDebtEquity);
            if (object.bullsSay != null)
                message.bullsSay = String(object.bullsSay);
            if (object.bearsSay != null)
                message.bearsSay = String(object.bearsSay);
            if (object.ipoDateNumber != null)
                if ($util.Long)
                    (message.ipoDateNumber = $util.Long.fromValue(object.ipoDateNumber)).unsigned = false;
                else if (typeof object.ipoDateNumber === "string")
                    message.ipoDateNumber = parseInt(object.ipoDateNumber, 10);
                else if (typeof object.ipoDateNumber === "number")
                    message.ipoDateNumber = object.ipoDateNumber;
                else if (typeof object.ipoDateNumber === "object")
                    message.ipoDateNumber = new $util.LongBits(object.ipoDateNumber.low >>> 0, object.ipoDateNumber.high >>> 0).toNumber();
            if (object.ffoPerShare != null)
                message.ffoPerShare = Number(object.ffoPerShare);
            if (object.quickRatioMrq != null)
                message.quickRatioMrq = Number(object.quickRatioMrq);
            if (object.highAllTime != null)
                message.highAllTime = Number(object.highAllTime);
            if (object.lowAllTime != null)
                message.lowAllTime = Number(object.lowAllTime);
            if (object.evToEbitda != null)
                message.evToEbitda = Number(object.evToEbitda);
            if (object.totalDebtEquityRatio != null)
                message.totalDebtEquityRatio = Number(object.totalDebtEquityRatio);
            if (object.dividendPayoutRatio != null)
                message.dividendPayoutRatio = Number(object.dividendPayoutRatio);
            if (object.operatingCashFlow != null)
                message.operatingCashFlow = Number(object.operatingCashFlow);
            if (object.insiderPercentage != null)
                message.insiderPercentage = Number(object.insiderPercentage);
            if (object.priceToCashFlowRatio != null)
                message.priceToCashFlowRatio = Number(object.priceToCashFlowRatio);
            if (object.regularHoursChange != null)
                message.regularHoursChange = Number(object.regularHoursChange);
            if (object.regularHoursPercentChange != null)
                message.regularHoursPercentChange = Number(object.regularHoursPercentChange);
            if (object.postToPreHoursChange != null)
                message.postToPreHoursChange = Number(object.postToPreHoursChange);
            if (object.postToPreHoursPercentChange != null)
                message.postToPreHoursPercentChange = Number(object.postToPreHoursPercentChange);
            if (object.scannerClose != null)
                message.scannerClose = Number(object.scannerClose);
            if (object.scannerChange != null)
                message.scannerChange = Number(object.scannerChange);
            if (object.scannerChangePercent != null)
                message.scannerChangePercent = Number(object.scannerChangePercent);
            if (object.scannerChangePercentClose != null)
                message.scannerChangePercentClose = Number(object.scannerChangePercentClose);
            if (object.scannerPreviousClose != null)
                message.scannerPreviousClose = Number(object.scannerPreviousClose);
            if (object.freeCashFlow != null)
                message.freeCashFlow = Number(object.freeCashFlow);
            if (object.minPriceTarget != null)
                message.minPriceTarget = Number(object.minPriceTarget);
            if (object.maxPriceTarget != null)
                message.maxPriceTarget = Number(object.maxPriceTarget);
            if (object.meanPriceTarget != null)
                message.meanPriceTarget = Number(object.meanPriceTarget);
            if (object.totalNumberOfAnalyst != null)
                message.totalNumberOfAnalyst = Number(object.totalNumberOfAnalyst);
            if (object.averageAnalystRecommendation != null)
                message.averageAnalystRecommendation = String(object.averageAnalystRecommendation);
            if (object.pegRatio != null)
                message.pegRatio = Number(object.pegRatio);
            if (object.priceToFreeCashFlowRatio != null)
                message.priceToFreeCashFlowRatio = Number(object.priceToFreeCashFlowRatio);
            if (object.distanceToMaxPriceTarget != null)
                message.distanceToMaxPriceTarget = Number(object.distanceToMaxPriceTarget);
            if (object.distanceToMinPriceTarget != null)
                message.distanceToMinPriceTarget = Number(object.distanceToMinPriceTarget);
            if (object.distanceToMeanPriceTarget != null)
                message.distanceToMeanPriceTarget = Number(object.distanceToMeanPriceTarget);
            if (object.shortTermTrend != null)
                message.shortTermTrend = String(object.shortTermTrend);
            if (object.mediumTermTrend != null)
                message.mediumTermTrend = String(object.mediumTermTrend);
            if (object.longTermTrend != null)
                message.longTermTrend = String(object.longTermTrend);
            if (object.twentySixWeekChange != null)
                message.twentySixWeekChange = Number(object.twentySixWeekChange);
            if (object.fiftyTwoWeekChange != null)
                message.fiftyTwoWeekChange = Number(object.fiftyTwoWeekChange);
            if (object.annualizedStandardDeviation != null)
                message.annualizedStandardDeviation = Number(object.annualizedStandardDeviation);
            if (object.momentum != null)
                message.momentum = Number(object.momentum);
            if (object.value != null)
                message.value = Number(object.value);
            if (object.piotroskiFScore != null)
                if ($util.Long)
                    (message.piotroskiFScore = $util.Long.fromValue(object.piotroskiFScore)).unsigned = false;
                else if (typeof object.piotroskiFScore === "string")
                    message.piotroskiFScore = parseInt(object.piotroskiFScore, 10);
                else if (typeof object.piotroskiFScore === "number")
                    message.piotroskiFScore = object.piotroskiFScore;
                else if (typeof object.piotroskiFScore === "object")
                    message.piotroskiFScore = new $util.LongBits(object.piotroskiFScore.low >>> 0, object.piotroskiFScore.high >>> 0).toNumber();
            if (object.netIncomeTtm != null)
                message.netIncomeTtm = Number(object.netIncomeTtm);
            if (object.currentRatioYearAgo != null)
                message.currentRatioYearAgo = Number(object.currentRatioYearAgo);
            if (object.roaYearAgo != null)
                message.roaYearAgo = Number(object.roaYearAgo);
            if (object.grossMarginYearAgo != null)
                message.grossMarginYearAgo = Number(object.grossMarginYearAgo);
            if (object.longTermDebt != null)
                message.longTermDebt = Number(object.longTermDebt);
            if (object.longTermDebtYearAgo != null)
                message.longTermDebtYearAgo = Number(object.longTermDebtYearAgo);
            if (object.shareIssued != null)
                message.shareIssued = Number(object.shareIssued);
            if (object.shareIssuedYearAgo != null)
                message.shareIssuedYearAgo = Number(object.shareIssuedYearAgo);
            if (object.totalAssets != null)
                message.totalAssets = Number(object.totalAssets);
            if (object.totalAssetsYearAgo != null)
                message.totalAssetsYearAgo = Number(object.totalAssetsYearAgo);
            if (object.totalAssets2YearAgo != null)
                message.totalAssets2YearAgo = Number(object.totalAssets2YearAgo);
            if (object.revenueTtmYearAgo != null)
                message.revenueTtmYearAgo = Number(object.revenueTtmYearAgo);
            if (object.longTermDebtAndCapitalLeaseObligation != null)
                message.longTermDebtAndCapitalLeaseObligation = Number(object.longTermDebtAndCapitalLeaseObligation);
            if (object.averageTotalAssets != null)
                message.averageTotalAssets = Number(object.averageTotalAssets);
            if (object.averageTotalAssetsYearAgo != null)
                message.averageTotalAssetsYearAgo = Number(object.averageTotalAssetsYearAgo);
            if (object.growth != null)
                message.growth = Number(object.growth);
            if (object.quality != null)
                message.quality = Number(object.quality);
            if (object.momentumPercentile != null)
                message.momentumPercentile = Number(object.momentumPercentile);
            if (object.valuePercentile != null)
                message.valuePercentile = Number(object.valuePercentile);
            if (object.growthPercentile != null)
                message.growthPercentile = Number(object.growthPercentile);
            if (object.qualityPercentile != null)
                message.qualityPercentile = Number(object.qualityPercentile);
            if (object.rateOfReturnDay != null)
                message.rateOfReturnDay = Number(object.rateOfReturnDay);
            if (object.rateOfReturnWeek != null)
                message.rateOfReturnWeek = Number(object.rateOfReturnWeek);
            if (object.rateOfReturnMonth != null)
                message.rateOfReturnMonth = Number(object.rateOfReturnMonth);
            if (object.dividendOneDay != null)
                message.dividendOneDay = Number(object.dividendOneDay);
            if (object.dividendOneWeek != null)
                message.dividendOneWeek = Number(object.dividendOneWeek);
            if (object.dividendOneMonth != null)
                message.dividendOneMonth = Number(object.dividendOneMonth);
            if (object.totalLiabilities != null)
                message.totalLiabilities = Number(object.totalLiabilities);
            if (object.retainedEarnings != null)
                message.retainedEarnings = Number(object.retainedEarnings);
            if (object.ebit != null)
                message.ebit = Number(object.ebit);
            if (object.altmanZScore != null)
                message.altmanZScore = Number(object.altmanZScore);
            if (object.powerEarningGap != null)
                message.powerEarningGap = Boolean(object.powerEarningGap);
            if (object.monsterPowerEarningGap != null)
                message.monsterPowerEarningGap = Boolean(object.monsterPowerEarningGap);
            if (object.monsterGap != null)
                message.monsterGap = Boolean(object.monsterGap);
            if (object.oelGap != null)
                message.oelGap = Boolean(object.oelGap);
            if (object.evToEbit != null)
                message.evToEbit = Number(object.evToEbit);
            if (object.priceToTangibleBookValue != null)
                message.priceToTangibleBookValue = Number(object.priceToTangibleBookValue);
            if (object.tangibleBookValuePerShare != null)
                message.tangibleBookValuePerShare = Number(object.tangibleBookValuePerShare);
            if (object.dailyDollarVolume != null)
                message.dailyDollarVolume = Number(object.dailyDollarVolume);
            if (object.bookValuePerShare != null)
                message.bookValuePerShare = Number(object.bookValuePerShare);
            if (object.movingAverage350Day != null)
                message.movingAverage350Day = Number(object.movingAverage350Day);
            if (object.priceToAdjEarningsTtm != null)
                message.priceToAdjEarningsTtm = Number(object.priceToAdjEarningsTtm);
            if (object.salesGrowthYoY != null)
                message.salesGrowthYoY = Number(object.salesGrowthYoY);
            if (object.salesGrowth3Year != null)
                message.salesGrowth3Year = Number(object.salesGrowth3Year);
            if (object.salesGrowth5Year != null)
                message.salesGrowth5Year = Number(object.salesGrowth5Year);
            if (object.debtQoQ != null)
                message.debtQoQ = Number(object.debtQoQ);
            if (object.debtYoY != null)
                message.debtYoY = Number(object.debtYoY);
            if (object.debt5Year != null)
                message.debt5Year = Number(object.debt5Year);
            if (object.epsGrowth3Year != null)
                message.epsGrowth3Year = Number(object.epsGrowth3Year);
            if (object.epsGrowth3NormalizedYear != null)
                message.epsGrowth3NormalizedYear = Number(object.epsGrowth3NormalizedYear);
            if (object.roe5YrAvg != null)
                message.roe5YrAvg = Number(object.roe5YrAvg);
            if (object.stockholdersEquity != null)
                message.stockholdersEquity = Number(object.stockholdersEquity);
            if (object.stockholdersEquityYearAgo != null)
                message.stockholdersEquityYearAgo = Number(object.stockholdersEquityYearAgo);
            if (object.stockholdersEquityGrowthYoY != null)
                message.stockholdersEquityGrowthYoY = Number(object.stockholdersEquityGrowthYoY);
            if (object.vwap1Day != null)
                message.vwap1Day = Number(object.vwap1Day);
            if (object.vwap5Day != null)
                message.vwap5Day = Number(object.vwap5Day);
            if (object.vwap10Day != null)
                message.vwap10Day = Number(object.vwap10Day);
            if (object.vwap50Day != null)
                message.vwap50Day = Number(object.vwap50Day);
            if (object.vwap100Day != null)
                message.vwap100Day = Number(object.vwap100Day);
            if (object.vwap200Day != null)
                message.vwap200Day = Number(object.vwap200Day);
            if (object.roic1YearAvg != null)
                message.roic1YearAvg = Number(object.roic1YearAvg);
            if (object.roic5YearAvg != null)
                message.roic5YearAvg = Number(object.roic5YearAvg);
            if (object.vwap1m != null)
                message.vwap1m = Number(object.vwap1m);
            if (object.vwap5m != null)
                message.vwap5m = Number(object.vwap5m);
            if (object.vwap15m != null)
                message.vwap15m = Number(object.vwap15m);
            if (object.vwap30m != null)
                message.vwap30m = Number(object.vwap30m);
            if (object.vwap60m != null)
                message.vwap60m = Number(object.vwap60m);
            if (object.candleStick != null)
                message.candleStick = String(object.candleStick);
            if (object.patterns != null)
                message.patterns = String(object.patterns);
            if (object.earningsForwardGrowth3Year != null)
                message.earningsForwardGrowth3Year = Number(object.earningsForwardGrowth3Year);
            if (object.earningsForwardGrowth5Year != null)
                message.earningsForwardGrowth5Year = Number(object.earningsForwardGrowth5Year);
            if (object.revenueForwardGrowth3Year != null)
                message.revenueForwardGrowth3Year = Number(object.revenueForwardGrowth3Year);
            if (object.revenueForwardGrowth5Year != null)
                message.revenueForwardGrowth5Year = Number(object.revenueForwardGrowth5Year);
            if (object.bidAskSpread != null)
                message.bidAskSpread = Number(object.bidAskSpread);
            if (object.bidAskSpreadPercent != null)
                message.bidAskSpreadPercent = Number(object.bidAskSpreadPercent);
            if (object.change1Minute != null)
                message.change1Minute = Number(object.change1Minute);
            if (object.preMarketChange1Minute != null)
                message.preMarketChange1Minute = Number(object.preMarketChange1Minute);
            if (object.preMarketChangePercent1Minute != null)
                message.preMarketChangePercent1Minute = Number(object.preMarketChangePercent1Minute);
            if (object.regularChange1Minute != null)
                message.regularChange1Minute = Number(object.regularChange1Minute);
            if (object.regularChangePercent1Minute != null)
                message.regularChangePercent1Minute = Number(object.regularChangePercent1Minute);
            if (object.afterMarketChange1Minute != null)
                message.afterMarketChange1Minute = Number(object.afterMarketChange1Minute);
            if (object.afterMarketChangePercent1Minute != null)
                message.afterMarketChangePercent1Minute = Number(object.afterMarketChangePercent1Minute);
            if (object.previousCloseDate != null)
                message.previousCloseDate = String(object.previousCloseDate);
            if (object.distanceToMaxPriceTargetPercent != null)
                message.distanceToMaxPriceTargetPercent = Number(object.distanceToMaxPriceTargetPercent);
            if (object.distanceToMinPriceTargetPercent != null)
                message.distanceToMinPriceTargetPercent = Number(object.distanceToMinPriceTargetPercent);
            if (object.distanceToMeanPriceTargetPercent != null)
                message.distanceToMeanPriceTargetPercent = Number(object.distanceToMeanPriceTargetPercent);
            return message;
        };

        /**
         * Creates a plain object from a Quote message. Also converts values to other types if specified.
         * @function toObject
         * @memberof QuoteProtos.Quote
         * @static
         * @param {QuoteProtos.Quote} message Quote
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Quote.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.clearFieldNumbers = [];
            if (options.defaults) {
                object.symbol = "";
                object.previousClose = 0;
                object.close = 0;
                object.change = 0;
                object.changePercent = 0;
                object.name = "";
                object.ipoDate = "";
                object.exchange = "";
                object.tradeExchange = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.marketCap = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.marketCap = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.rsi = 0;
                object.atr = 0;
                object.priceToEarnings = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.averageVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.averageVolume = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sharesOutstanding = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.sharesOutstanding = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.sector = "";
                object.sectorCode = 0;
                object.industry = "";
                object.industryCode = 0;
                object.forwardPERatio = 0;
                object.pricetoEBITDA = 0;
                object.trailingDividendYield = 0;
                object.PBRatio = 0;
                object.priceToSales = 0;
                object.FCFPerShare = 0;
                object.buyBackYield = 0;
                object.open = 0;
                object.price = 0;
                object.high = 0;
                object.low = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.time = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.size = 0;
                object.type = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.dayVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.dayVolume = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.askPrice = 0;
                object.bidPrice = 0;
                object.shareFloatDate = "";
                object.sharesOutstandingDate = "";
                object.cik = 0;
                object.updateType = options.enums === String ? "UNKNOWN" : 0;
                object.sessionType = options.enums === String ? "NA" : 0;
                object.change1Month = 0;
                object.change3Month = 0;
                object.changePercent3Month = 0;
                object.price6Month = 0;
                object.change1Year = 0;
                object.preMarketChange5Minute = 0;
                object.preMarketChangePercent5Minute = 0;
                object.afterMarketChangePercent = 0;
                object.changePercent1Minute = 0;
                object.changePercentClose = 0;
                object.changePercent5Minute = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.volume1Minute = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.volume1Minute = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.relativeVolume1Minute = 0;
                object.change15Minute = 0;
                object.changePercent15Minute = 0;
                object.change30Minute = 0;
                object.changePercent30Minute = 0;
                object.change60Minute = 0;
                object.changePercent60Minute = 0;
                object.changePercentOpen = 0;
                object.changeOpen = 0;
                object.change5Minute = 0;
                object.customChange = 0;
                object.customChangePercent = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.customDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.customDate = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.preMarketChange = 0;
                object.preMarketChangePercent = 0;
                object.afterMarketChange = 0;
                object.gics = 0;
                object.gicsSector = 0;
                object.gicsSectorName = "";
                object.gicsIndustryGroup = 0;
                object.gicsIndustryGroupName = "";
                object.gicsIndustry = 0;
                object.gicsIndustryName = "";
                object.gicsSubIndustry = 0;
                object.gicsSubIndustryName = "";
                object.optionable = 0;
                object.signalName = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.shareFloat = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.shareFloat = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.lastTradeTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.lastTradeTime = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.country = "";
                object.preMarketChange15Minute = 0;
                object.preMarketChangePercent15Minute = 0;
                object.preMarketChange30Minute = 0;
                object.preMarketChangePercent30Minute = 0;
                object.preMarketChange60Minute = 0;
                object.preMarketChangePercent60Minute = 0;
                object.regularChange5Minute = 0;
                object.regularChangePercent5Minute = 0;
                object.regularChange15Minute = 0;
                object.regularChangePercent15Minute = 0;
                object.regularChange30Minute = 0;
                object.regularChangePercent30Minute = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.volume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.volume = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.regularChange60Minute = 0;
                object.regularChangePercent60Minute = 0;
                object.afterMarketChange5Minute = 0;
                object.opol = "";
                object.subtype = "";
                object.afterMarketChange15Minute = 0;
                object.afterMarketChangePercent15Minute = 0;
                object.afterMarketChange30Minute = 0;
                object.afterMarketChangePercent30Minute = 0;
                object.afterMarketChange60Minute = 0;
                object.afterMarketChangePercent60Minute = 0;
                object.change6Month = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sharesShort = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.sharesShort = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.sharesShortPercentOfFloat = 0;
                object.sharesShortChangePercent = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sharesShortReceiptDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.sharesShortReceiptDate = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sharesShortSettlementDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.sharesShortSettlementDate = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.shortInterestRatio = 0;
                object.sharesShortValue = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sharesShortPrevious = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.sharesShortPrevious = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.sharesShortPreviousValue = 0;
                object.sharesShortPreviousPercentOfFloat = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sharesShortChange = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.sharesShortChange = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.afterMarketChangePercent5Minute = 0;
                object.price3Month = 0;
                object.changePercent6Month = 0;
                object.preMarketPrice = 0;
                object.afterMarketPrice = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.sentTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.sentTime = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.closeTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.closeTime = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.volume5Minute = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.volume5Minute = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.volume15Minute = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.volume15Minute = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.volume30Minute = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.volume30Minute = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.volume60Minute = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.volume60Minute = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.relativeVolume5Minute = 0;
                object.relativeVolume90Day = 0;
                object.rvol1m10d = 0;
                object.rvol5m10d = 0;
                object.rvol5m30d = 0;
                object.rvol5m90d = 0;
                object.nextEarningsDate = 0;
                object.dividend = 0;
                object.dividendYield = 0;
                object.dividendExDate = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.dividendFrequency = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.dividendFrequency = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.forwardDividendYield = 0;
                object.roe = 0;
                object.roa = 0;
                object.roic = 0;
                object.currentRatio = 0;
                object.grossMargin = 0;
                object.netMargin = 0;
                object.operationMargin = 0;
                object.epsMrq = 0;
                object.epsTtm = 0;
                object.dilutedEpsMrq = 0;
                object.dilutedEpsTtm = 0;
                object.low52Week = 0;
                object.high52Week = 0;
                object.revenueTtm = 0;
                object.earningsAsOf = 0;
                object.netProfitMargin = 0;
                object.roeMrq = 0;
                object.roaMrq = 0;
                object.roicMrq = 0;
                object.currentRatioMrq = 0;
                object.grossMarginMrq = 0;
                object.netMarginMrq = 0;
                object.operationMarginMrq = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.previousDayVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.previousDayVolume = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.previousDayAtr = 0;
                object.previousDayAdx = 0;
                object.previousDayPlusDMSmoothed = 0;
                object.previousDayMinusDMSmoothed = 0;
                object.previousDayHigh = 0;
                object.previousDayLow = 0;
                object.adx = 0;
                object.percentInstitutionalOwnership = 0;
                object.percentInstitutionalTransactions = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.averageVolume10Day = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.averageVolume10Day = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.averageVolumeChangePercent10Day = 0;
                object.high10Day = 0;
                object.highChangePercent10Day = 0;
                object.low10Day = 0;
                object.lowChangePercent10Day = 0;
                object.movingAverage10Day = 0;
                object.movingAverageChangePercent10Day = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.averageVolume20Day = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.averageVolume20Day = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.averageVolumeChangePercent20Day = 0;
                object.high20Day = 0;
                object.highChangePercent20Day = 0;
                object.low20Day = 0;
                object.lowChangePercent20Day = 0;
                object.movingAverage20Day = 0;
                object.movingAverageChangePercent20Day = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.averageVolume50Day = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.averageVolume50Day = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.averageVolumeChangePercent50Day = 0;
                object.high50Day = 0;
                object.highChangePercent50Day = 0;
                object.low50Day = 0;
                object.lowChangePercent50Day = 0;
                object.movingAverage50Day = 0;
                object.movingAverageChangePercent50Day = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.averageVolume100Day = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.averageVolume100Day = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.averageVolumeChangePercent100Day = 0;
                object.high100Day = 0;
                object.highChangePercent100Day = 0;
                object.low100Day = 0;
                object.lowChangePercent100Day = 0;
                object.movingAverage100Day = 0;
                object.movingAverageChangePercent100Day = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.averageVolume200Day = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.averageVolume200Day = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.averageVolumeChangePercent200Day = 0;
                object.high200Day = 0;
                object.highChangePercent200Day = 0;
                object.low200Day = 0;
                object.lowChangePercent200Day = 0;
                object.movingAverage200Day = 0;
                object.movingAverageChangePercent200Day = 0;
                object.movingAverage250Day = 0;
                object.movingAverageChangePercent250Day = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.averageVolume90Day = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.averageVolume90Day = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.evToEbitda = 0;
                object.lowAllTime = 0;
                object.highAllTime = 0;
                object.quickRatioMrq = 0;
                object.ffoPerShare = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.ipoDateNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.ipoDateNumber = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.ltDebtEquity = 0;
                object.epsGrowthYearAgoQ = 0;
                object.revenueGrowthYearAgoQ = 0;
                object.revenueGrowth5Year = 0;
                object.revenueGrowthQ2Q = 0;
                object.revenueGrowthY2Y = 0;
                object.revenueGrowthTtm = 0;
                object.epsGrowth5Year = 0;
                object.epsGrowthQ2Q = 0;
                object.epsGrowthY2Y = 0;
                object.epsGrowthTtm = 0;
                object.dilutedRevenueTtmSurprisePercent = 0;
                object.dilutedRevenueMrqSurprisePercent = 0;
                object.dilutedEpsTtmSurprisePercent = 0;
                object.dilutedEpsMrqSurprisePercent = 0;
                object.adr14d = 0;
                object.gapChangePercent = 0;
                object.gapChange = 0;
                object.movingAverage500Day = 0;
                object.dividendGrowthRate5Year = 0;
                object.dividendGrowthRate3Year = 0;
                object.dividendGrowthRate1Year = 0;
                object.newsBzWireTitle = "";
                object.newsBzWireNodeId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.newsBzWireTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.newsBzWireTimestamp = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.newsPRTitle = "";
                object.newsPRNodeId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.newsPRTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.newsPRTimestamp = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.newsSecTitle = "";
                object.newsSecNodeId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.newsSecTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.newsSecTimestamp = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.newsBzWireTitleWithNodeId = "";
                object.newsPRTitleWithNodeId = "";
                object.newsSecTitleWithNodeId = "";
                object.mtdChange = 0;
                object.ytdChange = 0;
                object.macdSignalLineBase = 0;
                object.macdHistogram = 0;
                object.macdSignalLine = 0;
                object.macd = 0;
                object.wiim = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.wiimAsOf = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.wiimAsOf = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.vwap = 0;
                object.vwapChangePercent = 0;
                object.vwapChange = 0;
                object.rsiAvgGain = 0;
                object.rsiAvgLoss = 0;
                object.halted = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.tradeCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.tradeCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.regularHighCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.regularHighCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.regularLowCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.regularLowCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.preMarketHighCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.preMarketHighCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.preMarketLowCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.preMarketLowCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.afterMarketHighCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.afterMarketHighCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.afterMarketLowCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.afterMarketLowCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.dayHighCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.dayHighCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.dayLowCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.dayLowCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.ema12d = 0;
                object.ema26d = 0;
                object.dayHigh = 0;
                object.dayLow = 0;
                object.preMarketHigh = 0;
                object.preMarketLow = 0;
                object.afterMarketHigh = 0;
                object.afterMarketLow = 0;
                object.regularHigh = 0;
                object.regularLow = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.priceSpikeUpCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.priceSpikeUpCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.priceSpikeDownCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.priceSpikeDownCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.haltedCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.haltedCount = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.usCongressTotal = 0;
                object.usCongressRepublicansTotal = 0;
                object.usCongressDemocratsTotal = 0;
                object.usCongressOtherTotal = 0;
                object.volumeFloatRatio = 0;
                object.atrp = 0;
                object.ytdGainLoss = 0;
                object.mtdGainLoss = 0;
                object.yearOpen = 0;
                object.rsi1m = 0;
                object.rsi2m = 0;
                object.rsi5m = 0;
                object.rsi15m = 0;
                object.rsi30m = 0;
                object.rsi60m = 0;
                object.rsiEth1m = 0;
                object.rsiEth2m = 0;
                object.rsiEth5m = 0;
                object.rsiEth15m = 0;
                object.rsiEth30m = 0;
                object.rsiEth60m = 0;
                object.monthOpen = 0;
                object.volumeFloatPercent = 0;
                object.averageDollarVolume10Day = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.averageVolume60Day = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.averageVolume60Day = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.relativeVolumePercent60Day = 0;
                object.rsi1mLowest = 0;
                object.rsi2mLowest = 0;
                object.rsi5mLowest = 0;
                object.rsi15mLowest = 0;
                object.rsi30mLowest = 0;
                object.rsi60mLowest = 0;
                object.rsiEth1mLowest = 0;
                object.rsiEth2mLowest = 0;
                object.rsiEth5mLowest = 0;
                object.rsiEth15mLowest = 0;
                object.rsiEth30mLowest = 0;
                object.rsiEth60mLowest = 0;
                object.rsi1mGreatest = 0;
                object.rsi2mGreatest = 0;
                object.rsi5mGreatest = 0;
                object.rsi15mGreatest = 0;
                object.rsi30mGreatest = 0;
                object.rsi60mGreatest = 0;
                object.rsiEth1mGreatest = 0;
                object.rsiEth2mGreatest = 0;
                object.rsiEth5mGreatest = 0;
                object.rsiEth15mGreatest = 0;
                object.rsiEth30mGreatest = 0;
                object.rsiEth60mGreatest = 0;
                object.rsiCrossOver = 0;
                object.change1Week = 0;
                object.price1Week = 0;
                object.priceChangePercent1Week = 0;
                object.price1Month = 0;
                object.priceChangePercent1Month = 0;
                object.priceHalfYear = 0;
                object.priceChangePercentHalfYear = 0;
                object.priceQuarter = 0;
                object.priceChangePercentQuarter = 0;
                object.price1Year = 0;
                object.priceChangePercent1Year = 0;
                object.priceYearToDate = 0;
                object.priceChangePercentYearToDate = 0;
                object.bullsSay = "";
                object.bearsSay = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.afterMarketVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.afterMarketVolume = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.preMarketOpen = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.preMarketOpenTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.preMarketOpenTime = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.preMarketVolume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.preMarketVolume = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.preMarketOpenChange = 0;
                object.preMarketOpenChangePercent = 0;
                object.source = options.enums === String ? "UNKNOWN_SOURCE" : 0;
                object.totalDebtEquityRatio = 0;
                object.dividendPayoutRatio = 0;
                object.operatingCashFlow = 0;
                object.insiderPercentage = 0;
                object.priceToCashFlowRatio = 0;
                object.regularHoursChange = 0;
                object.regularHoursPercentChange = 0;
                object.postToPreHoursChange = 0;
                object.postToPreHoursPercentChange = 0;
                object.scannerClose = 0;
                object.scannerChange = 0;
                object.scannerChangePercent = 0;
                object.scannerChangePercentClose = 0;
                object.scannerPreviousClose = 0;
                object.freeCashFlow = 0;
                object.minPriceTarget = 0;
                object.maxPriceTarget = 0;
                object.meanPriceTarget = 0;
                object.totalNumberOfAnalyst = 0;
                object.averageAnalystRecommendation = "";
                object.pegRatio = 0;
                object.priceToFreeCashFlowRatio = 0;
                object.distanceToMaxPriceTarget = 0;
                object.distanceToMinPriceTarget = 0;
                object.distanceToMeanPriceTarget = 0;
                object.shortTermTrend = "";
                object.mediumTermTrend = "";
                object.longTermTrend = "";
                object.twentySixWeekChange = 0;
                object.fiftyTwoWeekChange = 0;
                object.annualizedStandardDeviation = 0;
                object.momentum = 0;
                object.value = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.piotroskiFScore = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                } else
                    object.piotroskiFScore = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                object.netIncomeTtm = 0;
                object.growth = 0;
                object.currentRatioYearAgo = 0;
                object.roaYearAgo = 0;
                object.grossMarginYearAgo = 0;
                object.longTermDebt = 0;
                object.longTermDebtYearAgo = 0;
                object.shareIssued = 0;
                object.shareIssuedYearAgo = 0;
                object.totalAssets = 0;
                object.totalAssetsYearAgo = 0;
                object.totalAssets2YearAgo = 0;
                object.revenueTtmYearAgo = 0;
                object.longTermDebtAndCapitalLeaseObligation = 0;
                object.averageTotalAssets = 0;
                object.averageTotalAssetsYearAgo = 0;
                object.quality = 0;
                object.momentumPercentile = 0;
                object.valuePercentile = 0;
                object.growthPercentile = 0;
                object.qualityPercentile = 0;
                object.totalDividendTtm = 0;
                object.dividendIncreasing = 0;
                object.rateOfReturnDay = 0;
                object.rateOfReturnWeek = 0;
                object.rateOfReturnMonth = 0;
                object.dividendOneDay = 0;
                object.dividendOneWeek = 0;
                object.dividendOneMonth = 0;
                object.totalLiabilities = 0;
                object.retainedEarnings = 0;
                object.ebit = 0;
                object.altmanZScore = 0;
                object.powerEarningGap = false;
                object.monsterPowerEarningGap = false;
                object.monsterGap = false;
                object.oelGap = false;
                object.evToEbit = 0;
                object.priceToTangibleBookValue = 0;
                object.tangibleBookValuePerShare = 0;
                object.dailyDollarVolume = 0;
                object.bookValuePerShare = 0;
                object.movingAverage350Day = 0;
                object.priceToAdjEarningsTtm = 0;
                object.salesGrowthYoY = 0;
                object.salesGrowth3Year = 0;
                object.salesGrowth5Year = 0;
                object.debtQoQ = 0;
                object.debtYoY = 0;
                object.debt5Year = 0;
                object.epsGrowth3Year = 0;
                object.epsGrowth3NormalizedYear = 0;
                object.roe5YrAvg = 0;
                object.stockholdersEquity = 0;
                object.stockholdersEquityYearAgo = 0;
                object.stockholdersEquityGrowthYoY = 0;
                object.vwap1Day = 0;
                object.vwap5Day = 0;
                object.vwap10Day = 0;
                object.vwap50Day = 0;
                object.vwap100Day = 0;
                object.vwap200Day = 0;
                object.roic1YearAvg = 0;
                object.roic5YearAvg = 0;
                object.vwap1m = 0;
                object.vwap5m = 0;
                object.vwap15m = 0;
                object.vwap30m = 0;
                object.vwap60m = 0;
                object.candleStick = "";
                object.patterns = "";
                object.earningsForwardGrowth3Year = 0;
                object.earningsForwardGrowth5Year = 0;
                object.revenueForwardGrowth3Year = 0;
                object.revenueForwardGrowth5Year = 0;
                object.bidAskSpread = 0;
                object.bidAskSpreadPercent = 0;
                object.change1Minute = 0;
                object.preMarketChange1Minute = 0;
                object.preMarketChangePercent1Minute = 0;
                object.regularChange1Minute = 0;
                object.regularChangePercent1Minute = 0;
                object.afterMarketChange1Minute = 0;
                object.afterMarketChangePercent1Minute = 0;
                object.previousCloseDate = "";
                object.distanceToMaxPriceTargetPercent = 0;
                object.distanceToMinPriceTargetPercent = 0;
                object.distanceToMeanPriceTargetPercent = 0;
            }
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                object.symbol = message.symbol;
            if (message.previousClose != null && message.hasOwnProperty("previousClose"))
                object.previousClose = options.json && !isFinite(message.previousClose) ? String(message.previousClose) : message.previousClose;
            if (message.close != null && message.hasOwnProperty("close"))
                object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
            if (message.change != null && message.hasOwnProperty("change"))
                object.change = options.json && !isFinite(message.change) ? String(message.change) : message.change;
            if (message.changePercent != null && message.hasOwnProperty("changePercent"))
                object.changePercent = options.json && !isFinite(message.changePercent) ? String(message.changePercent) : message.changePercent;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.ipoDate != null && message.hasOwnProperty("ipoDate"))
                object.ipoDate = message.ipoDate;
            if (message.exchange != null && message.hasOwnProperty("exchange"))
                object.exchange = message.exchange;
            if (message.tradeExchange != null && message.hasOwnProperty("tradeExchange"))
                object.tradeExchange = message.tradeExchange;
            if (message.marketCap != null && message.hasOwnProperty("marketCap"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.marketCap = typeof message.marketCap === "number" ? BigInt(message.marketCap) : $util.Long.fromBits(message.marketCap.low >>> 0, message.marketCap.high >>> 0, false).toBigInt();
                else if (typeof message.marketCap === "number")
                    object.marketCap = options.longs === String ? String(message.marketCap) : message.marketCap;
                else
                    object.marketCap = options.longs === String ? $util.Long.prototype.toString.call(message.marketCap) : options.longs === Number ? new $util.LongBits(message.marketCap.low >>> 0, message.marketCap.high >>> 0).toNumber() : message.marketCap;
            if (message.rsi != null && message.hasOwnProperty("rsi"))
                object.rsi = options.json && !isFinite(message.rsi) ? String(message.rsi) : message.rsi;
            if (message.atr != null && message.hasOwnProperty("atr"))
                object.atr = options.json && !isFinite(message.atr) ? String(message.atr) : message.atr;
            if (message.priceToEarnings != null && message.hasOwnProperty("priceToEarnings"))
                object.priceToEarnings = options.json && !isFinite(message.priceToEarnings) ? String(message.priceToEarnings) : message.priceToEarnings;
            if (message.averageVolume != null && message.hasOwnProperty("averageVolume"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.averageVolume = typeof message.averageVolume === "number" ? BigInt(message.averageVolume) : $util.Long.fromBits(message.averageVolume.low >>> 0, message.averageVolume.high >>> 0, false).toBigInt();
                else if (typeof message.averageVolume === "number")
                    object.averageVolume = options.longs === String ? String(message.averageVolume) : message.averageVolume;
                else
                    object.averageVolume = options.longs === String ? $util.Long.prototype.toString.call(message.averageVolume) : options.longs === Number ? new $util.LongBits(message.averageVolume.low >>> 0, message.averageVolume.high >>> 0).toNumber() : message.averageVolume;
            if (message.sharesOutstanding != null && message.hasOwnProperty("sharesOutstanding"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.sharesOutstanding = typeof message.sharesOutstanding === "number" ? BigInt(message.sharesOutstanding) : $util.Long.fromBits(message.sharesOutstanding.low >>> 0, message.sharesOutstanding.high >>> 0, false).toBigInt();
                else if (typeof message.sharesOutstanding === "number")
                    object.sharesOutstanding = options.longs === String ? String(message.sharesOutstanding) : message.sharesOutstanding;
                else
                    object.sharesOutstanding = options.longs === String ? $util.Long.prototype.toString.call(message.sharesOutstanding) : options.longs === Number ? new $util.LongBits(message.sharesOutstanding.low >>> 0, message.sharesOutstanding.high >>> 0).toNumber() : message.sharesOutstanding;
            if (message.sector != null && message.hasOwnProperty("sector"))
                object.sector = message.sector;
            if (message.sectorCode != null && message.hasOwnProperty("sectorCode"))
                object.sectorCode = message.sectorCode;
            if (message.industry != null && message.hasOwnProperty("industry"))
                object.industry = message.industry;
            if (message.industryCode != null && message.hasOwnProperty("industryCode"))
                object.industryCode = message.industryCode;
            if (message.forwardPERatio != null && message.hasOwnProperty("forwardPERatio"))
                object.forwardPERatio = options.json && !isFinite(message.forwardPERatio) ? String(message.forwardPERatio) : message.forwardPERatio;
            if (message.pricetoEBITDA != null && message.hasOwnProperty("pricetoEBITDA"))
                object.pricetoEBITDA = options.json && !isFinite(message.pricetoEBITDA) ? String(message.pricetoEBITDA) : message.pricetoEBITDA;
            if (message.trailingDividendYield != null && message.hasOwnProperty("trailingDividendYield"))
                object.trailingDividendYield = options.json && !isFinite(message.trailingDividendYield) ? String(message.trailingDividendYield) : message.trailingDividendYield;
            if (message.PBRatio != null && message.hasOwnProperty("PBRatio"))
                object.PBRatio = options.json && !isFinite(message.PBRatio) ? String(message.PBRatio) : message.PBRatio;
            if (message.priceToSales != null && message.hasOwnProperty("priceToSales"))
                object.priceToSales = options.json && !isFinite(message.priceToSales) ? String(message.priceToSales) : message.priceToSales;
            if (message.FCFPerShare != null && message.hasOwnProperty("FCFPerShare"))
                object.FCFPerShare = options.json && !isFinite(message.FCFPerShare) ? String(message.FCFPerShare) : message.FCFPerShare;
            if (message.buyBackYield != null && message.hasOwnProperty("buyBackYield"))
                object.buyBackYield = options.json && !isFinite(message.buyBackYield) ? String(message.buyBackYield) : message.buyBackYield;
            if (message.open != null && message.hasOwnProperty("open"))
                object.open = options.json && !isFinite(message.open) ? String(message.open) : message.open;
            if (message.price != null && message.hasOwnProperty("price"))
                object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
            if (message.high != null && message.hasOwnProperty("high"))
                object.high = options.json && !isFinite(message.high) ? String(message.high) : message.high;
            if (message.low != null && message.hasOwnProperty("low"))
                object.low = options.json && !isFinite(message.low) ? String(message.low) : message.low;
            if (message.time != null && message.hasOwnProperty("time"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.time = typeof message.time === "number" ? BigInt(message.time) : $util.Long.fromBits(message.time.low >>> 0, message.time.high >>> 0, false).toBigInt();
                else if (typeof message.time === "number")
                    object.time = options.longs === String ? String(message.time) : message.time;
                else
                    object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = message.size;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.dayVolume != null && message.hasOwnProperty("dayVolume"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.dayVolume = typeof message.dayVolume === "number" ? BigInt(message.dayVolume) : $util.Long.fromBits(message.dayVolume.low >>> 0, message.dayVolume.high >>> 0, false).toBigInt();
                else if (typeof message.dayVolume === "number")
                    object.dayVolume = options.longs === String ? String(message.dayVolume) : message.dayVolume;
                else
                    object.dayVolume = options.longs === String ? $util.Long.prototype.toString.call(message.dayVolume) : options.longs === Number ? new $util.LongBits(message.dayVolume.low >>> 0, message.dayVolume.high >>> 0).toNumber() : message.dayVolume;
            if (message.askPrice != null && message.hasOwnProperty("askPrice"))
                object.askPrice = options.json && !isFinite(message.askPrice) ? String(message.askPrice) : message.askPrice;
            if (message.bidPrice != null && message.hasOwnProperty("bidPrice"))
                object.bidPrice = options.json && !isFinite(message.bidPrice) ? String(message.bidPrice) : message.bidPrice;
            if (message.shareFloatDate != null && message.hasOwnProperty("shareFloatDate"))
                object.shareFloatDate = message.shareFloatDate;
            if (message.sharesOutstandingDate != null && message.hasOwnProperty("sharesOutstandingDate"))
                object.sharesOutstandingDate = message.sharesOutstandingDate;
            if (message.cik != null && message.hasOwnProperty("cik"))
                object.cik = message.cik;
            if (message.updateType != null && message.hasOwnProperty("updateType"))
                object.updateType = options.enums === String ? $root.QuoteProtos.TickType[message.updateType] === undefined ? message.updateType : $root.QuoteProtos.TickType[message.updateType] : message.updateType;
            if (message.sessionType != null && message.hasOwnProperty("sessionType"))
                object.sessionType = options.enums === String ? $root.QuoteProtos.SessionType[message.sessionType] === undefined ? message.sessionType : $root.QuoteProtos.SessionType[message.sessionType] : message.sessionType;
            if (message.change1Month != null && message.hasOwnProperty("change1Month"))
                object.change1Month = options.json && !isFinite(message.change1Month) ? String(message.change1Month) : message.change1Month;
            if (message.change3Month != null && message.hasOwnProperty("change3Month"))
                object.change3Month = options.json && !isFinite(message.change3Month) ? String(message.change3Month) : message.change3Month;
            if (message.changePercent3Month != null && message.hasOwnProperty("changePercent3Month"))
                object.changePercent3Month = options.json && !isFinite(message.changePercent3Month) ? String(message.changePercent3Month) : message.changePercent3Month;
            if (message.price6Month != null && message.hasOwnProperty("price6Month"))
                object.price6Month = options.json && !isFinite(message.price6Month) ? String(message.price6Month) : message.price6Month;
            if (message.change1Year != null && message.hasOwnProperty("change1Year"))
                object.change1Year = options.json && !isFinite(message.change1Year) ? String(message.change1Year) : message.change1Year;
            if (message.preMarketChange5Minute != null && message.hasOwnProperty("preMarketChange5Minute"))
                object.preMarketChange5Minute = options.json && !isFinite(message.preMarketChange5Minute) ? String(message.preMarketChange5Minute) : message.preMarketChange5Minute;
            if (message.preMarketChangePercent5Minute != null && message.hasOwnProperty("preMarketChangePercent5Minute"))
                object.preMarketChangePercent5Minute = options.json && !isFinite(message.preMarketChangePercent5Minute) ? String(message.preMarketChangePercent5Minute) : message.preMarketChangePercent5Minute;
            if (message.afterMarketChangePercent != null && message.hasOwnProperty("afterMarketChangePercent"))
                object.afterMarketChangePercent = options.json && !isFinite(message.afterMarketChangePercent) ? String(message.afterMarketChangePercent) : message.afterMarketChangePercent;
            if (message.changePercent1Minute != null && message.hasOwnProperty("changePercent1Minute"))
                object.changePercent1Minute = options.json && !isFinite(message.changePercent1Minute) ? String(message.changePercent1Minute) : message.changePercent1Minute;
            if (message.changePercentClose != null && message.hasOwnProperty("changePercentClose"))
                object.changePercentClose = options.json && !isFinite(message.changePercentClose) ? String(message.changePercentClose) : message.changePercentClose;
            if (message.changePercent5Minute != null && message.hasOwnProperty("changePercent5Minute"))
                object.changePercent5Minute = options.json && !isFinite(message.changePercent5Minute) ? String(message.changePercent5Minute) : message.changePercent5Minute;
            if (message.volume1Minute != null && message.hasOwnProperty("volume1Minute"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.volume1Minute = typeof message.volume1Minute === "number" ? BigInt(message.volume1Minute) : $util.Long.fromBits(message.volume1Minute.low >>> 0, message.volume1Minute.high >>> 0, false).toBigInt();
                else if (typeof message.volume1Minute === "number")
                    object.volume1Minute = options.longs === String ? String(message.volume1Minute) : message.volume1Minute;
                else
                    object.volume1Minute = options.longs === String ? $util.Long.prototype.toString.call(message.volume1Minute) : options.longs === Number ? new $util.LongBits(message.volume1Minute.low >>> 0, message.volume1Minute.high >>> 0).toNumber() : message.volume1Minute;
            if (message.relativeVolume1Minute != null && message.hasOwnProperty("relativeVolume1Minute"))
                object.relativeVolume1Minute = options.json && !isFinite(message.relativeVolume1Minute) ? String(message.relativeVolume1Minute) : message.relativeVolume1Minute;
            if (message.change15Minute != null && message.hasOwnProperty("change15Minute"))
                object.change15Minute = options.json && !isFinite(message.change15Minute) ? String(message.change15Minute) : message.change15Minute;
            if (message.changePercent15Minute != null && message.hasOwnProperty("changePercent15Minute"))
                object.changePercent15Minute = options.json && !isFinite(message.changePercent15Minute) ? String(message.changePercent15Minute) : message.changePercent15Minute;
            if (message.change30Minute != null && message.hasOwnProperty("change30Minute"))
                object.change30Minute = options.json && !isFinite(message.change30Minute) ? String(message.change30Minute) : message.change30Minute;
            if (message.changePercent30Minute != null && message.hasOwnProperty("changePercent30Minute"))
                object.changePercent30Minute = options.json && !isFinite(message.changePercent30Minute) ? String(message.changePercent30Minute) : message.changePercent30Minute;
            if (message.change60Minute != null && message.hasOwnProperty("change60Minute"))
                object.change60Minute = options.json && !isFinite(message.change60Minute) ? String(message.change60Minute) : message.change60Minute;
            if (message.changePercent60Minute != null && message.hasOwnProperty("changePercent60Minute"))
                object.changePercent60Minute = options.json && !isFinite(message.changePercent60Minute) ? String(message.changePercent60Minute) : message.changePercent60Minute;
            if (message.changePercentOpen != null && message.hasOwnProperty("changePercentOpen"))
                object.changePercentOpen = options.json && !isFinite(message.changePercentOpen) ? String(message.changePercentOpen) : message.changePercentOpen;
            if (message.changeOpen != null && message.hasOwnProperty("changeOpen"))
                object.changeOpen = options.json && !isFinite(message.changeOpen) ? String(message.changeOpen) : message.changeOpen;
            if (message.change5Minute != null && message.hasOwnProperty("change5Minute"))
                object.change5Minute = options.json && !isFinite(message.change5Minute) ? String(message.change5Minute) : message.change5Minute;
            if (message.customChange != null && message.hasOwnProperty("customChange"))
                object.customChange = options.json && !isFinite(message.customChange) ? String(message.customChange) : message.customChange;
            if (message.customChangePercent != null && message.hasOwnProperty("customChangePercent"))
                object.customChangePercent = options.json && !isFinite(message.customChangePercent) ? String(message.customChangePercent) : message.customChangePercent;
            if (message.customDate != null && message.hasOwnProperty("customDate"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.customDate = typeof message.customDate === "number" ? BigInt(message.customDate) : $util.Long.fromBits(message.customDate.low >>> 0, message.customDate.high >>> 0, false).toBigInt();
                else if (typeof message.customDate === "number")
                    object.customDate = options.longs === String ? String(message.customDate) : message.customDate;
                else
                    object.customDate = options.longs === String ? $util.Long.prototype.toString.call(message.customDate) : options.longs === Number ? new $util.LongBits(message.customDate.low >>> 0, message.customDate.high >>> 0).toNumber() : message.customDate;
            if (message.preMarketChange != null && message.hasOwnProperty("preMarketChange"))
                object.preMarketChange = options.json && !isFinite(message.preMarketChange) ? String(message.preMarketChange) : message.preMarketChange;
            if (message.preMarketChangePercent != null && message.hasOwnProperty("preMarketChangePercent"))
                object.preMarketChangePercent = options.json && !isFinite(message.preMarketChangePercent) ? String(message.preMarketChangePercent) : message.preMarketChangePercent;
            if (message.afterMarketChange != null && message.hasOwnProperty("afterMarketChange"))
                object.afterMarketChange = options.json && !isFinite(message.afterMarketChange) ? String(message.afterMarketChange) : message.afterMarketChange;
            if (message.gics != null && message.hasOwnProperty("gics"))
                object.gics = message.gics;
            if (message.gicsSector != null && message.hasOwnProperty("gicsSector"))
                object.gicsSector = message.gicsSector;
            if (message.gicsSectorName != null && message.hasOwnProperty("gicsSectorName"))
                object.gicsSectorName = message.gicsSectorName;
            if (message.gicsIndustryGroup != null && message.hasOwnProperty("gicsIndustryGroup"))
                object.gicsIndustryGroup = message.gicsIndustryGroup;
            if (message.gicsIndustryGroupName != null && message.hasOwnProperty("gicsIndustryGroupName"))
                object.gicsIndustryGroupName = message.gicsIndustryGroupName;
            if (message.gicsIndustry != null && message.hasOwnProperty("gicsIndustry"))
                object.gicsIndustry = message.gicsIndustry;
            if (message.gicsIndustryName != null && message.hasOwnProperty("gicsIndustryName"))
                object.gicsIndustryName = message.gicsIndustryName;
            if (message.gicsSubIndustry != null && message.hasOwnProperty("gicsSubIndustry"))
                object.gicsSubIndustry = message.gicsSubIndustry;
            if (message.gicsSubIndustryName != null && message.hasOwnProperty("gicsSubIndustryName"))
                object.gicsSubIndustryName = message.gicsSubIndustryName;
            if (message.optionable != null && message.hasOwnProperty("optionable"))
                object.optionable = message.optionable;
            if (message.signalName != null && message.hasOwnProperty("signalName"))
                object.signalName = message.signalName;
            if (message.shareFloat != null && message.hasOwnProperty("shareFloat"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.shareFloat = typeof message.shareFloat === "number" ? BigInt(message.shareFloat) : $util.Long.fromBits(message.shareFloat.low >>> 0, message.shareFloat.high >>> 0, false).toBigInt();
                else if (typeof message.shareFloat === "number")
                    object.shareFloat = options.longs === String ? String(message.shareFloat) : message.shareFloat;
                else
                    object.shareFloat = options.longs === String ? $util.Long.prototype.toString.call(message.shareFloat) : options.longs === Number ? new $util.LongBits(message.shareFloat.low >>> 0, message.shareFloat.high >>> 0).toNumber() : message.shareFloat;
            if (message.lastTradeTime != null && message.hasOwnProperty("lastTradeTime"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.lastTradeTime = typeof message.lastTradeTime === "number" ? BigInt(message.lastTradeTime) : $util.Long.fromBits(message.lastTradeTime.low >>> 0, message.lastTradeTime.high >>> 0, false).toBigInt();
                else if (typeof message.lastTradeTime === "number")
                    object.lastTradeTime = options.longs === String ? String(message.lastTradeTime) : message.lastTradeTime;
                else
                    object.lastTradeTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastTradeTime) : options.longs === Number ? new $util.LongBits(message.lastTradeTime.low >>> 0, message.lastTradeTime.high >>> 0).toNumber() : message.lastTradeTime;
            if (message.country != null && message.hasOwnProperty("country"))
                object.country = message.country;
            if (message.preMarketChange15Minute != null && message.hasOwnProperty("preMarketChange15Minute"))
                object.preMarketChange15Minute = options.json && !isFinite(message.preMarketChange15Minute) ? String(message.preMarketChange15Minute) : message.preMarketChange15Minute;
            if (message.preMarketChangePercent15Minute != null && message.hasOwnProperty("preMarketChangePercent15Minute"))
                object.preMarketChangePercent15Minute = options.json && !isFinite(message.preMarketChangePercent15Minute) ? String(message.preMarketChangePercent15Minute) : message.preMarketChangePercent15Minute;
            if (message.preMarketChange30Minute != null && message.hasOwnProperty("preMarketChange30Minute"))
                object.preMarketChange30Minute = options.json && !isFinite(message.preMarketChange30Minute) ? String(message.preMarketChange30Minute) : message.preMarketChange30Minute;
            if (message.preMarketChangePercent30Minute != null && message.hasOwnProperty("preMarketChangePercent30Minute"))
                object.preMarketChangePercent30Minute = options.json && !isFinite(message.preMarketChangePercent30Minute) ? String(message.preMarketChangePercent30Minute) : message.preMarketChangePercent30Minute;
            if (message.preMarketChange60Minute != null && message.hasOwnProperty("preMarketChange60Minute"))
                object.preMarketChange60Minute = options.json && !isFinite(message.preMarketChange60Minute) ? String(message.preMarketChange60Minute) : message.preMarketChange60Minute;
            if (message.preMarketChangePercent60Minute != null && message.hasOwnProperty("preMarketChangePercent60Minute"))
                object.preMarketChangePercent60Minute = options.json && !isFinite(message.preMarketChangePercent60Minute) ? String(message.preMarketChangePercent60Minute) : message.preMarketChangePercent60Minute;
            if (message.regularChange5Minute != null && message.hasOwnProperty("regularChange5Minute"))
                object.regularChange5Minute = options.json && !isFinite(message.regularChange5Minute) ? String(message.regularChange5Minute) : message.regularChange5Minute;
            if (message.regularChangePercent5Minute != null && message.hasOwnProperty("regularChangePercent5Minute"))
                object.regularChangePercent5Minute = options.json && !isFinite(message.regularChangePercent5Minute) ? String(message.regularChangePercent5Minute) : message.regularChangePercent5Minute;
            if (message.regularChange15Minute != null && message.hasOwnProperty("regularChange15Minute"))
                object.regularChange15Minute = options.json && !isFinite(message.regularChange15Minute) ? String(message.regularChange15Minute) : message.regularChange15Minute;
            if (message.regularChangePercent15Minute != null && message.hasOwnProperty("regularChangePercent15Minute"))
                object.regularChangePercent15Minute = options.json && !isFinite(message.regularChangePercent15Minute) ? String(message.regularChangePercent15Minute) : message.regularChangePercent15Minute;
            if (message.regularChange30Minute != null && message.hasOwnProperty("regularChange30Minute"))
                object.regularChange30Minute = options.json && !isFinite(message.regularChange30Minute) ? String(message.regularChange30Minute) : message.regularChange30Minute;
            if (message.regularChangePercent30Minute != null && message.hasOwnProperty("regularChangePercent30Minute"))
                object.regularChangePercent30Minute = options.json && !isFinite(message.regularChangePercent30Minute) ? String(message.regularChangePercent30Minute) : message.regularChangePercent30Minute;
            if (message.volume != null && message.hasOwnProperty("volume"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.volume = typeof message.volume === "number" ? BigInt(message.volume) : $util.Long.fromBits(message.volume.low >>> 0, message.volume.high >>> 0, false).toBigInt();
                else if (typeof message.volume === "number")
                    object.volume = options.longs === String ? String(message.volume) : message.volume;
                else
                    object.volume = options.longs === String ? $util.Long.prototype.toString.call(message.volume) : options.longs === Number ? new $util.LongBits(message.volume.low >>> 0, message.volume.high >>> 0).toNumber() : message.volume;
            if (message.regularChange60Minute != null && message.hasOwnProperty("regularChange60Minute"))
                object.regularChange60Minute = options.json && !isFinite(message.regularChange60Minute) ? String(message.regularChange60Minute) : message.regularChange60Minute;
            if (message.regularChangePercent60Minute != null && message.hasOwnProperty("regularChangePercent60Minute"))
                object.regularChangePercent60Minute = options.json && !isFinite(message.regularChangePercent60Minute) ? String(message.regularChangePercent60Minute) : message.regularChangePercent60Minute;
            if (message.afterMarketChange5Minute != null && message.hasOwnProperty("afterMarketChange5Minute"))
                object.afterMarketChange5Minute = options.json && !isFinite(message.afterMarketChange5Minute) ? String(message.afterMarketChange5Minute) : message.afterMarketChange5Minute;
            if (message.opol != null && message.hasOwnProperty("opol"))
                object.opol = message.opol;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.afterMarketChange15Minute != null && message.hasOwnProperty("afterMarketChange15Minute"))
                object.afterMarketChange15Minute = options.json && !isFinite(message.afterMarketChange15Minute) ? String(message.afterMarketChange15Minute) : message.afterMarketChange15Minute;
            if (message.afterMarketChangePercent15Minute != null && message.hasOwnProperty("afterMarketChangePercent15Minute"))
                object.afterMarketChangePercent15Minute = options.json && !isFinite(message.afterMarketChangePercent15Minute) ? String(message.afterMarketChangePercent15Minute) : message.afterMarketChangePercent15Minute;
            if (message.afterMarketChange30Minute != null && message.hasOwnProperty("afterMarketChange30Minute"))
                object.afterMarketChange30Minute = options.json && !isFinite(message.afterMarketChange30Minute) ? String(message.afterMarketChange30Minute) : message.afterMarketChange30Minute;
            if (message.afterMarketChangePercent30Minute != null && message.hasOwnProperty("afterMarketChangePercent30Minute"))
                object.afterMarketChangePercent30Minute = options.json && !isFinite(message.afterMarketChangePercent30Minute) ? String(message.afterMarketChangePercent30Minute) : message.afterMarketChangePercent30Minute;
            if (message.afterMarketChange60Minute != null && message.hasOwnProperty("afterMarketChange60Minute"))
                object.afterMarketChange60Minute = options.json && !isFinite(message.afterMarketChange60Minute) ? String(message.afterMarketChange60Minute) : message.afterMarketChange60Minute;
            if (message.afterMarketChangePercent60Minute != null && message.hasOwnProperty("afterMarketChangePercent60Minute"))
                object.afterMarketChangePercent60Minute = options.json && !isFinite(message.afterMarketChangePercent60Minute) ? String(message.afterMarketChangePercent60Minute) : message.afterMarketChangePercent60Minute;
            if (message.change6Month != null && message.hasOwnProperty("change6Month"))
                object.change6Month = options.json && !isFinite(message.change6Month) ? String(message.change6Month) : message.change6Month;
            if (message.sharesShort != null && message.hasOwnProperty("sharesShort"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.sharesShort = typeof message.sharesShort === "number" ? BigInt(message.sharesShort) : $util.Long.fromBits(message.sharesShort.low >>> 0, message.sharesShort.high >>> 0, false).toBigInt();
                else if (typeof message.sharesShort === "number")
                    object.sharesShort = options.longs === String ? String(message.sharesShort) : message.sharesShort;
                else
                    object.sharesShort = options.longs === String ? $util.Long.prototype.toString.call(message.sharesShort) : options.longs === Number ? new $util.LongBits(message.sharesShort.low >>> 0, message.sharesShort.high >>> 0).toNumber() : message.sharesShort;
            if (message.sharesShortPercentOfFloat != null && message.hasOwnProperty("sharesShortPercentOfFloat"))
                object.sharesShortPercentOfFloat = options.json && !isFinite(message.sharesShortPercentOfFloat) ? String(message.sharesShortPercentOfFloat) : message.sharesShortPercentOfFloat;
            if (message.sharesShortChangePercent != null && message.hasOwnProperty("sharesShortChangePercent"))
                object.sharesShortChangePercent = options.json && !isFinite(message.sharesShortChangePercent) ? String(message.sharesShortChangePercent) : message.sharesShortChangePercent;
            if (message.sharesShortReceiptDate != null && message.hasOwnProperty("sharesShortReceiptDate"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.sharesShortReceiptDate = typeof message.sharesShortReceiptDate === "number" ? BigInt(message.sharesShortReceiptDate) : $util.Long.fromBits(message.sharesShortReceiptDate.low >>> 0, message.sharesShortReceiptDate.high >>> 0, false).toBigInt();
                else if (typeof message.sharesShortReceiptDate === "number")
                    object.sharesShortReceiptDate = options.longs === String ? String(message.sharesShortReceiptDate) : message.sharesShortReceiptDate;
                else
                    object.sharesShortReceiptDate = options.longs === String ? $util.Long.prototype.toString.call(message.sharesShortReceiptDate) : options.longs === Number ? new $util.LongBits(message.sharesShortReceiptDate.low >>> 0, message.sharesShortReceiptDate.high >>> 0).toNumber() : message.sharesShortReceiptDate;
            if (message.sharesShortSettlementDate != null && message.hasOwnProperty("sharesShortSettlementDate"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.sharesShortSettlementDate = typeof message.sharesShortSettlementDate === "number" ? BigInt(message.sharesShortSettlementDate) : $util.Long.fromBits(message.sharesShortSettlementDate.low >>> 0, message.sharesShortSettlementDate.high >>> 0, false).toBigInt();
                else if (typeof message.sharesShortSettlementDate === "number")
                    object.sharesShortSettlementDate = options.longs === String ? String(message.sharesShortSettlementDate) : message.sharesShortSettlementDate;
                else
                    object.sharesShortSettlementDate = options.longs === String ? $util.Long.prototype.toString.call(message.sharesShortSettlementDate) : options.longs === Number ? new $util.LongBits(message.sharesShortSettlementDate.low >>> 0, message.sharesShortSettlementDate.high >>> 0).toNumber() : message.sharesShortSettlementDate;
            if (message.shortInterestRatio != null && message.hasOwnProperty("shortInterestRatio"))
                object.shortInterestRatio = options.json && !isFinite(message.shortInterestRatio) ? String(message.shortInterestRatio) : message.shortInterestRatio;
            if (message.sharesShortValue != null && message.hasOwnProperty("sharesShortValue"))
                object.sharesShortValue = options.json && !isFinite(message.sharesShortValue) ? String(message.sharesShortValue) : message.sharesShortValue;
            if (message.sharesShortPrevious != null && message.hasOwnProperty("sharesShortPrevious"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.sharesShortPrevious = typeof message.sharesShortPrevious === "number" ? BigInt(message.sharesShortPrevious) : $util.Long.fromBits(message.sharesShortPrevious.low >>> 0, message.sharesShortPrevious.high >>> 0, false).toBigInt();
                else if (typeof message.sharesShortPrevious === "number")
                    object.sharesShortPrevious = options.longs === String ? String(message.sharesShortPrevious) : message.sharesShortPrevious;
                else
                    object.sharesShortPrevious = options.longs === String ? $util.Long.prototype.toString.call(message.sharesShortPrevious) : options.longs === Number ? new $util.LongBits(message.sharesShortPrevious.low >>> 0, message.sharesShortPrevious.high >>> 0).toNumber() : message.sharesShortPrevious;
            if (message.sharesShortPreviousValue != null && message.hasOwnProperty("sharesShortPreviousValue"))
                object.sharesShortPreviousValue = options.json && !isFinite(message.sharesShortPreviousValue) ? String(message.sharesShortPreviousValue) : message.sharesShortPreviousValue;
            if (message.sharesShortPreviousPercentOfFloat != null && message.hasOwnProperty("sharesShortPreviousPercentOfFloat"))
                object.sharesShortPreviousPercentOfFloat = options.json && !isFinite(message.sharesShortPreviousPercentOfFloat) ? String(message.sharesShortPreviousPercentOfFloat) : message.sharesShortPreviousPercentOfFloat;
            if (message.sharesShortChange != null && message.hasOwnProperty("sharesShortChange"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.sharesShortChange = typeof message.sharesShortChange === "number" ? BigInt(message.sharesShortChange) : $util.Long.fromBits(message.sharesShortChange.low >>> 0, message.sharesShortChange.high >>> 0, false).toBigInt();
                else if (typeof message.sharesShortChange === "number")
                    object.sharesShortChange = options.longs === String ? String(message.sharesShortChange) : message.sharesShortChange;
                else
                    object.sharesShortChange = options.longs === String ? $util.Long.prototype.toString.call(message.sharesShortChange) : options.longs === Number ? new $util.LongBits(message.sharesShortChange.low >>> 0, message.sharesShortChange.high >>> 0).toNumber() : message.sharesShortChange;
            if (message.afterMarketChangePercent5Minute != null && message.hasOwnProperty("afterMarketChangePercent5Minute"))
                object.afterMarketChangePercent5Minute = options.json && !isFinite(message.afterMarketChangePercent5Minute) ? String(message.afterMarketChangePercent5Minute) : message.afterMarketChangePercent5Minute;
            if (message.price3Month != null && message.hasOwnProperty("price3Month"))
                object.price3Month = options.json && !isFinite(message.price3Month) ? String(message.price3Month) : message.price3Month;
            if (message.changePercent6Month != null && message.hasOwnProperty("changePercent6Month"))
                object.changePercent6Month = options.json && !isFinite(message.changePercent6Month) ? String(message.changePercent6Month) : message.changePercent6Month;
            if (message.preMarketPrice != null && message.hasOwnProperty("preMarketPrice"))
                object.preMarketPrice = options.json && !isFinite(message.preMarketPrice) ? String(message.preMarketPrice) : message.preMarketPrice;
            if (message.afterMarketPrice != null && message.hasOwnProperty("afterMarketPrice"))
                object.afterMarketPrice = options.json && !isFinite(message.afterMarketPrice) ? String(message.afterMarketPrice) : message.afterMarketPrice;
            if (message.sentTime != null && message.hasOwnProperty("sentTime"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.sentTime = typeof message.sentTime === "number" ? BigInt(message.sentTime) : $util.Long.fromBits(message.sentTime.low >>> 0, message.sentTime.high >>> 0, false).toBigInt();
                else if (typeof message.sentTime === "number")
                    object.sentTime = options.longs === String ? String(message.sentTime) : message.sentTime;
                else
                    object.sentTime = options.longs === String ? $util.Long.prototype.toString.call(message.sentTime) : options.longs === Number ? new $util.LongBits(message.sentTime.low >>> 0, message.sentTime.high >>> 0).toNumber() : message.sentTime;
            if (message.closeTime != null && message.hasOwnProperty("closeTime"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.closeTime = typeof message.closeTime === "number" ? BigInt(message.closeTime) : $util.Long.fromBits(message.closeTime.low >>> 0, message.closeTime.high >>> 0, false).toBigInt();
                else if (typeof message.closeTime === "number")
                    object.closeTime = options.longs === String ? String(message.closeTime) : message.closeTime;
                else
                    object.closeTime = options.longs === String ? $util.Long.prototype.toString.call(message.closeTime) : options.longs === Number ? new $util.LongBits(message.closeTime.low >>> 0, message.closeTime.high >>> 0).toNumber() : message.closeTime;
            if (message.volume5Minute != null && message.hasOwnProperty("volume5Minute"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.volume5Minute = typeof message.volume5Minute === "number" ? BigInt(message.volume5Minute) : $util.Long.fromBits(message.volume5Minute.low >>> 0, message.volume5Minute.high >>> 0, false).toBigInt();
                else if (typeof message.volume5Minute === "number")
                    object.volume5Minute = options.longs === String ? String(message.volume5Minute) : message.volume5Minute;
                else
                    object.volume5Minute = options.longs === String ? $util.Long.prototype.toString.call(message.volume5Minute) : options.longs === Number ? new $util.LongBits(message.volume5Minute.low >>> 0, message.volume5Minute.high >>> 0).toNumber() : message.volume5Minute;
            if (message.volume15Minute != null && message.hasOwnProperty("volume15Minute"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.volume15Minute = typeof message.volume15Minute === "number" ? BigInt(message.volume15Minute) : $util.Long.fromBits(message.volume15Minute.low >>> 0, message.volume15Minute.high >>> 0, false).toBigInt();
                else if (typeof message.volume15Minute === "number")
                    object.volume15Minute = options.longs === String ? String(message.volume15Minute) : message.volume15Minute;
                else
                    object.volume15Minute = options.longs === String ? $util.Long.prototype.toString.call(message.volume15Minute) : options.longs === Number ? new $util.LongBits(message.volume15Minute.low >>> 0, message.volume15Minute.high >>> 0).toNumber() : message.volume15Minute;
            if (message.volume30Minute != null && message.hasOwnProperty("volume30Minute"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.volume30Minute = typeof message.volume30Minute === "number" ? BigInt(message.volume30Minute) : $util.Long.fromBits(message.volume30Minute.low >>> 0, message.volume30Minute.high >>> 0, false).toBigInt();
                else if (typeof message.volume30Minute === "number")
                    object.volume30Minute = options.longs === String ? String(message.volume30Minute) : message.volume30Minute;
                else
                    object.volume30Minute = options.longs === String ? $util.Long.prototype.toString.call(message.volume30Minute) : options.longs === Number ? new $util.LongBits(message.volume30Minute.low >>> 0, message.volume30Minute.high >>> 0).toNumber() : message.volume30Minute;
            if (message.volume60Minute != null && message.hasOwnProperty("volume60Minute"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.volume60Minute = typeof message.volume60Minute === "number" ? BigInt(message.volume60Minute) : $util.Long.fromBits(message.volume60Minute.low >>> 0, message.volume60Minute.high >>> 0, false).toBigInt();
                else if (typeof message.volume60Minute === "number")
                    object.volume60Minute = options.longs === String ? String(message.volume60Minute) : message.volume60Minute;
                else
                    object.volume60Minute = options.longs === String ? $util.Long.prototype.toString.call(message.volume60Minute) : options.longs === Number ? new $util.LongBits(message.volume60Minute.low >>> 0, message.volume60Minute.high >>> 0).toNumber() : message.volume60Minute;
            if (message.relativeVolume5Minute != null && message.hasOwnProperty("relativeVolume5Minute"))
                object.relativeVolume5Minute = options.json && !isFinite(message.relativeVolume5Minute) ? String(message.relativeVolume5Minute) : message.relativeVolume5Minute;
            if (message.relativeVolume90Day != null && message.hasOwnProperty("relativeVolume90Day"))
                object.relativeVolume90Day = options.json && !isFinite(message.relativeVolume90Day) ? String(message.relativeVolume90Day) : message.relativeVolume90Day;
            if (message.rvol1m10d != null && message.hasOwnProperty("rvol1m10d"))
                object.rvol1m10d = options.json && !isFinite(message.rvol1m10d) ? String(message.rvol1m10d) : message.rvol1m10d;
            if (message.rvol5m10d != null && message.hasOwnProperty("rvol5m10d"))
                object.rvol5m10d = options.json && !isFinite(message.rvol5m10d) ? String(message.rvol5m10d) : message.rvol5m10d;
            if (message.rvol5m30d != null && message.hasOwnProperty("rvol5m30d"))
                object.rvol5m30d = options.json && !isFinite(message.rvol5m30d) ? String(message.rvol5m30d) : message.rvol5m30d;
            if (message.rvol5m90d != null && message.hasOwnProperty("rvol5m90d"))
                object.rvol5m90d = options.json && !isFinite(message.rvol5m90d) ? String(message.rvol5m90d) : message.rvol5m90d;
            if (message.nextEarningsDate != null && message.hasOwnProperty("nextEarningsDate"))
                object.nextEarningsDate = message.nextEarningsDate;
            if (message.dividend != null && message.hasOwnProperty("dividend"))
                object.dividend = options.json && !isFinite(message.dividend) ? String(message.dividend) : message.dividend;
            if (message.dividendYield != null && message.hasOwnProperty("dividendYield"))
                object.dividendYield = options.json && !isFinite(message.dividendYield) ? String(message.dividendYield) : message.dividendYield;
            if (message.dividendExDate != null && message.hasOwnProperty("dividendExDate"))
                object.dividendExDate = message.dividendExDate;
            if (message.dividendFrequency != null && message.hasOwnProperty("dividendFrequency"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.dividendFrequency = typeof message.dividendFrequency === "number" ? BigInt(message.dividendFrequency) : $util.Long.fromBits(message.dividendFrequency.low >>> 0, message.dividendFrequency.high >>> 0, false).toBigInt();
                else if (typeof message.dividendFrequency === "number")
                    object.dividendFrequency = options.longs === String ? String(message.dividendFrequency) : message.dividendFrequency;
                else
                    object.dividendFrequency = options.longs === String ? $util.Long.prototype.toString.call(message.dividendFrequency) : options.longs === Number ? new $util.LongBits(message.dividendFrequency.low >>> 0, message.dividendFrequency.high >>> 0).toNumber() : message.dividendFrequency;
            if (message.forwardDividendYield != null && message.hasOwnProperty("forwardDividendYield"))
                object.forwardDividendYield = options.json && !isFinite(message.forwardDividendYield) ? String(message.forwardDividendYield) : message.forwardDividendYield;
            if (message.roe != null && message.hasOwnProperty("roe"))
                object.roe = options.json && !isFinite(message.roe) ? String(message.roe) : message.roe;
            if (message.roa != null && message.hasOwnProperty("roa"))
                object.roa = options.json && !isFinite(message.roa) ? String(message.roa) : message.roa;
            if (message.roic != null && message.hasOwnProperty("roic"))
                object.roic = options.json && !isFinite(message.roic) ? String(message.roic) : message.roic;
            if (message.currentRatio != null && message.hasOwnProperty("currentRatio"))
                object.currentRatio = options.json && !isFinite(message.currentRatio) ? String(message.currentRatio) : message.currentRatio;
            if (message.grossMargin != null && message.hasOwnProperty("grossMargin"))
                object.grossMargin = options.json && !isFinite(message.grossMargin) ? String(message.grossMargin) : message.grossMargin;
            if (message.netMargin != null && message.hasOwnProperty("netMargin"))
                object.netMargin = options.json && !isFinite(message.netMargin) ? String(message.netMargin) : message.netMargin;
            if (message.operationMargin != null && message.hasOwnProperty("operationMargin"))
                object.operationMargin = options.json && !isFinite(message.operationMargin) ? String(message.operationMargin) : message.operationMargin;
            if (message.epsMrq != null && message.hasOwnProperty("epsMrq"))
                object.epsMrq = options.json && !isFinite(message.epsMrq) ? String(message.epsMrq) : message.epsMrq;
            if (message.epsTtm != null && message.hasOwnProperty("epsTtm"))
                object.epsTtm = options.json && !isFinite(message.epsTtm) ? String(message.epsTtm) : message.epsTtm;
            if (message.dilutedEpsMrq != null && message.hasOwnProperty("dilutedEpsMrq"))
                object.dilutedEpsMrq = options.json && !isFinite(message.dilutedEpsMrq) ? String(message.dilutedEpsMrq) : message.dilutedEpsMrq;
            if (message.dilutedEpsTtm != null && message.hasOwnProperty("dilutedEpsTtm"))
                object.dilutedEpsTtm = options.json && !isFinite(message.dilutedEpsTtm) ? String(message.dilutedEpsTtm) : message.dilutedEpsTtm;
            if (message.low52Week != null && message.hasOwnProperty("low52Week"))
                object.low52Week = options.json && !isFinite(message.low52Week) ? String(message.low52Week) : message.low52Week;
            if (message.high52Week != null && message.hasOwnProperty("high52Week"))
                object.high52Week = options.json && !isFinite(message.high52Week) ? String(message.high52Week) : message.high52Week;
            if (message.revenueTtm != null && message.hasOwnProperty("revenueTtm"))
                object.revenueTtm = options.json && !isFinite(message.revenueTtm) ? String(message.revenueTtm) : message.revenueTtm;
            if (message.earningsAsOf != null && message.hasOwnProperty("earningsAsOf"))
                object.earningsAsOf = message.earningsAsOf;
            if (message.netProfitMargin != null && message.hasOwnProperty("netProfitMargin"))
                object.netProfitMargin = options.json && !isFinite(message.netProfitMargin) ? String(message.netProfitMargin) : message.netProfitMargin;
            if (message.roeMrq != null && message.hasOwnProperty("roeMrq"))
                object.roeMrq = options.json && !isFinite(message.roeMrq) ? String(message.roeMrq) : message.roeMrq;
            if (message.roaMrq != null && message.hasOwnProperty("roaMrq"))
                object.roaMrq = options.json && !isFinite(message.roaMrq) ? String(message.roaMrq) : message.roaMrq;
            if (message.roicMrq != null && message.hasOwnProperty("roicMrq"))
                object.roicMrq = options.json && !isFinite(message.roicMrq) ? String(message.roicMrq) : message.roicMrq;
            if (message.currentRatioMrq != null && message.hasOwnProperty("currentRatioMrq"))
                object.currentRatioMrq = options.json && !isFinite(message.currentRatioMrq) ? String(message.currentRatioMrq) : message.currentRatioMrq;
            if (message.grossMarginMrq != null && message.hasOwnProperty("grossMarginMrq"))
                object.grossMarginMrq = options.json && !isFinite(message.grossMarginMrq) ? String(message.grossMarginMrq) : message.grossMarginMrq;
            if (message.netMarginMrq != null && message.hasOwnProperty("netMarginMrq"))
                object.netMarginMrq = options.json && !isFinite(message.netMarginMrq) ? String(message.netMarginMrq) : message.netMarginMrq;
            if (message.operationMarginMrq != null && message.hasOwnProperty("operationMarginMrq"))
                object.operationMarginMrq = options.json && !isFinite(message.operationMarginMrq) ? String(message.operationMarginMrq) : message.operationMarginMrq;
            if (message.previousDayVolume != null && message.hasOwnProperty("previousDayVolume"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.previousDayVolume = typeof message.previousDayVolume === "number" ? BigInt(message.previousDayVolume) : $util.Long.fromBits(message.previousDayVolume.low >>> 0, message.previousDayVolume.high >>> 0, false).toBigInt();
                else if (typeof message.previousDayVolume === "number")
                    object.previousDayVolume = options.longs === String ? String(message.previousDayVolume) : message.previousDayVolume;
                else
                    object.previousDayVolume = options.longs === String ? $util.Long.prototype.toString.call(message.previousDayVolume) : options.longs === Number ? new $util.LongBits(message.previousDayVolume.low >>> 0, message.previousDayVolume.high >>> 0).toNumber() : message.previousDayVolume;
            if (message.previousDayAtr != null && message.hasOwnProperty("previousDayAtr"))
                object.previousDayAtr = options.json && !isFinite(message.previousDayAtr) ? String(message.previousDayAtr) : message.previousDayAtr;
            if (message.previousDayAdx != null && message.hasOwnProperty("previousDayAdx"))
                object.previousDayAdx = options.json && !isFinite(message.previousDayAdx) ? String(message.previousDayAdx) : message.previousDayAdx;
            if (message.previousDayPlusDMSmoothed != null && message.hasOwnProperty("previousDayPlusDMSmoothed"))
                object.previousDayPlusDMSmoothed = options.json && !isFinite(message.previousDayPlusDMSmoothed) ? String(message.previousDayPlusDMSmoothed) : message.previousDayPlusDMSmoothed;
            if (message.previousDayMinusDMSmoothed != null && message.hasOwnProperty("previousDayMinusDMSmoothed"))
                object.previousDayMinusDMSmoothed = options.json && !isFinite(message.previousDayMinusDMSmoothed) ? String(message.previousDayMinusDMSmoothed) : message.previousDayMinusDMSmoothed;
            if (message.previousDayHigh != null && message.hasOwnProperty("previousDayHigh"))
                object.previousDayHigh = options.json && !isFinite(message.previousDayHigh) ? String(message.previousDayHigh) : message.previousDayHigh;
            if (message.previousDayLow != null && message.hasOwnProperty("previousDayLow"))
                object.previousDayLow = options.json && !isFinite(message.previousDayLow) ? String(message.previousDayLow) : message.previousDayLow;
            if (message.adx != null && message.hasOwnProperty("adx"))
                object.adx = options.json && !isFinite(message.adx) ? String(message.adx) : message.adx;
            if (message.percentInstitutionalOwnership != null && message.hasOwnProperty("percentInstitutionalOwnership"))
                object.percentInstitutionalOwnership = options.json && !isFinite(message.percentInstitutionalOwnership) ? String(message.percentInstitutionalOwnership) : message.percentInstitutionalOwnership;
            if (message.percentInstitutionalTransactions != null && message.hasOwnProperty("percentInstitutionalTransactions"))
                object.percentInstitutionalTransactions = options.json && !isFinite(message.percentInstitutionalTransactions) ? String(message.percentInstitutionalTransactions) : message.percentInstitutionalTransactions;
            if (message.averageVolume10Day != null && message.hasOwnProperty("averageVolume10Day"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.averageVolume10Day = typeof message.averageVolume10Day === "number" ? BigInt(message.averageVolume10Day) : $util.Long.fromBits(message.averageVolume10Day.low >>> 0, message.averageVolume10Day.high >>> 0, false).toBigInt();
                else if (typeof message.averageVolume10Day === "number")
                    object.averageVolume10Day = options.longs === String ? String(message.averageVolume10Day) : message.averageVolume10Day;
                else
                    object.averageVolume10Day = options.longs === String ? $util.Long.prototype.toString.call(message.averageVolume10Day) : options.longs === Number ? new $util.LongBits(message.averageVolume10Day.low >>> 0, message.averageVolume10Day.high >>> 0).toNumber() : message.averageVolume10Day;
            if (message.averageVolumeChangePercent10Day != null && message.hasOwnProperty("averageVolumeChangePercent10Day"))
                object.averageVolumeChangePercent10Day = options.json && !isFinite(message.averageVolumeChangePercent10Day) ? String(message.averageVolumeChangePercent10Day) : message.averageVolumeChangePercent10Day;
            if (message.high10Day != null && message.hasOwnProperty("high10Day"))
                object.high10Day = options.json && !isFinite(message.high10Day) ? String(message.high10Day) : message.high10Day;
            if (message.highChangePercent10Day != null && message.hasOwnProperty("highChangePercent10Day"))
                object.highChangePercent10Day = options.json && !isFinite(message.highChangePercent10Day) ? String(message.highChangePercent10Day) : message.highChangePercent10Day;
            if (message.low10Day != null && message.hasOwnProperty("low10Day"))
                object.low10Day = options.json && !isFinite(message.low10Day) ? String(message.low10Day) : message.low10Day;
            if (message.lowChangePercent10Day != null && message.hasOwnProperty("lowChangePercent10Day"))
                object.lowChangePercent10Day = options.json && !isFinite(message.lowChangePercent10Day) ? String(message.lowChangePercent10Day) : message.lowChangePercent10Day;
            if (message.movingAverage10Day != null && message.hasOwnProperty("movingAverage10Day"))
                object.movingAverage10Day = options.json && !isFinite(message.movingAverage10Day) ? String(message.movingAverage10Day) : message.movingAverage10Day;
            if (message.movingAverageChangePercent10Day != null && message.hasOwnProperty("movingAverageChangePercent10Day"))
                object.movingAverageChangePercent10Day = options.json && !isFinite(message.movingAverageChangePercent10Day) ? String(message.movingAverageChangePercent10Day) : message.movingAverageChangePercent10Day;
            if (message.averageVolume20Day != null && message.hasOwnProperty("averageVolume20Day"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.averageVolume20Day = typeof message.averageVolume20Day === "number" ? BigInt(message.averageVolume20Day) : $util.Long.fromBits(message.averageVolume20Day.low >>> 0, message.averageVolume20Day.high >>> 0, false).toBigInt();
                else if (typeof message.averageVolume20Day === "number")
                    object.averageVolume20Day = options.longs === String ? String(message.averageVolume20Day) : message.averageVolume20Day;
                else
                    object.averageVolume20Day = options.longs === String ? $util.Long.prototype.toString.call(message.averageVolume20Day) : options.longs === Number ? new $util.LongBits(message.averageVolume20Day.low >>> 0, message.averageVolume20Day.high >>> 0).toNumber() : message.averageVolume20Day;
            if (message.averageVolumeChangePercent20Day != null && message.hasOwnProperty("averageVolumeChangePercent20Day"))
                object.averageVolumeChangePercent20Day = options.json && !isFinite(message.averageVolumeChangePercent20Day) ? String(message.averageVolumeChangePercent20Day) : message.averageVolumeChangePercent20Day;
            if (message.high20Day != null && message.hasOwnProperty("high20Day"))
                object.high20Day = options.json && !isFinite(message.high20Day) ? String(message.high20Day) : message.high20Day;
            if (message.highChangePercent20Day != null && message.hasOwnProperty("highChangePercent20Day"))
                object.highChangePercent20Day = options.json && !isFinite(message.highChangePercent20Day) ? String(message.highChangePercent20Day) : message.highChangePercent20Day;
            if (message.low20Day != null && message.hasOwnProperty("low20Day"))
                object.low20Day = options.json && !isFinite(message.low20Day) ? String(message.low20Day) : message.low20Day;
            if (message.lowChangePercent20Day != null && message.hasOwnProperty("lowChangePercent20Day"))
                object.lowChangePercent20Day = options.json && !isFinite(message.lowChangePercent20Day) ? String(message.lowChangePercent20Day) : message.lowChangePercent20Day;
            if (message.movingAverage20Day != null && message.hasOwnProperty("movingAverage20Day"))
                object.movingAverage20Day = options.json && !isFinite(message.movingAverage20Day) ? String(message.movingAverage20Day) : message.movingAverage20Day;
            if (message.movingAverageChangePercent20Day != null && message.hasOwnProperty("movingAverageChangePercent20Day"))
                object.movingAverageChangePercent20Day = options.json && !isFinite(message.movingAverageChangePercent20Day) ? String(message.movingAverageChangePercent20Day) : message.movingAverageChangePercent20Day;
            if (message.averageVolume50Day != null && message.hasOwnProperty("averageVolume50Day"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.averageVolume50Day = typeof message.averageVolume50Day === "number" ? BigInt(message.averageVolume50Day) : $util.Long.fromBits(message.averageVolume50Day.low >>> 0, message.averageVolume50Day.high >>> 0, false).toBigInt();
                else if (typeof message.averageVolume50Day === "number")
                    object.averageVolume50Day = options.longs === String ? String(message.averageVolume50Day) : message.averageVolume50Day;
                else
                    object.averageVolume50Day = options.longs === String ? $util.Long.prototype.toString.call(message.averageVolume50Day) : options.longs === Number ? new $util.LongBits(message.averageVolume50Day.low >>> 0, message.averageVolume50Day.high >>> 0).toNumber() : message.averageVolume50Day;
            if (message.averageVolumeChangePercent50Day != null && message.hasOwnProperty("averageVolumeChangePercent50Day"))
                object.averageVolumeChangePercent50Day = options.json && !isFinite(message.averageVolumeChangePercent50Day) ? String(message.averageVolumeChangePercent50Day) : message.averageVolumeChangePercent50Day;
            if (message.high50Day != null && message.hasOwnProperty("high50Day"))
                object.high50Day = options.json && !isFinite(message.high50Day) ? String(message.high50Day) : message.high50Day;
            if (message.highChangePercent50Day != null && message.hasOwnProperty("highChangePercent50Day"))
                object.highChangePercent50Day = options.json && !isFinite(message.highChangePercent50Day) ? String(message.highChangePercent50Day) : message.highChangePercent50Day;
            if (message.low50Day != null && message.hasOwnProperty("low50Day"))
                object.low50Day = options.json && !isFinite(message.low50Day) ? String(message.low50Day) : message.low50Day;
            if (message.lowChangePercent50Day != null && message.hasOwnProperty("lowChangePercent50Day"))
                object.lowChangePercent50Day = options.json && !isFinite(message.lowChangePercent50Day) ? String(message.lowChangePercent50Day) : message.lowChangePercent50Day;
            if (message.movingAverage50Day != null && message.hasOwnProperty("movingAverage50Day"))
                object.movingAverage50Day = options.json && !isFinite(message.movingAverage50Day) ? String(message.movingAverage50Day) : message.movingAverage50Day;
            if (message.movingAverageChangePercent50Day != null && message.hasOwnProperty("movingAverageChangePercent50Day"))
                object.movingAverageChangePercent50Day = options.json && !isFinite(message.movingAverageChangePercent50Day) ? String(message.movingAverageChangePercent50Day) : message.movingAverageChangePercent50Day;
            if (message.averageVolume100Day != null && message.hasOwnProperty("averageVolume100Day"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.averageVolume100Day = typeof message.averageVolume100Day === "number" ? BigInt(message.averageVolume100Day) : $util.Long.fromBits(message.averageVolume100Day.low >>> 0, message.averageVolume100Day.high >>> 0, false).toBigInt();
                else if (typeof message.averageVolume100Day === "number")
                    object.averageVolume100Day = options.longs === String ? String(message.averageVolume100Day) : message.averageVolume100Day;
                else
                    object.averageVolume100Day = options.longs === String ? $util.Long.prototype.toString.call(message.averageVolume100Day) : options.longs === Number ? new $util.LongBits(message.averageVolume100Day.low >>> 0, message.averageVolume100Day.high >>> 0).toNumber() : message.averageVolume100Day;
            if (message.averageVolumeChangePercent100Day != null && message.hasOwnProperty("averageVolumeChangePercent100Day"))
                object.averageVolumeChangePercent100Day = options.json && !isFinite(message.averageVolumeChangePercent100Day) ? String(message.averageVolumeChangePercent100Day) : message.averageVolumeChangePercent100Day;
            if (message.high100Day != null && message.hasOwnProperty("high100Day"))
                object.high100Day = options.json && !isFinite(message.high100Day) ? String(message.high100Day) : message.high100Day;
            if (message.highChangePercent100Day != null && message.hasOwnProperty("highChangePercent100Day"))
                object.highChangePercent100Day = options.json && !isFinite(message.highChangePercent100Day) ? String(message.highChangePercent100Day) : message.highChangePercent100Day;
            if (message.low100Day != null && message.hasOwnProperty("low100Day"))
                object.low100Day = options.json && !isFinite(message.low100Day) ? String(message.low100Day) : message.low100Day;
            if (message.lowChangePercent100Day != null && message.hasOwnProperty("lowChangePercent100Day"))
                object.lowChangePercent100Day = options.json && !isFinite(message.lowChangePercent100Day) ? String(message.lowChangePercent100Day) : message.lowChangePercent100Day;
            if (message.movingAverage100Day != null && message.hasOwnProperty("movingAverage100Day"))
                object.movingAverage100Day = options.json && !isFinite(message.movingAverage100Day) ? String(message.movingAverage100Day) : message.movingAverage100Day;
            if (message.movingAverageChangePercent100Day != null && message.hasOwnProperty("movingAverageChangePercent100Day"))
                object.movingAverageChangePercent100Day = options.json && !isFinite(message.movingAverageChangePercent100Day) ? String(message.movingAverageChangePercent100Day) : message.movingAverageChangePercent100Day;
            if (message.averageVolume200Day != null && message.hasOwnProperty("averageVolume200Day"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.averageVolume200Day = typeof message.averageVolume200Day === "number" ? BigInt(message.averageVolume200Day) : $util.Long.fromBits(message.averageVolume200Day.low >>> 0, message.averageVolume200Day.high >>> 0, false).toBigInt();
                else if (typeof message.averageVolume200Day === "number")
                    object.averageVolume200Day = options.longs === String ? String(message.averageVolume200Day) : message.averageVolume200Day;
                else
                    object.averageVolume200Day = options.longs === String ? $util.Long.prototype.toString.call(message.averageVolume200Day) : options.longs === Number ? new $util.LongBits(message.averageVolume200Day.low >>> 0, message.averageVolume200Day.high >>> 0).toNumber() : message.averageVolume200Day;
            if (message.averageVolumeChangePercent200Day != null && message.hasOwnProperty("averageVolumeChangePercent200Day"))
                object.averageVolumeChangePercent200Day = options.json && !isFinite(message.averageVolumeChangePercent200Day) ? String(message.averageVolumeChangePercent200Day) : message.averageVolumeChangePercent200Day;
            if (message.high200Day != null && message.hasOwnProperty("high200Day"))
                object.high200Day = options.json && !isFinite(message.high200Day) ? String(message.high200Day) : message.high200Day;
            if (message.highChangePercent200Day != null && message.hasOwnProperty("highChangePercent200Day"))
                object.highChangePercent200Day = options.json && !isFinite(message.highChangePercent200Day) ? String(message.highChangePercent200Day) : message.highChangePercent200Day;
            if (message.low200Day != null && message.hasOwnProperty("low200Day"))
                object.low200Day = options.json && !isFinite(message.low200Day) ? String(message.low200Day) : message.low200Day;
            if (message.lowChangePercent200Day != null && message.hasOwnProperty("lowChangePercent200Day"))
                object.lowChangePercent200Day = options.json && !isFinite(message.lowChangePercent200Day) ? String(message.lowChangePercent200Day) : message.lowChangePercent200Day;
            if (message.movingAverage200Day != null && message.hasOwnProperty("movingAverage200Day"))
                object.movingAverage200Day = options.json && !isFinite(message.movingAverage200Day) ? String(message.movingAverage200Day) : message.movingAverage200Day;
            if (message.movingAverageChangePercent200Day != null && message.hasOwnProperty("movingAverageChangePercent200Day"))
                object.movingAverageChangePercent200Day = options.json && !isFinite(message.movingAverageChangePercent200Day) ? String(message.movingAverageChangePercent200Day) : message.movingAverageChangePercent200Day;
            if (message.movingAverage250Day != null && message.hasOwnProperty("movingAverage250Day"))
                object.movingAverage250Day = options.json && !isFinite(message.movingAverage250Day) ? String(message.movingAverage250Day) : message.movingAverage250Day;
            if (message.movingAverageChangePercent250Day != null && message.hasOwnProperty("movingAverageChangePercent250Day"))
                object.movingAverageChangePercent250Day = options.json && !isFinite(message.movingAverageChangePercent250Day) ? String(message.movingAverageChangePercent250Day) : message.movingAverageChangePercent250Day;
            if (message.averageVolume90Day != null && message.hasOwnProperty("averageVolume90Day"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.averageVolume90Day = typeof message.averageVolume90Day === "number" ? BigInt(message.averageVolume90Day) : $util.Long.fromBits(message.averageVolume90Day.low >>> 0, message.averageVolume90Day.high >>> 0, false).toBigInt();
                else if (typeof message.averageVolume90Day === "number")
                    object.averageVolume90Day = options.longs === String ? String(message.averageVolume90Day) : message.averageVolume90Day;
                else
                    object.averageVolume90Day = options.longs === String ? $util.Long.prototype.toString.call(message.averageVolume90Day) : options.longs === Number ? new $util.LongBits(message.averageVolume90Day.low >>> 0, message.averageVolume90Day.high >>> 0).toNumber() : message.averageVolume90Day;
            if (message.evToEbitda != null && message.hasOwnProperty("evToEbitda"))
                object.evToEbitda = options.json && !isFinite(message.evToEbitda) ? String(message.evToEbitda) : message.evToEbitda;
            if (message.lowAllTime != null && message.hasOwnProperty("lowAllTime"))
                object.lowAllTime = options.json && !isFinite(message.lowAllTime) ? String(message.lowAllTime) : message.lowAllTime;
            if (message.highAllTime != null && message.hasOwnProperty("highAllTime"))
                object.highAllTime = options.json && !isFinite(message.highAllTime) ? String(message.highAllTime) : message.highAllTime;
            if (message.quickRatioMrq != null && message.hasOwnProperty("quickRatioMrq"))
                object.quickRatioMrq = options.json && !isFinite(message.quickRatioMrq) ? String(message.quickRatioMrq) : message.quickRatioMrq;
            if (message.ffoPerShare != null && message.hasOwnProperty("ffoPerShare"))
                object.ffoPerShare = options.json && !isFinite(message.ffoPerShare) ? String(message.ffoPerShare) : message.ffoPerShare;
            if (message.ipoDateNumber != null && message.hasOwnProperty("ipoDateNumber"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.ipoDateNumber = typeof message.ipoDateNumber === "number" ? BigInt(message.ipoDateNumber) : $util.Long.fromBits(message.ipoDateNumber.low >>> 0, message.ipoDateNumber.high >>> 0, false).toBigInt();
                else if (typeof message.ipoDateNumber === "number")
                    object.ipoDateNumber = options.longs === String ? String(message.ipoDateNumber) : message.ipoDateNumber;
                else
                    object.ipoDateNumber = options.longs === String ? $util.Long.prototype.toString.call(message.ipoDateNumber) : options.longs === Number ? new $util.LongBits(message.ipoDateNumber.low >>> 0, message.ipoDateNumber.high >>> 0).toNumber() : message.ipoDateNumber;
            if (message.ltDebtEquity != null && message.hasOwnProperty("ltDebtEquity"))
                object.ltDebtEquity = options.json && !isFinite(message.ltDebtEquity) ? String(message.ltDebtEquity) : message.ltDebtEquity;
            if (message.epsGrowthYearAgoQ != null && message.hasOwnProperty("epsGrowthYearAgoQ"))
                object.epsGrowthYearAgoQ = options.json && !isFinite(message.epsGrowthYearAgoQ) ? String(message.epsGrowthYearAgoQ) : message.epsGrowthYearAgoQ;
            if (message.revenueGrowthYearAgoQ != null && message.hasOwnProperty("revenueGrowthYearAgoQ"))
                object.revenueGrowthYearAgoQ = options.json && !isFinite(message.revenueGrowthYearAgoQ) ? String(message.revenueGrowthYearAgoQ) : message.revenueGrowthYearAgoQ;
            if (message.revenueGrowth5Year != null && message.hasOwnProperty("revenueGrowth5Year"))
                object.revenueGrowth5Year = options.json && !isFinite(message.revenueGrowth5Year) ? String(message.revenueGrowth5Year) : message.revenueGrowth5Year;
            if (message.revenueGrowthQ2Q != null && message.hasOwnProperty("revenueGrowthQ2Q"))
                object.revenueGrowthQ2Q = options.json && !isFinite(message.revenueGrowthQ2Q) ? String(message.revenueGrowthQ2Q) : message.revenueGrowthQ2Q;
            if (message.revenueGrowthY2Y != null && message.hasOwnProperty("revenueGrowthY2Y"))
                object.revenueGrowthY2Y = options.json && !isFinite(message.revenueGrowthY2Y) ? String(message.revenueGrowthY2Y) : message.revenueGrowthY2Y;
            if (message.revenueGrowthTtm != null && message.hasOwnProperty("revenueGrowthTtm"))
                object.revenueGrowthTtm = options.json && !isFinite(message.revenueGrowthTtm) ? String(message.revenueGrowthTtm) : message.revenueGrowthTtm;
            if (message.epsGrowth5Year != null && message.hasOwnProperty("epsGrowth5Year"))
                object.epsGrowth5Year = options.json && !isFinite(message.epsGrowth5Year) ? String(message.epsGrowth5Year) : message.epsGrowth5Year;
            if (message.epsGrowthQ2Q != null && message.hasOwnProperty("epsGrowthQ2Q"))
                object.epsGrowthQ2Q = options.json && !isFinite(message.epsGrowthQ2Q) ? String(message.epsGrowthQ2Q) : message.epsGrowthQ2Q;
            if (message.epsGrowthY2Y != null && message.hasOwnProperty("epsGrowthY2Y"))
                object.epsGrowthY2Y = options.json && !isFinite(message.epsGrowthY2Y) ? String(message.epsGrowthY2Y) : message.epsGrowthY2Y;
            if (message.epsGrowthTtm != null && message.hasOwnProperty("epsGrowthTtm"))
                object.epsGrowthTtm = options.json && !isFinite(message.epsGrowthTtm) ? String(message.epsGrowthTtm) : message.epsGrowthTtm;
            if (message.dilutedRevenueTtmSurprisePercent != null && message.hasOwnProperty("dilutedRevenueTtmSurprisePercent"))
                object.dilutedRevenueTtmSurprisePercent = options.json && !isFinite(message.dilutedRevenueTtmSurprisePercent) ? String(message.dilutedRevenueTtmSurprisePercent) : message.dilutedRevenueTtmSurprisePercent;
            if (message.dilutedRevenueMrqSurprisePercent != null && message.hasOwnProperty("dilutedRevenueMrqSurprisePercent"))
                object.dilutedRevenueMrqSurprisePercent = options.json && !isFinite(message.dilutedRevenueMrqSurprisePercent) ? String(message.dilutedRevenueMrqSurprisePercent) : message.dilutedRevenueMrqSurprisePercent;
            if (message.dilutedEpsTtmSurprisePercent != null && message.hasOwnProperty("dilutedEpsTtmSurprisePercent"))
                object.dilutedEpsTtmSurprisePercent = options.json && !isFinite(message.dilutedEpsTtmSurprisePercent) ? String(message.dilutedEpsTtmSurprisePercent) : message.dilutedEpsTtmSurprisePercent;
            if (message.dilutedEpsMrqSurprisePercent != null && message.hasOwnProperty("dilutedEpsMrqSurprisePercent"))
                object.dilutedEpsMrqSurprisePercent = options.json && !isFinite(message.dilutedEpsMrqSurprisePercent) ? String(message.dilutedEpsMrqSurprisePercent) : message.dilutedEpsMrqSurprisePercent;
            if (message.adr14d != null && message.hasOwnProperty("adr14d"))
                object.adr14d = options.json && !isFinite(message.adr14d) ? String(message.adr14d) : message.adr14d;
            if (message.gapChangePercent != null && message.hasOwnProperty("gapChangePercent"))
                object.gapChangePercent = options.json && !isFinite(message.gapChangePercent) ? String(message.gapChangePercent) : message.gapChangePercent;
            if (message.gapChange != null && message.hasOwnProperty("gapChange"))
                object.gapChange = options.json && !isFinite(message.gapChange) ? String(message.gapChange) : message.gapChange;
            if (message.movingAverage500Day != null && message.hasOwnProperty("movingAverage500Day"))
                object.movingAverage500Day = options.json && !isFinite(message.movingAverage500Day) ? String(message.movingAverage500Day) : message.movingAverage500Day;
            if (message.dividendGrowthRate5Year != null && message.hasOwnProperty("dividendGrowthRate5Year"))
                object.dividendGrowthRate5Year = options.json && !isFinite(message.dividendGrowthRate5Year) ? String(message.dividendGrowthRate5Year) : message.dividendGrowthRate5Year;
            if (message.dividendGrowthRate3Year != null && message.hasOwnProperty("dividendGrowthRate3Year"))
                object.dividendGrowthRate3Year = options.json && !isFinite(message.dividendGrowthRate3Year) ? String(message.dividendGrowthRate3Year) : message.dividendGrowthRate3Year;
            if (message.dividendGrowthRate1Year != null && message.hasOwnProperty("dividendGrowthRate1Year"))
                object.dividendGrowthRate1Year = options.json && !isFinite(message.dividendGrowthRate1Year) ? String(message.dividendGrowthRate1Year) : message.dividendGrowthRate1Year;
            if (message.newsBzWireTitle != null && message.hasOwnProperty("newsBzWireTitle"))
                object.newsBzWireTitle = message.newsBzWireTitle;
            if (message.newsBzWireNodeId != null && message.hasOwnProperty("newsBzWireNodeId"))
                object.newsBzWireNodeId = message.newsBzWireNodeId;
            if (message.newsBzWireTimestamp != null && message.hasOwnProperty("newsBzWireTimestamp"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.newsBzWireTimestamp = typeof message.newsBzWireTimestamp === "number" ? BigInt(message.newsBzWireTimestamp) : $util.Long.fromBits(message.newsBzWireTimestamp.low >>> 0, message.newsBzWireTimestamp.high >>> 0, false).toBigInt();
                else if (typeof message.newsBzWireTimestamp === "number")
                    object.newsBzWireTimestamp = options.longs === String ? String(message.newsBzWireTimestamp) : message.newsBzWireTimestamp;
                else
                    object.newsBzWireTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.newsBzWireTimestamp) : options.longs === Number ? new $util.LongBits(message.newsBzWireTimestamp.low >>> 0, message.newsBzWireTimestamp.high >>> 0).toNumber() : message.newsBzWireTimestamp;
            if (message.newsPRTitle != null && message.hasOwnProperty("newsPRTitle"))
                object.newsPRTitle = message.newsPRTitle;
            if (message.newsPRNodeId != null && message.hasOwnProperty("newsPRNodeId"))
                object.newsPRNodeId = message.newsPRNodeId;
            if (message.newsPRTimestamp != null && message.hasOwnProperty("newsPRTimestamp"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.newsPRTimestamp = typeof message.newsPRTimestamp === "number" ? BigInt(message.newsPRTimestamp) : $util.Long.fromBits(message.newsPRTimestamp.low >>> 0, message.newsPRTimestamp.high >>> 0, false).toBigInt();
                else if (typeof message.newsPRTimestamp === "number")
                    object.newsPRTimestamp = options.longs === String ? String(message.newsPRTimestamp) : message.newsPRTimestamp;
                else
                    object.newsPRTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.newsPRTimestamp) : options.longs === Number ? new $util.LongBits(message.newsPRTimestamp.low >>> 0, message.newsPRTimestamp.high >>> 0).toNumber() : message.newsPRTimestamp;
            if (message.newsSecTitle != null && message.hasOwnProperty("newsSecTitle"))
                object.newsSecTitle = message.newsSecTitle;
            if (message.newsSecNodeId != null && message.hasOwnProperty("newsSecNodeId"))
                object.newsSecNodeId = message.newsSecNodeId;
            if (message.newsSecTimestamp != null && message.hasOwnProperty("newsSecTimestamp"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.newsSecTimestamp = typeof message.newsSecTimestamp === "number" ? BigInt(message.newsSecTimestamp) : $util.Long.fromBits(message.newsSecTimestamp.low >>> 0, message.newsSecTimestamp.high >>> 0, false).toBigInt();
                else if (typeof message.newsSecTimestamp === "number")
                    object.newsSecTimestamp = options.longs === String ? String(message.newsSecTimestamp) : message.newsSecTimestamp;
                else
                    object.newsSecTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.newsSecTimestamp) : options.longs === Number ? new $util.LongBits(message.newsSecTimestamp.low >>> 0, message.newsSecTimestamp.high >>> 0).toNumber() : message.newsSecTimestamp;
            if (message.newsBzWireTitleWithNodeId != null && message.hasOwnProperty("newsBzWireTitleWithNodeId"))
                object.newsBzWireTitleWithNodeId = message.newsBzWireTitleWithNodeId;
            if (message.newsPRTitleWithNodeId != null && message.hasOwnProperty("newsPRTitleWithNodeId"))
                object.newsPRTitleWithNodeId = message.newsPRTitleWithNodeId;
            if (message.newsSecTitleWithNodeId != null && message.hasOwnProperty("newsSecTitleWithNodeId"))
                object.newsSecTitleWithNodeId = message.newsSecTitleWithNodeId;
            if (message.mtdChange != null && message.hasOwnProperty("mtdChange"))
                object.mtdChange = options.json && !isFinite(message.mtdChange) ? String(message.mtdChange) : message.mtdChange;
            if (message.ytdChange != null && message.hasOwnProperty("ytdChange"))
                object.ytdChange = options.json && !isFinite(message.ytdChange) ? String(message.ytdChange) : message.ytdChange;
            if (message.macdSignalLineBase != null && message.hasOwnProperty("macdSignalLineBase"))
                object.macdSignalLineBase = options.json && !isFinite(message.macdSignalLineBase) ? String(message.macdSignalLineBase) : message.macdSignalLineBase;
            if (message.macdHistogram != null && message.hasOwnProperty("macdHistogram"))
                object.macdHistogram = options.json && !isFinite(message.macdHistogram) ? String(message.macdHistogram) : message.macdHistogram;
            if (message.macdSignalLine != null && message.hasOwnProperty("macdSignalLine"))
                object.macdSignalLine = options.json && !isFinite(message.macdSignalLine) ? String(message.macdSignalLine) : message.macdSignalLine;
            if (message.macd != null && message.hasOwnProperty("macd"))
                object.macd = options.json && !isFinite(message.macd) ? String(message.macd) : message.macd;
            if (message.wiim != null && message.hasOwnProperty("wiim"))
                object.wiim = message.wiim;
            if (message.wiimAsOf != null && message.hasOwnProperty("wiimAsOf"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.wiimAsOf = typeof message.wiimAsOf === "number" ? BigInt(message.wiimAsOf) : $util.Long.fromBits(message.wiimAsOf.low >>> 0, message.wiimAsOf.high >>> 0, false).toBigInt();
                else if (typeof message.wiimAsOf === "number")
                    object.wiimAsOf = options.longs === String ? String(message.wiimAsOf) : message.wiimAsOf;
                else
                    object.wiimAsOf = options.longs === String ? $util.Long.prototype.toString.call(message.wiimAsOf) : options.longs === Number ? new $util.LongBits(message.wiimAsOf.low >>> 0, message.wiimAsOf.high >>> 0).toNumber() : message.wiimAsOf;
            if (message.vwap != null && message.hasOwnProperty("vwap"))
                object.vwap = options.json && !isFinite(message.vwap) ? String(message.vwap) : message.vwap;
            if (message.vwapChangePercent != null && message.hasOwnProperty("vwapChangePercent"))
                object.vwapChangePercent = options.json && !isFinite(message.vwapChangePercent) ? String(message.vwapChangePercent) : message.vwapChangePercent;
            if (message.vwapChange != null && message.hasOwnProperty("vwapChange"))
                object.vwapChange = options.json && !isFinite(message.vwapChange) ? String(message.vwapChange) : message.vwapChange;
            if (message.rsiAvgGain != null && message.hasOwnProperty("rsiAvgGain"))
                object.rsiAvgGain = options.json && !isFinite(message.rsiAvgGain) ? String(message.rsiAvgGain) : message.rsiAvgGain;
            if (message.rsiAvgLoss != null && message.hasOwnProperty("rsiAvgLoss"))
                object.rsiAvgLoss = options.json && !isFinite(message.rsiAvgLoss) ? String(message.rsiAvgLoss) : message.rsiAvgLoss;
            if (message.halted != null && message.hasOwnProperty("halted"))
                object.halted = message.halted;
            if (message.tradeCount != null && message.hasOwnProperty("tradeCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.tradeCount = typeof message.tradeCount === "number" ? BigInt(message.tradeCount) : $util.Long.fromBits(message.tradeCount.low >>> 0, message.tradeCount.high >>> 0, false).toBigInt();
                else if (typeof message.tradeCount === "number")
                    object.tradeCount = options.longs === String ? String(message.tradeCount) : message.tradeCount;
                else
                    object.tradeCount = options.longs === String ? $util.Long.prototype.toString.call(message.tradeCount) : options.longs === Number ? new $util.LongBits(message.tradeCount.low >>> 0, message.tradeCount.high >>> 0).toNumber() : message.tradeCount;
            if (message.regularHighCount != null && message.hasOwnProperty("regularHighCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.regularHighCount = typeof message.regularHighCount === "number" ? BigInt(message.regularHighCount) : $util.Long.fromBits(message.regularHighCount.low >>> 0, message.regularHighCount.high >>> 0, false).toBigInt();
                else if (typeof message.regularHighCount === "number")
                    object.regularHighCount = options.longs === String ? String(message.regularHighCount) : message.regularHighCount;
                else
                    object.regularHighCount = options.longs === String ? $util.Long.prototype.toString.call(message.regularHighCount) : options.longs === Number ? new $util.LongBits(message.regularHighCount.low >>> 0, message.regularHighCount.high >>> 0).toNumber() : message.regularHighCount;
            if (message.regularLowCount != null && message.hasOwnProperty("regularLowCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.regularLowCount = typeof message.regularLowCount === "number" ? BigInt(message.regularLowCount) : $util.Long.fromBits(message.regularLowCount.low >>> 0, message.regularLowCount.high >>> 0, false).toBigInt();
                else if (typeof message.regularLowCount === "number")
                    object.regularLowCount = options.longs === String ? String(message.regularLowCount) : message.regularLowCount;
                else
                    object.regularLowCount = options.longs === String ? $util.Long.prototype.toString.call(message.regularLowCount) : options.longs === Number ? new $util.LongBits(message.regularLowCount.low >>> 0, message.regularLowCount.high >>> 0).toNumber() : message.regularLowCount;
            if (message.preMarketHighCount != null && message.hasOwnProperty("preMarketHighCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.preMarketHighCount = typeof message.preMarketHighCount === "number" ? BigInt(message.preMarketHighCount) : $util.Long.fromBits(message.preMarketHighCount.low >>> 0, message.preMarketHighCount.high >>> 0, false).toBigInt();
                else if (typeof message.preMarketHighCount === "number")
                    object.preMarketHighCount = options.longs === String ? String(message.preMarketHighCount) : message.preMarketHighCount;
                else
                    object.preMarketHighCount = options.longs === String ? $util.Long.prototype.toString.call(message.preMarketHighCount) : options.longs === Number ? new $util.LongBits(message.preMarketHighCount.low >>> 0, message.preMarketHighCount.high >>> 0).toNumber() : message.preMarketHighCount;
            if (message.preMarketLowCount != null && message.hasOwnProperty("preMarketLowCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.preMarketLowCount = typeof message.preMarketLowCount === "number" ? BigInt(message.preMarketLowCount) : $util.Long.fromBits(message.preMarketLowCount.low >>> 0, message.preMarketLowCount.high >>> 0, false).toBigInt();
                else if (typeof message.preMarketLowCount === "number")
                    object.preMarketLowCount = options.longs === String ? String(message.preMarketLowCount) : message.preMarketLowCount;
                else
                    object.preMarketLowCount = options.longs === String ? $util.Long.prototype.toString.call(message.preMarketLowCount) : options.longs === Number ? new $util.LongBits(message.preMarketLowCount.low >>> 0, message.preMarketLowCount.high >>> 0).toNumber() : message.preMarketLowCount;
            if (message.afterMarketHighCount != null && message.hasOwnProperty("afterMarketHighCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.afterMarketHighCount = typeof message.afterMarketHighCount === "number" ? BigInt(message.afterMarketHighCount) : $util.Long.fromBits(message.afterMarketHighCount.low >>> 0, message.afterMarketHighCount.high >>> 0, false).toBigInt();
                else if (typeof message.afterMarketHighCount === "number")
                    object.afterMarketHighCount = options.longs === String ? String(message.afterMarketHighCount) : message.afterMarketHighCount;
                else
                    object.afterMarketHighCount = options.longs === String ? $util.Long.prototype.toString.call(message.afterMarketHighCount) : options.longs === Number ? new $util.LongBits(message.afterMarketHighCount.low >>> 0, message.afterMarketHighCount.high >>> 0).toNumber() : message.afterMarketHighCount;
            if (message.afterMarketLowCount != null && message.hasOwnProperty("afterMarketLowCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.afterMarketLowCount = typeof message.afterMarketLowCount === "number" ? BigInt(message.afterMarketLowCount) : $util.Long.fromBits(message.afterMarketLowCount.low >>> 0, message.afterMarketLowCount.high >>> 0, false).toBigInt();
                else if (typeof message.afterMarketLowCount === "number")
                    object.afterMarketLowCount = options.longs === String ? String(message.afterMarketLowCount) : message.afterMarketLowCount;
                else
                    object.afterMarketLowCount = options.longs === String ? $util.Long.prototype.toString.call(message.afterMarketLowCount) : options.longs === Number ? new $util.LongBits(message.afterMarketLowCount.low >>> 0, message.afterMarketLowCount.high >>> 0).toNumber() : message.afterMarketLowCount;
            if (message.dayHighCount != null && message.hasOwnProperty("dayHighCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.dayHighCount = typeof message.dayHighCount === "number" ? BigInt(message.dayHighCount) : $util.Long.fromBits(message.dayHighCount.low >>> 0, message.dayHighCount.high >>> 0, false).toBigInt();
                else if (typeof message.dayHighCount === "number")
                    object.dayHighCount = options.longs === String ? String(message.dayHighCount) : message.dayHighCount;
                else
                    object.dayHighCount = options.longs === String ? $util.Long.prototype.toString.call(message.dayHighCount) : options.longs === Number ? new $util.LongBits(message.dayHighCount.low >>> 0, message.dayHighCount.high >>> 0).toNumber() : message.dayHighCount;
            if (message.dayLowCount != null && message.hasOwnProperty("dayLowCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.dayLowCount = typeof message.dayLowCount === "number" ? BigInt(message.dayLowCount) : $util.Long.fromBits(message.dayLowCount.low >>> 0, message.dayLowCount.high >>> 0, false).toBigInt();
                else if (typeof message.dayLowCount === "number")
                    object.dayLowCount = options.longs === String ? String(message.dayLowCount) : message.dayLowCount;
                else
                    object.dayLowCount = options.longs === String ? $util.Long.prototype.toString.call(message.dayLowCount) : options.longs === Number ? new $util.LongBits(message.dayLowCount.low >>> 0, message.dayLowCount.high >>> 0).toNumber() : message.dayLowCount;
            if (message.ema12d != null && message.hasOwnProperty("ema12d"))
                object.ema12d = options.json && !isFinite(message.ema12d) ? String(message.ema12d) : message.ema12d;
            if (message.ema26d != null && message.hasOwnProperty("ema26d"))
                object.ema26d = options.json && !isFinite(message.ema26d) ? String(message.ema26d) : message.ema26d;
            if (message.dayHigh != null && message.hasOwnProperty("dayHigh"))
                object.dayHigh = options.json && !isFinite(message.dayHigh) ? String(message.dayHigh) : message.dayHigh;
            if (message.dayLow != null && message.hasOwnProperty("dayLow"))
                object.dayLow = options.json && !isFinite(message.dayLow) ? String(message.dayLow) : message.dayLow;
            if (message.preMarketHigh != null && message.hasOwnProperty("preMarketHigh"))
                object.preMarketHigh = options.json && !isFinite(message.preMarketHigh) ? String(message.preMarketHigh) : message.preMarketHigh;
            if (message.preMarketLow != null && message.hasOwnProperty("preMarketLow"))
                object.preMarketLow = options.json && !isFinite(message.preMarketLow) ? String(message.preMarketLow) : message.preMarketLow;
            if (message.afterMarketHigh != null && message.hasOwnProperty("afterMarketHigh"))
                object.afterMarketHigh = options.json && !isFinite(message.afterMarketHigh) ? String(message.afterMarketHigh) : message.afterMarketHigh;
            if (message.afterMarketLow != null && message.hasOwnProperty("afterMarketLow"))
                object.afterMarketLow = options.json && !isFinite(message.afterMarketLow) ? String(message.afterMarketLow) : message.afterMarketLow;
            if (message.regularHigh != null && message.hasOwnProperty("regularHigh"))
                object.regularHigh = options.json && !isFinite(message.regularHigh) ? String(message.regularHigh) : message.regularHigh;
            if (message.regularLow != null && message.hasOwnProperty("regularLow"))
                object.regularLow = options.json && !isFinite(message.regularLow) ? String(message.regularLow) : message.regularLow;
            if (message.priceSpikeUpCount != null && message.hasOwnProperty("priceSpikeUpCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.priceSpikeUpCount = typeof message.priceSpikeUpCount === "number" ? BigInt(message.priceSpikeUpCount) : $util.Long.fromBits(message.priceSpikeUpCount.low >>> 0, message.priceSpikeUpCount.high >>> 0, false).toBigInt();
                else if (typeof message.priceSpikeUpCount === "number")
                    object.priceSpikeUpCount = options.longs === String ? String(message.priceSpikeUpCount) : message.priceSpikeUpCount;
                else
                    object.priceSpikeUpCount = options.longs === String ? $util.Long.prototype.toString.call(message.priceSpikeUpCount) : options.longs === Number ? new $util.LongBits(message.priceSpikeUpCount.low >>> 0, message.priceSpikeUpCount.high >>> 0).toNumber() : message.priceSpikeUpCount;
            if (message.priceSpikeDownCount != null && message.hasOwnProperty("priceSpikeDownCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.priceSpikeDownCount = typeof message.priceSpikeDownCount === "number" ? BigInt(message.priceSpikeDownCount) : $util.Long.fromBits(message.priceSpikeDownCount.low >>> 0, message.priceSpikeDownCount.high >>> 0, false).toBigInt();
                else if (typeof message.priceSpikeDownCount === "number")
                    object.priceSpikeDownCount = options.longs === String ? String(message.priceSpikeDownCount) : message.priceSpikeDownCount;
                else
                    object.priceSpikeDownCount = options.longs === String ? $util.Long.prototype.toString.call(message.priceSpikeDownCount) : options.longs === Number ? new $util.LongBits(message.priceSpikeDownCount.low >>> 0, message.priceSpikeDownCount.high >>> 0).toNumber() : message.priceSpikeDownCount;
            if (message.haltedCount != null && message.hasOwnProperty("haltedCount"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.haltedCount = typeof message.haltedCount === "number" ? BigInt(message.haltedCount) : $util.Long.fromBits(message.haltedCount.low >>> 0, message.haltedCount.high >>> 0, false).toBigInt();
                else if (typeof message.haltedCount === "number")
                    object.haltedCount = options.longs === String ? String(message.haltedCount) : message.haltedCount;
                else
                    object.haltedCount = options.longs === String ? $util.Long.prototype.toString.call(message.haltedCount) : options.longs === Number ? new $util.LongBits(message.haltedCount.low >>> 0, message.haltedCount.high >>> 0).toNumber() : message.haltedCount;
            if (message.usCongressTotal != null && message.hasOwnProperty("usCongressTotal"))
                object.usCongressTotal = options.json && !isFinite(message.usCongressTotal) ? String(message.usCongressTotal) : message.usCongressTotal;
            if (message.usCongressRepublicansTotal != null && message.hasOwnProperty("usCongressRepublicansTotal"))
                object.usCongressRepublicansTotal = options.json && !isFinite(message.usCongressRepublicansTotal) ? String(message.usCongressRepublicansTotal) : message.usCongressRepublicansTotal;
            if (message.usCongressDemocratsTotal != null && message.hasOwnProperty("usCongressDemocratsTotal"))
                object.usCongressDemocratsTotal = options.json && !isFinite(message.usCongressDemocratsTotal) ? String(message.usCongressDemocratsTotal) : message.usCongressDemocratsTotal;
            if (message.usCongressOtherTotal != null && message.hasOwnProperty("usCongressOtherTotal"))
                object.usCongressOtherTotal = options.json && !isFinite(message.usCongressOtherTotal) ? String(message.usCongressOtherTotal) : message.usCongressOtherTotal;
            if (message.volumeFloatRatio != null && message.hasOwnProperty("volumeFloatRatio"))
                object.volumeFloatRatio = options.json && !isFinite(message.volumeFloatRatio) ? String(message.volumeFloatRatio) : message.volumeFloatRatio;
            if (message.atrp != null && message.hasOwnProperty("atrp"))
                object.atrp = options.json && !isFinite(message.atrp) ? String(message.atrp) : message.atrp;
            if (message.ytdGainLoss != null && message.hasOwnProperty("ytdGainLoss"))
                object.ytdGainLoss = options.json && !isFinite(message.ytdGainLoss) ? String(message.ytdGainLoss) : message.ytdGainLoss;
            if (message.mtdGainLoss != null && message.hasOwnProperty("mtdGainLoss"))
                object.mtdGainLoss = options.json && !isFinite(message.mtdGainLoss) ? String(message.mtdGainLoss) : message.mtdGainLoss;
            if (message.yearOpen != null && message.hasOwnProperty("yearOpen"))
                object.yearOpen = options.json && !isFinite(message.yearOpen) ? String(message.yearOpen) : message.yearOpen;
            if (message.rsi1m != null && message.hasOwnProperty("rsi1m"))
                object.rsi1m = options.json && !isFinite(message.rsi1m) ? String(message.rsi1m) : message.rsi1m;
            if (message.rsi2m != null && message.hasOwnProperty("rsi2m"))
                object.rsi2m = options.json && !isFinite(message.rsi2m) ? String(message.rsi2m) : message.rsi2m;
            if (message.rsi5m != null && message.hasOwnProperty("rsi5m"))
                object.rsi5m = options.json && !isFinite(message.rsi5m) ? String(message.rsi5m) : message.rsi5m;
            if (message.rsi15m != null && message.hasOwnProperty("rsi15m"))
                object.rsi15m = options.json && !isFinite(message.rsi15m) ? String(message.rsi15m) : message.rsi15m;
            if (message.rsi30m != null && message.hasOwnProperty("rsi30m"))
                object.rsi30m = options.json && !isFinite(message.rsi30m) ? String(message.rsi30m) : message.rsi30m;
            if (message.rsi60m != null && message.hasOwnProperty("rsi60m"))
                object.rsi60m = options.json && !isFinite(message.rsi60m) ? String(message.rsi60m) : message.rsi60m;
            if (message.rsiEth1m != null && message.hasOwnProperty("rsiEth1m"))
                object.rsiEth1m = options.json && !isFinite(message.rsiEth1m) ? String(message.rsiEth1m) : message.rsiEth1m;
            if (message.rsiEth2m != null && message.hasOwnProperty("rsiEth2m"))
                object.rsiEth2m = options.json && !isFinite(message.rsiEth2m) ? String(message.rsiEth2m) : message.rsiEth2m;
            if (message.rsiEth5m != null && message.hasOwnProperty("rsiEth5m"))
                object.rsiEth5m = options.json && !isFinite(message.rsiEth5m) ? String(message.rsiEth5m) : message.rsiEth5m;
            if (message.rsiEth15m != null && message.hasOwnProperty("rsiEth15m"))
                object.rsiEth15m = options.json && !isFinite(message.rsiEth15m) ? String(message.rsiEth15m) : message.rsiEth15m;
            if (message.rsiEth30m != null && message.hasOwnProperty("rsiEth30m"))
                object.rsiEth30m = options.json && !isFinite(message.rsiEth30m) ? String(message.rsiEth30m) : message.rsiEth30m;
            if (message.rsiEth60m != null && message.hasOwnProperty("rsiEth60m"))
                object.rsiEth60m = options.json && !isFinite(message.rsiEth60m) ? String(message.rsiEth60m) : message.rsiEth60m;
            if (message.monthOpen != null && message.hasOwnProperty("monthOpen"))
                object.monthOpen = options.json && !isFinite(message.monthOpen) ? String(message.monthOpen) : message.monthOpen;
            if (message.volumeFloatPercent != null && message.hasOwnProperty("volumeFloatPercent"))
                object.volumeFloatPercent = options.json && !isFinite(message.volumeFloatPercent) ? String(message.volumeFloatPercent) : message.volumeFloatPercent;
            if (message.averageDollarVolume10Day != null && message.hasOwnProperty("averageDollarVolume10Day"))
                object.averageDollarVolume10Day = options.json && !isFinite(message.averageDollarVolume10Day) ? String(message.averageDollarVolume10Day) : message.averageDollarVolume10Day;
            if (message.averageVolume60Day != null && message.hasOwnProperty("averageVolume60Day"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.averageVolume60Day = typeof message.averageVolume60Day === "number" ? BigInt(message.averageVolume60Day) : $util.Long.fromBits(message.averageVolume60Day.low >>> 0, message.averageVolume60Day.high >>> 0, false).toBigInt();
                else if (typeof message.averageVolume60Day === "number")
                    object.averageVolume60Day = options.longs === String ? String(message.averageVolume60Day) : message.averageVolume60Day;
                else
                    object.averageVolume60Day = options.longs === String ? $util.Long.prototype.toString.call(message.averageVolume60Day) : options.longs === Number ? new $util.LongBits(message.averageVolume60Day.low >>> 0, message.averageVolume60Day.high >>> 0).toNumber() : message.averageVolume60Day;
            if (message.relativeVolumePercent60Day != null && message.hasOwnProperty("relativeVolumePercent60Day"))
                object.relativeVolumePercent60Day = options.json && !isFinite(message.relativeVolumePercent60Day) ? String(message.relativeVolumePercent60Day) : message.relativeVolumePercent60Day;
            if (message.rsi1mLowest != null && message.hasOwnProperty("rsi1mLowest"))
                object.rsi1mLowest = options.json && !isFinite(message.rsi1mLowest) ? String(message.rsi1mLowest) : message.rsi1mLowest;
            if (message.rsi2mLowest != null && message.hasOwnProperty("rsi2mLowest"))
                object.rsi2mLowest = options.json && !isFinite(message.rsi2mLowest) ? String(message.rsi2mLowest) : message.rsi2mLowest;
            if (message.rsi5mLowest != null && message.hasOwnProperty("rsi5mLowest"))
                object.rsi5mLowest = options.json && !isFinite(message.rsi5mLowest) ? String(message.rsi5mLowest) : message.rsi5mLowest;
            if (message.rsi15mLowest != null && message.hasOwnProperty("rsi15mLowest"))
                object.rsi15mLowest = options.json && !isFinite(message.rsi15mLowest) ? String(message.rsi15mLowest) : message.rsi15mLowest;
            if (message.rsi30mLowest != null && message.hasOwnProperty("rsi30mLowest"))
                object.rsi30mLowest = options.json && !isFinite(message.rsi30mLowest) ? String(message.rsi30mLowest) : message.rsi30mLowest;
            if (message.rsi60mLowest != null && message.hasOwnProperty("rsi60mLowest"))
                object.rsi60mLowest = options.json && !isFinite(message.rsi60mLowest) ? String(message.rsi60mLowest) : message.rsi60mLowest;
            if (message.rsiEth1mLowest != null && message.hasOwnProperty("rsiEth1mLowest"))
                object.rsiEth1mLowest = options.json && !isFinite(message.rsiEth1mLowest) ? String(message.rsiEth1mLowest) : message.rsiEth1mLowest;
            if (message.rsiEth2mLowest != null && message.hasOwnProperty("rsiEth2mLowest"))
                object.rsiEth2mLowest = options.json && !isFinite(message.rsiEth2mLowest) ? String(message.rsiEth2mLowest) : message.rsiEth2mLowest;
            if (message.rsiEth5mLowest != null && message.hasOwnProperty("rsiEth5mLowest"))
                object.rsiEth5mLowest = options.json && !isFinite(message.rsiEth5mLowest) ? String(message.rsiEth5mLowest) : message.rsiEth5mLowest;
            if (message.rsiEth15mLowest != null && message.hasOwnProperty("rsiEth15mLowest"))
                object.rsiEth15mLowest = options.json && !isFinite(message.rsiEth15mLowest) ? String(message.rsiEth15mLowest) : message.rsiEth15mLowest;
            if (message.rsiEth30mLowest != null && message.hasOwnProperty("rsiEth30mLowest"))
                object.rsiEth30mLowest = options.json && !isFinite(message.rsiEth30mLowest) ? String(message.rsiEth30mLowest) : message.rsiEth30mLowest;
            if (message.rsiEth60mLowest != null && message.hasOwnProperty("rsiEth60mLowest"))
                object.rsiEth60mLowest = options.json && !isFinite(message.rsiEth60mLowest) ? String(message.rsiEth60mLowest) : message.rsiEth60mLowest;
            if (message.rsi1mGreatest != null && message.hasOwnProperty("rsi1mGreatest"))
                object.rsi1mGreatest = options.json && !isFinite(message.rsi1mGreatest) ? String(message.rsi1mGreatest) : message.rsi1mGreatest;
            if (message.rsi2mGreatest != null && message.hasOwnProperty("rsi2mGreatest"))
                object.rsi2mGreatest = options.json && !isFinite(message.rsi2mGreatest) ? String(message.rsi2mGreatest) : message.rsi2mGreatest;
            if (message.rsi5mGreatest != null && message.hasOwnProperty("rsi5mGreatest"))
                object.rsi5mGreatest = options.json && !isFinite(message.rsi5mGreatest) ? String(message.rsi5mGreatest) : message.rsi5mGreatest;
            if (message.rsi15mGreatest != null && message.hasOwnProperty("rsi15mGreatest"))
                object.rsi15mGreatest = options.json && !isFinite(message.rsi15mGreatest) ? String(message.rsi15mGreatest) : message.rsi15mGreatest;
            if (message.rsi30mGreatest != null && message.hasOwnProperty("rsi30mGreatest"))
                object.rsi30mGreatest = options.json && !isFinite(message.rsi30mGreatest) ? String(message.rsi30mGreatest) : message.rsi30mGreatest;
            if (message.rsi60mGreatest != null && message.hasOwnProperty("rsi60mGreatest"))
                object.rsi60mGreatest = options.json && !isFinite(message.rsi60mGreatest) ? String(message.rsi60mGreatest) : message.rsi60mGreatest;
            if (message.rsiEth1mGreatest != null && message.hasOwnProperty("rsiEth1mGreatest"))
                object.rsiEth1mGreatest = options.json && !isFinite(message.rsiEth1mGreatest) ? String(message.rsiEth1mGreatest) : message.rsiEth1mGreatest;
            if (message.rsiEth2mGreatest != null && message.hasOwnProperty("rsiEth2mGreatest"))
                object.rsiEth2mGreatest = options.json && !isFinite(message.rsiEth2mGreatest) ? String(message.rsiEth2mGreatest) : message.rsiEth2mGreatest;
            if (message.rsiEth5mGreatest != null && message.hasOwnProperty("rsiEth5mGreatest"))
                object.rsiEth5mGreatest = options.json && !isFinite(message.rsiEth5mGreatest) ? String(message.rsiEth5mGreatest) : message.rsiEth5mGreatest;
            if (message.rsiEth15mGreatest != null && message.hasOwnProperty("rsiEth15mGreatest"))
                object.rsiEth15mGreatest = options.json && !isFinite(message.rsiEth15mGreatest) ? String(message.rsiEth15mGreatest) : message.rsiEth15mGreatest;
            if (message.rsiEth30mGreatest != null && message.hasOwnProperty("rsiEth30mGreatest"))
                object.rsiEth30mGreatest = options.json && !isFinite(message.rsiEth30mGreatest) ? String(message.rsiEth30mGreatest) : message.rsiEth30mGreatest;
            if (message.rsiEth60mGreatest != null && message.hasOwnProperty("rsiEth60mGreatest"))
                object.rsiEth60mGreatest = options.json && !isFinite(message.rsiEth60mGreatest) ? String(message.rsiEth60mGreatest) : message.rsiEth60mGreatest;
            if (message.rsiCrossOver != null && message.hasOwnProperty("rsiCrossOver"))
                object.rsiCrossOver = options.json && !isFinite(message.rsiCrossOver) ? String(message.rsiCrossOver) : message.rsiCrossOver;
            if (message.change1Week != null && message.hasOwnProperty("change1Week"))
                object.change1Week = options.json && !isFinite(message.change1Week) ? String(message.change1Week) : message.change1Week;
            if (message.price1Week != null && message.hasOwnProperty("price1Week"))
                object.price1Week = options.json && !isFinite(message.price1Week) ? String(message.price1Week) : message.price1Week;
            if (message.priceChangePercent1Week != null && message.hasOwnProperty("priceChangePercent1Week"))
                object.priceChangePercent1Week = options.json && !isFinite(message.priceChangePercent1Week) ? String(message.priceChangePercent1Week) : message.priceChangePercent1Week;
            if (message.price1Month != null && message.hasOwnProperty("price1Month"))
                object.price1Month = options.json && !isFinite(message.price1Month) ? String(message.price1Month) : message.price1Month;
            if (message.priceChangePercent1Month != null && message.hasOwnProperty("priceChangePercent1Month"))
                object.priceChangePercent1Month = options.json && !isFinite(message.priceChangePercent1Month) ? String(message.priceChangePercent1Month) : message.priceChangePercent1Month;
            if (message.priceHalfYear != null && message.hasOwnProperty("priceHalfYear"))
                object.priceHalfYear = options.json && !isFinite(message.priceHalfYear) ? String(message.priceHalfYear) : message.priceHalfYear;
            if (message.priceChangePercentHalfYear != null && message.hasOwnProperty("priceChangePercentHalfYear"))
                object.priceChangePercentHalfYear = options.json && !isFinite(message.priceChangePercentHalfYear) ? String(message.priceChangePercentHalfYear) : message.priceChangePercentHalfYear;
            if (message.priceQuarter != null && message.hasOwnProperty("priceQuarter"))
                object.priceQuarter = options.json && !isFinite(message.priceQuarter) ? String(message.priceQuarter) : message.priceQuarter;
            if (message.priceChangePercentQuarter != null && message.hasOwnProperty("priceChangePercentQuarter"))
                object.priceChangePercentQuarter = options.json && !isFinite(message.priceChangePercentQuarter) ? String(message.priceChangePercentQuarter) : message.priceChangePercentQuarter;
            if (message.price1Year != null && message.hasOwnProperty("price1Year"))
                object.price1Year = options.json && !isFinite(message.price1Year) ? String(message.price1Year) : message.price1Year;
            if (message.priceChangePercent1Year != null && message.hasOwnProperty("priceChangePercent1Year"))
                object.priceChangePercent1Year = options.json && !isFinite(message.priceChangePercent1Year) ? String(message.priceChangePercent1Year) : message.priceChangePercent1Year;
            if (message.priceYearToDate != null && message.hasOwnProperty("priceYearToDate"))
                object.priceYearToDate = options.json && !isFinite(message.priceYearToDate) ? String(message.priceYearToDate) : message.priceYearToDate;
            if (message.priceChangePercentYearToDate != null && message.hasOwnProperty("priceChangePercentYearToDate"))
                object.priceChangePercentYearToDate = options.json && !isFinite(message.priceChangePercentYearToDate) ? String(message.priceChangePercentYearToDate) : message.priceChangePercentYearToDate;
            if (message.bullsSay != null && message.hasOwnProperty("bullsSay"))
                object.bullsSay = message.bullsSay;
            if (message.bearsSay != null && message.hasOwnProperty("bearsSay"))
                object.bearsSay = message.bearsSay;
            if (message.afterMarketVolume != null && message.hasOwnProperty("afterMarketVolume"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.afterMarketVolume = typeof message.afterMarketVolume === "number" ? BigInt(message.afterMarketVolume) : $util.Long.fromBits(message.afterMarketVolume.low >>> 0, message.afterMarketVolume.high >>> 0, false).toBigInt();
                else if (typeof message.afterMarketVolume === "number")
                    object.afterMarketVolume = options.longs === String ? String(message.afterMarketVolume) : message.afterMarketVolume;
                else
                    object.afterMarketVolume = options.longs === String ? $util.Long.prototype.toString.call(message.afterMarketVolume) : options.longs === Number ? new $util.LongBits(message.afterMarketVolume.low >>> 0, message.afterMarketVolume.high >>> 0).toNumber() : message.afterMarketVolume;
            if (message.preMarketOpen != null && message.hasOwnProperty("preMarketOpen"))
                object.preMarketOpen = options.json && !isFinite(message.preMarketOpen) ? String(message.preMarketOpen) : message.preMarketOpen;
            if (message.preMarketOpenTime != null && message.hasOwnProperty("preMarketOpenTime"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.preMarketOpenTime = typeof message.preMarketOpenTime === "number" ? BigInt(message.preMarketOpenTime) : $util.Long.fromBits(message.preMarketOpenTime.low >>> 0, message.preMarketOpenTime.high >>> 0, false).toBigInt();
                else if (typeof message.preMarketOpenTime === "number")
                    object.preMarketOpenTime = options.longs === String ? String(message.preMarketOpenTime) : message.preMarketOpenTime;
                else
                    object.preMarketOpenTime = options.longs === String ? $util.Long.prototype.toString.call(message.preMarketOpenTime) : options.longs === Number ? new $util.LongBits(message.preMarketOpenTime.low >>> 0, message.preMarketOpenTime.high >>> 0).toNumber() : message.preMarketOpenTime;
            if (message.preMarketVolume != null && message.hasOwnProperty("preMarketVolume"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.preMarketVolume = typeof message.preMarketVolume === "number" ? BigInt(message.preMarketVolume) : $util.Long.fromBits(message.preMarketVolume.low >>> 0, message.preMarketVolume.high >>> 0, false).toBigInt();
                else if (typeof message.preMarketVolume === "number")
                    object.preMarketVolume = options.longs === String ? String(message.preMarketVolume) : message.preMarketVolume;
                else
                    object.preMarketVolume = options.longs === String ? $util.Long.prototype.toString.call(message.preMarketVolume) : options.longs === Number ? new $util.LongBits(message.preMarketVolume.low >>> 0, message.preMarketVolume.high >>> 0).toNumber() : message.preMarketVolume;
            if (message.preMarketOpenChange != null && message.hasOwnProperty("preMarketOpenChange"))
                object.preMarketOpenChange = options.json && !isFinite(message.preMarketOpenChange) ? String(message.preMarketOpenChange) : message.preMarketOpenChange;
            if (message.preMarketOpenChangePercent != null && message.hasOwnProperty("preMarketOpenChangePercent"))
                object.preMarketOpenChangePercent = options.json && !isFinite(message.preMarketOpenChangePercent) ? String(message.preMarketOpenChangePercent) : message.preMarketOpenChangePercent;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.enums === String ? $root.QuoteProtos.QuoteSource[message.source] === undefined ? message.source : $root.QuoteProtos.QuoteSource[message.source] : message.source;
            if (message.clearFieldNumbers && message.clearFieldNumbers.length) {
                object.clearFieldNumbers = [];
                for (let j = 0; j < message.clearFieldNumbers.length; ++j)
                    object.clearFieldNumbers[j] = message.clearFieldNumbers[j];
            }
            if (message.totalDebtEquityRatio != null && message.hasOwnProperty("totalDebtEquityRatio"))
                object.totalDebtEquityRatio = options.json && !isFinite(message.totalDebtEquityRatio) ? String(message.totalDebtEquityRatio) : message.totalDebtEquityRatio;
            if (message.dividendPayoutRatio != null && message.hasOwnProperty("dividendPayoutRatio"))
                object.dividendPayoutRatio = options.json && !isFinite(message.dividendPayoutRatio) ? String(message.dividendPayoutRatio) : message.dividendPayoutRatio;
            if (message.operatingCashFlow != null && message.hasOwnProperty("operatingCashFlow"))
                object.operatingCashFlow = options.json && !isFinite(message.operatingCashFlow) ? String(message.operatingCashFlow) : message.operatingCashFlow;
            if (message.insiderPercentage != null && message.hasOwnProperty("insiderPercentage"))
                object.insiderPercentage = options.json && !isFinite(message.insiderPercentage) ? String(message.insiderPercentage) : message.insiderPercentage;
            if (message.priceToCashFlowRatio != null && message.hasOwnProperty("priceToCashFlowRatio"))
                object.priceToCashFlowRatio = options.json && !isFinite(message.priceToCashFlowRatio) ? String(message.priceToCashFlowRatio) : message.priceToCashFlowRatio;
            if (message.regularHoursChange != null && message.hasOwnProperty("regularHoursChange"))
                object.regularHoursChange = options.json && !isFinite(message.regularHoursChange) ? String(message.regularHoursChange) : message.regularHoursChange;
            if (message.regularHoursPercentChange != null && message.hasOwnProperty("regularHoursPercentChange"))
                object.regularHoursPercentChange = options.json && !isFinite(message.regularHoursPercentChange) ? String(message.regularHoursPercentChange) : message.regularHoursPercentChange;
            if (message.postToPreHoursChange != null && message.hasOwnProperty("postToPreHoursChange"))
                object.postToPreHoursChange = options.json && !isFinite(message.postToPreHoursChange) ? String(message.postToPreHoursChange) : message.postToPreHoursChange;
            if (message.postToPreHoursPercentChange != null && message.hasOwnProperty("postToPreHoursPercentChange"))
                object.postToPreHoursPercentChange = options.json && !isFinite(message.postToPreHoursPercentChange) ? String(message.postToPreHoursPercentChange) : message.postToPreHoursPercentChange;
            if (message.scannerClose != null && message.hasOwnProperty("scannerClose"))
                object.scannerClose = options.json && !isFinite(message.scannerClose) ? String(message.scannerClose) : message.scannerClose;
            if (message.scannerChange != null && message.hasOwnProperty("scannerChange"))
                object.scannerChange = options.json && !isFinite(message.scannerChange) ? String(message.scannerChange) : message.scannerChange;
            if (message.scannerChangePercent != null && message.hasOwnProperty("scannerChangePercent"))
                object.scannerChangePercent = options.json && !isFinite(message.scannerChangePercent) ? String(message.scannerChangePercent) : message.scannerChangePercent;
            if (message.scannerChangePercentClose != null && message.hasOwnProperty("scannerChangePercentClose"))
                object.scannerChangePercentClose = options.json && !isFinite(message.scannerChangePercentClose) ? String(message.scannerChangePercentClose) : message.scannerChangePercentClose;
            if (message.scannerPreviousClose != null && message.hasOwnProperty("scannerPreviousClose"))
                object.scannerPreviousClose = options.json && !isFinite(message.scannerPreviousClose) ? String(message.scannerPreviousClose) : message.scannerPreviousClose;
            if (message.freeCashFlow != null && message.hasOwnProperty("freeCashFlow"))
                object.freeCashFlow = options.json && !isFinite(message.freeCashFlow) ? String(message.freeCashFlow) : message.freeCashFlow;
            if (message.minPriceTarget != null && message.hasOwnProperty("minPriceTarget"))
                object.minPriceTarget = options.json && !isFinite(message.minPriceTarget) ? String(message.minPriceTarget) : message.minPriceTarget;
            if (message.maxPriceTarget != null && message.hasOwnProperty("maxPriceTarget"))
                object.maxPriceTarget = options.json && !isFinite(message.maxPriceTarget) ? String(message.maxPriceTarget) : message.maxPriceTarget;
            if (message.meanPriceTarget != null && message.hasOwnProperty("meanPriceTarget"))
                object.meanPriceTarget = options.json && !isFinite(message.meanPriceTarget) ? String(message.meanPriceTarget) : message.meanPriceTarget;
            if (message.totalNumberOfAnalyst != null && message.hasOwnProperty("totalNumberOfAnalyst"))
                object.totalNumberOfAnalyst = options.json && !isFinite(message.totalNumberOfAnalyst) ? String(message.totalNumberOfAnalyst) : message.totalNumberOfAnalyst;
            if (message.averageAnalystRecommendation != null && message.hasOwnProperty("averageAnalystRecommendation"))
                object.averageAnalystRecommendation = message.averageAnalystRecommendation;
            if (message.pegRatio != null && message.hasOwnProperty("pegRatio"))
                object.pegRatio = options.json && !isFinite(message.pegRatio) ? String(message.pegRatio) : message.pegRatio;
            if (message.priceToFreeCashFlowRatio != null && message.hasOwnProperty("priceToFreeCashFlowRatio"))
                object.priceToFreeCashFlowRatio = options.json && !isFinite(message.priceToFreeCashFlowRatio) ? String(message.priceToFreeCashFlowRatio) : message.priceToFreeCashFlowRatio;
            if (message.distanceToMaxPriceTarget != null && message.hasOwnProperty("distanceToMaxPriceTarget"))
                object.distanceToMaxPriceTarget = options.json && !isFinite(message.distanceToMaxPriceTarget) ? String(message.distanceToMaxPriceTarget) : message.distanceToMaxPriceTarget;
            if (message.distanceToMinPriceTarget != null && message.hasOwnProperty("distanceToMinPriceTarget"))
                object.distanceToMinPriceTarget = options.json && !isFinite(message.distanceToMinPriceTarget) ? String(message.distanceToMinPriceTarget) : message.distanceToMinPriceTarget;
            if (message.distanceToMeanPriceTarget != null && message.hasOwnProperty("distanceToMeanPriceTarget"))
                object.distanceToMeanPriceTarget = options.json && !isFinite(message.distanceToMeanPriceTarget) ? String(message.distanceToMeanPriceTarget) : message.distanceToMeanPriceTarget;
            if (message.shortTermTrend != null && message.hasOwnProperty("shortTermTrend"))
                object.shortTermTrend = message.shortTermTrend;
            if (message.mediumTermTrend != null && message.hasOwnProperty("mediumTermTrend"))
                object.mediumTermTrend = message.mediumTermTrend;
            if (message.longTermTrend != null && message.hasOwnProperty("longTermTrend"))
                object.longTermTrend = message.longTermTrend;
            if (message.twentySixWeekChange != null && message.hasOwnProperty("twentySixWeekChange"))
                object.twentySixWeekChange = options.json && !isFinite(message.twentySixWeekChange) ? String(message.twentySixWeekChange) : message.twentySixWeekChange;
            if (message.fiftyTwoWeekChange != null && message.hasOwnProperty("fiftyTwoWeekChange"))
                object.fiftyTwoWeekChange = options.json && !isFinite(message.fiftyTwoWeekChange) ? String(message.fiftyTwoWeekChange) : message.fiftyTwoWeekChange;
            if (message.annualizedStandardDeviation != null && message.hasOwnProperty("annualizedStandardDeviation"))
                object.annualizedStandardDeviation = options.json && !isFinite(message.annualizedStandardDeviation) ? String(message.annualizedStandardDeviation) : message.annualizedStandardDeviation;
            if (message.momentum != null && message.hasOwnProperty("momentum"))
                object.momentum = options.json && !isFinite(message.momentum) ? String(message.momentum) : message.momentum;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
            if (message.piotroskiFScore != null && message.hasOwnProperty("piotroskiFScore"))
                if (typeof BigInt !== "undefined" && options.longs === BigInt)
                    object.piotroskiFScore = typeof message.piotroskiFScore === "number" ? BigInt(message.piotroskiFScore) : $util.Long.fromBits(message.piotroskiFScore.low >>> 0, message.piotroskiFScore.high >>> 0, false).toBigInt();
                else if (typeof message.piotroskiFScore === "number")
                    object.piotroskiFScore = options.longs === String ? String(message.piotroskiFScore) : message.piotroskiFScore;
                else
                    object.piotroskiFScore = options.longs === String ? $util.Long.prototype.toString.call(message.piotroskiFScore) : options.longs === Number ? new $util.LongBits(message.piotroskiFScore.low >>> 0, message.piotroskiFScore.high >>> 0).toNumber() : message.piotroskiFScore;
            if (message.netIncomeTtm != null && message.hasOwnProperty("netIncomeTtm"))
                object.netIncomeTtm = options.json && !isFinite(message.netIncomeTtm) ? String(message.netIncomeTtm) : message.netIncomeTtm;
            if (message.growth != null && message.hasOwnProperty("growth"))
                object.growth = options.json && !isFinite(message.growth) ? String(message.growth) : message.growth;
            if (message.currentRatioYearAgo != null && message.hasOwnProperty("currentRatioYearAgo"))
                object.currentRatioYearAgo = options.json && !isFinite(message.currentRatioYearAgo) ? String(message.currentRatioYearAgo) : message.currentRatioYearAgo;
            if (message.roaYearAgo != null && message.hasOwnProperty("roaYearAgo"))
                object.roaYearAgo = options.json && !isFinite(message.roaYearAgo) ? String(message.roaYearAgo) : message.roaYearAgo;
            if (message.grossMarginYearAgo != null && message.hasOwnProperty("grossMarginYearAgo"))
                object.grossMarginYearAgo = options.json && !isFinite(message.grossMarginYearAgo) ? String(message.grossMarginYearAgo) : message.grossMarginYearAgo;
            if (message.longTermDebt != null && message.hasOwnProperty("longTermDebt"))
                object.longTermDebt = options.json && !isFinite(message.longTermDebt) ? String(message.longTermDebt) : message.longTermDebt;
            if (message.longTermDebtYearAgo != null && message.hasOwnProperty("longTermDebtYearAgo"))
                object.longTermDebtYearAgo = options.json && !isFinite(message.longTermDebtYearAgo) ? String(message.longTermDebtYearAgo) : message.longTermDebtYearAgo;
            if (message.shareIssued != null && message.hasOwnProperty("shareIssued"))
                object.shareIssued = options.json && !isFinite(message.shareIssued) ? String(message.shareIssued) : message.shareIssued;
            if (message.shareIssuedYearAgo != null && message.hasOwnProperty("shareIssuedYearAgo"))
                object.shareIssuedYearAgo = options.json && !isFinite(message.shareIssuedYearAgo) ? String(message.shareIssuedYearAgo) : message.shareIssuedYearAgo;
            if (message.totalAssets != null && message.hasOwnProperty("totalAssets"))
                object.totalAssets = options.json && !isFinite(message.totalAssets) ? String(message.totalAssets) : message.totalAssets;
            if (message.totalAssetsYearAgo != null && message.hasOwnProperty("totalAssetsYearAgo"))
                object.totalAssetsYearAgo = options.json && !isFinite(message.totalAssetsYearAgo) ? String(message.totalAssetsYearAgo) : message.totalAssetsYearAgo;
            if (message.totalAssets2YearAgo != null && message.hasOwnProperty("totalAssets2YearAgo"))
                object.totalAssets2YearAgo = options.json && !isFinite(message.totalAssets2YearAgo) ? String(message.totalAssets2YearAgo) : message.totalAssets2YearAgo;
            if (message.revenueTtmYearAgo != null && message.hasOwnProperty("revenueTtmYearAgo"))
                object.revenueTtmYearAgo = options.json && !isFinite(message.revenueTtmYearAgo) ? String(message.revenueTtmYearAgo) : message.revenueTtmYearAgo;
            if (message.longTermDebtAndCapitalLeaseObligation != null && message.hasOwnProperty("longTermDebtAndCapitalLeaseObligation"))
                object.longTermDebtAndCapitalLeaseObligation = options.json && !isFinite(message.longTermDebtAndCapitalLeaseObligation) ? String(message.longTermDebtAndCapitalLeaseObligation) : message.longTermDebtAndCapitalLeaseObligation;
            if (message.averageTotalAssets != null && message.hasOwnProperty("averageTotalAssets"))
                object.averageTotalAssets = options.json && !isFinite(message.averageTotalAssets) ? String(message.averageTotalAssets) : message.averageTotalAssets;
            if (message.averageTotalAssetsYearAgo != null && message.hasOwnProperty("averageTotalAssetsYearAgo"))
                object.averageTotalAssetsYearAgo = options.json && !isFinite(message.averageTotalAssetsYearAgo) ? String(message.averageTotalAssetsYearAgo) : message.averageTotalAssetsYearAgo;
            if (message.quality != null && message.hasOwnProperty("quality"))
                object.quality = options.json && !isFinite(message.quality) ? String(message.quality) : message.quality;
            if (message.momentumPercentile != null && message.hasOwnProperty("momentumPercentile"))
                object.momentumPercentile = options.json && !isFinite(message.momentumPercentile) ? String(message.momentumPercentile) : message.momentumPercentile;
            if (message.valuePercentile != null && message.hasOwnProperty("valuePercentile"))
                object.valuePercentile = options.json && !isFinite(message.valuePercentile) ? String(message.valuePercentile) : message.valuePercentile;
            if (message.growthPercentile != null && message.hasOwnProperty("growthPercentile"))
                object.growthPercentile = options.json && !isFinite(message.growthPercentile) ? String(message.growthPercentile) : message.growthPercentile;
            if (message.qualityPercentile != null && message.hasOwnProperty("qualityPercentile"))
                object.qualityPercentile = options.json && !isFinite(message.qualityPercentile) ? String(message.qualityPercentile) : message.qualityPercentile;
            if (message.totalDividendTtm != null && message.hasOwnProperty("totalDividendTtm"))
                object.totalDividendTtm = options.json && !isFinite(message.totalDividendTtm) ? String(message.totalDividendTtm) : message.totalDividendTtm;
            if (message.dividendIncreasing != null && message.hasOwnProperty("dividendIncreasing"))
                object.dividendIncreasing = message.dividendIncreasing;
            if (message.rateOfReturnDay != null && message.hasOwnProperty("rateOfReturnDay"))
                object.rateOfReturnDay = options.json && !isFinite(message.rateOfReturnDay) ? String(message.rateOfReturnDay) : message.rateOfReturnDay;
            if (message.rateOfReturnWeek != null && message.hasOwnProperty("rateOfReturnWeek"))
                object.rateOfReturnWeek = options.json && !isFinite(message.rateOfReturnWeek) ? String(message.rateOfReturnWeek) : message.rateOfReturnWeek;
            if (message.rateOfReturnMonth != null && message.hasOwnProperty("rateOfReturnMonth"))
                object.rateOfReturnMonth = options.json && !isFinite(message.rateOfReturnMonth) ? String(message.rateOfReturnMonth) : message.rateOfReturnMonth;
            if (message.dividendOneDay != null && message.hasOwnProperty("dividendOneDay"))
                object.dividendOneDay = options.json && !isFinite(message.dividendOneDay) ? String(message.dividendOneDay) : message.dividendOneDay;
            if (message.dividendOneWeek != null && message.hasOwnProperty("dividendOneWeek"))
                object.dividendOneWeek = options.json && !isFinite(message.dividendOneWeek) ? String(message.dividendOneWeek) : message.dividendOneWeek;
            if (message.dividendOneMonth != null && message.hasOwnProperty("dividendOneMonth"))
                object.dividendOneMonth = options.json && !isFinite(message.dividendOneMonth) ? String(message.dividendOneMonth) : message.dividendOneMonth;
            if (message.totalLiabilities != null && message.hasOwnProperty("totalLiabilities"))
                object.totalLiabilities = options.json && !isFinite(message.totalLiabilities) ? String(message.totalLiabilities) : message.totalLiabilities;
            if (message.retainedEarnings != null && message.hasOwnProperty("retainedEarnings"))
                object.retainedEarnings = options.json && !isFinite(message.retainedEarnings) ? String(message.retainedEarnings) : message.retainedEarnings;
            if (message.ebit != null && message.hasOwnProperty("ebit"))
                object.ebit = options.json && !isFinite(message.ebit) ? String(message.ebit) : message.ebit;
            if (message.altmanZScore != null && message.hasOwnProperty("altmanZScore"))
                object.altmanZScore = options.json && !isFinite(message.altmanZScore) ? String(message.altmanZScore) : message.altmanZScore;
            if (message.powerEarningGap != null && message.hasOwnProperty("powerEarningGap"))
                object.powerEarningGap = message.powerEarningGap;
            if (message.monsterPowerEarningGap != null && message.hasOwnProperty("monsterPowerEarningGap"))
                object.monsterPowerEarningGap = message.monsterPowerEarningGap;
            if (message.monsterGap != null && message.hasOwnProperty("monsterGap"))
                object.monsterGap = message.monsterGap;
            if (message.oelGap != null && message.hasOwnProperty("oelGap"))
                object.oelGap = message.oelGap;
            if (message.evToEbit != null && message.hasOwnProperty("evToEbit"))
                object.evToEbit = options.json && !isFinite(message.evToEbit) ? String(message.evToEbit) : message.evToEbit;
            if (message.priceToTangibleBookValue != null && message.hasOwnProperty("priceToTangibleBookValue"))
                object.priceToTangibleBookValue = options.json && !isFinite(message.priceToTangibleBookValue) ? String(message.priceToTangibleBookValue) : message.priceToTangibleBookValue;
            if (message.tangibleBookValuePerShare != null && message.hasOwnProperty("tangibleBookValuePerShare"))
                object.tangibleBookValuePerShare = options.json && !isFinite(message.tangibleBookValuePerShare) ? String(message.tangibleBookValuePerShare) : message.tangibleBookValuePerShare;
            if (message.dailyDollarVolume != null && message.hasOwnProperty("dailyDollarVolume"))
                object.dailyDollarVolume = options.json && !isFinite(message.dailyDollarVolume) ? String(message.dailyDollarVolume) : message.dailyDollarVolume;
            if (message.bookValuePerShare != null && message.hasOwnProperty("bookValuePerShare"))
                object.bookValuePerShare = options.json && !isFinite(message.bookValuePerShare) ? String(message.bookValuePerShare) : message.bookValuePerShare;
            if (message.movingAverage350Day != null && message.hasOwnProperty("movingAverage350Day"))
                object.movingAverage350Day = options.json && !isFinite(message.movingAverage350Day) ? String(message.movingAverage350Day) : message.movingAverage350Day;
            if (message.priceToAdjEarningsTtm != null && message.hasOwnProperty("priceToAdjEarningsTtm"))
                object.priceToAdjEarningsTtm = options.json && !isFinite(message.priceToAdjEarningsTtm) ? String(message.priceToAdjEarningsTtm) : message.priceToAdjEarningsTtm;
            if (message.salesGrowthYoY != null && message.hasOwnProperty("salesGrowthYoY"))
                object.salesGrowthYoY = options.json && !isFinite(message.salesGrowthYoY) ? String(message.salesGrowthYoY) : message.salesGrowthYoY;
            if (message.salesGrowth3Year != null && message.hasOwnProperty("salesGrowth3Year"))
                object.salesGrowth3Year = options.json && !isFinite(message.salesGrowth3Year) ? String(message.salesGrowth3Year) : message.salesGrowth3Year;
            if (message.salesGrowth5Year != null && message.hasOwnProperty("salesGrowth5Year"))
                object.salesGrowth5Year = options.json && !isFinite(message.salesGrowth5Year) ? String(message.salesGrowth5Year) : message.salesGrowth5Year;
            if (message.debtQoQ != null && message.hasOwnProperty("debtQoQ"))
                object.debtQoQ = options.json && !isFinite(message.debtQoQ) ? String(message.debtQoQ) : message.debtQoQ;
            if (message.debtYoY != null && message.hasOwnProperty("debtYoY"))
                object.debtYoY = options.json && !isFinite(message.debtYoY) ? String(message.debtYoY) : message.debtYoY;
            if (message.debt5Year != null && message.hasOwnProperty("debt5Year"))
                object.debt5Year = options.json && !isFinite(message.debt5Year) ? String(message.debt5Year) : message.debt5Year;
            if (message.epsGrowth3Year != null && message.hasOwnProperty("epsGrowth3Year"))
                object.epsGrowth3Year = options.json && !isFinite(message.epsGrowth3Year) ? String(message.epsGrowth3Year) : message.epsGrowth3Year;
            if (message.epsGrowth3NormalizedYear != null && message.hasOwnProperty("epsGrowth3NormalizedYear"))
                object.epsGrowth3NormalizedYear = options.json && !isFinite(message.epsGrowth3NormalizedYear) ? String(message.epsGrowth3NormalizedYear) : message.epsGrowth3NormalizedYear;
            if (message.roe5YrAvg != null && message.hasOwnProperty("roe5YrAvg"))
                object.roe5YrAvg = options.json && !isFinite(message.roe5YrAvg) ? String(message.roe5YrAvg) : message.roe5YrAvg;
            if (message.stockholdersEquity != null && message.hasOwnProperty("stockholdersEquity"))
                object.stockholdersEquity = options.json && !isFinite(message.stockholdersEquity) ? String(message.stockholdersEquity) : message.stockholdersEquity;
            if (message.stockholdersEquityYearAgo != null && message.hasOwnProperty("stockholdersEquityYearAgo"))
                object.stockholdersEquityYearAgo = options.json && !isFinite(message.stockholdersEquityYearAgo) ? String(message.stockholdersEquityYearAgo) : message.stockholdersEquityYearAgo;
            if (message.stockholdersEquityGrowthYoY != null && message.hasOwnProperty("stockholdersEquityGrowthYoY"))
                object.stockholdersEquityGrowthYoY = options.json && !isFinite(message.stockholdersEquityGrowthYoY) ? String(message.stockholdersEquityGrowthYoY) : message.stockholdersEquityGrowthYoY;
            if (message.vwap1Day != null && message.hasOwnProperty("vwap1Day"))
                object.vwap1Day = options.json && !isFinite(message.vwap1Day) ? String(message.vwap1Day) : message.vwap1Day;
            if (message.vwap5Day != null && message.hasOwnProperty("vwap5Day"))
                object.vwap5Day = options.json && !isFinite(message.vwap5Day) ? String(message.vwap5Day) : message.vwap5Day;
            if (message.vwap10Day != null && message.hasOwnProperty("vwap10Day"))
                object.vwap10Day = options.json && !isFinite(message.vwap10Day) ? String(message.vwap10Day) : message.vwap10Day;
            if (message.vwap50Day != null && message.hasOwnProperty("vwap50Day"))
                object.vwap50Day = options.json && !isFinite(message.vwap50Day) ? String(message.vwap50Day) : message.vwap50Day;
            if (message.vwap100Day != null && message.hasOwnProperty("vwap100Day"))
                object.vwap100Day = options.json && !isFinite(message.vwap100Day) ? String(message.vwap100Day) : message.vwap100Day;
            if (message.vwap200Day != null && message.hasOwnProperty("vwap200Day"))
                object.vwap200Day = options.json && !isFinite(message.vwap200Day) ? String(message.vwap200Day) : message.vwap200Day;
            if (message.roic1YearAvg != null && message.hasOwnProperty("roic1YearAvg"))
                object.roic1YearAvg = options.json && !isFinite(message.roic1YearAvg) ? String(message.roic1YearAvg) : message.roic1YearAvg;
            if (message.roic5YearAvg != null && message.hasOwnProperty("roic5YearAvg"))
                object.roic5YearAvg = options.json && !isFinite(message.roic5YearAvg) ? String(message.roic5YearAvg) : message.roic5YearAvg;
            if (message.vwap1m != null && message.hasOwnProperty("vwap1m"))
                object.vwap1m = options.json && !isFinite(message.vwap1m) ? String(message.vwap1m) : message.vwap1m;
            if (message.vwap5m != null && message.hasOwnProperty("vwap5m"))
                object.vwap5m = options.json && !isFinite(message.vwap5m) ? String(message.vwap5m) : message.vwap5m;
            if (message.vwap15m != null && message.hasOwnProperty("vwap15m"))
                object.vwap15m = options.json && !isFinite(message.vwap15m) ? String(message.vwap15m) : message.vwap15m;
            if (message.vwap30m != null && message.hasOwnProperty("vwap30m"))
                object.vwap30m = options.json && !isFinite(message.vwap30m) ? String(message.vwap30m) : message.vwap30m;
            if (message.vwap60m != null && message.hasOwnProperty("vwap60m"))
                object.vwap60m = options.json && !isFinite(message.vwap60m) ? String(message.vwap60m) : message.vwap60m;
            if (message.candleStick != null && message.hasOwnProperty("candleStick"))
                object.candleStick = message.candleStick;
            if (message.patterns != null && message.hasOwnProperty("patterns"))
                object.patterns = message.patterns;
            if (message.earningsForwardGrowth3Year != null && message.hasOwnProperty("earningsForwardGrowth3Year"))
                object.earningsForwardGrowth3Year = options.json && !isFinite(message.earningsForwardGrowth3Year) ? String(message.earningsForwardGrowth3Year) : message.earningsForwardGrowth3Year;
            if (message.earningsForwardGrowth5Year != null && message.hasOwnProperty("earningsForwardGrowth5Year"))
                object.earningsForwardGrowth5Year = options.json && !isFinite(message.earningsForwardGrowth5Year) ? String(message.earningsForwardGrowth5Year) : message.earningsForwardGrowth5Year;
            if (message.revenueForwardGrowth3Year != null && message.hasOwnProperty("revenueForwardGrowth3Year"))
                object.revenueForwardGrowth3Year = options.json && !isFinite(message.revenueForwardGrowth3Year) ? String(message.revenueForwardGrowth3Year) : message.revenueForwardGrowth3Year;
            if (message.revenueForwardGrowth5Year != null && message.hasOwnProperty("revenueForwardGrowth5Year"))
                object.revenueForwardGrowth5Year = options.json && !isFinite(message.revenueForwardGrowth5Year) ? String(message.revenueForwardGrowth5Year) : message.revenueForwardGrowth5Year;
            if (message.bidAskSpread != null && message.hasOwnProperty("bidAskSpread"))
                object.bidAskSpread = options.json && !isFinite(message.bidAskSpread) ? String(message.bidAskSpread) : message.bidAskSpread;
            if (message.bidAskSpreadPercent != null && message.hasOwnProperty("bidAskSpreadPercent"))
                object.bidAskSpreadPercent = options.json && !isFinite(message.bidAskSpreadPercent) ? String(message.bidAskSpreadPercent) : message.bidAskSpreadPercent;
            if (message.change1Minute != null && message.hasOwnProperty("change1Minute"))
                object.change1Minute = options.json && !isFinite(message.change1Minute) ? String(message.change1Minute) : message.change1Minute;
            if (message.preMarketChange1Minute != null && message.hasOwnProperty("preMarketChange1Minute"))
                object.preMarketChange1Minute = options.json && !isFinite(message.preMarketChange1Minute) ? String(message.preMarketChange1Minute) : message.preMarketChange1Minute;
            if (message.preMarketChangePercent1Minute != null && message.hasOwnProperty("preMarketChangePercent1Minute"))
                object.preMarketChangePercent1Minute = options.json && !isFinite(message.preMarketChangePercent1Minute) ? String(message.preMarketChangePercent1Minute) : message.preMarketChangePercent1Minute;
            if (message.regularChange1Minute != null && message.hasOwnProperty("regularChange1Minute"))
                object.regularChange1Minute = options.json && !isFinite(message.regularChange1Minute) ? String(message.regularChange1Minute) : message.regularChange1Minute;
            if (message.regularChangePercent1Minute != null && message.hasOwnProperty("regularChangePercent1Minute"))
                object.regularChangePercent1Minute = options.json && !isFinite(message.regularChangePercent1Minute) ? String(message.regularChangePercent1Minute) : message.regularChangePercent1Minute;
            if (message.afterMarketChange1Minute != null && message.hasOwnProperty("afterMarketChange1Minute"))
                object.afterMarketChange1Minute = options.json && !isFinite(message.afterMarketChange1Minute) ? String(message.afterMarketChange1Minute) : message.afterMarketChange1Minute;
            if (message.afterMarketChangePercent1Minute != null && message.hasOwnProperty("afterMarketChangePercent1Minute"))
                object.afterMarketChangePercent1Minute = options.json && !isFinite(message.afterMarketChangePercent1Minute) ? String(message.afterMarketChangePercent1Minute) : message.afterMarketChangePercent1Minute;
            if (message.previousCloseDate != null && message.hasOwnProperty("previousCloseDate"))
                object.previousCloseDate = message.previousCloseDate;
            if (message.distanceToMaxPriceTargetPercent != null && message.hasOwnProperty("distanceToMaxPriceTargetPercent"))
                object.distanceToMaxPriceTargetPercent = options.json && !isFinite(message.distanceToMaxPriceTargetPercent) ? String(message.distanceToMaxPriceTargetPercent) : message.distanceToMaxPriceTargetPercent;
            if (message.distanceToMinPriceTargetPercent != null && message.hasOwnProperty("distanceToMinPriceTargetPercent"))
                object.distanceToMinPriceTargetPercent = options.json && !isFinite(message.distanceToMinPriceTargetPercent) ? String(message.distanceToMinPriceTargetPercent) : message.distanceToMinPriceTargetPercent;
            if (message.distanceToMeanPriceTargetPercent != null && message.hasOwnProperty("distanceToMeanPriceTargetPercent"))
                object.distanceToMeanPriceTargetPercent = options.json && !isFinite(message.distanceToMeanPriceTargetPercent) ? String(message.distanceToMeanPriceTargetPercent) : message.distanceToMeanPriceTargetPercent;
            return object;
        };

        /**
         * Converts this Quote to JSON.
         * @function toJSON
         * @memberof QuoteProtos.Quote
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Quote.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Quote;
    })();

    return QuoteProtos;
})();

export { $root as default };
